! function() {
    var e = {
            979: function() {
                for (var e = document.getElementsByClassName("js-accordion-trigger"), a = function() {
                        var e = this.getAttribute("aria-controls"),
                            a = document.getElementById("".concat(e));
                        this.classList.toggle("active"), null == a || a.classList.toggle("active"), null != a && a.classList.contains("active") ? null == a || a.setAttribute("aria-hidden", !1) : null == a || a.setAttribute("aria-hidden", !0)
                    }, t = 0; t < e.length; t++) e[t].addEventListener("click", a, !1)
            },
            62: function() {
                var e = document.querySelectorAll(".js-click-to-section");
                console.log("navLinks", e)
            },
            696: function() {
                var e = document.getElementById("sort-by");
                if (e) {
                    if (void 0 === window.Shopify && (window.Shopify = {}), window.Shopify.queryParams = {}, location.search.length)
                        for (var a, t = 0, n = location.search.substr(1).split("&"); t < n.length; t++)(a = n[t].split("=")).length > 1 && (window.Shopify.queryParams[decodeURIComponent(a[0])] = decodeURIComponent(a[1]));
                    e.addEventListener("change", (function(e) {
                        var a = e.currentTarget.value;
                        window.Shopify.queryParams.sort_by = a, location.search = new URLSearchParams(window.Shopify.queryParams).toString()
                    }))
                }
            },
            793: function() {
                for (var e = document.getElementsByClassName("js-toggle-book-links"), a = function() {
                        document.body.classList.toggle("mind-body-links-open")
                    }, t = 0; t < e.length; t++) e[t].addEventListener("click", a, !1)
            },
            335: function() {
                for (var e = document.getElementsByClassName("js-toggle-nav"), a = document.getElementsByClassName("js-close-nav"), t = function(e) {
                        e.preventDefault(), document.body.classList.toggle("nav-open"), document.body.classList.remove("filter-open"), document.body.classList.remove("search-open"), document.getElementById("js-search").focus()
                    }, n = function(e) {
                        e.preventDefault(), document.body.classList.remove("nav-open")
                    }, i = 0; i < e.length; i++) e[i].addEventListener("click", t, !1);
                for (var r = 0; r < a.length; r++) a[r].addEventListener("click", n, !1)
            },
            360: function() {
                window.addEventListener("load", (function() {
                    var e = document.getElementsByClassName("js-toggle-search"),
                        a = document.getElementsByClassName("js-close-search");
                    console.log("toggleSearchElement", e);
                    for (var t = function(e) {
                            console.log("toggleSearch"), e.preventDefault(), document.body.classList.toggle("search-open"), document.body.classList.remove("filter-open"), document.getElementById("js-search").focus()
                        }, n = function(e) {
                            e.preventDefault(), document.body.classList.remove("search-open")
                        }, i = 0; i < e.length; i++) e[i].addEventListener("click", t, !1);
                    for (var r = 0; r < a.length; r++) a[r].addEventListener("click", n, !1)
                }))
            },
            172: function() {
                document.querySelectorAll(".js-video-plays-in-view").forEach((function(e) {
                    e.muted = !0;
                    var a = e.play();
                    void 0 !== a && a.then((function(a) {
                        new IntersectionObserver((function(a) {
                            a.forEach((function(a) {
                                a.intersectionRatio <= .1 && !e.paused ? e.pause() : e.paused && setTimeout((function() {
                                    e.play()
                                }), 500)
                            }))
                        }), {
                            threshold: .1
                        }).observe(e)
                    }))
                }))
            },
            755: function(e, a) {
                var t;
                ! function(a, t) {
                    "use strict";
                    "object" == typeof e.exports ? e.exports = a.document ? t(a, !0) : function(e) {
                        if (!e.document) throw new Error("jQuery requires a window with a document");
                        return t(e)
                    } : t(a)
                }("undefined" != typeof window ? window : this, (function(n, i) {
                    "use strict";
                    var r = [],
                        s = Object.getPrototypeOf,
                        o = r.slice,
                        l = r.flat ? function(e) {
                            return r.flat.call(e)
                        } : function(e) {
                            return r.concat.apply([], e)
                        },
                        u = r.push,
                        d = r.indexOf,
                        c = {},
                        p = c.toString,
                        h = c.hasOwnProperty,
                        f = h.toString,
                        m = f.call(Object),
                        g = {},
                        v = function(e) {
                            return "function" == typeof e && "number" != typeof e.nodeType && "function" != typeof e.item
                        },
                        y = function(e) {
                            return null != e && e === e.window
                        },
                        b = n.document,
                        S = {
                            type: !0,
                            src: !0,
                            nonce: !0,
                            noModule: !0
                        };

                    function w(e, a, t) {
                        var n, i, r = (t = t || b).createElement("script");
                        if (r.text = e, a)
                            for (n in S)(i = a[n] || a.getAttribute && a.getAttribute(n)) && r.setAttribute(n, i);
                        t.head.appendChild(r).parentNode.removeChild(r)
                    }

                    function k(e) {
                        return null == e ? e + "" : "object" == typeof e || "function" == typeof e ? c[p.call(e)] || "object" : typeof e
                    }
                    var T = "3.6.4",
                        x = function(e, a) {
                            return new x.fn.init(e, a)
                        };

                    function C(e) {
                        var a = !!e && "length" in e && e.length,
                            t = k(e);
                        return !v(e) && !y(e) && ("array" === t || 0 === a || "number" == typeof a && a > 0 && a - 1 in e)
                    }
                    x.fn = x.prototype = {
                        jquery: T,
                        constructor: x,
                        length: 0,
                        toArray: function() {
                            return o.call(this)
                        },
                        get: function(e) {
                            return null == e ? o.call(this) : e < 0 ? this[e + this.length] : this[e]
                        },
                        pushStack: function(e) {
                            var a = x.merge(this.constructor(), e);
                            return a.prevObject = this, a
                        },
                        each: function(e) {
                            return x.each(this, e)
                        },
                        map: function(e) {
                            return this.pushStack(x.map(this, (function(a, t) {
                                return e.call(a, t, a)
                            })))
                        },
                        slice: function() {
                            return this.pushStack(o.apply(this, arguments))
                        },
                        first: function() {
                            return this.eq(0)
                        },
                        last: function() {
                            return this.eq(-1)
                        },
                        even: function() {
                            return this.pushStack(x.grep(this, (function(e, a) {
                                return (a + 1) % 2
                            })))
                        },
                        odd: function() {
                            return this.pushStack(x.grep(this, (function(e, a) {
                                return a % 2
                            })))
                        },
                        eq: function(e) {
                            var a = this.length,
                                t = +e + (e < 0 ? a : 0);
                            return this.pushStack(t >= 0 && t < a ? [this[t]] : [])
                        },
                        end: function() {
                            return this.prevObject || this.constructor()
                        },
                        push: u,
                        sort: r.sort,
                        splice: r.splice
                    }, x.extend = x.fn.extend = function() {
                        var e, a, t, n, i, r, s = arguments[0] || {},
                            o = 1,
                            l = arguments.length,
                            u = !1;
                        for ("boolean" == typeof s && (u = s, s = arguments[o] || {}, o++), "object" == typeof s || v(s) || (s = {}), o === l && (s = this, o--); o < l; o++)
                            if (null != (e = arguments[o]))
                                for (a in e) n = e[a], "__proto__" !== a && s !== n && (u && n && (x.isPlainObject(n) || (i = Array.isArray(n))) ? (t = s[a], r = i && !Array.isArray(t) ? [] : i || x.isPlainObject(t) ? t : {}, i = !1, s[a] = x.extend(u, r, n)) : void 0 !== n && (s[a] = n));
                        return s
                    }, x.extend({
                        expando: "jQuery" + (T + Math.random()).replace(/\D/g, ""),
                        isReady: !0,
                        error: function(e) {
                            throw new Error(e)
                        },
                        noop: function() {},
                        isPlainObject: function(e) {
                            var a, t;
                            return !(!e || "[object Object]" !== p.call(e)) && (!(a = s(e)) || "function" == typeof(t = h.call(a, "constructor") && a.constructor) && f.call(t) === m)
                        },
                        isEmptyObject: function(e) {
                            var a;
                            for (a in e) return !1;
                            return !0
                        },
                        globalEval: function(e, a, t) {
                            w(e, {
                                nonce: a && a.nonce
                            }, t)
                        },
                        each: function(e, a) {
                            var t, n = 0;
                            if (C(e))
                                for (t = e.length; n < t && !1 !== a.call(e[n], n, e[n]); n++);
                            else
                                for (n in e)
                                    if (!1 === a.call(e[n], n, e[n])) break;
                            return e
                        },
                        makeArray: function(e, a) {
                            var t = a || [];
                            return null != e && (C(Object(e)) ? x.merge(t, "string" == typeof e ? [e] : e) : u.call(t, e)), t
                        },
                        inArray: function(e, a, t) {
                            return null == a ? -1 : d.call(a, e, t)
                        },
                        merge: function(e, a) {
                            for (var t = +a.length, n = 0, i = e.length; n < t; n++) e[i++] = a[n];
                            return e.length = i, e
                        },
                        grep: function(e, a, t) {
                            for (var n = [], i = 0, r = e.length, s = !t; i < r; i++) !a(e[i], i) !== s && n.push(e[i]);
                            return n
                        },
                        map: function(e, a, t) {
                            var n, i, r = 0,
                                s = [];
                            if (C(e))
                                for (n = e.length; r < n; r++) null != (i = a(e[r], r, t)) && s.push(i);
                            else
                                for (r in e) null != (i = a(e[r], r, t)) && s.push(i);
                            return l(s)
                        },
                        guid: 1,
                        support: g
                    }), "function" == typeof Symbol && (x.fn[Symbol.iterator] = r[Symbol.iterator]), x.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), (function(e, a) {
                        c["[object " + a + "]"] = a.toLowerCase()
                    }));
                    var E = function(e) {
                        var a, t, n, i, r, s, o, l, u, d, c, p, h, f, m, g, v, y, b, S = "sizzle" + 1 * new Date,
                            w = e.document,
                            k = 0,
                            T = 0,
                            x = le(),
                            C = le(),
                            E = le(),
                            M = le(),
                            A = function(e, a) {
                                return e === a && (c = !0), 0
                            },
                            P = {}.hasOwnProperty,
                            L = [],
                            j = L.pop,
                            B = L.push,
                            N = L.push,
                            z = L.slice,
                            D = function(e, a) {
                                for (var t = 0, n = e.length; t < n; t++)
                                    if (e[t] === a) return t;
                                return -1
                            },
                            I = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
                            O = "[\\x20\\t\\r\\n\\f]",
                            R = "(?:\\\\[\\da-fA-F]{1,6}" + O + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
                            H = "\\[" + O + "*(" + R + ")(?:" + O + "*([*^$|!~]?=)" + O + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + R + "))|)" + O + "*\\]",
                            G = ":(" + R + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + H + ")*)|.*)\\)|)",
                            q = new RegExp(O + "+", "g"),
                            K = new RegExp("^" + O + "+|((?:^|[^\\\\])(?:\\\\.)*)" + O + "+$", "g"),
                            $ = new RegExp("^" + O + "*," + O + "*"),
                            V = new RegExp("^" + O + "*([>+~]|" + O + ")" + O + "*"),
                            W = new RegExp(O + "|>"),
                            F = new RegExp(G),
                            _ = new RegExp("^" + R + "$"),
                            Y = {
                                ID: new RegExp("^#(" + R + ")"),
                                CLASS: new RegExp("^\\.(" + R + ")"),
                                TAG: new RegExp("^(" + R + "|[*])"),
                                ATTR: new RegExp("^" + H),
                                PSEUDO: new RegExp("^" + G),
                                CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + O + "*(even|odd|(([+-]|)(\\d*)n|)" + O + "*(?:([+-]|)" + O + "*(\\d+)|))" + O + "*\\)|)", "i"),
                                bool: new RegExp("^(?:" + I + ")$", "i"),
                                needsContext: new RegExp("^" + O + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + O + "*((?:-\\d)?\\d*)" + O + "*\\)|)(?=[^-]|$)", "i")
                            },
                            X = /HTML$/i,
                            J = /^(?:input|select|textarea|button)$/i,
                            U = /^h\d$/i,
                            Z = /^[^{]+\{\s*\[native \w/,
                            Q = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
                            ee = /[+~]/,
                            ae = new RegExp("\\\\[\\da-fA-F]{1,6}" + O + "?|\\\\([^\\r\\n\\f])", "g"),
                            te = function(e, a) {
                                var t = "0x" + e.slice(1) - 65536;
                                return a || (t < 0 ? String.fromCharCode(t + 65536) : String.fromCharCode(t >> 10 | 55296, 1023 & t | 56320))
                            },
                            ne = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
                            ie = function(e, a) {
                                return a ? "\0" === e ? "�" : e.slice(0, -1) + "\\" + e.charCodeAt(e.length - 1).toString(16) + " " : "\\" + e
                            },
                            re = function() {
                                p()
                            },
                            se = Se((function(e) {
                                return !0 === e.disabled && "fieldset" === e.nodeName.toLowerCase()
                            }), {
                                dir: "parentNode",
                                next: "legend"
                            });
                        try {
                            N.apply(L = z.call(w.childNodes), w.childNodes), L[w.childNodes.length].nodeType
                        } catch (e) {
                            N = {
                                apply: L.length ? function(e, a) {
                                    B.apply(e, z.call(a))
                                } : function(e, a) {
                                    for (var t = e.length, n = 0; e[t++] = a[n++];);
                                    e.length = t - 1
                                }
                            }
                        }

                        function oe(e, a, n, i) {
                            var r, o, u, d, c, f, v, y = a && a.ownerDocument,
                                w = a ? a.nodeType : 9;
                            if (n = n || [], "string" != typeof e || !e || 1 !== w && 9 !== w && 11 !== w) return n;
                            if (!i && (p(a), a = a || h, m)) {
                                if (11 !== w && (c = Q.exec(e)))
                                    if (r = c[1]) {
                                        if (9 === w) {
                                            if (!(u = a.getElementById(r))) return n;
                                            if (u.id === r) return n.push(u), n
                                        } else if (y && (u = y.getElementById(r)) && b(a, u) && u.id === r) return n.push(u), n
                                    } else {
                                        if (c[2]) return N.apply(n, a.getElementsByTagName(e)), n;
                                        if ((r = c[3]) && t.getElementsByClassName && a.getElementsByClassName) return N.apply(n, a.getElementsByClassName(r)), n
                                    } if (t.qsa && !M[e + " "] && (!g || !g.test(e)) && (1 !== w || "object" !== a.nodeName.toLowerCase())) {
                                    if (v = e, y = a, 1 === w && (W.test(e) || V.test(e))) {
                                        for ((y = ee.test(e) && ve(a.parentNode) || a) === a && t.scope || ((d = a.getAttribute("id")) ? d = d.replace(ne, ie) : a.setAttribute("id", d = S)), o = (f = s(e)).length; o--;) f[o] = (d ? "#" + d : ":scope") + " " + be(f[o]);
                                        v = f.join(",")
                                    }
                                    try {
                                        return N.apply(n, y.querySelectorAll(v)), n
                                    } catch (a) {
                                        M(e, !0)
                                    } finally {
                                        d === S && a.removeAttribute("id")
                                    }
                                }
                            }
                            return l(e.replace(K, "$1"), a, n, i)
                        }

                        function le() {
                            var e = [];
                            return function a(t, i) {
                                return e.push(t + " ") > n.cacheLength && delete a[e.shift()], a[t + " "] = i
                            }
                        }

                        function ue(e) {
                            return e[S] = !0, e
                        }

                        function de(e) {
                            var a = h.createElement("fieldset");
                            try {
                                return !!e(a)
                            } catch (e) {
                                return !1
                            } finally {
                                a.parentNode && a.parentNode.removeChild(a), a = null
                            }
                        }

                        function ce(e, a) {
                            for (var t = e.split("|"), i = t.length; i--;) n.attrHandle[t[i]] = a
                        }

                        function pe(e, a) {
                            var t = a && e,
                                n = t && 1 === e.nodeType && 1 === a.nodeType && e.sourceIndex - a.sourceIndex;
                            if (n) return n;
                            if (t)
                                for (; t = t.nextSibling;)
                                    if (t === a) return -1;
                            return e ? 1 : -1
                        }

                        function he(e) {
                            return function(a) {
                                return "input" === a.nodeName.toLowerCase() && a.type === e
                            }
                        }

                        function fe(e) {
                            return function(a) {
                                var t = a.nodeName.toLowerCase();
                                return ("input" === t || "button" === t) && a.type === e
                            }
                        }

                        function me(e) {
                            return function(a) {
                                return "form" in a ? a.parentNode && !1 === a.disabled ? "label" in a ? "label" in a.parentNode ? a.parentNode.disabled === e : a.disabled === e : a.isDisabled === e || a.isDisabled !== !e && se(a) === e : a.disabled === e : "label" in a && a.disabled === e
                            }
                        }

                        function ge(e) {
                            return ue((function(a) {
                                return a = +a, ue((function(t, n) {
                                    for (var i, r = e([], t.length, a), s = r.length; s--;) t[i = r[s]] && (t[i] = !(n[i] = t[i]))
                                }))
                            }))
                        }

                        function ve(e) {
                            return e && void 0 !== e.getElementsByTagName && e
                        }
                        for (a in t = oe.support = {}, r = oe.isXML = function(e) {
                                var a = e && e.namespaceURI,
                                    t = e && (e.ownerDocument || e).documentElement;
                                return !X.test(a || t && t.nodeName || "HTML")
                            }, p = oe.setDocument = function(e) {
                                var a, i, s = e ? e.ownerDocument || e : w;
                                return s != h && 9 === s.nodeType && s.documentElement ? (f = (h = s).documentElement, m = !r(h), w != h && (i = h.defaultView) && i.top !== i && (i.addEventListener ? i.addEventListener("unload", re, !1) : i.attachEvent && i.attachEvent("onunload", re)), t.scope = de((function(e) {
                                    return f.appendChild(e).appendChild(h.createElement("div")), void 0 !== e.querySelectorAll && !e.querySelectorAll(":scope fieldset div").length
                                })), t.cssHas = de((function() {
                                    try {
                                        return h.querySelector(":has(*,:jqfake)"), !1
                                    } catch (e) {
                                        return !0
                                    }
                                })), t.attributes = de((function(e) {
                                    return e.className = "i", !e.getAttribute("className")
                                })), t.getElementsByTagName = de((function(e) {
                                    return e.appendChild(h.createComment("")), !e.getElementsByTagName("*").length
                                })), t.getElementsByClassName = Z.test(h.getElementsByClassName), t.getById = de((function(e) {
                                    return f.appendChild(e).id = S, !h.getElementsByName || !h.getElementsByName(S).length
                                })), t.getById ? (n.filter.ID = function(e) {
                                    var a = e.replace(ae, te);
                                    return function(e) {
                                        return e.getAttribute("id") === a
                                    }
                                }, n.find.ID = function(e, a) {
                                    if (void 0 !== a.getElementById && m) {
                                        var t = a.getElementById(e);
                                        return t ? [t] : []
                                    }
                                }) : (n.filter.ID = function(e) {
                                    var a = e.replace(ae, te);
                                    return function(e) {
                                        var t = void 0 !== e.getAttributeNode && e.getAttributeNode("id");
                                        return t && t.value === a
                                    }
                                }, n.find.ID = function(e, a) {
                                    if (void 0 !== a.getElementById && m) {
                                        var t, n, i, r = a.getElementById(e);
                                        if (r) {
                                            if ((t = r.getAttributeNode("id")) && t.value === e) return [r];
                                            for (i = a.getElementsByName(e), n = 0; r = i[n++];)
                                                if ((t = r.getAttributeNode("id")) && t.value === e) return [r]
                                        }
                                        return []
                                    }
                                }), n.find.TAG = t.getElementsByTagName ? function(e, a) {
                                    return void 0 !== a.getElementsByTagName ? a.getElementsByTagName(e) : t.qsa ? a.querySelectorAll(e) : void 0
                                } : function(e, a) {
                                    var t, n = [],
                                        i = 0,
                                        r = a.getElementsByTagName(e);
                                    if ("*" === e) {
                                        for (; t = r[i++];) 1 === t.nodeType && n.push(t);
                                        return n
                                    }
                                    return r
                                }, n.find.CLASS = t.getElementsByClassName && function(e, a) {
                                    if (void 0 !== a.getElementsByClassName && m) return a.getElementsByClassName(e)
                                }, v = [], g = [], (t.qsa = Z.test(h.querySelectorAll)) && (de((function(e) {
                                    var a;
                                    f.appendChild(e).innerHTML = "<a id='" + S + "'></a><select id='" + S + "-\r\\' msallowcapture=''><option selected=''></option></select>", e.querySelectorAll("[msallowcapture^='']").length && g.push("[*^$]=" + O + "*(?:''|\"\")"), e.querySelectorAll("[selected]").length || g.push("\\[" + O + "*(?:value|" + I + ")"), e.querySelectorAll("[id~=" + S + "-]").length || g.push("~="), (a = h.createElement("input")).setAttribute("name", ""), e.appendChild(a), e.querySelectorAll("[name='']").length || g.push("\\[" + O + "*name" + O + "*=" + O + "*(?:''|\"\")"), e.querySelectorAll(":checked").length || g.push(":checked"), e.querySelectorAll("a#" + S + "+*").length || g.push(".#.+[+~]"), e.querySelectorAll("\\\f"), g.push("[\\r\\n\\f]")
                                })), de((function(e) {
                                    e.innerHTML = "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                                    var a = h.createElement("input");
                                    a.setAttribute("type", "hidden"), e.appendChild(a).setAttribute("name", "D"), e.querySelectorAll("[name=d]").length && g.push("name" + O + "*[*^$|!~]?="), 2 !== e.querySelectorAll(":enabled").length && g.push(":enabled", ":disabled"), f.appendChild(e).disabled = !0, 2 !== e.querySelectorAll(":disabled").length && g.push(":enabled", ":disabled"), e.querySelectorAll("*,:x"), g.push(",.*:")
                                }))), (t.matchesSelector = Z.test(y = f.matches || f.webkitMatchesSelector || f.mozMatchesSelector || f.oMatchesSelector || f.msMatchesSelector)) && de((function(e) {
                                    t.disconnectedMatch = y.call(e, "*"), y.call(e, "[s!='']:x"), v.push("!=", G)
                                })), t.cssHas || g.push(":has"), g = g.length && new RegExp(g.join("|")), v = v.length && new RegExp(v.join("|")), a = Z.test(f.compareDocumentPosition), b = a || Z.test(f.contains) ? function(e, a) {
                                    var t = 9 === e.nodeType && e.documentElement || e,
                                        n = a && a.parentNode;
                                    return e === n || !(!n || 1 !== n.nodeType || !(t.contains ? t.contains(n) : e.compareDocumentPosition && 16 & e.compareDocumentPosition(n)))
                                } : function(e, a) {
                                    if (a)
                                        for (; a = a.parentNode;)
                                            if (a === e) return !0;
                                    return !1
                                }, A = a ? function(e, a) {
                                    if (e === a) return c = !0, 0;
                                    var n = !e.compareDocumentPosition - !a.compareDocumentPosition;
                                    return n || (1 & (n = (e.ownerDocument || e) == (a.ownerDocument || a) ? e.compareDocumentPosition(a) : 1) || !t.sortDetached && a.compareDocumentPosition(e) === n ? e == h || e.ownerDocument == w && b(w, e) ? -1 : a == h || a.ownerDocument == w && b(w, a) ? 1 : d ? D(d, e) - D(d, a) : 0 : 4 & n ? -1 : 1)
                                } : function(e, a) {
                                    if (e === a) return c = !0, 0;
                                    var t, n = 0,
                                        i = e.parentNode,
                                        r = a.parentNode,
                                        s = [e],
                                        o = [a];
                                    if (!i || !r) return e == h ? -1 : a == h ? 1 : i ? -1 : r ? 1 : d ? D(d, e) - D(d, a) : 0;
                                    if (i === r) return pe(e, a);
                                    for (t = e; t = t.parentNode;) s.unshift(t);
                                    for (t = a; t = t.parentNode;) o.unshift(t);
                                    for (; s[n] === o[n];) n++;
                                    return n ? pe(s[n], o[n]) : s[n] == w ? -1 : o[n] == w ? 1 : 0
                                }, h) : h
                            }, oe.matches = function(e, a) {
                                return oe(e, null, null, a)
                            }, oe.matchesSelector = function(e, a) {
                                if (p(e), t.matchesSelector && m && !M[a + " "] && (!v || !v.test(a)) && (!g || !g.test(a))) try {
                                    var n = y.call(e, a);
                                    if (n || t.disconnectedMatch || e.document && 11 !== e.document.nodeType) return n
                                } catch (e) {
                                    M(a, !0)
                                }
                                return oe(a, h, null, [e]).length > 0
                            }, oe.contains = function(e, a) {
                                return (e.ownerDocument || e) != h && p(e), b(e, a)
                            }, oe.attr = function(e, a) {
                                (e.ownerDocument || e) != h && p(e);
                                var i = n.attrHandle[a.toLowerCase()],
                                    r = i && P.call(n.attrHandle, a.toLowerCase()) ? i(e, a, !m) : void 0;
                                return void 0 !== r ? r : t.attributes || !m ? e.getAttribute(a) : (r = e.getAttributeNode(a)) && r.specified ? r.value : null
                            }, oe.escape = function(e) {
                                return (e + "").replace(ne, ie)
                            }, oe.error = function(e) {
                                throw new Error("Syntax error, unrecognized expression: " + e)
                            }, oe.uniqueSort = function(e) {
                                var a, n = [],
                                    i = 0,
                                    r = 0;
                                if (c = !t.detectDuplicates, d = !t.sortStable && e.slice(0), e.sort(A), c) {
                                    for (; a = e[r++];) a === e[r] && (i = n.push(r));
                                    for (; i--;) e.splice(n[i], 1)
                                }
                                return d = null, e
                            }, i = oe.getText = function(e) {
                                var a, t = "",
                                    n = 0,
                                    r = e.nodeType;
                                if (r) {
                                    if (1 === r || 9 === r || 11 === r) {
                                        if ("string" == typeof e.textContent) return e.textContent;
                                        for (e = e.firstChild; e; e = e.nextSibling) t += i(e)
                                    } else if (3 === r || 4 === r) return e.nodeValue
                                } else
                                    for (; a = e[n++];) t += i(a);
                                return t
                            }, n = oe.selectors = {
                                cacheLength: 50,
                                createPseudo: ue,
                                match: Y,
                                attrHandle: {},
                                find: {},
                                relative: {
                                    ">": {
                                        dir: "parentNode",
                                        first: !0
                                    },
                                    " ": {
                                        dir: "parentNode"
                                    },
                                    "+": {
                                        dir: "previousSibling",
                                        first: !0
                                    },
                                    "~": {
                                        dir: "previousSibling"
                                    }
                                },
                                preFilter: {
                                    ATTR: function(e) {
                                        return e[1] = e[1].replace(ae, te), e[3] = (e[3] || e[4] || e[5] || "").replace(ae, te), "~=" === e[2] && (e[3] = " " + e[3] + " "), e.slice(0, 4)
                                    },
                                    CHILD: function(e) {
                                        return e[1] = e[1].toLowerCase(), "nth" === e[1].slice(0, 3) ? (e[3] || oe.error(e[0]), e[4] = +(e[4] ? e[5] + (e[6] || 1) : 2 * ("even" === e[3] || "odd" === e[3])), e[5] = +(e[7] + e[8] || "odd" === e[3])) : e[3] && oe.error(e[0]), e
                                    },
                                    PSEUDO: function(e) {
                                        var a, t = !e[6] && e[2];
                                        return Y.CHILD.test(e[0]) ? null : (e[3] ? e[2] = e[4] || e[5] || "" : t && F.test(t) && (a = s(t, !0)) && (a = t.indexOf(")", t.length - a) - t.length) && (e[0] = e[0].slice(0, a), e[2] = t.slice(0, a)), e.slice(0, 3))
                                    }
                                },
                                filter: {
                                    TAG: function(e) {
                                        var a = e.replace(ae, te).toLowerCase();
                                        return "*" === e ? function() {
                                            return !0
                                        } : function(e) {
                                            return e.nodeName && e.nodeName.toLowerCase() === a
                                        }
                                    },
                                    CLASS: function(e) {
                                        var a = x[e + " "];
                                        return a || (a = new RegExp("(^|" + O + ")" + e + "(" + O + "|$)")) && x(e, (function(e) {
                                            return a.test("string" == typeof e.className && e.className || void 0 !== e.getAttribute && e.getAttribute("class") || "")
                                        }))
                                    },
                                    ATTR: function(e, a, t) {
                                        return function(n) {
                                            var i = oe.attr(n, e);
                                            return null == i ? "!=" === a : !a || (i += "", "=" === a ? i === t : "!=" === a ? i !== t : "^=" === a ? t && 0 === i.indexOf(t) : "*=" === a ? t && i.indexOf(t) > -1 : "$=" === a ? t && i.slice(-t.length) === t : "~=" === a ? (" " + i.replace(q, " ") + " ").indexOf(t) > -1 : "|=" === a && (i === t || i.slice(0, t.length + 1) === t + "-"))
                                        }
                                    },
                                    CHILD: function(e, a, t, n, i) {
                                        var r = "nth" !== e.slice(0, 3),
                                            s = "last" !== e.slice(-4),
                                            o = "of-type" === a;
                                        return 1 === n && 0 === i ? function(e) {
                                            return !!e.parentNode
                                        } : function(a, t, l) {
                                            var u, d, c, p, h, f, m = r !== s ? "nextSibling" : "previousSibling",
                                                g = a.parentNode,
                                                v = o && a.nodeName.toLowerCase(),
                                                y = !l && !o,
                                                b = !1;
                                            if (g) {
                                                if (r) {
                                                    for (; m;) {
                                                        for (p = a; p = p[m];)
                                                            if (o ? p.nodeName.toLowerCase() === v : 1 === p.nodeType) return !1;
                                                        f = m = "only" === e && !f && "nextSibling"
                                                    }
                                                    return !0
                                                }
                                                if (f = [s ? g.firstChild : g.lastChild], s && y) {
                                                    for (b = (h = (u = (d = (c = (p = g)[S] || (p[S] = {}))[p.uniqueID] || (c[p.uniqueID] = {}))[e] || [])[0] === k && u[1]) && u[2], p = h && g.childNodes[h]; p = ++h && p && p[m] || (b = h = 0) || f.pop();)
                                                        if (1 === p.nodeType && ++b && p === a) {
                                                            d[e] = [k, h, b];
                                                            break
                                                        }
                                                } else if (y && (b = h = (u = (d = (c = (p = a)[S] || (p[S] = {}))[p.uniqueID] || (c[p.uniqueID] = {}))[e] || [])[0] === k && u[1]), !1 === b)
                                                    for (;
                                                        (p = ++h && p && p[m] || (b = h = 0) || f.pop()) && ((o ? p.nodeName.toLowerCase() !== v : 1 !== p.nodeType) || !++b || (y && ((d = (c = p[S] || (p[S] = {}))[p.uniqueID] || (c[p.uniqueID] = {}))[e] = [k, b]), p !== a)););
                                                return (b -= i) === n || b % n == 0 && b / n >= 0
                                            }
                                        }
                                    },
                                    PSEUDO: function(e, a) {
                                        var t, i = n.pseudos[e] || n.setFilters[e.toLowerCase()] || oe.error("unsupported pseudo: " + e);
                                        return i[S] ? i(a) : i.length > 1 ? (t = [e, e, "", a], n.setFilters.hasOwnProperty(e.toLowerCase()) ? ue((function(e, t) {
                                            for (var n, r = i(e, a), s = r.length; s--;) e[n = D(e, r[s])] = !(t[n] = r[s])
                                        })) : function(e) {
                                            return i(e, 0, t)
                                        }) : i
                                    }
                                },
                                pseudos: {
                                    not: ue((function(e) {
                                        var a = [],
                                            t = [],
                                            n = o(e.replace(K, "$1"));
                                        return n[S] ? ue((function(e, a, t, i) {
                                            for (var r, s = n(e, null, i, []), o = e.length; o--;)(r = s[o]) && (e[o] = !(a[o] = r))
                                        })) : function(e, i, r) {
                                            return a[0] = e, n(a, null, r, t), a[0] = null, !t.pop()
                                        }
                                    })),
                                    has: ue((function(e) {
                                        return function(a) {
                                            return oe(e, a).length > 0
                                        }
                                    })),
                                    contains: ue((function(e) {
                                        return e = e.replace(ae, te),
                                            function(a) {
                                                return (a.textContent || i(a)).indexOf(e) > -1
                                            }
                                    })),
                                    lang: ue((function(e) {
                                        return _.test(e || "") || oe.error("unsupported lang: " + e), e = e.replace(ae, te).toLowerCase(),
                                            function(a) {
                                                var t;
                                                do {
                                                    if (t = m ? a.lang : a.getAttribute("xml:lang") || a.getAttribute("lang")) return (t = t.toLowerCase()) === e || 0 === t.indexOf(e + "-")
                                                } while ((a = a.parentNode) && 1 === a.nodeType);
                                                return !1
                                            }
                                    })),
                                    target: function(a) {
                                        var t = e.location && e.location.hash;
                                        return t && t.slice(1) === a.id
                                    },
                                    root: function(e) {
                                        return e === f
                                    },
                                    focus: function(e) {
                                        return e === h.activeElement && (!h.hasFocus || h.hasFocus()) && !!(e.type || e.href || ~e.tabIndex)
                                    },
                                    enabled: me(!1),
                                    disabled: me(!0),
                                    checked: function(e) {
                                        var a = e.nodeName.toLowerCase();
                                        return "input" === a && !!e.checked || "option" === a && !!e.selected
                                    },
                                    selected: function(e) {
                                        return e.parentNode && e.parentNode.selectedIndex, !0 === e.selected
                                    },
                                    empty: function(e) {
                                        for (e = e.firstChild; e; e = e.nextSibling)
                                            if (e.nodeType < 6) return !1;
                                        return !0
                                    },
                                    parent: function(e) {
                                        return !n.pseudos.empty(e)
                                    },
                                    header: function(e) {
                                        return U.test(e.nodeName)
                                    },
                                    input: function(e) {
                                        return J.test(e.nodeName)
                                    },
                                    button: function(e) {
                                        var a = e.nodeName.toLowerCase();
                                        return "input" === a && "button" === e.type || "button" === a
                                    },
                                    text: function(e) {
                                        var a;
                                        return "input" === e.nodeName.toLowerCase() && "text" === e.type && (null == (a = e.getAttribute("type")) || "text" === a.toLowerCase())
                                    },
                                    first: ge((function() {
                                        return [0]
                                    })),
                                    last: ge((function(e, a) {
                                        return [a - 1]
                                    })),
                                    eq: ge((function(e, a, t) {
                                        return [t < 0 ? t + a : t]
                                    })),
                                    even: ge((function(e, a) {
                                        for (var t = 0; t < a; t += 2) e.push(t);
                                        return e
                                    })),
                                    odd: ge((function(e, a) {
                                        for (var t = 1; t < a; t += 2) e.push(t);
                                        return e
                                    })),
                                    lt: ge((function(e, a, t) {
                                        for (var n = t < 0 ? t + a : t > a ? a : t; --n >= 0;) e.push(n);
                                        return e
                                    })),
                                    gt: ge((function(e, a, t) {
                                        for (var n = t < 0 ? t + a : t; ++n < a;) e.push(n);
                                        return e
                                    }))
                                }
                            }, n.pseudos.nth = n.pseudos.eq, {
                                radio: !0,
                                checkbox: !0,
                                file: !0,
                                password: !0,
                                image: !0
                            }) n.pseudos[a] = he(a);
                        for (a in {
                                submit: !0,
                                reset: !0
                            }) n.pseudos[a] = fe(a);

                        function ye() {}

                        function be(e) {
                            for (var a = 0, t = e.length, n = ""; a < t; a++) n += e[a].value;
                            return n
                        }

                        function Se(e, a, t) {
                            var n = a.dir,
                                i = a.next,
                                r = i || n,
                                s = t && "parentNode" === r,
                                o = T++;
                            return a.first ? function(a, t, i) {
                                for (; a = a[n];)
                                    if (1 === a.nodeType || s) return e(a, t, i);
                                return !1
                            } : function(a, t, l) {
                                var u, d, c, p = [k, o];
                                if (l) {
                                    for (; a = a[n];)
                                        if ((1 === a.nodeType || s) && e(a, t, l)) return !0
                                } else
                                    for (; a = a[n];)
                                        if (1 === a.nodeType || s)
                                            if (d = (c = a[S] || (a[S] = {}))[a.uniqueID] || (c[a.uniqueID] = {}), i && i === a.nodeName.toLowerCase()) a = a[n] || a;
                                            else {
                                                if ((u = d[r]) && u[0] === k && u[1] === o) return p[2] = u[2];
                                                if (d[r] = p, p[2] = e(a, t, l)) return !0
                                            } return !1
                            }
                        }

                        function we(e) {
                            return e.length > 1 ? function(a, t, n) {
                                for (var i = e.length; i--;)
                                    if (!e[i](a, t, n)) return !1;
                                return !0
                            } : e[0]
                        }

                        function ke(e, a, t, n, i) {
                            for (var r, s = [], o = 0, l = e.length, u = null != a; o < l; o++)(r = e[o]) && (t && !t(r, n, i) || (s.push(r), u && a.push(o)));
                            return s
                        }

                        function Te(e, a, t, n, i, r) {
                            return n && !n[S] && (n = Te(n)), i && !i[S] && (i = Te(i, r)), ue((function(r, s, o, l) {
                                var u, d, c, p = [],
                                    h = [],
                                    f = s.length,
                                    m = r || function(e, a, t) {
                                        for (var n = 0, i = a.length; n < i; n++) oe(e, a[n], t);
                                        return t
                                    }(a || "*", o.nodeType ? [o] : o, []),
                                    g = !e || !r && a ? m : ke(m, p, e, o, l),
                                    v = t ? i || (r ? e : f || n) ? [] : s : g;
                                if (t && t(g, v, o, l), n)
                                    for (u = ke(v, h), n(u, [], o, l), d = u.length; d--;)(c = u[d]) && (v[h[d]] = !(g[h[d]] = c));
                                if (r) {
                                    if (i || e) {
                                        if (i) {
                                            for (u = [], d = v.length; d--;)(c = v[d]) && u.push(g[d] = c);
                                            i(null, v = [], u, l)
                                        }
                                        for (d = v.length; d--;)(c = v[d]) && (u = i ? D(r, c) : p[d]) > -1 && (r[u] = !(s[u] = c))
                                    }
                                } else v = ke(v === s ? v.splice(f, v.length) : v), i ? i(null, s, v, l) : N.apply(s, v)
                            }))
                        }

                        function xe(e) {
                            for (var a, t, i, r = e.length, s = n.relative[e[0].type], o = s || n.relative[" "], l = s ? 1 : 0, d = Se((function(e) {
                                    return e === a
                                }), o, !0), c = Se((function(e) {
                                    return D(a, e) > -1
                                }), o, !0), p = [function(e, t, n) {
                                    var i = !s && (n || t !== u) || ((a = t).nodeType ? d(e, t, n) : c(e, t, n));
                                    return a = null, i
                                }]; l < r; l++)
                                if (t = n.relative[e[l].type]) p = [Se(we(p), t)];
                                else {
                                    if ((t = n.filter[e[l].type].apply(null, e[l].matches))[S]) {
                                        for (i = ++l; i < r && !n.relative[e[i].type]; i++);
                                        return Te(l > 1 && we(p), l > 1 && be(e.slice(0, l - 1).concat({
                                            value: " " === e[l - 2].type ? "*" : ""
                                        })).replace(K, "$1"), t, l < i && xe(e.slice(l, i)), i < r && xe(e = e.slice(i)), i < r && be(e))
                                    }
                                    p.push(t)
                                } return we(p)
                        }
                        return ye.prototype = n.filters = n.pseudos, n.setFilters = new ye, s = oe.tokenize = function(e, a) {
                            var t, i, r, s, o, l, u, d = C[e + " "];
                            if (d) return a ? 0 : d.slice(0);
                            for (o = e, l = [], u = n.preFilter; o;) {
                                for (s in t && !(i = $.exec(o)) || (i && (o = o.slice(i[0].length) || o), l.push(r = [])), t = !1, (i = V.exec(o)) && (t = i.shift(), r.push({
                                        value: t,
                                        type: i[0].replace(K, " ")
                                    }), o = o.slice(t.length)), n.filter) !(i = Y[s].exec(o)) || u[s] && !(i = u[s](i)) || (t = i.shift(), r.push({
                                    value: t,
                                    type: s,
                                    matches: i
                                }), o = o.slice(t.length));
                                if (!t) break
                            }
                            return a ? o.length : o ? oe.error(e) : C(e, l).slice(0)
                        }, o = oe.compile = function(e, a) {
                            var t, i = [],
                                r = [],
                                o = E[e + " "];
                            if (!o) {
                                for (a || (a = s(e)), t = a.length; t--;)(o = xe(a[t]))[S] ? i.push(o) : r.push(o);
                                o = E(e, function(e, a) {
                                    var t = a.length > 0,
                                        i = e.length > 0,
                                        r = function(r, s, o, l, d) {
                                            var c, f, g, v = 0,
                                                y = "0",
                                                b = r && [],
                                                S = [],
                                                w = u,
                                                T = r || i && n.find.TAG("*", d),
                                                x = k += null == w ? 1 : Math.random() || .1,
                                                C = T.length;
                                            for (d && (u = s == h || s || d); y !== C && null != (c = T[y]); y++) {
                                                if (i && c) {
                                                    for (f = 0, s || c.ownerDocument == h || (p(c), o = !m); g = e[f++];)
                                                        if (g(c, s || h, o)) {
                                                            l.push(c);
                                                            break
                                                        } d && (k = x)
                                                }
                                                t && ((c = !g && c) && v--, r && b.push(c))
                                            }
                                            if (v += y, t && y !== v) {
                                                for (f = 0; g = a[f++];) g(b, S, s, o);
                                                if (r) {
                                                    if (v > 0)
                                                        for (; y--;) b[y] || S[y] || (S[y] = j.call(l));
                                                    S = ke(S)
                                                }
                                                N.apply(l, S), d && !r && S.length > 0 && v + a.length > 1 && oe.uniqueSort(l)
                                            }
                                            return d && (k = x, u = w), b
                                        };
                                    return t ? ue(r) : r
                                }(r, i)), o.selector = e
                            }
                            return o
                        }, l = oe.select = function(e, a, t, i) {
                            var r, l, u, d, c, p = "function" == typeof e && e,
                                h = !i && s(e = p.selector || e);
                            if (t = t || [], 1 === h.length) {
                                if ((l = h[0] = h[0].slice(0)).length > 2 && "ID" === (u = l[0]).type && 9 === a.nodeType && m && n.relative[l[1].type]) {
                                    if (!(a = (n.find.ID(u.matches[0].replace(ae, te), a) || [])[0])) return t;
                                    p && (a = a.parentNode), e = e.slice(l.shift().value.length)
                                }
                                for (r = Y.needsContext.test(e) ? 0 : l.length; r-- && (u = l[r], !n.relative[d = u.type]);)
                                    if ((c = n.find[d]) && (i = c(u.matches[0].replace(ae, te), ee.test(l[0].type) && ve(a.parentNode) || a))) {
                                        if (l.splice(r, 1), !(e = i.length && be(l))) return N.apply(t, i), t;
                                        break
                                    }
                            }
                            return (p || o(e, h))(i, a, !m, t, !a || ee.test(e) && ve(a.parentNode) || a), t
                        }, t.sortStable = S.split("").sort(A).join("") === S, t.detectDuplicates = !!c, p(), t.sortDetached = de((function(e) {
                            return 1 & e.compareDocumentPosition(h.createElement("fieldset"))
                        })), de((function(e) {
                            return e.innerHTML = "<a href='#'></a>", "#" === e.firstChild.getAttribute("href")
                        })) || ce("type|href|height|width", (function(e, a, t) {
                            if (!t) return e.getAttribute(a, "type" === a.toLowerCase() ? 1 : 2)
                        })), t.attributes && de((function(e) {
                            return e.innerHTML = "<input/>", e.firstChild.setAttribute("value", ""), "" === e.firstChild.getAttribute("value")
                        })) || ce("value", (function(e, a, t) {
                            if (!t && "input" === e.nodeName.toLowerCase()) return e.defaultValue
                        })), de((function(e) {
                            return null == e.getAttribute("disabled")
                        })) || ce(I, (function(e, a, t) {
                            var n;
                            if (!t) return !0 === e[a] ? a.toLowerCase() : (n = e.getAttributeNode(a)) && n.specified ? n.value : null
                        })), oe
                    }(n);
                    x.find = E, x.expr = E.selectors, x.expr[":"] = x.expr.pseudos, x.uniqueSort = x.unique = E.uniqueSort, x.text = E.getText, x.isXMLDoc = E.isXML, x.contains = E.contains, x.escapeSelector = E.escape;
                    var M = function(e, a, t) {
                            for (var n = [], i = void 0 !== t;
                                (e = e[a]) && 9 !== e.nodeType;)
                                if (1 === e.nodeType) {
                                    if (i && x(e).is(t)) break;
                                    n.push(e)
                                } return n
                        },
                        A = function(e, a) {
                            for (var t = []; e; e = e.nextSibling) 1 === e.nodeType && e !== a && t.push(e);
                            return t
                        },
                        P = x.expr.match.needsContext;

                    function L(e, a) {
                        return e.nodeName && e.nodeName.toLowerCase() === a.toLowerCase()
                    }
                    var j = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;

                    function B(e, a, t) {
                        return v(a) ? x.grep(e, (function(e, n) {
                            return !!a.call(e, n, e) !== t
                        })) : a.nodeType ? x.grep(e, (function(e) {
                            return e === a !== t
                        })) : "string" != typeof a ? x.grep(e, (function(e) {
                            return d.call(a, e) > -1 !== t
                        })) : x.filter(a, e, t)
                    }
                    x.filter = function(e, a, t) {
                        var n = a[0];
                        return t && (e = ":not(" + e + ")"), 1 === a.length && 1 === n.nodeType ? x.find.matchesSelector(n, e) ? [n] : [] : x.find.matches(e, x.grep(a, (function(e) {
                            return 1 === e.nodeType
                        })))
                    }, x.fn.extend({
                        find: function(e) {
                            var a, t, n = this.length,
                                i = this;
                            if ("string" != typeof e) return this.pushStack(x(e).filter((function() {
                                for (a = 0; a < n; a++)
                                    if (x.contains(i[a], this)) return !0
                            })));
                            for (t = this.pushStack([]), a = 0; a < n; a++) x.find(e, i[a], t);
                            return n > 1 ? x.uniqueSort(t) : t
                        },
                        filter: function(e) {
                            return this.pushStack(B(this, e || [], !1))
                        },
                        not: function(e) {
                            return this.pushStack(B(this, e || [], !0))
                        },
                        is: function(e) {
                            return !!B(this, "string" == typeof e && P.test(e) ? x(e) : e || [], !1).length
                        }
                    });
                    var N, z = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
                    (x.fn.init = function(e, a, t) {
                        var n, i;
                        if (!e) return this;
                        if (t = t || N, "string" == typeof e) {
                            if (!(n = "<" === e[0] && ">" === e[e.length - 1] && e.length >= 3 ? [null, e, null] : z.exec(e)) || !n[1] && a) return !a || a.jquery ? (a || t).find(e) : this.constructor(a).find(e);
                            if (n[1]) {
                                if (a = a instanceof x ? a[0] : a, x.merge(this, x.parseHTML(n[1], a && a.nodeType ? a.ownerDocument || a : b, !0)), j.test(n[1]) && x.isPlainObject(a))
                                    for (n in a) v(this[n]) ? this[n](a[n]) : this.attr(n, a[n]);
                                return this
                            }
                            return (i = b.getElementById(n[2])) && (this[0] = i, this.length = 1), this
                        }
                        return e.nodeType ? (this[0] = e, this.length = 1, this) : v(e) ? void 0 !== t.ready ? t.ready(e) : e(x) : x.makeArray(e, this)
                    }).prototype = x.fn, N = x(b);
                    var D = /^(?:parents|prev(?:Until|All))/,
                        I = {
                            children: !0,
                            contents: !0,
                            next: !0,
                            prev: !0
                        };

                    function O(e, a) {
                        for (;
                            (e = e[a]) && 1 !== e.nodeType;);
                        return e
                    }
                    x.fn.extend({
                        has: function(e) {
                            var a = x(e, this),
                                t = a.length;
                            return this.filter((function() {
                                for (var e = 0; e < t; e++)
                                    if (x.contains(this, a[e])) return !0
                            }))
                        },
                        closest: function(e, a) {
                            var t, n = 0,
                                i = this.length,
                                r = [],
                                s = "string" != typeof e && x(e);
                            if (!P.test(e))
                                for (; n < i; n++)
                                    for (t = this[n]; t && t !== a; t = t.parentNode)
                                        if (t.nodeType < 11 && (s ? s.index(t) > -1 : 1 === t.nodeType && x.find.matchesSelector(t, e))) {
                                            r.push(t);
                                            break
                                        } return this.pushStack(r.length > 1 ? x.uniqueSort(r) : r)
                        },
                        index: function(e) {
                            return e ? "string" == typeof e ? d.call(x(e), this[0]) : d.call(this, e.jquery ? e[0] : e) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1
                        },
                        add: function(e, a) {
                            return this.pushStack(x.uniqueSort(x.merge(this.get(), x(e, a))))
                        },
                        addBack: function(e) {
                            return this.add(null == e ? this.prevObject : this.prevObject.filter(e))
                        }
                    }), x.each({
                        parent: function(e) {
                            var a = e.parentNode;
                            return a && 11 !== a.nodeType ? a : null
                        },
                        parents: function(e) {
                            return M(e, "parentNode")
                        },
                        parentsUntil: function(e, a, t) {
                            return M(e, "parentNode", t)
                        },
                        next: function(e) {
                            return O(e, "nextSibling")
                        },
                        prev: function(e) {
                            return O(e, "previousSibling")
                        },
                        nextAll: function(e) {
                            return M(e, "nextSibling")
                        },
                        prevAll: function(e) {
                            return M(e, "previousSibling")
                        },
                        nextUntil: function(e, a, t) {
                            return M(e, "nextSibling", t)
                        },
                        prevUntil: function(e, a, t) {
                            return M(e, "previousSibling", t)
                        },
                        siblings: function(e) {
                            return A((e.parentNode || {}).firstChild, e)
                        },
                        children: function(e) {
                            return A(e.firstChild)
                        },
                        contents: function(e) {
                            return null != e.contentDocument && s(e.contentDocument) ? e.contentDocument : (L(e, "template") && (e = e.content || e), x.merge([], e.childNodes))
                        }
                    }, (function(e, a) {
                        x.fn[e] = function(t, n) {
                            var i = x.map(this, a, t);
                            return "Until" !== e.slice(-5) && (n = t), n && "string" == typeof n && (i = x.filter(n, i)), this.length > 1 && (I[e] || x.uniqueSort(i), D.test(e) && i.reverse()), this.pushStack(i)
                        }
                    }));
                    var R = /[^\x20\t\r\n\f]+/g;

                    function H(e) {
                        return e
                    }

                    function G(e) {
                        throw e
                    }

                    function q(e, a, t, n) {
                        var i;
                        try {
                            e && v(i = e.promise) ? i.call(e).done(a).fail(t) : e && v(i = e.then) ? i.call(e, a, t) : a.apply(void 0, [e].slice(n))
                        } catch (e) {
                            t.apply(void 0, [e])
                        }
                    }
                    x.Callbacks = function(e) {
                        e = "string" == typeof e ? function(e) {
                            var a = {};
                            return x.each(e.match(R) || [], (function(e, t) {
                                a[t] = !0
                            })), a
                        }(e) : x.extend({}, e);
                        var a, t, n, i, r = [],
                            s = [],
                            o = -1,
                            l = function() {
                                for (i = i || e.once, n = a = !0; s.length; o = -1)
                                    for (t = s.shift(); ++o < r.length;) !1 === r[o].apply(t[0], t[1]) && e.stopOnFalse && (o = r.length, t = !1);
                                e.memory || (t = !1), a = !1, i && (r = t ? [] : "")
                            },
                            u = {
                                add: function() {
                                    return r && (t && !a && (o = r.length - 1, s.push(t)), function a(t) {
                                        x.each(t, (function(t, n) {
                                            v(n) ? e.unique && u.has(n) || r.push(n) : n && n.length && "string" !== k(n) && a(n)
                                        }))
                                    }(arguments), t && !a && l()), this
                                },
                                remove: function() {
                                    return x.each(arguments, (function(e, a) {
                                        for (var t;
                                            (t = x.inArray(a, r, t)) > -1;) r.splice(t, 1), t <= o && o--
                                    })), this
                                },
                                has: function(e) {
                                    return e ? x.inArray(e, r) > -1 : r.length > 0
                                },
                                empty: function() {
                                    return r && (r = []), this
                                },
                                disable: function() {
                                    return i = s = [], r = t = "", this
                                },
                                disabled: function() {
                                    return !r
                                },
                                lock: function() {
                                    return i = s = [], t || a || (r = t = ""), this
                                },
                                locked: function() {
                                    return !!i
                                },
                                fireWith: function(e, t) {
                                    return i || (t = [e, (t = t || []).slice ? t.slice() : t], s.push(t), a || l()), this
                                },
                                fire: function() {
                                    return u.fireWith(this, arguments), this
                                },
                                fired: function() {
                                    return !!n
                                }
                            };
                        return u
                    }, x.extend({
                        Deferred: function(e) {
                            var a = [
                                    ["notify", "progress", x.Callbacks("memory"), x.Callbacks("memory"), 2],
                                    ["resolve", "done", x.Callbacks("once memory"), x.Callbacks("once memory"), 0, "resolved"],
                                    ["reject", "fail", x.Callbacks("once memory"), x.Callbacks("once memory"), 1, "rejected"]
                                ],
                                t = "pending",
                                i = {
                                    state: function() {
                                        return t
                                    },
                                    always: function() {
                                        return r.done(arguments).fail(arguments), this
                                    },
                                    catch: function(e) {
                                        return i.then(null, e)
                                    },
                                    pipe: function() {
                                        var e = arguments;
                                        return x.Deferred((function(t) {
                                            x.each(a, (function(a, n) {
                                                var i = v(e[n[4]]) && e[n[4]];
                                                r[n[1]]((function() {
                                                    var e = i && i.apply(this, arguments);
                                                    e && v(e.promise) ? e.promise().progress(t.notify).done(t.resolve).fail(t.reject) : t[n[0] + "With"](this, i ? [e] : arguments)
                                                }))
                                            })), e = null
                                        })).promise()
                                    },
                                    then: function(e, t, i) {
                                        var r = 0;

                                        function s(e, a, t, i) {
                                            return function() {
                                                var o = this,
                                                    l = arguments,
                                                    u = function() {
                                                        var n, u;
                                                        if (!(e < r)) {
                                                            if ((n = t.apply(o, l)) === a.promise()) throw new TypeError("Thenable self-resolution");
                                                            u = n && ("object" == typeof n || "function" == typeof n) && n.then, v(u) ? i ? u.call(n, s(r, a, H, i), s(r, a, G, i)) : (r++, u.call(n, s(r, a, H, i), s(r, a, G, i), s(r, a, H, a.notifyWith))) : (t !== H && (o = void 0, l = [n]), (i || a.resolveWith)(o, l))
                                                        }
                                                    },
                                                    d = i ? u : function() {
                                                        try {
                                                            u()
                                                        } catch (n) {
                                                            x.Deferred.exceptionHook && x.Deferred.exceptionHook(n, d.stackTrace), e + 1 >= r && (t !== G && (o = void 0, l = [n]), a.rejectWith(o, l))
                                                        }
                                                    };
                                                e ? d() : (x.Deferred.getStackHook && (d.stackTrace = x.Deferred.getStackHook()), n.setTimeout(d))
                                            }
                                        }
                                        return x.Deferred((function(n) {
                                            a[0][3].add(s(0, n, v(i) ? i : H, n.notifyWith)), a[1][3].add(s(0, n, v(e) ? e : H)), a[2][3].add(s(0, n, v(t) ? t : G))
                                        })).promise()
                                    },
                                    promise: function(e) {
                                        return null != e ? x.extend(e, i) : i
                                    }
                                },
                                r = {};
                            return x.each(a, (function(e, n) {
                                var s = n[2],
                                    o = n[5];
                                i[n[1]] = s.add, o && s.add((function() {
                                    t = o
                                }), a[3 - e][2].disable, a[3 - e][3].disable, a[0][2].lock, a[0][3].lock), s.add(n[3].fire), r[n[0]] = function() {
                                    return r[n[0] + "With"](this === r ? void 0 : this, arguments), this
                                }, r[n[0] + "With"] = s.fireWith
                            })), i.promise(r), e && e.call(r, r), r
                        },
                        when: function(e) {
                            var a = arguments.length,
                                t = a,
                                n = Array(t),
                                i = o.call(arguments),
                                r = x.Deferred(),
                                s = function(e) {
                                    return function(t) {
                                        n[e] = this, i[e] = arguments.length > 1 ? o.call(arguments) : t, --a || r.resolveWith(n, i)
                                    }
                                };
                            if (a <= 1 && (q(e, r.done(s(t)).resolve, r.reject, !a), "pending" === r.state() || v(i[t] && i[t].then))) return r.then();
                            for (; t--;) q(i[t], s(t), r.reject);
                            return r.promise()
                        }
                    });
                    var K = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
                    x.Deferred.exceptionHook = function(e, a) {
                        n.console && n.console.warn && e && K.test(e.name) && n.console.warn("jQuery.Deferred exception: " + e.message, e.stack, a)
                    }, x.readyException = function(e) {
                        n.setTimeout((function() {
                            throw e
                        }))
                    };
                    var $ = x.Deferred();

                    function V() {
                        b.removeEventListener("DOMContentLoaded", V), n.removeEventListener("load", V), x.ready()
                    }
                    x.fn.ready = function(e) {
                        return $.then(e).catch((function(e) {
                            x.readyException(e)
                        })), this
                    }, x.extend({
                        isReady: !1,
                        readyWait: 1,
                        ready: function(e) {
                            (!0 === e ? --x.readyWait : x.isReady) || (x.isReady = !0, !0 !== e && --x.readyWait > 0 || $.resolveWith(b, [x]))
                        }
                    }), x.ready.then = $.then, "complete" === b.readyState || "loading" !== b.readyState && !b.documentElement.doScroll ? n.setTimeout(x.ready) : (b.addEventListener("DOMContentLoaded", V), n.addEventListener("load", V));
                    var W = function(e, a, t, n, i, r, s) {
                            var o = 0,
                                l = e.length,
                                u = null == t;
                            if ("object" === k(t))
                                for (o in i = !0, t) W(e, a, o, t[o], !0, r, s);
                            else if (void 0 !== n && (i = !0, v(n) || (s = !0), u && (s ? (a.call(e, n), a = null) : (u = a, a = function(e, a, t) {
                                    return u.call(x(e), t)
                                })), a))
                                for (; o < l; o++) a(e[o], t, s ? n : n.call(e[o], o, a(e[o], t)));
                            return i ? e : u ? a.call(e) : l ? a(e[0], t) : r
                        },
                        F = /^-ms-/,
                        _ = /-([a-z])/g;

                    function Y(e, a) {
                        return a.toUpperCase()
                    }

                    function X(e) {
                        return e.replace(F, "ms-").replace(_, Y)
                    }
                    var J = function(e) {
                        return 1 === e.nodeType || 9 === e.nodeType || !+e.nodeType
                    };

                    function U() {
                        this.expando = x.expando + U.uid++
                    }
                    U.uid = 1, U.prototype = {
                        cache: function(e) {
                            var a = e[this.expando];
                            return a || (a = {}, J(e) && (e.nodeType ? e[this.expando] = a : Object.defineProperty(e, this.expando, {
                                value: a,
                                configurable: !0
                            }))), a
                        },
                        set: function(e, a, t) {
                            var n, i = this.cache(e);
                            if ("string" == typeof a) i[X(a)] = t;
                            else
                                for (n in a) i[X(n)] = a[n];
                            return i
                        },
                        get: function(e, a) {
                            return void 0 === a ? this.cache(e) : e[this.expando] && e[this.expando][X(a)]
                        },
                        access: function(e, a, t) {
                            return void 0 === a || a && "string" == typeof a && void 0 === t ? this.get(e, a) : (this.set(e, a, t), void 0 !== t ? t : a)
                        },
                        remove: function(e, a) {
                            var t, n = e[this.expando];
                            if (void 0 !== n) {
                                if (void 0 !== a) {
                                    t = (a = Array.isArray(a) ? a.map(X) : (a = X(a)) in n ? [a] : a.match(R) || []).length;
                                    for (; t--;) delete n[a[t]]
                                }(void 0 === a || x.isEmptyObject(n)) && (e.nodeType ? e[this.expando] = void 0 : delete e[this.expando])
                            }
                        },
                        hasData: function(e) {
                            var a = e[this.expando];
                            return void 0 !== a && !x.isEmptyObject(a)
                        }
                    };
                    var Z = new U,
                        Q = new U,
                        ee = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
                        ae = /[A-Z]/g;

                    function te(e, a, t) {
                        var n;
                        if (void 0 === t && 1 === e.nodeType)
                            if (n = "data-" + a.replace(ae, "-$&").toLowerCase(), "string" == typeof(t = e.getAttribute(n))) {
                                try {
                                    t = function(e) {
                                        return "true" === e || "false" !== e && ("null" === e ? null : e === +e + "" ? +e : ee.test(e) ? JSON.parse(e) : e)
                                    }(t)
                                } catch (e) {}
                                Q.set(e, a, t)
                            } else t = void 0;
                        return t
                    }
                    x.extend({
                        hasData: function(e) {
                            return Q.hasData(e) || Z.hasData(e)
                        },
                        data: function(e, a, t) {
                            return Q.access(e, a, t)
                        },
                        removeData: function(e, a) {
                            Q.remove(e, a)
                        },
                        _data: function(e, a, t) {
                            return Z.access(e, a, t)
                        },
                        _removeData: function(e, a) {
                            Z.remove(e, a)
                        }
                    }), x.fn.extend({
                        data: function(e, a) {
                            var t, n, i, r = this[0],
                                s = r && r.attributes;
                            if (void 0 === e) {
                                if (this.length && (i = Q.get(r), 1 === r.nodeType && !Z.get(r, "hasDataAttrs"))) {
                                    for (t = s.length; t--;) s[t] && 0 === (n = s[t].name).indexOf("data-") && (n = X(n.slice(5)), te(r, n, i[n]));
                                    Z.set(r, "hasDataAttrs", !0)
                                }
                                return i
                            }
                            return "object" == typeof e ? this.each((function() {
                                Q.set(this, e)
                            })) : W(this, (function(a) {
                                var t;
                                if (r && void 0 === a) return void 0 !== (t = Q.get(r, e)) || void 0 !== (t = te(r, e)) ? t : void 0;
                                this.each((function() {
                                    Q.set(this, e, a)
                                }))
                            }), null, a, arguments.length > 1, null, !0)
                        },
                        removeData: function(e) {
                            return this.each((function() {
                                Q.remove(this, e)
                            }))
                        }
                    }), x.extend({
                        queue: function(e, a, t) {
                            var n;
                            if (e) return a = (a || "fx") + "queue", n = Z.get(e, a), t && (!n || Array.isArray(t) ? n = Z.access(e, a, x.makeArray(t)) : n.push(t)), n || []
                        },
                        dequeue: function(e, a) {
                            a = a || "fx";
                            var t = x.queue(e, a),
                                n = t.length,
                                i = t.shift(),
                                r = x._queueHooks(e, a);
                            "inprogress" === i && (i = t.shift(), n--), i && ("fx" === a && t.unshift("inprogress"), delete r.stop, i.call(e, (function() {
                                x.dequeue(e, a)
                            }), r)), !n && r && r.empty.fire()
                        },
                        _queueHooks: function(e, a) {
                            var t = a + "queueHooks";
                            return Z.get(e, t) || Z.access(e, t, {
                                empty: x.Callbacks("once memory").add((function() {
                                    Z.remove(e, [a + "queue", t])
                                }))
                            })
                        }
                    }), x.fn.extend({
                        queue: function(e, a) {
                            var t = 2;
                            return "string" != typeof e && (a = e, e = "fx", t--), arguments.length < t ? x.queue(this[0], e) : void 0 === a ? this : this.each((function() {
                                var t = x.queue(this, e, a);
                                x._queueHooks(this, e), "fx" === e && "inprogress" !== t[0] && x.dequeue(this, e)
                            }))
                        },
                        dequeue: function(e) {
                            return this.each((function() {
                                x.dequeue(this, e)
                            }))
                        },
                        clearQueue: function(e) {
                            return this.queue(e || "fx", [])
                        },
                        promise: function(e, a) {
                            var t, n = 1,
                                i = x.Deferred(),
                                r = this,
                                s = this.length,
                                o = function() {
                                    --n || i.resolveWith(r, [r])
                                };
                            for ("string" != typeof e && (a = e, e = void 0), e = e || "fx"; s--;)(t = Z.get(r[s], e + "queueHooks")) && t.empty && (n++, t.empty.add(o));
                            return o(), i.promise(a)
                        }
                    });
                    var ne = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
                        ie = new RegExp("^(?:([+-])=|)(" + ne + ")([a-z%]*)$", "i"),
                        re = ["Top", "Right", "Bottom", "Left"],
                        se = b.documentElement,
                        oe = function(e) {
                            return x.contains(e.ownerDocument, e)
                        },
                        le = {
                            composed: !0
                        };
                    se.getRootNode && (oe = function(e) {
                        return x.contains(e.ownerDocument, e) || e.getRootNode(le) === e.ownerDocument
                    });
                    var ue = function(e, a) {
                        return "none" === (e = a || e).style.display || "" === e.style.display && oe(e) && "none" === x.css(e, "display")
                    };

                    function de(e, a, t, n) {
                        var i, r, s = 20,
                            o = n ? function() {
                                return n.cur()
                            } : function() {
                                return x.css(e, a, "")
                            },
                            l = o(),
                            u = t && t[3] || (x.cssNumber[a] ? "" : "px"),
                            d = e.nodeType && (x.cssNumber[a] || "px" !== u && +l) && ie.exec(x.css(e, a));
                        if (d && d[3] !== u) {
                            for (l /= 2, u = u || d[3], d = +l || 1; s--;) x.style(e, a, d + u), (1 - r) * (1 - (r = o() / l || .5)) <= 0 && (s = 0), d /= r;
                            d *= 2, x.style(e, a, d + u), t = t || []
                        }
                        return t && (d = +d || +l || 0, i = t[1] ? d + (t[1] + 1) * t[2] : +t[2], n && (n.unit = u, n.start = d, n.end = i)), i
                    }
                    var ce = {};

                    function pe(e) {
                        var a, t = e.ownerDocument,
                            n = e.nodeName,
                            i = ce[n];
                        return i || (a = t.body.appendChild(t.createElement(n)), i = x.css(a, "display"), a.parentNode.removeChild(a), "none" === i && (i = "block"), ce[n] = i, i)
                    }

                    function he(e, a) {
                        for (var t, n, i = [], r = 0, s = e.length; r < s; r++)(n = e[r]).style && (t = n.style.display, a ? ("none" === t && (i[r] = Z.get(n, "display") || null, i[r] || (n.style.display = "")), "" === n.style.display && ue(n) && (i[r] = pe(n))) : "none" !== t && (i[r] = "none", Z.set(n, "display", t)));
                        for (r = 0; r < s; r++) null != i[r] && (e[r].style.display = i[r]);
                        return e
                    }
                    x.fn.extend({
                        show: function() {
                            return he(this, !0)
                        },
                        hide: function() {
                            return he(this)
                        },
                        toggle: function(e) {
                            return "boolean" == typeof e ? e ? this.show() : this.hide() : this.each((function() {
                                ue(this) ? x(this).show() : x(this).hide()
                            }))
                        }
                    });
                    var fe, me, ge = /^(?:checkbox|radio)$/i,
                        ve = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i,
                        ye = /^$|^module$|\/(?:java|ecma)script/i;
                    fe = b.createDocumentFragment().appendChild(b.createElement("div")), (me = b.createElement("input")).setAttribute("type", "radio"), me.setAttribute("checked", "checked"), me.setAttribute("name", "t"), fe.appendChild(me), g.checkClone = fe.cloneNode(!0).cloneNode(!0).lastChild.checked, fe.innerHTML = "<textarea>x</textarea>", g.noCloneChecked = !!fe.cloneNode(!0).lastChild.defaultValue, fe.innerHTML = "<option></option>", g.option = !!fe.lastChild;
                    var be = {
                        thead: [1, "<table>", "</table>"],
                        col: [2, "<table><colgroup>", "</colgroup></table>"],
                        tr: [2, "<table><tbody>", "</tbody></table>"],
                        td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
                        _default: [0, "", ""]
                    };

                    function Se(e, a) {
                        var t;
                        return t = void 0 !== e.getElementsByTagName ? e.getElementsByTagName(a || "*") : void 0 !== e.querySelectorAll ? e.querySelectorAll(a || "*") : [], void 0 === a || a && L(e, a) ? x.merge([e], t) : t
                    }

                    function we(e, a) {
                        for (var t = 0, n = e.length; t < n; t++) Z.set(e[t], "globalEval", !a || Z.get(a[t], "globalEval"))
                    }
                    be.tbody = be.tfoot = be.colgroup = be.caption = be.thead, be.th = be.td, g.option || (be.optgroup = be.option = [1, "<select multiple='multiple'>", "</select>"]);
                    var ke = /<|&#?\w+;/;

                    function Te(e, a, t, n, i) {
                        for (var r, s, o, l, u, d, c = a.createDocumentFragment(), p = [], h = 0, f = e.length; h < f; h++)
                            if ((r = e[h]) || 0 === r)
                                if ("object" === k(r)) x.merge(p, r.nodeType ? [r] : r);
                                else if (ke.test(r)) {
                            for (s = s || c.appendChild(a.createElement("div")), o = (ve.exec(r) || ["", ""])[1].toLowerCase(), l = be[o] || be._default, s.innerHTML = l[1] + x.htmlPrefilter(r) + l[2], d = l[0]; d--;) s = s.lastChild;
                            x.merge(p, s.childNodes), (s = c.firstChild).textContent = ""
                        } else p.push(a.createTextNode(r));
                        for (c.textContent = "", h = 0; r = p[h++];)
                            if (n && x.inArray(r, n) > -1) i && i.push(r);
                            else if (u = oe(r), s = Se(c.appendChild(r), "script"), u && we(s), t)
                            for (d = 0; r = s[d++];) ye.test(r.type || "") && t.push(r);
                        return c
                    }
                    var xe = /^([^.]*)(?:\.(.+)|)/;

                    function Ce() {
                        return !0
                    }

                    function Ee() {
                        return !1
                    }

                    function Me(e, a) {
                        return e === function() {
                            try {
                                return b.activeElement
                            } catch (e) {}
                        }() == ("focus" === a)
                    }

                    function Ae(e, a, t, n, i, r) {
                        var s, o;
                        if ("object" == typeof a) {
                            for (o in "string" != typeof t && (n = n || t, t = void 0), a) Ae(e, o, t, n, a[o], r);
                            return e
                        }
                        if (null == n && null == i ? (i = t, n = t = void 0) : null == i && ("string" == typeof t ? (i = n, n = void 0) : (i = n, n = t, t = void 0)), !1 === i) i = Ee;
                        else if (!i) return e;
                        return 1 === r && (s = i, i = function(e) {
                            return x().off(e), s.apply(this, arguments)
                        }, i.guid = s.guid || (s.guid = x.guid++)), e.each((function() {
                            x.event.add(this, a, i, n, t)
                        }))
                    }

                    function Pe(e, a, t) {
                        t ? (Z.set(e, a, !1), x.event.add(e, a, {
                            namespace: !1,
                            handler: function(e) {
                                var n, i, r = Z.get(this, a);
                                if (1 & e.isTrigger && this[a]) {
                                    if (r.length)(x.event.special[a] || {}).delegateType && e.stopPropagation();
                                    else if (r = o.call(arguments), Z.set(this, a, r), n = t(this, a), this[a](), r !== (i = Z.get(this, a)) || n ? Z.set(this, a, !1) : i = {}, r !== i) return e.stopImmediatePropagation(), e.preventDefault(), i && i.value
                                } else r.length && (Z.set(this, a, {
                                    value: x.event.trigger(x.extend(r[0], x.Event.prototype), r.slice(1), this)
                                }), e.stopImmediatePropagation())
                            }
                        })) : void 0 === Z.get(e, a) && x.event.add(e, a, Ce)
                    }
                    x.event = {
                        global: {},
                        add: function(e, a, t, n, i) {
                            var r, s, o, l, u, d, c, p, h, f, m, g = Z.get(e);
                            if (J(e))
                                for (t.handler && (t = (r = t).handler, i = r.selector), i && x.find.matchesSelector(se, i), t.guid || (t.guid = x.guid++), (l = g.events) || (l = g.events = Object.create(null)), (s = g.handle) || (s = g.handle = function(a) {
                                        return void 0 !== x && x.event.triggered !== a.type ? x.event.dispatch.apply(e, arguments) : void 0
                                    }), u = (a = (a || "").match(R) || [""]).length; u--;) h = m = (o = xe.exec(a[u]) || [])[1], f = (o[2] || "").split(".").sort(), h && (c = x.event.special[h] || {}, h = (i ? c.delegateType : c.bindType) || h, c = x.event.special[h] || {}, d = x.extend({
                                    type: h,
                                    origType: m,
                                    data: n,
                                    handler: t,
                                    guid: t.guid,
                                    selector: i,
                                    needsContext: i && x.expr.match.needsContext.test(i),
                                    namespace: f.join(".")
                                }, r), (p = l[h]) || ((p = l[h] = []).delegateCount = 0, c.setup && !1 !== c.setup.call(e, n, f, s) || e.addEventListener && e.addEventListener(h, s)), c.add && (c.add.call(e, d), d.handler.guid || (d.handler.guid = t.guid)), i ? p.splice(p.delegateCount++, 0, d) : p.push(d), x.event.global[h] = !0)
                        },
                        remove: function(e, a, t, n, i) {
                            var r, s, o, l, u, d, c, p, h, f, m, g = Z.hasData(e) && Z.get(e);
                            if (g && (l = g.events)) {
                                for (u = (a = (a || "").match(R) || [""]).length; u--;)
                                    if (h = m = (o = xe.exec(a[u]) || [])[1], f = (o[2] || "").split(".").sort(), h) {
                                        for (c = x.event.special[h] || {}, p = l[h = (n ? c.delegateType : c.bindType) || h] || [], o = o[2] && new RegExp("(^|\\.)" + f.join("\\.(?:.*\\.|)") + "(\\.|$)"), s = r = p.length; r--;) d = p[r], !i && m !== d.origType || t && t.guid !== d.guid || o && !o.test(d.namespace) || n && n !== d.selector && ("**" !== n || !d.selector) || (p.splice(r, 1), d.selector && p.delegateCount--, c.remove && c.remove.call(e, d));
                                        s && !p.length && (c.teardown && !1 !== c.teardown.call(e, f, g.handle) || x.removeEvent(e, h, g.handle), delete l[h])
                                    } else
                                        for (h in l) x.event.remove(e, h + a[u], t, n, !0);
                                x.isEmptyObject(l) && Z.remove(e, "handle events")
                            }
                        },
                        dispatch: function(e) {
                            var a, t, n, i, r, s, o = new Array(arguments.length),
                                l = x.event.fix(e),
                                u = (Z.get(this, "events") || Object.create(null))[l.type] || [],
                                d = x.event.special[l.type] || {};
                            for (o[0] = l, a = 1; a < arguments.length; a++) o[a] = arguments[a];
                            if (l.delegateTarget = this, !d.preDispatch || !1 !== d.preDispatch.call(this, l)) {
                                for (s = x.event.handlers.call(this, l, u), a = 0;
                                    (i = s[a++]) && !l.isPropagationStopped();)
                                    for (l.currentTarget = i.elem, t = 0;
                                        (r = i.handlers[t++]) && !l.isImmediatePropagationStopped();) l.rnamespace && !1 !== r.namespace && !l.rnamespace.test(r.namespace) || (l.handleObj = r, l.data = r.data, void 0 !== (n = ((x.event.special[r.origType] || {}).handle || r.handler).apply(i.elem, o)) && !1 === (l.result = n) && (l.preventDefault(), l.stopPropagation()));
                                return d.postDispatch && d.postDispatch.call(this, l), l.result
                            }
                        },
                        handlers: function(e, a) {
                            var t, n, i, r, s, o = [],
                                l = a.delegateCount,
                                u = e.target;
                            if (l && u.nodeType && !("click" === e.type && e.button >= 1))
                                for (; u !== this; u = u.parentNode || this)
                                    if (1 === u.nodeType && ("click" !== e.type || !0 !== u.disabled)) {
                                        for (r = [], s = {}, t = 0; t < l; t++) void 0 === s[i = (n = a[t]).selector + " "] && (s[i] = n.needsContext ? x(i, this).index(u) > -1 : x.find(i, this, null, [u]).length), s[i] && r.push(n);
                                        r.length && o.push({
                                            elem: u,
                                            handlers: r
                                        })
                                    } return u = this, l < a.length && o.push({
                                elem: u,
                                handlers: a.slice(l)
                            }), o
                        },
                        addProp: function(e, a) {
                            Object.defineProperty(x.Event.prototype, e, {
                                enumerable: !0,
                                configurable: !0,
                                get: v(a) ? function() {
                                    if (this.originalEvent) return a(this.originalEvent)
                                } : function() {
                                    if (this.originalEvent) return this.originalEvent[e]
                                },
                                set: function(a) {
                                    Object.defineProperty(this, e, {
                                        enumerable: !0,
                                        configurable: !0,
                                        writable: !0,
                                        value: a
                                    })
                                }
                            })
                        },
                        fix: function(e) {
                            return e[x.expando] ? e : new x.Event(e)
                        },
                        special: {
                            load: {
                                noBubble: !0
                            },
                            click: {
                                setup: function(e) {
                                    var a = this || e;
                                    return ge.test(a.type) && a.click && L(a, "input") && Pe(a, "click", Ce), !1
                                },
                                trigger: function(e) {
                                    var a = this || e;
                                    return ge.test(a.type) && a.click && L(a, "input") && Pe(a, "click"), !0
                                },
                                _default: function(e) {
                                    var a = e.target;
                                    return ge.test(a.type) && a.click && L(a, "input") && Z.get(a, "click") || L(a, "a")
                                }
                            },
                            beforeunload: {
                                postDispatch: function(e) {
                                    void 0 !== e.result && e.originalEvent && (e.originalEvent.returnValue = e.result)
                                }
                            }
                        }
                    }, x.removeEvent = function(e, a, t) {
                        e.removeEventListener && e.removeEventListener(a, t)
                    }, x.Event = function(e, a) {
                        if (!(this instanceof x.Event)) return new x.Event(e, a);
                        e && e.type ? (this.originalEvent = e, this.type = e.type, this.isDefaultPrevented = e.defaultPrevented || void 0 === e.defaultPrevented && !1 === e.returnValue ? Ce : Ee, this.target = e.target && 3 === e.target.nodeType ? e.target.parentNode : e.target, this.currentTarget = e.currentTarget, this.relatedTarget = e.relatedTarget) : this.type = e, a && x.extend(this, a), this.timeStamp = e && e.timeStamp || Date.now(), this[x.expando] = !0
                    }, x.Event.prototype = {
                        constructor: x.Event,
                        isDefaultPrevented: Ee,
                        isPropagationStopped: Ee,
                        isImmediatePropagationStopped: Ee,
                        isSimulated: !1,
                        preventDefault: function() {
                            var e = this.originalEvent;
                            this.isDefaultPrevented = Ce, e && !this.isSimulated && e.preventDefault()
                        },
                        stopPropagation: function() {
                            var e = this.originalEvent;
                            this.isPropagationStopped = Ce, e && !this.isSimulated && e.stopPropagation()
                        },
                        stopImmediatePropagation: function() {
                            var e = this.originalEvent;
                            this.isImmediatePropagationStopped = Ce, e && !this.isSimulated && e.stopImmediatePropagation(), this.stopPropagation()
                        }
                    }, x.each({
                        altKey: !0,
                        bubbles: !0,
                        cancelable: !0,
                        changedTouches: !0,
                        ctrlKey: !0,
                        detail: !0,
                        eventPhase: !0,
                        metaKey: !0,
                        pageX: !0,
                        pageY: !0,
                        shiftKey: !0,
                        view: !0,
                        char: !0,
                        code: !0,
                        charCode: !0,
                        key: !0,
                        keyCode: !0,
                        button: !0,
                        buttons: !0,
                        clientX: !0,
                        clientY: !0,
                        offsetX: !0,
                        offsetY: !0,
                        pointerId: !0,
                        pointerType: !0,
                        screenX: !0,
                        screenY: !0,
                        targetTouches: !0,
                        toElement: !0,
                        touches: !0,
                        which: !0
                    }, x.event.addProp), x.each({
                        focus: "focusin",
                        blur: "focusout"
                    }, (function(e, a) {
                        x.event.special[e] = {
                            setup: function() {
                                return Pe(this, e, Me), !1
                            },
                            trigger: function() {
                                return Pe(this, e), !0
                            },
                            _default: function(a) {
                                return Z.get(a.target, e)
                            },
                            delegateType: a
                        }
                    })), x.each({
                        mouseenter: "mouseover",
                        mouseleave: "mouseout",
                        pointerenter: "pointerover",
                        pointerleave: "pointerout"
                    }, (function(e, a) {
                        x.event.special[e] = {
                            delegateType: a,
                            bindType: a,
                            handle: function(e) {
                                var t, n = e.relatedTarget,
                                    i = e.handleObj;
                                return n && (n === this || x.contains(this, n)) || (e.type = i.origType, t = i.handler.apply(this, arguments), e.type = a), t
                            }
                        }
                    })), x.fn.extend({
                        on: function(e, a, t, n) {
                            return Ae(this, e, a, t, n)
                        },
                        one: function(e, a, t, n) {
                            return Ae(this, e, a, t, n, 1)
                        },
                        off: function(e, a, t) {
                            var n, i;
                            if (e && e.preventDefault && e.handleObj) return n = e.handleObj, x(e.delegateTarget).off(n.namespace ? n.origType + "." + n.namespace : n.origType, n.selector, n.handler), this;
                            if ("object" == typeof e) {
                                for (i in e) this.off(i, a, e[i]);
                                return this
                            }
                            return !1 !== a && "function" != typeof a || (t = a, a = void 0), !1 === t && (t = Ee), this.each((function() {
                                x.event.remove(this, e, t, a)
                            }))
                        }
                    });
                    var Le = /<script|<style|<link/i,
                        je = /checked\s*(?:[^=]|=\s*.checked.)/i,
                        Be = /^\s*<!\[CDATA\[|\]\]>\s*$/g;

                    function Ne(e, a) {
                        return L(e, "table") && L(11 !== a.nodeType ? a : a.firstChild, "tr") && x(e).children("tbody")[0] || e
                    }

                    function ze(e) {
                        return e.type = (null !== e.getAttribute("type")) + "/" + e.type, e
                    }

                    function De(e) {
                        return "true/" === (e.type || "").slice(0, 5) ? e.type = e.type.slice(5) : e.removeAttribute("type"), e
                    }

                    function Ie(e, a) {
                        var t, n, i, r, s, o;
                        if (1 === a.nodeType) {
                            if (Z.hasData(e) && (o = Z.get(e).events))
                                for (i in Z.remove(a, "handle events"), o)
                                    for (t = 0, n = o[i].length; t < n; t++) x.event.add(a, i, o[i][t]);
                            Q.hasData(e) && (r = Q.access(e), s = x.extend({}, r), Q.set(a, s))
                        }
                    }

                    function Oe(e, a) {
                        var t = a.nodeName.toLowerCase();
                        "input" === t && ge.test(e.type) ? a.checked = e.checked : "input" !== t && "textarea" !== t || (a.defaultValue = e.defaultValue)
                    }

                    function Re(e, a, t, n) {
                        a = l(a);
                        var i, r, s, o, u, d, c = 0,
                            p = e.length,
                            h = p - 1,
                            f = a[0],
                            m = v(f);
                        if (m || p > 1 && "string" == typeof f && !g.checkClone && je.test(f)) return e.each((function(i) {
                            var r = e.eq(i);
                            m && (a[0] = f.call(this, i, r.html())), Re(r, a, t, n)
                        }));
                        if (p && (r = (i = Te(a, e[0].ownerDocument, !1, e, n)).firstChild, 1 === i.childNodes.length && (i = r), r || n)) {
                            for (o = (s = x.map(Se(i, "script"), ze)).length; c < p; c++) u = i, c !== h && (u = x.clone(u, !0, !0), o && x.merge(s, Se(u, "script"))), t.call(e[c], u, c);
                            if (o)
                                for (d = s[s.length - 1].ownerDocument, x.map(s, De), c = 0; c < o; c++) u = s[c], ye.test(u.type || "") && !Z.access(u, "globalEval") && x.contains(d, u) && (u.src && "module" !== (u.type || "").toLowerCase() ? x._evalUrl && !u.noModule && x._evalUrl(u.src, {
                                    nonce: u.nonce || u.getAttribute("nonce")
                                }, d) : w(u.textContent.replace(Be, ""), u, d))
                        }
                        return e
                    }

                    function He(e, a, t) {
                        for (var n, i = a ? x.filter(a, e) : e, r = 0; null != (n = i[r]); r++) t || 1 !== n.nodeType || x.cleanData(Se(n)), n.parentNode && (t && oe(n) && we(Se(n, "script")), n.parentNode.removeChild(n));
                        return e
                    }
                    x.extend({
                        htmlPrefilter: function(e) {
                            return e
                        },
                        clone: function(e, a, t) {
                            var n, i, r, s, o = e.cloneNode(!0),
                                l = oe(e);
                            if (!(g.noCloneChecked || 1 !== e.nodeType && 11 !== e.nodeType || x.isXMLDoc(e)))
                                for (s = Se(o), n = 0, i = (r = Se(e)).length; n < i; n++) Oe(r[n], s[n]);
                            if (a)
                                if (t)
                                    for (r = r || Se(e), s = s || Se(o), n = 0, i = r.length; n < i; n++) Ie(r[n], s[n]);
                                else Ie(e, o);
                            return (s = Se(o, "script")).length > 0 && we(s, !l && Se(e, "script")), o
                        },
                        cleanData: function(e) {
                            for (var a, t, n, i = x.event.special, r = 0; void 0 !== (t = e[r]); r++)
                                if (J(t)) {
                                    if (a = t[Z.expando]) {
                                        if (a.events)
                                            for (n in a.events) i[n] ? x.event.remove(t, n) : x.removeEvent(t, n, a.handle);
                                        t[Z.expando] = void 0
                                    }
                                    t[Q.expando] && (t[Q.expando] = void 0)
                                }
                        }
                    }), x.fn.extend({
                        detach: function(e) {
                            return He(this, e, !0)
                        },
                        remove: function(e) {
                            return He(this, e)
                        },
                        text: function(e) {
                            return W(this, (function(e) {
                                return void 0 === e ? x.text(this) : this.empty().each((function() {
                                    1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || (this.textContent = e)
                                }))
                            }), null, e, arguments.length)
                        },
                        append: function() {
                            return Re(this, arguments, (function(e) {
                                1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType || Ne(this, e).appendChild(e)
                            }))
                        },
                        prepend: function() {
                            return Re(this, arguments, (function(e) {
                                if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                                    var a = Ne(this, e);
                                    a.insertBefore(e, a.firstChild)
                                }
                            }))
                        },
                        before: function() {
                            return Re(this, arguments, (function(e) {
                                this.parentNode && this.parentNode.insertBefore(e, this)
                            }))
                        },
                        after: function() {
                            return Re(this, arguments, (function(e) {
                                this.parentNode && this.parentNode.insertBefore(e, this.nextSibling)
                            }))
                        },
                        empty: function() {
                            for (var e, a = 0; null != (e = this[a]); a++) 1 === e.nodeType && (x.cleanData(Se(e, !1)), e.textContent = "");
                            return this
                        },
                        clone: function(e, a) {
                            return e = null != e && e, a = null == a ? e : a, this.map((function() {
                                return x.clone(this, e, a)
                            }))
                        },
                        html: function(e) {
                            return W(this, (function(e) {
                                var a = this[0] || {},
                                    t = 0,
                                    n = this.length;
                                if (void 0 === e && 1 === a.nodeType) return a.innerHTML;
                                if ("string" == typeof e && !Le.test(e) && !be[(ve.exec(e) || ["", ""])[1].toLowerCase()]) {
                                    e = x.htmlPrefilter(e);
                                    try {
                                        for (; t < n; t++) 1 === (a = this[t] || {}).nodeType && (x.cleanData(Se(a, !1)), a.innerHTML = e);
                                        a = 0
                                    } catch (e) {}
                                }
                                a && this.empty().append(e)
                            }), null, e, arguments.length)
                        },
                        replaceWith: function() {
                            var e = [];
                            return Re(this, arguments, (function(a) {
                                var t = this.parentNode;
                                x.inArray(this, e) < 0 && (x.cleanData(Se(this)), t && t.replaceChild(a, this))
                            }), e)
                        }
                    }), x.each({
                        appendTo: "append",
                        prependTo: "prepend",
                        insertBefore: "before",
                        insertAfter: "after",
                        replaceAll: "replaceWith"
                    }, (function(e, a) {
                        x.fn[e] = function(e) {
                            for (var t, n = [], i = x(e), r = i.length - 1, s = 0; s <= r; s++) t = s === r ? this : this.clone(!0), x(i[s])[a](t), u.apply(n, t.get());
                            return this.pushStack(n)
                        }
                    }));
                    var Ge = new RegExp("^(" + ne + ")(?!px)[a-z%]+$", "i"),
                        qe = /^--/,
                        Ke = function(e) {
                            var a = e.ownerDocument.defaultView;
                            return a && a.opener || (a = n), a.getComputedStyle(e)
                        },
                        $e = function(e, a, t) {
                            var n, i, r = {};
                            for (i in a) r[i] = e.style[i], e.style[i] = a[i];
                            for (i in n = t.call(e), a) e.style[i] = r[i];
                            return n
                        },
                        Ve = new RegExp(re.join("|"), "i"),
                        We = "[\\x20\\t\\r\\n\\f]",
                        Fe = new RegExp("^" + We + "+|((?:^|[^\\\\])(?:\\\\.)*)" + We + "+$", "g");

                    function _e(e, a, t) {
                        var n, i, r, s, o = qe.test(a),
                            l = e.style;
                        return (t = t || Ke(e)) && (s = t.getPropertyValue(a) || t[a], o && s && (s = s.replace(Fe, "$1") || void 0), "" !== s || oe(e) || (s = x.style(e, a)), !g.pixelBoxStyles() && Ge.test(s) && Ve.test(a) && (n = l.width, i = l.minWidth, r = l.maxWidth, l.minWidth = l.maxWidth = l.width = s, s = t.width, l.width = n, l.minWidth = i, l.maxWidth = r)), void 0 !== s ? s + "" : s
                    }

                    function Ye(e, a) {
                        return {
                            get: function() {
                                if (!e()) return (this.get = a).apply(this, arguments);
                                delete this.get
                            }
                        }
                    }! function() {
                        function e() {
                            if (d) {
                                u.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0", d.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%", se.appendChild(u).appendChild(d);
                                var e = n.getComputedStyle(d);
                                t = "1%" !== e.top, l = 12 === a(e.marginLeft), d.style.right = "60%", s = 36 === a(e.right), i = 36 === a(e.width), d.style.position = "absolute", r = 12 === a(d.offsetWidth / 3), se.removeChild(u), d = null
                            }
                        }

                        function a(e) {
                            return Math.round(parseFloat(e))
                        }
                        var t, i, r, s, o, l, u = b.createElement("div"),
                            d = b.createElement("div");
                        d.style && (d.style.backgroundClip = "content-box", d.cloneNode(!0).style.backgroundClip = "", g.clearCloneStyle = "content-box" === d.style.backgroundClip, x.extend(g, {
                            boxSizingReliable: function() {
                                return e(), i
                            },
                            pixelBoxStyles: function() {
                                return e(), s
                            },
                            pixelPosition: function() {
                                return e(), t
                            },
                            reliableMarginLeft: function() {
                                return e(), l
                            },
                            scrollboxSize: function() {
                                return e(), r
                            },
                            reliableTrDimensions: function() {
                                var e, a, t, i;
                                return null == o && (e = b.createElement("table"), a = b.createElement("tr"), t = b.createElement("div"), e.style.cssText = "position:absolute;left:-11111px;border-collapse:separate", a.style.cssText = "border:1px solid", a.style.height = "1px", t.style.height = "9px", t.style.display = "block", se.appendChild(e).appendChild(a).appendChild(t), i = n.getComputedStyle(a), o = parseInt(i.height, 10) + parseInt(i.borderTopWidth, 10) + parseInt(i.borderBottomWidth, 10) === a.offsetHeight, se.removeChild(e)), o
                            }
                        }))
                    }();
                    var Xe = ["Webkit", "Moz", "ms"],
                        Je = b.createElement("div").style,
                        Ue = {};

                    function Ze(e) {
                        var a = x.cssProps[e] || Ue[e];
                        return a || (e in Je ? e : Ue[e] = function(e) {
                            for (var a = e[0].toUpperCase() + e.slice(1), t = Xe.length; t--;)
                                if ((e = Xe[t] + a) in Je) return e
                        }(e) || e)
                    }
                    var Qe = /^(none|table(?!-c[ea]).+)/,
                        ea = {
                            position: "absolute",
                            visibility: "hidden",
                            display: "block"
                        },
                        aa = {
                            letterSpacing: "0",
                            fontWeight: "400"
                        };

                    function ta(e, a, t) {
                        var n = ie.exec(a);
                        return n ? Math.max(0, n[2] - (t || 0)) + (n[3] || "px") : a
                    }

                    function na(e, a, t, n, i, r) {
                        var s = "width" === a ? 1 : 0,
                            o = 0,
                            l = 0;
                        if (t === (n ? "border" : "content")) return 0;
                        for (; s < 4; s += 2) "margin" === t && (l += x.css(e, t + re[s], !0, i)), n ? ("content" === t && (l -= x.css(e, "padding" + re[s], !0, i)), "margin" !== t && (l -= x.css(e, "border" + re[s] + "Width", !0, i))) : (l += x.css(e, "padding" + re[s], !0, i), "padding" !== t ? l += x.css(e, "border" + re[s] + "Width", !0, i) : o += x.css(e, "border" + re[s] + "Width", !0, i));
                        return !n && r >= 0 && (l += Math.max(0, Math.ceil(e["offset" + a[0].toUpperCase() + a.slice(1)] - r - l - o - .5)) || 0), l
                    }

                    function ia(e, a, t) {
                        var n = Ke(e),
                            i = (!g.boxSizingReliable() || t) && "border-box" === x.css(e, "boxSizing", !1, n),
                            r = i,
                            s = _e(e, a, n),
                            o = "offset" + a[0].toUpperCase() + a.slice(1);
                        if (Ge.test(s)) {
                            if (!t) return s;
                            s = "auto"
                        }
                        return (!g.boxSizingReliable() && i || !g.reliableTrDimensions() && L(e, "tr") || "auto" === s || !parseFloat(s) && "inline" === x.css(e, "display", !1, n)) && e.getClientRects().length && (i = "border-box" === x.css(e, "boxSizing", !1, n), (r = o in e) && (s = e[o])), (s = parseFloat(s) || 0) + na(e, a, t || (i ? "border" : "content"), r, n, s) + "px"
                    }

                    function ra(e, a, t, n, i) {
                        return new ra.prototype.init(e, a, t, n, i)
                    }
                    x.extend({
                        cssHooks: {
                            opacity: {
                                get: function(e, a) {
                                    if (a) {
                                        var t = _e(e, "opacity");
                                        return "" === t ? "1" : t
                                    }
                                }
                            }
                        },
                        cssNumber: {
                            animationIterationCount: !0,
                            columnCount: !0,
                            fillOpacity: !0,
                            flexGrow: !0,
                            flexShrink: !0,
                            fontWeight: !0,
                            gridArea: !0,
                            gridColumn: !0,
                            gridColumnEnd: !0,
                            gridColumnStart: !0,
                            gridRow: !0,
                            gridRowEnd: !0,
                            gridRowStart: !0,
                            lineHeight: !0,
                            opacity: !0,
                            order: !0,
                            orphans: !0,
                            widows: !0,
                            zIndex: !0,
                            zoom: !0
                        },
                        cssProps: {},
                        style: function(e, a, t, n) {
                            if (e && 3 !== e.nodeType && 8 !== e.nodeType && e.style) {
                                var i, r, s, o = X(a),
                                    l = qe.test(a),
                                    u = e.style;
                                if (l || (a = Ze(o)), s = x.cssHooks[a] || x.cssHooks[o], void 0 === t) return s && "get" in s && void 0 !== (i = s.get(e, !1, n)) ? i : u[a];
                                "string" === (r = typeof t) && (i = ie.exec(t)) && i[1] && (t = de(e, a, i), r = "number"), null != t && t == t && ("number" !== r || l || (t += i && i[3] || (x.cssNumber[o] ? "" : "px")), g.clearCloneStyle || "" !== t || 0 !== a.indexOf("background") || (u[a] = "inherit"), s && "set" in s && void 0 === (t = s.set(e, t, n)) || (l ? u.setProperty(a, t) : u[a] = t))
                            }
                        },
                        css: function(e, a, t, n) {
                            var i, r, s, o = X(a);
                            return qe.test(a) || (a = Ze(o)), (s = x.cssHooks[a] || x.cssHooks[o]) && "get" in s && (i = s.get(e, !0, t)), void 0 === i && (i = _e(e, a, n)), "normal" === i && a in aa && (i = aa[a]), "" === t || t ? (r = parseFloat(i), !0 === t || isFinite(r) ? r || 0 : i) : i
                        }
                    }), x.each(["height", "width"], (function(e, a) {
                        x.cssHooks[a] = {
                            get: function(e, t, n) {
                                if (t) return !Qe.test(x.css(e, "display")) || e.getClientRects().length && e.getBoundingClientRect().width ? ia(e, a, n) : $e(e, ea, (function() {
                                    return ia(e, a, n)
                                }))
                            },
                            set: function(e, t, n) {
                                var i, r = Ke(e),
                                    s = !g.scrollboxSize() && "absolute" === r.position,
                                    o = (s || n) && "border-box" === x.css(e, "boxSizing", !1, r),
                                    l = n ? na(e, a, n, o, r) : 0;
                                return o && s && (l -= Math.ceil(e["offset" + a[0].toUpperCase() + a.slice(1)] - parseFloat(r[a]) - na(e, a, "border", !1, r) - .5)), l && (i = ie.exec(t)) && "px" !== (i[3] || "px") && (e.style[a] = t, t = x.css(e, a)), ta(0, t, l)
                            }
                        }
                    })), x.cssHooks.marginLeft = Ye(g.reliableMarginLeft, (function(e, a) {
                        if (a) return (parseFloat(_e(e, "marginLeft")) || e.getBoundingClientRect().left - $e(e, {
                            marginLeft: 0
                        }, (function() {
                            return e.getBoundingClientRect().left
                        }))) + "px"
                    })), x.each({
                        margin: "",
                        padding: "",
                        border: "Width"
                    }, (function(e, a) {
                        x.cssHooks[e + a] = {
                            expand: function(t) {
                                for (var n = 0, i = {}, r = "string" == typeof t ? t.split(" ") : [t]; n < 4; n++) i[e + re[n] + a] = r[n] || r[n - 2] || r[0];
                                return i
                            }
                        }, "margin" !== e && (x.cssHooks[e + a].set = ta)
                    })), x.fn.extend({
                        css: function(e, a) {
                            return W(this, (function(e, a, t) {
                                var n, i, r = {},
                                    s = 0;
                                if (Array.isArray(a)) {
                                    for (n = Ke(e), i = a.length; s < i; s++) r[a[s]] = x.css(e, a[s], !1, n);
                                    return r
                                }
                                return void 0 !== t ? x.style(e, a, t) : x.css(e, a)
                            }), e, a, arguments.length > 1)
                        }
                    }), x.Tween = ra, ra.prototype = {
                        constructor: ra,
                        init: function(e, a, t, n, i, r) {
                            this.elem = e, this.prop = t, this.easing = i || x.easing._default, this.options = a, this.start = this.now = this.cur(), this.end = n, this.unit = r || (x.cssNumber[t] ? "" : "px")
                        },
                        cur: function() {
                            var e = ra.propHooks[this.prop];
                            return e && e.get ? e.get(this) : ra.propHooks._default.get(this)
                        },
                        run: function(e) {
                            var a, t = ra.propHooks[this.prop];
                            return this.options.duration ? this.pos = a = x.easing[this.easing](e, this.options.duration * e, 0, 1, this.options.duration) : this.pos = a = e, this.now = (this.end - this.start) * a + this.start, this.options.step && this.options.step.call(this.elem, this.now, this), t && t.set ? t.set(this) : ra.propHooks._default.set(this), this
                        }
                    }, ra.prototype.init.prototype = ra.prototype, ra.propHooks = {
                        _default: {
                            get: function(e) {
                                var a;
                                return 1 !== e.elem.nodeType || null != e.elem[e.prop] && null == e.elem.style[e.prop] ? e.elem[e.prop] : (a = x.css(e.elem, e.prop, "")) && "auto" !== a ? a : 0
                            },
                            set: function(e) {
                                x.fx.step[e.prop] ? x.fx.step[e.prop](e) : 1 !== e.elem.nodeType || !x.cssHooks[e.prop] && null == e.elem.style[Ze(e.prop)] ? e.elem[e.prop] = e.now : x.style(e.elem, e.prop, e.now + e.unit)
                            }
                        }
                    }, ra.propHooks.scrollTop = ra.propHooks.scrollLeft = {
                        set: function(e) {
                            e.elem.nodeType && e.elem.parentNode && (e.elem[e.prop] = e.now)
                        }
                    }, x.easing = {
                        linear: function(e) {
                            return e
                        },
                        swing: function(e) {
                            return .5 - Math.cos(e * Math.PI) / 2
                        },
                        _default: "swing"
                    }, x.fx = ra.prototype.init, x.fx.step = {};
                    var sa, oa, la = /^(?:toggle|show|hide)$/,
                        ua = /queueHooks$/;

                    function da() {
                        oa && (!1 === b.hidden && n.requestAnimationFrame ? n.requestAnimationFrame(da) : n.setTimeout(da, x.fx.interval), x.fx.tick())
                    }

                    function ca() {
                        return n.setTimeout((function() {
                            sa = void 0
                        })), sa = Date.now()
                    }

                    function pa(e, a) {
                        var t, n = 0,
                            i = {
                                height: e
                            };
                        for (a = a ? 1 : 0; n < 4; n += 2 - a) i["margin" + (t = re[n])] = i["padding" + t] = e;
                        return a && (i.opacity = i.width = e), i
                    }

                    function ha(e, a, t) {
                        for (var n, i = (fa.tweeners[a] || []).concat(fa.tweeners["*"]), r = 0, s = i.length; r < s; r++)
                            if (n = i[r].call(t, a, e)) return n
                    }

                    function fa(e, a, t) {
                        var n, i, r = 0,
                            s = fa.prefilters.length,
                            o = x.Deferred().always((function() {
                                delete l.elem
                            })),
                            l = function() {
                                if (i) return !1;
                                for (var a = sa || ca(), t = Math.max(0, u.startTime + u.duration - a), n = 1 - (t / u.duration || 0), r = 0, s = u.tweens.length; r < s; r++) u.tweens[r].run(n);
                                return o.notifyWith(e, [u, n, t]), n < 1 && s ? t : (s || o.notifyWith(e, [u, 1, 0]), o.resolveWith(e, [u]), !1)
                            },
                            u = o.promise({
                                elem: e,
                                props: x.extend({}, a),
                                opts: x.extend(!0, {
                                    specialEasing: {},
                                    easing: x.easing._default
                                }, t),
                                originalProperties: a,
                                originalOptions: t,
                                startTime: sa || ca(),
                                duration: t.duration,
                                tweens: [],
                                createTween: function(a, t) {
                                    var n = x.Tween(e, u.opts, a, t, u.opts.specialEasing[a] || u.opts.easing);
                                    return u.tweens.push(n), n
                                },
                                stop: function(a) {
                                    var t = 0,
                                        n = a ? u.tweens.length : 0;
                                    if (i) return this;
                                    for (i = !0; t < n; t++) u.tweens[t].run(1);
                                    return a ? (o.notifyWith(e, [u, 1, 0]), o.resolveWith(e, [u, a])) : o.rejectWith(e, [u, a]), this
                                }
                            }),
                            d = u.props;
                        for (! function(e, a) {
                                var t, n, i, r, s;
                                for (t in e)
                                    if (i = a[n = X(t)], r = e[t], Array.isArray(r) && (i = r[1], r = e[t] = r[0]), t !== n && (e[n] = r, delete e[t]), (s = x.cssHooks[n]) && "expand" in s)
                                        for (t in r = s.expand(r), delete e[n], r) t in e || (e[t] = r[t], a[t] = i);
                                    else a[n] = i
                            }(d, u.opts.specialEasing); r < s; r++)
                            if (n = fa.prefilters[r].call(u, e, d, u.opts)) return v(n.stop) && (x._queueHooks(u.elem, u.opts.queue).stop = n.stop.bind(n)), n;
                        return x.map(d, ha, u), v(u.opts.start) && u.opts.start.call(e, u), u.progress(u.opts.progress).done(u.opts.done, u.opts.complete).fail(u.opts.fail).always(u.opts.always), x.fx.timer(x.extend(l, {
                            elem: e,
                            anim: u,
                            queue: u.opts.queue
                        })), u
                    }
                    x.Animation = x.extend(fa, {
                            tweeners: {
                                "*": [function(e, a) {
                                    var t = this.createTween(e, a);
                                    return de(t.elem, e, ie.exec(a), t), t
                                }]
                            },
                            tweener: function(e, a) {
                                v(e) ? (a = e, e = ["*"]) : e = e.match(R);
                                for (var t, n = 0, i = e.length; n < i; n++) t = e[n], fa.tweeners[t] = fa.tweeners[t] || [], fa.tweeners[t].unshift(a)
                            },
                            prefilters: [function(e, a, t) {
                                var n, i, r, s, o, l, u, d, c = "width" in a || "height" in a,
                                    p = this,
                                    h = {},
                                    f = e.style,
                                    m = e.nodeType && ue(e),
                                    g = Z.get(e, "fxshow");
                                for (n in t.queue || (null == (s = x._queueHooks(e, "fx")).unqueued && (s.unqueued = 0, o = s.empty.fire, s.empty.fire = function() {
                                        s.unqueued || o()
                                    }), s.unqueued++, p.always((function() {
                                        p.always((function() {
                                            s.unqueued--, x.queue(e, "fx").length || s.empty.fire()
                                        }))
                                    }))), a)
                                    if (i = a[n], la.test(i)) {
                                        if (delete a[n], r = r || "toggle" === i, i === (m ? "hide" : "show")) {
                                            if ("show" !== i || !g || void 0 === g[n]) continue;
                                            m = !0
                                        }
                                        h[n] = g && g[n] || x.style(e, n)
                                    } if ((l = !x.isEmptyObject(a)) || !x.isEmptyObject(h))
                                    for (n in c && 1 === e.nodeType && (t.overflow = [f.overflow, f.overflowX, f.overflowY], null == (u = g && g.display) && (u = Z.get(e, "display")), "none" === (d = x.css(e, "display")) && (u ? d = u : (he([e], !0), u = e.style.display || u, d = x.css(e, "display"), he([e]))), ("inline" === d || "inline-block" === d && null != u) && "none" === x.css(e, "float") && (l || (p.done((function() {
                                            f.display = u
                                        })), null == u && (d = f.display, u = "none" === d ? "" : d)), f.display = "inline-block")), t.overflow && (f.overflow = "hidden", p.always((function() {
                                            f.overflow = t.overflow[0], f.overflowX = t.overflow[1], f.overflowY = t.overflow[2]
                                        }))), l = !1, h) l || (g ? "hidden" in g && (m = g.hidden) : g = Z.access(e, "fxshow", {
                                        display: u
                                    }), r && (g.hidden = !m), m && he([e], !0), p.done((function() {
                                        for (n in m || he([e]), Z.remove(e, "fxshow"), h) x.style(e, n, h[n])
                                    }))), l = ha(m ? g[n] : 0, n, p), n in g || (g[n] = l.start, m && (l.end = l.start, l.start = 0))
                            }],
                            prefilter: function(e, a) {
                                a ? fa.prefilters.unshift(e) : fa.prefilters.push(e)
                            }
                        }), x.speed = function(e, a, t) {
                            var n = e && "object" == typeof e ? x.extend({}, e) : {
                                complete: t || !t && a || v(e) && e,
                                duration: e,
                                easing: t && a || a && !v(a) && a
                            };
                            return x.fx.off ? n.duration = 0 : "number" != typeof n.duration && (n.duration in x.fx.speeds ? n.duration = x.fx.speeds[n.duration] : n.duration = x.fx.speeds._default), null != n.queue && !0 !== n.queue || (n.queue = "fx"), n.old = n.complete, n.complete = function() {
                                v(n.old) && n.old.call(this), n.queue && x.dequeue(this, n.queue)
                            }, n
                        }, x.fn.extend({
                            fadeTo: function(e, a, t, n) {
                                return this.filter(ue).css("opacity", 0).show().end().animate({
                                    opacity: a
                                }, e, t, n)
                            },
                            animate: function(e, a, t, n) {
                                var i = x.isEmptyObject(e),
                                    r = x.speed(a, t, n),
                                    s = function() {
                                        var a = fa(this, x.extend({}, e), r);
                                        (i || Z.get(this, "finish")) && a.stop(!0)
                                    };
                                return s.finish = s, i || !1 === r.queue ? this.each(s) : this.queue(r.queue, s)
                            },
                            stop: function(e, a, t) {
                                var n = function(e) {
                                    var a = e.stop;
                                    delete e.stop, a(t)
                                };
                                return "string" != typeof e && (t = a, a = e, e = void 0), a && this.queue(e || "fx", []), this.each((function() {
                                    var a = !0,
                                        i = null != e && e + "queueHooks",
                                        r = x.timers,
                                        s = Z.get(this);
                                    if (i) s[i] && s[i].stop && n(s[i]);
                                    else
                                        for (i in s) s[i] && s[i].stop && ua.test(i) && n(s[i]);
                                    for (i = r.length; i--;) r[i].elem !== this || null != e && r[i].queue !== e || (r[i].anim.stop(t), a = !1, r.splice(i, 1));
                                    !a && t || x.dequeue(this, e)
                                }))
                            },
                            finish: function(e) {
                                return !1 !== e && (e = e || "fx"), this.each((function() {
                                    var a, t = Z.get(this),
                                        n = t[e + "queue"],
                                        i = t[e + "queueHooks"],
                                        r = x.timers,
                                        s = n ? n.length : 0;
                                    for (t.finish = !0, x.queue(this, e, []), i && i.stop && i.stop.call(this, !0), a = r.length; a--;) r[a].elem === this && r[a].queue === e && (r[a].anim.stop(!0), r.splice(a, 1));
                                    for (a = 0; a < s; a++) n[a] && n[a].finish && n[a].finish.call(this);
                                    delete t.finish
                                }))
                            }
                        }), x.each(["toggle", "show", "hide"], (function(e, a) {
                            var t = x.fn[a];
                            x.fn[a] = function(e, n, i) {
                                return null == e || "boolean" == typeof e ? t.apply(this, arguments) : this.animate(pa(a, !0), e, n, i)
                            }
                        })), x.each({
                            slideDown: pa("show"),
                            slideUp: pa("hide"),
                            slideToggle: pa("toggle"),
                            fadeIn: {
                                opacity: "show"
                            },
                            fadeOut: {
                                opacity: "hide"
                            },
                            fadeToggle: {
                                opacity: "toggle"
                            }
                        }, (function(e, a) {
                            x.fn[e] = function(e, t, n) {
                                return this.animate(a, e, t, n)
                            }
                        })), x.timers = [], x.fx.tick = function() {
                            var e, a = 0,
                                t = x.timers;
                            for (sa = Date.now(); a < t.length; a++)(e = t[a])() || t[a] !== e || t.splice(a--, 1);
                            t.length || x.fx.stop(), sa = void 0
                        }, x.fx.timer = function(e) {
                            x.timers.push(e), x.fx.start()
                        }, x.fx.interval = 13, x.fx.start = function() {
                            oa || (oa = !0, da())
                        }, x.fx.stop = function() {
                            oa = null
                        }, x.fx.speeds = {
                            slow: 600,
                            fast: 200,
                            _default: 400
                        }, x.fn.delay = function(e, a) {
                            return e = x.fx && x.fx.speeds[e] || e, a = a || "fx", this.queue(a, (function(a, t) {
                                var i = n.setTimeout(a, e);
                                t.stop = function() {
                                    n.clearTimeout(i)
                                }
                            }))
                        },
                        function() {
                            var e = b.createElement("input"),
                                a = b.createElement("select").appendChild(b.createElement("option"));
                            e.type = "checkbox", g.checkOn = "" !== e.value, g.optSelected = a.selected, (e = b.createElement("input")).value = "t", e.type = "radio", g.radioValue = "t" === e.value
                        }();
                    var ma, ga = x.expr.attrHandle;
                    x.fn.extend({
                        attr: function(e, a) {
                            return W(this, x.attr, e, a, arguments.length > 1)
                        },
                        removeAttr: function(e) {
                            return this.each((function() {
                                x.removeAttr(this, e)
                            }))
                        }
                    }), x.extend({
                        attr: function(e, a, t) {
                            var n, i, r = e.nodeType;
                            if (3 !== r && 8 !== r && 2 !== r) return void 0 === e.getAttribute ? x.prop(e, a, t) : (1 === r && x.isXMLDoc(e) || (i = x.attrHooks[a.toLowerCase()] || (x.expr.match.bool.test(a) ? ma : void 0)), void 0 !== t ? null === t ? void x.removeAttr(e, a) : i && "set" in i && void 0 !== (n = i.set(e, t, a)) ? n : (e.setAttribute(a, t + ""), t) : i && "get" in i && null !== (n = i.get(e, a)) ? n : null == (n = x.find.attr(e, a)) ? void 0 : n)
                        },
                        attrHooks: {
                            type: {
                                set: function(e, a) {
                                    if (!g.radioValue && "radio" === a && L(e, "input")) {
                                        var t = e.value;
                                        return e.setAttribute("type", a), t && (e.value = t), a
                                    }
                                }
                            }
                        },
                        removeAttr: function(e, a) {
                            var t, n = 0,
                                i = a && a.match(R);
                            if (i && 1 === e.nodeType)
                                for (; t = i[n++];) e.removeAttribute(t)
                        }
                    }), ma = {
                        set: function(e, a, t) {
                            return !1 === a ? x.removeAttr(e, t) : e.setAttribute(t, t), t
                        }
                    }, x.each(x.expr.match.bool.source.match(/\w+/g), (function(e, a) {
                        var t = ga[a] || x.find.attr;
                        ga[a] = function(e, a, n) {
                            var i, r, s = a.toLowerCase();
                            return n || (r = ga[s], ga[s] = i, i = null != t(e, a, n) ? s : null, ga[s] = r), i
                        }
                    }));
                    var va = /^(?:input|select|textarea|button)$/i,
                        ya = /^(?:a|area)$/i;

                    function ba(e) {
                        return (e.match(R) || []).join(" ")
                    }

                    function Sa(e) {
                        return e.getAttribute && e.getAttribute("class") || ""
                    }

                    function wa(e) {
                        return Array.isArray(e) ? e : "string" == typeof e && e.match(R) || []
                    }
                    x.fn.extend({
                        prop: function(e, a) {
                            return W(this, x.prop, e, a, arguments.length > 1)
                        },
                        removeProp: function(e) {
                            return this.each((function() {
                                delete this[x.propFix[e] || e]
                            }))
                        }
                    }), x.extend({
                        prop: function(e, a, t) {
                            var n, i, r = e.nodeType;
                            if (3 !== r && 8 !== r && 2 !== r) return 1 === r && x.isXMLDoc(e) || (a = x.propFix[a] || a, i = x.propHooks[a]), void 0 !== t ? i && "set" in i && void 0 !== (n = i.set(e, t, a)) ? n : e[a] = t : i && "get" in i && null !== (n = i.get(e, a)) ? n : e[a]
                        },
                        propHooks: {
                            tabIndex: {
                                get: function(e) {
                                    var a = x.find.attr(e, "tabindex");
                                    return a ? parseInt(a, 10) : va.test(e.nodeName) || ya.test(e.nodeName) && e.href ? 0 : -1
                                }
                            }
                        },
                        propFix: {
                            for: "htmlFor",
                            class: "className"
                        }
                    }), g.optSelected || (x.propHooks.selected = {
                        get: function(e) {
                            var a = e.parentNode;
                            return a && a.parentNode && a.parentNode.selectedIndex, null
                        },
                        set: function(e) {
                            var a = e.parentNode;
                            a && (a.selectedIndex, a.parentNode && a.parentNode.selectedIndex)
                        }
                    }), x.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], (function() {
                        x.propFix[this.toLowerCase()] = this
                    })), x.fn.extend({
                        addClass: function(e) {
                            var a, t, n, i, r, s;
                            return v(e) ? this.each((function(a) {
                                x(this).addClass(e.call(this, a, Sa(this)))
                            })) : (a = wa(e)).length ? this.each((function() {
                                if (n = Sa(this), t = 1 === this.nodeType && " " + ba(n) + " ") {
                                    for (r = 0; r < a.length; r++) i = a[r], t.indexOf(" " + i + " ") < 0 && (t += i + " ");
                                    s = ba(t), n !== s && this.setAttribute("class", s)
                                }
                            })) : this
                        },
                        removeClass: function(e) {
                            var a, t, n, i, r, s;
                            return v(e) ? this.each((function(a) {
                                x(this).removeClass(e.call(this, a, Sa(this)))
                            })) : arguments.length ? (a = wa(e)).length ? this.each((function() {
                                if (n = Sa(this), t = 1 === this.nodeType && " " + ba(n) + " ") {
                                    for (r = 0; r < a.length; r++)
                                        for (i = a[r]; t.indexOf(" " + i + " ") > -1;) t = t.replace(" " + i + " ", " ");
                                    s = ba(t), n !== s && this.setAttribute("class", s)
                                }
                            })) : this : this.attr("class", "")
                        },
                        toggleClass: function(e, a) {
                            var t, n, i, r, s = typeof e,
                                o = "string" === s || Array.isArray(e);
                            return v(e) ? this.each((function(t) {
                                x(this).toggleClass(e.call(this, t, Sa(this), a), a)
                            })) : "boolean" == typeof a && o ? a ? this.addClass(e) : this.removeClass(e) : (t = wa(e), this.each((function() {
                                if (o)
                                    for (r = x(this), i = 0; i < t.length; i++) n = t[i], r.hasClass(n) ? r.removeClass(n) : r.addClass(n);
                                else void 0 !== e && "boolean" !== s || ((n = Sa(this)) && Z.set(this, "__className__", n), this.setAttribute && this.setAttribute("class", n || !1 === e ? "" : Z.get(this, "__className__") || ""))
                            })))
                        },
                        hasClass: function(e) {
                            var a, t, n = 0;
                            for (a = " " + e + " "; t = this[n++];)
                                if (1 === t.nodeType && (" " + ba(Sa(t)) + " ").indexOf(a) > -1) return !0;
                            return !1
                        }
                    });
                    var ka = /\r/g;
                    x.fn.extend({
                        val: function(e) {
                            var a, t, n, i = this[0];
                            return arguments.length ? (n = v(e), this.each((function(t) {
                                var i;
                                1 === this.nodeType && (null == (i = n ? e.call(this, t, x(this).val()) : e) ? i = "" : "number" == typeof i ? i += "" : Array.isArray(i) && (i = x.map(i, (function(e) {
                                    return null == e ? "" : e + ""
                                }))), (a = x.valHooks[this.type] || x.valHooks[this.nodeName.toLowerCase()]) && "set" in a && void 0 !== a.set(this, i, "value") || (this.value = i))
                            }))) : i ? (a = x.valHooks[i.type] || x.valHooks[i.nodeName.toLowerCase()]) && "get" in a && void 0 !== (t = a.get(i, "value")) ? t : "string" == typeof(t = i.value) ? t.replace(ka, "") : null == t ? "" : t : void 0
                        }
                    }), x.extend({
                        valHooks: {
                            option: {
                                get: function(e) {
                                    var a = x.find.attr(e, "value");
                                    return null != a ? a : ba(x.text(e))
                                }
                            },
                            select: {
                                get: function(e) {
                                    var a, t, n, i = e.options,
                                        r = e.selectedIndex,
                                        s = "select-one" === e.type,
                                        o = s ? null : [],
                                        l = s ? r + 1 : i.length;
                                    for (n = r < 0 ? l : s ? r : 0; n < l; n++)
                                        if (((t = i[n]).selected || n === r) && !t.disabled && (!t.parentNode.disabled || !L(t.parentNode, "optgroup"))) {
                                            if (a = x(t).val(), s) return a;
                                            o.push(a)
                                        } return o
                                },
                                set: function(e, a) {
                                    for (var t, n, i = e.options, r = x.makeArray(a), s = i.length; s--;)((n = i[s]).selected = x.inArray(x.valHooks.option.get(n), r) > -1) && (t = !0);
                                    return t || (e.selectedIndex = -1), r
                                }
                            }
                        }
                    }), x.each(["radio", "checkbox"], (function() {
                        x.valHooks[this] = {
                            set: function(e, a) {
                                if (Array.isArray(a)) return e.checked = x.inArray(x(e).val(), a) > -1
                            }
                        }, g.checkOn || (x.valHooks[this].get = function(e) {
                            return null === e.getAttribute("value") ? "on" : e.value
                        })
                    })), g.focusin = "onfocusin" in n;
                    var Ta = /^(?:focusinfocus|focusoutblur)$/,
                        xa = function(e) {
                            e.stopPropagation()
                        };
                    x.extend(x.event, {
                        trigger: function(e, a, t, i) {
                            var r, s, o, l, u, d, c, p, f = [t || b],
                                m = h.call(e, "type") ? e.type : e,
                                g = h.call(e, "namespace") ? e.namespace.split(".") : [];
                            if (s = p = o = t = t || b, 3 !== t.nodeType && 8 !== t.nodeType && !Ta.test(m + x.event.triggered) && (m.indexOf(".") > -1 && (g = m.split("."), m = g.shift(), g.sort()), u = m.indexOf(":") < 0 && "on" + m, (e = e[x.expando] ? e : new x.Event(m, "object" == typeof e && e)).isTrigger = i ? 2 : 3, e.namespace = g.join("."), e.rnamespace = e.namespace ? new RegExp("(^|\\.)" + g.join("\\.(?:.*\\.|)") + "(\\.|$)") : null, e.result = void 0, e.target || (e.target = t), a = null == a ? [e] : x.makeArray(a, [e]), c = x.event.special[m] || {}, i || !c.trigger || !1 !== c.trigger.apply(t, a))) {
                                if (!i && !c.noBubble && !y(t)) {
                                    for (l = c.delegateType || m, Ta.test(l + m) || (s = s.parentNode); s; s = s.parentNode) f.push(s), o = s;
                                    o === (t.ownerDocument || b) && f.push(o.defaultView || o.parentWindow || n)
                                }
                                for (r = 0;
                                    (s = f[r++]) && !e.isPropagationStopped();) p = s, e.type = r > 1 ? l : c.bindType || m, (d = (Z.get(s, "events") || Object.create(null))[e.type] && Z.get(s, "handle")) && d.apply(s, a), (d = u && s[u]) && d.apply && J(s) && (e.result = d.apply(s, a), !1 === e.result && e.preventDefault());
                                return e.type = m, i || e.isDefaultPrevented() || c._default && !1 !== c._default.apply(f.pop(), a) || !J(t) || u && v(t[m]) && !y(t) && ((o = t[u]) && (t[u] = null), x.event.triggered = m, e.isPropagationStopped() && p.addEventListener(m, xa), t[m](), e.isPropagationStopped() && p.removeEventListener(m, xa), x.event.triggered = void 0, o && (t[u] = o)), e.result
                            }
                        },
                        simulate: function(e, a, t) {
                            var n = x.extend(new x.Event, t, {
                                type: e,
                                isSimulated: !0
                            });
                            x.event.trigger(n, null, a)
                        }
                    }), x.fn.extend({
                        trigger: function(e, a) {
                            return this.each((function() {
                                x.event.trigger(e, a, this)
                            }))
                        },
                        triggerHandler: function(e, a) {
                            var t = this[0];
                            if (t) return x.event.trigger(e, a, t, !0)
                        }
                    }), g.focusin || x.each({
                        focus: "focusin",
                        blur: "focusout"
                    }, (function(e, a) {
                        var t = function(e) {
                            x.event.simulate(a, e.target, x.event.fix(e))
                        };
                        x.event.special[a] = {
                            setup: function() {
                                var n = this.ownerDocument || this.document || this,
                                    i = Z.access(n, a);
                                i || n.addEventListener(e, t, !0), Z.access(n, a, (i || 0) + 1)
                            },
                            teardown: function() {
                                var n = this.ownerDocument || this.document || this,
                                    i = Z.access(n, a) - 1;
                                i ? Z.access(n, a, i) : (n.removeEventListener(e, t, !0), Z.remove(n, a))
                            }
                        }
                    }));
                    var Ca = n.location,
                        Ea = {
                            guid: Date.now()
                        },
                        Ma = /\?/;
                    x.parseXML = function(e) {
                        var a, t;
                        if (!e || "string" != typeof e) return null;
                        try {
                            a = (new n.DOMParser).parseFromString(e, "text/xml")
                        } catch (e) {}
                        return t = a && a.getElementsByTagName("parsererror")[0], a && !t || x.error("Invalid XML: " + (t ? x.map(t.childNodes, (function(e) {
                            return e.textContent
                        })).join("\n") : e)), a
                    };
                    var Aa = /\[\]$/,
                        Pa = /\r?\n/g,
                        La = /^(?:submit|button|image|reset|file)$/i,
                        ja = /^(?:input|select|textarea|keygen)/i;

                    function Ba(e, a, t, n) {
                        var i;
                        if (Array.isArray(a)) x.each(a, (function(a, i) {
                            t || Aa.test(e) ? n(e, i) : Ba(e + "[" + ("object" == typeof i && null != i ? a : "") + "]", i, t, n)
                        }));
                        else if (t || "object" !== k(a)) n(e, a);
                        else
                            for (i in a) Ba(e + "[" + i + "]", a[i], t, n)
                    }
                    x.param = function(e, a) {
                        var t, n = [],
                            i = function(e, a) {
                                var t = v(a) ? a() : a;
                                n[n.length] = encodeURIComponent(e) + "=" + encodeURIComponent(null == t ? "" : t)
                            };
                        if (null == e) return "";
                        if (Array.isArray(e) || e.jquery && !x.isPlainObject(e)) x.each(e, (function() {
                            i(this.name, this.value)
                        }));
                        else
                            for (t in e) Ba(t, e[t], a, i);
                        return n.join("&")
                    }, x.fn.extend({
                        serialize: function() {
                            return x.param(this.serializeArray())
                        },
                        serializeArray: function() {
                            return this.map((function() {
                                var e = x.prop(this, "elements");
                                return e ? x.makeArray(e) : this
                            })).filter((function() {
                                var e = this.type;
                                return this.name && !x(this).is(":disabled") && ja.test(this.nodeName) && !La.test(e) && (this.checked || !ge.test(e))
                            })).map((function(e, a) {
                                var t = x(this).val();
                                return null == t ? null : Array.isArray(t) ? x.map(t, (function(e) {
                                    return {
                                        name: a.name,
                                        value: e.replace(Pa, "\r\n")
                                    }
                                })) : {
                                    name: a.name,
                                    value: t.replace(Pa, "\r\n")
                                }
                            })).get()
                        }
                    });
                    var Na = /%20/g,
                        za = /#.*$/,
                        Da = /([?&])_=[^&]*/,
                        Ia = /^(.*?):[ \t]*([^\r\n]*)$/gm,
                        Oa = /^(?:GET|HEAD)$/,
                        Ra = /^\/\//,
                        Ha = {},
                        Ga = {},
                        qa = "*/".concat("*"),
                        Ka = b.createElement("a");

                    function $a(e) {
                        return function(a, t) {
                            "string" != typeof a && (t = a, a = "*");
                            var n, i = 0,
                                r = a.toLowerCase().match(R) || [];
                            if (v(t))
                                for (; n = r[i++];) "+" === n[0] ? (n = n.slice(1) || "*", (e[n] = e[n] || []).unshift(t)) : (e[n] = e[n] || []).push(t)
                        }
                    }

                    function Va(e, a, t, n) {
                        var i = {},
                            r = e === Ga;

                        function s(o) {
                            var l;
                            return i[o] = !0, x.each(e[o] || [], (function(e, o) {
                                var u = o(a, t, n);
                                return "string" != typeof u || r || i[u] ? r ? !(l = u) : void 0 : (a.dataTypes.unshift(u), s(u), !1)
                            })), l
                        }
                        return s(a.dataTypes[0]) || !i["*"] && s("*")
                    }

                    function Wa(e, a) {
                        var t, n, i = x.ajaxSettings.flatOptions || {};
                        for (t in a) void 0 !== a[t] && ((i[t] ? e : n || (n = {}))[t] = a[t]);
                        return n && x.extend(!0, e, n), e
                    }
                    Ka.href = Ca.href, x.extend({
                        active: 0,
                        lastModified: {},
                        etag: {},
                        ajaxSettings: {
                            url: Ca.href,
                            type: "GET",
                            isLocal: /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(Ca.protocol),
                            global: !0,
                            processData: !0,
                            async: !0,
                            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
                            accepts: {
                                "*": qa,
                                text: "text/plain",
                                html: "text/html",
                                xml: "application/xml, text/xml",
                                json: "application/json, text/javascript"
                            },
                            contents: {
                                xml: /\bxml\b/,
                                html: /\bhtml/,
                                json: /\bjson\b/
                            },
                            responseFields: {
                                xml: "responseXML",
                                text: "responseText",
                                json: "responseJSON"
                            },
                            converters: {
                                "* text": String,
                                "text html": !0,
                                "text json": JSON.parse,
                                "text xml": x.parseXML
                            },
                            flatOptions: {
                                url: !0,
                                context: !0
                            }
                        },
                        ajaxSetup: function(e, a) {
                            return a ? Wa(Wa(e, x.ajaxSettings), a) : Wa(x.ajaxSettings, e)
                        },
                        ajaxPrefilter: $a(Ha),
                        ajaxTransport: $a(Ga),
                        ajax: function(e, a) {
                            "object" == typeof e && (a = e, e = void 0), a = a || {};
                            var t, i, r, s, o, l, u, d, c, p, h = x.ajaxSetup({}, a),
                                f = h.context || h,
                                m = h.context && (f.nodeType || f.jquery) ? x(f) : x.event,
                                g = x.Deferred(),
                                v = x.Callbacks("once memory"),
                                y = h.statusCode || {},
                                S = {},
                                w = {},
                                k = "canceled",
                                T = {
                                    readyState: 0,
                                    getResponseHeader: function(e) {
                                        var a;
                                        if (u) {
                                            if (!s)
                                                for (s = {}; a = Ia.exec(r);) s[a[1].toLowerCase() + " "] = (s[a[1].toLowerCase() + " "] || []).concat(a[2]);
                                            a = s[e.toLowerCase() + " "]
                                        }
                                        return null == a ? null : a.join(", ")
                                    },
                                    getAllResponseHeaders: function() {
                                        return u ? r : null
                                    },
                                    setRequestHeader: function(e, a) {
                                        return null == u && (e = w[e.toLowerCase()] = w[e.toLowerCase()] || e, S[e] = a), this
                                    },
                                    overrideMimeType: function(e) {
                                        return null == u && (h.mimeType = e), this
                                    },
                                    statusCode: function(e) {
                                        var a;
                                        if (e)
                                            if (u) T.always(e[T.status]);
                                            else
                                                for (a in e) y[a] = [y[a], e[a]];
                                        return this
                                    },
                                    abort: function(e) {
                                        var a = e || k;
                                        return t && t.abort(a), C(0, a), this
                                    }
                                };
                            if (g.promise(T), h.url = ((e || h.url || Ca.href) + "").replace(Ra, Ca.protocol + "//"), h.type = a.method || a.type || h.method || h.type, h.dataTypes = (h.dataType || "*").toLowerCase().match(R) || [""], null == h.crossDomain) {
                                l = b.createElement("a");
                                try {
                                    l.href = h.url, l.href = l.href, h.crossDomain = Ka.protocol + "//" + Ka.host != l.protocol + "//" + l.host
                                } catch (e) {
                                    h.crossDomain = !0
                                }
                            }
                            if (h.data && h.processData && "string" != typeof h.data && (h.data = x.param(h.data, h.traditional)), Va(Ha, h, a, T), u) return T;
                            for (c in (d = x.event && h.global) && 0 == x.active++ && x.event.trigger("ajaxStart"), h.type = h.type.toUpperCase(), h.hasContent = !Oa.test(h.type), i = h.url.replace(za, ""), h.hasContent ? h.data && h.processData && 0 === (h.contentType || "").indexOf("application/x-www-form-urlencoded") && (h.data = h.data.replace(Na, "+")) : (p = h.url.slice(i.length), h.data && (h.processData || "string" == typeof h.data) && (i += (Ma.test(i) ? "&" : "?") + h.data, delete h.data), !1 === h.cache && (i = i.replace(Da, "$1"), p = (Ma.test(i) ? "&" : "?") + "_=" + Ea.guid++ + p), h.url = i + p), h.ifModified && (x.lastModified[i] && T.setRequestHeader("If-Modified-Since", x.lastModified[i]), x.etag[i] && T.setRequestHeader("If-None-Match", x.etag[i])), (h.data && h.hasContent && !1 !== h.contentType || a.contentType) && T.setRequestHeader("Content-Type", h.contentType), T.setRequestHeader("Accept", h.dataTypes[0] && h.accepts[h.dataTypes[0]] ? h.accepts[h.dataTypes[0]] + ("*" !== h.dataTypes[0] ? ", " + qa + "; q=0.01" : "") : h.accepts["*"]), h.headers) T.setRequestHeader(c, h.headers[c]);
                            if (h.beforeSend && (!1 === h.beforeSend.call(f, T, h) || u)) return T.abort();
                            if (k = "abort", v.add(h.complete), T.done(h.success), T.fail(h.error), t = Va(Ga, h, a, T)) {
                                if (T.readyState = 1, d && m.trigger("ajaxSend", [T, h]), u) return T;
                                h.async && h.timeout > 0 && (o = n.setTimeout((function() {
                                    T.abort("timeout")
                                }), h.timeout));
                                try {
                                    u = !1, t.send(S, C)
                                } catch (e) {
                                    if (u) throw e;
                                    C(-1, e)
                                }
                            } else C(-1, "No Transport");

                            function C(e, a, s, l) {
                                var c, p, b, S, w, k = a;
                                u || (u = !0, o && n.clearTimeout(o), t = void 0, r = l || "", T.readyState = e > 0 ? 4 : 0, c = e >= 200 && e < 300 || 304 === e, s && (S = function(e, a, t) {
                                    for (var n, i, r, s, o = e.contents, l = e.dataTypes;
                                        "*" === l[0];) l.shift(), void 0 === n && (n = e.mimeType || a.getResponseHeader("Content-Type"));
                                    if (n)
                                        for (i in o)
                                            if (o[i] && o[i].test(n)) {
                                                l.unshift(i);
                                                break
                                            } if (l[0] in t) r = l[0];
                                    else {
                                        for (i in t) {
                                            if (!l[0] || e.converters[i + " " + l[0]]) {
                                                r = i;
                                                break
                                            }
                                            s || (s = i)
                                        }
                                        r = r || s
                                    }
                                    if (r) return r !== l[0] && l.unshift(r), t[r]
                                }(h, T, s)), !c && x.inArray("script", h.dataTypes) > -1 && x.inArray("json", h.dataTypes) < 0 && (h.converters["text script"] = function() {}), S = function(e, a, t, n) {
                                    var i, r, s, o, l, u = {},
                                        d = e.dataTypes.slice();
                                    if (d[1])
                                        for (s in e.converters) u[s.toLowerCase()] = e.converters[s];
                                    for (r = d.shift(); r;)
                                        if (e.responseFields[r] && (t[e.responseFields[r]] = a), !l && n && e.dataFilter && (a = e.dataFilter(a, e.dataType)), l = r, r = d.shift())
                                            if ("*" === r) r = l;
                                            else if ("*" !== l && l !== r) {
                                        if (!(s = u[l + " " + r] || u["* " + r]))
                                            for (i in u)
                                                if ((o = i.split(" "))[1] === r && (s = u[l + " " + o[0]] || u["* " + o[0]])) {
                                                    !0 === s ? s = u[i] : !0 !== u[i] && (r = o[0], d.unshift(o[1]));
                                                    break
                                                } if (!0 !== s)
                                            if (s && e.throws) a = s(a);
                                            else try {
                                                a = s(a)
                                            } catch (e) {
                                                return {
                                                    state: "parsererror",
                                                    error: s ? e : "No conversion from " + l + " to " + r
                                                }
                                            }
                                    }
                                    return {
                                        state: "success",
                                        data: a
                                    }
                                }(h, S, T, c), c ? (h.ifModified && ((w = T.getResponseHeader("Last-Modified")) && (x.lastModified[i] = w), (w = T.getResponseHeader("etag")) && (x.etag[i] = w)), 204 === e || "HEAD" === h.type ? k = "nocontent" : 304 === e ? k = "notmodified" : (k = S.state, p = S.data, c = !(b = S.error))) : (b = k, !e && k || (k = "error", e < 0 && (e = 0))), T.status = e, T.statusText = (a || k) + "", c ? g.resolveWith(f, [p, k, T]) : g.rejectWith(f, [T, k, b]), T.statusCode(y), y = void 0, d && m.trigger(c ? "ajaxSuccess" : "ajaxError", [T, h, c ? p : b]), v.fireWith(f, [T, k]), d && (m.trigger("ajaxComplete", [T, h]), --x.active || x.event.trigger("ajaxStop")))
                            }
                            return T
                        },
                        getJSON: function(e, a, t) {
                            return x.get(e, a, t, "json")
                        },
                        getScript: function(e, a) {
                            return x.get(e, void 0, a, "script")
                        }
                    }), x.each(["get", "post"], (function(e, a) {
                        x[a] = function(e, t, n, i) {
                            return v(t) && (i = i || n, n = t, t = void 0), x.ajax(x.extend({
                                url: e,
                                type: a,
                                dataType: i,
                                data: t,
                                success: n
                            }, x.isPlainObject(e) && e))
                        }
                    })), x.ajaxPrefilter((function(e) {
                        var a;
                        for (a in e.headers) "content-type" === a.toLowerCase() && (e.contentType = e.headers[a] || "")
                    })), x._evalUrl = function(e, a, t) {
                        return x.ajax({
                            url: e,
                            type: "GET",
                            dataType: "script",
                            cache: !0,
                            async: !1,
                            global: !1,
                            converters: {
                                "text script": function() {}
                            },
                            dataFilter: function(e) {
                                x.globalEval(e, a, t)
                            }
                        })
                    }, x.fn.extend({
                        wrapAll: function(e) {
                            var a;
                            return this[0] && (v(e) && (e = e.call(this[0])), a = x(e, this[0].ownerDocument).eq(0).clone(!0), this[0].parentNode && a.insertBefore(this[0]), a.map((function() {
                                for (var e = this; e.firstElementChild;) e = e.firstElementChild;
                                return e
                            })).append(this)), this
                        },
                        wrapInner: function(e) {
                            return v(e) ? this.each((function(a) {
                                x(this).wrapInner(e.call(this, a))
                            })) : this.each((function() {
                                var a = x(this),
                                    t = a.contents();
                                t.length ? t.wrapAll(e) : a.append(e)
                            }))
                        },
                        wrap: function(e) {
                            var a = v(e);
                            return this.each((function(t) {
                                x(this).wrapAll(a ? e.call(this, t) : e)
                            }))
                        },
                        unwrap: function(e) {
                            return this.parent(e).not("body").each((function() {
                                x(this).replaceWith(this.childNodes)
                            })), this
                        }
                    }), x.expr.pseudos.hidden = function(e) {
                        return !x.expr.pseudos.visible(e)
                    }, x.expr.pseudos.visible = function(e) {
                        return !!(e.offsetWidth || e.offsetHeight || e.getClientRects().length)
                    }, x.ajaxSettings.xhr = function() {
                        try {
                            return new n.XMLHttpRequest
                        } catch (e) {}
                    };
                    var Fa = {
                            0: 200,
                            1223: 204
                        },
                        _a = x.ajaxSettings.xhr();
                    g.cors = !!_a && "withCredentials" in _a, g.ajax = _a = !!_a, x.ajaxTransport((function(e) {
                        var a, t;
                        if (g.cors || _a && !e.crossDomain) return {
                            send: function(i, r) {
                                var s, o = e.xhr();
                                if (o.open(e.type, e.url, e.async, e.username, e.password), e.xhrFields)
                                    for (s in e.xhrFields) o[s] = e.xhrFields[s];
                                for (s in e.mimeType && o.overrideMimeType && o.overrideMimeType(e.mimeType), e.crossDomain || i["X-Requested-With"] || (i["X-Requested-With"] = "XMLHttpRequest"), i) o.setRequestHeader(s, i[s]);
                                a = function(e) {
                                    return function() {
                                        a && (a = t = o.onload = o.onerror = o.onabort = o.ontimeout = o.onreadystatechange = null, "abort" === e ? o.abort() : "error" === e ? "number" != typeof o.status ? r(0, "error") : r(o.status, o.statusText) : r(Fa[o.status] || o.status, o.statusText, "text" !== (o.responseType || "text") || "string" != typeof o.responseText ? {
                                            binary: o.response
                                        } : {
                                            text: o.responseText
                                        }, o.getAllResponseHeaders()))
                                    }
                                }, o.onload = a(), t = o.onerror = o.ontimeout = a("error"), void 0 !== o.onabort ? o.onabort = t : o.onreadystatechange = function() {
                                    4 === o.readyState && n.setTimeout((function() {
                                        a && t()
                                    }))
                                }, a = a("abort");
                                try {
                                    o.send(e.hasContent && e.data || null)
                                } catch (e) {
                                    if (a) throw e
                                }
                            },
                            abort: function() {
                                a && a()
                            }
                        }
                    })), x.ajaxPrefilter((function(e) {
                        e.crossDomain && (e.contents.script = !1)
                    })), x.ajaxSetup({
                        accepts: {
                            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
                        },
                        contents: {
                            script: /\b(?:java|ecma)script\b/
                        },
                        converters: {
                            "text script": function(e) {
                                return x.globalEval(e), e
                            }
                        }
                    }), x.ajaxPrefilter("script", (function(e) {
                        void 0 === e.cache && (e.cache = !1), e.crossDomain && (e.type = "GET")
                    })), x.ajaxTransport("script", (function(e) {
                        var a, t;
                        if (e.crossDomain || e.scriptAttrs) return {
                            send: function(n, i) {
                                a = x("<script>").attr(e.scriptAttrs || {}).prop({
                                    charset: e.scriptCharset,
                                    src: e.url
                                }).on("load error", t = function(e) {
                                    a.remove(), t = null, e && i("error" === e.type ? 404 : 200, e.type)
                                }), b.head.appendChild(a[0])
                            },
                            abort: function() {
                                t && t()
                            }
                        }
                    }));
                    var Ya, Xa = [],
                        Ja = /(=)\?(?=&|$)|\?\?/;
                    x.ajaxSetup({
                        jsonp: "callback",
                        jsonpCallback: function() {
                            var e = Xa.pop() || x.expando + "_" + Ea.guid++;
                            return this[e] = !0, e
                        }
                    }), x.ajaxPrefilter("json jsonp", (function(e, a, t) {
                        var i, r, s, o = !1 !== e.jsonp && (Ja.test(e.url) ? "url" : "string" == typeof e.data && 0 === (e.contentType || "").indexOf("application/x-www-form-urlencoded") && Ja.test(e.data) && "data");
                        if (o || "jsonp" === e.dataTypes[0]) return i = e.jsonpCallback = v(e.jsonpCallback) ? e.jsonpCallback() : e.jsonpCallback, o ? e[o] = e[o].replace(Ja, "$1" + i) : !1 !== e.jsonp && (e.url += (Ma.test(e.url) ? "&" : "?") + e.jsonp + "=" + i), e.converters["script json"] = function() {
                            return s || x.error(i + " was not called"), s[0]
                        }, e.dataTypes[0] = "json", r = n[i], n[i] = function() {
                            s = arguments
                        }, t.always((function() {
                            void 0 === r ? x(n).removeProp(i) : n[i] = r, e[i] && (e.jsonpCallback = a.jsonpCallback, Xa.push(i)), s && v(r) && r(s[0]), s = r = void 0
                        })), "script"
                    })), g.createHTMLDocument = ((Ya = b.implementation.createHTMLDocument("").body).innerHTML = "<form></form><form></form>", 2 === Ya.childNodes.length), x.parseHTML = function(e, a, t) {
                        return "string" != typeof e ? [] : ("boolean" == typeof a && (t = a, a = !1), a || (g.createHTMLDocument ? ((n = (a = b.implementation.createHTMLDocument("")).createElement("base")).href = b.location.href, a.head.appendChild(n)) : a = b), r = !t && [], (i = j.exec(e)) ? [a.createElement(i[1])] : (i = Te([e], a, r), r && r.length && x(r).remove(), x.merge([], i.childNodes)));
                        var n, i, r
                    }, x.fn.load = function(e, a, t) {
                        var n, i, r, s = this,
                            o = e.indexOf(" ");
                        return o > -1 && (n = ba(e.slice(o)), e = e.slice(0, o)), v(a) ? (t = a, a = void 0) : a && "object" == typeof a && (i = "POST"), s.length > 0 && x.ajax({
                            url: e,
                            type: i || "GET",
                            dataType: "html",
                            data: a
                        }).done((function(e) {
                            r = arguments, s.html(n ? x("<div>").append(x.parseHTML(e)).find(n) : e)
                        })).always(t && function(e, a) {
                            s.each((function() {
                                t.apply(this, r || [e.responseText, a, e])
                            }))
                        }), this
                    }, x.expr.pseudos.animated = function(e) {
                        return x.grep(x.timers, (function(a) {
                            return e === a.elem
                        })).length
                    }, x.offset = {
                        setOffset: function(e, a, t) {
                            var n, i, r, s, o, l, u = x.css(e, "position"),
                                d = x(e),
                                c = {};
                            "static" === u && (e.style.position = "relative"), o = d.offset(), r = x.css(e, "top"), l = x.css(e, "left"), ("absolute" === u || "fixed" === u) && (r + l).indexOf("auto") > -1 ? (s = (n = d.position()).top, i = n.left) : (s = parseFloat(r) || 0, i = parseFloat(l) || 0), v(a) && (a = a.call(e, t, x.extend({}, o))), null != a.top && (c.top = a.top - o.top + s), null != a.left && (c.left = a.left - o.left + i), "using" in a ? a.using.call(e, c) : d.css(c)
                        }
                    }, x.fn.extend({
                        offset: function(e) {
                            if (arguments.length) return void 0 === e ? this : this.each((function(a) {
                                x.offset.setOffset(this, e, a)
                            }));
                            var a, t, n = this[0];
                            return n ? n.getClientRects().length ? (a = n.getBoundingClientRect(), t = n.ownerDocument.defaultView, {
                                top: a.top + t.pageYOffset,
                                left: a.left + t.pageXOffset
                            }) : {
                                top: 0,
                                left: 0
                            } : void 0
                        },
                        position: function() {
                            if (this[0]) {
                                var e, a, t, n = this[0],
                                    i = {
                                        top: 0,
                                        left: 0
                                    };
                                if ("fixed" === x.css(n, "position")) a = n.getBoundingClientRect();
                                else {
                                    for (a = this.offset(), t = n.ownerDocument, e = n.offsetParent || t.documentElement; e && (e === t.body || e === t.documentElement) && "static" === x.css(e, "position");) e = e.parentNode;
                                    e && e !== n && 1 === e.nodeType && ((i = x(e).offset()).top += x.css(e, "borderTopWidth", !0), i.left += x.css(e, "borderLeftWidth", !0))
                                }
                                return {
                                    top: a.top - i.top - x.css(n, "marginTop", !0),
                                    left: a.left - i.left - x.css(n, "marginLeft", !0)
                                }
                            }
                        },
                        offsetParent: function() {
                            return this.map((function() {
                                for (var e = this.offsetParent; e && "static" === x.css(e, "position");) e = e.offsetParent;
                                return e || se
                            }))
                        }
                    }), x.each({
                        scrollLeft: "pageXOffset",
                        scrollTop: "pageYOffset"
                    }, (function(e, a) {
                        var t = "pageYOffset" === a;
                        x.fn[e] = function(n) {
                            return W(this, (function(e, n, i) {
                                var r;
                                if (y(e) ? r = e : 9 === e.nodeType && (r = e.defaultView), void 0 === i) return r ? r[a] : e[n];
                                r ? r.scrollTo(t ? r.pageXOffset : i, t ? i : r.pageYOffset) : e[n] = i
                            }), e, n, arguments.length)
                        }
                    })), x.each(["top", "left"], (function(e, a) {
                        x.cssHooks[a] = Ye(g.pixelPosition, (function(e, t) {
                            if (t) return t = _e(e, a), Ge.test(t) ? x(e).position()[a] + "px" : t
                        }))
                    })), x.each({
                        Height: "height",
                        Width: "width"
                    }, (function(e, a) {
                        x.each({
                            padding: "inner" + e,
                            content: a,
                            "": "outer" + e
                        }, (function(t, n) {
                            x.fn[n] = function(i, r) {
                                var s = arguments.length && (t || "boolean" != typeof i),
                                    o = t || (!0 === i || !0 === r ? "margin" : "border");
                                return W(this, (function(a, t, i) {
                                    var r;
                                    return y(a) ? 0 === n.indexOf("outer") ? a["inner" + e] : a.document.documentElement["client" + e] : 9 === a.nodeType ? (r = a.documentElement, Math.max(a.body["scroll" + e], r["scroll" + e], a.body["offset" + e], r["offset" + e], r["client" + e])) : void 0 === i ? x.css(a, t, o) : x.style(a, t, i, o)
                                }), a, s ? i : void 0, s)
                            }
                        }))
                    })), x.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], (function(e, a) {
                        x.fn[a] = function(e) {
                            return this.on(a, e)
                        }
                    })), x.fn.extend({
                        bind: function(e, a, t) {
                            return this.on(e, null, a, t)
                        },
                        unbind: function(e, a) {
                            return this.off(e, null, a)
                        },
                        delegate: function(e, a, t, n) {
                            return this.on(a, e, t, n)
                        },
                        undelegate: function(e, a, t) {
                            return 1 === arguments.length ? this.off(e, "**") : this.off(a, e || "**", t)
                        },
                        hover: function(e, a) {
                            return this.mouseenter(e).mouseleave(a || e)
                        }
                    }), x.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), (function(e, a) {
                        x.fn[a] = function(e, t) {
                            return arguments.length > 0 ? this.on(a, null, e, t) : this.trigger(a)
                        }
                    }));
                    var Ua = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;
                    x.proxy = function(e, a) {
                        var t, n, i;
                        if ("string" == typeof a && (t = e[a], a = e, e = t), v(e)) return n = o.call(arguments, 2), i = function() {
                            return e.apply(a || this, n.concat(o.call(arguments)))
                        }, i.guid = e.guid = e.guid || x.guid++, i
                    }, x.holdReady = function(e) {
                        e ? x.readyWait++ : x.ready(!0)
                    }, x.isArray = Array.isArray, x.parseJSON = JSON.parse, x.nodeName = L, x.isFunction = v, x.isWindow = y, x.camelCase = X, x.type = k, x.now = Date.now, x.isNumeric = function(e) {
                        var a = x.type(e);
                        return ("number" === a || "string" === a) && !isNaN(e - parseFloat(e))
                    }, x.trim = function(e) {
                        return null == e ? "" : (e + "").replace(Ua, "$1")
                    }, void 0 === (t = function() {
                        return x
                    }.apply(a, [])) || (e.exports = t);
                    var Za = n.jQuery,
                        Qa = n.$;
                    return x.noConflict = function(e) {
                        return n.$ === x && (n.$ = Qa), e && n.jQuery === x && (n.jQuery = Za), x
                    }, void 0 === i && (n.jQuery = n.$ = x), x
                }))
            },
            90: function(e) {
                ! function(a, t) {
                    var n = function(e, a, t) {
                        "use strict";
                        var n, i;
                        if (function() {
                                var a, t = {
                                    lazyClass: "lazyload",
                                    loadedClass: "lazyloaded",
                                    loadingClass: "lazyloading",
                                    preloadClass: "lazypreload",
                                    errorClass: "lazyerror",
                                    autosizesClass: "lazyautosizes",
                                    fastLoadedClass: "ls-is-cached",
                                    iframeLoadMode: 0,
                                    srcAttr: "data-src",
                                    srcsetAttr: "data-srcset",
                                    sizesAttr: "data-sizes",
                                    minSize: 40,
                                    customMedia: {},
                                    init: !0,
                                    expFactor: 1.5,
                                    hFac: .8,
                                    loadMode: 2,
                                    loadHidden: !0,
                                    ricTimeout: 0,
                                    throttleDelay: 125
                                };
                                for (a in i = e.lazySizesConfig || e.lazysizesConfig || {}, t) a in i || (i[a] = t[a])
                            }(), !a || !a.getElementsByClassName) return {
                            init: function() {},
                            cfg: i,
                            noSupport: !0
                        };
                        var r = a.documentElement,
                            s = e.HTMLPictureElement,
                            o = "addEventListener",
                            l = "getAttribute",
                            u = e[o].bind(e),
                            d = e.setTimeout,
                            c = e.requestAnimationFrame || d,
                            p = e.requestIdleCallback,
                            h = /^picture$/i,
                            f = ["load", "error", "lazyincluded", "_lazyloaded"],
                            m = {},
                            g = Array.prototype.forEach,
                            v = function(e, a) {
                                return m[a] || (m[a] = new RegExp("(\\s|^)" + a + "(\\s|$)")), m[a].test(e[l]("class") || "") && m[a]
                            },
                            y = function(e, a) {
                                v(e, a) || e.setAttribute("class", (e[l]("class") || "").trim() + " " + a)
                            },
                            b = function(e, a) {
                                var t;
                                (t = v(e, a)) && e.setAttribute("class", (e[l]("class") || "").replace(t, " "))
                            },
                            S = function(e, a, t) {
                                var n = t ? o : "removeEventListener";
                                t && S(e, a), f.forEach((function(t) {
                                    e[n](t, a)
                                }))
                            },
                            w = function(e, t, i, r, s) {
                                var o = a.createEvent("Event");
                                return i || (i = {}), i.instance = n, o.initEvent(t, !r, !s), o.detail = i, e.dispatchEvent(o), o
                            },
                            k = function(a, t) {
                                var n;
                                !s && (n = e.picturefill || i.pf) ? (t && t.src && !a[l]("srcset") && a.setAttribute("srcset", t.src), n({
                                    reevaluate: !0,
                                    elements: [a]
                                })) : t && t.src && (a.src = t.src)
                            },
                            T = function(e, a) {
                                return (getComputedStyle(e, null) || {})[a]
                            },
                            x = function(e, a, t) {
                                for (t = t || e.offsetWidth; t < i.minSize && a && !e._lazysizesWidth;) t = a.offsetWidth, a = a.parentNode;
                                return t
                            },
                            C = (ye = [], be = [], Se = ye, we = function() {
                                var e = Se;
                                for (Se = ye.length ? be : ye, ge = !0, ve = !1; e.length;) e.shift()();
                                ge = !1
                            }, ke = function(e, t) {
                                ge && !t ? e.apply(this, arguments) : (Se.push(e), ve || (ve = !0, (a.hidden ? d : c)(we)))
                            }, ke._lsFlush = we, ke),
                            E = function(e, a) {
                                return a ? function() {
                                    C(e)
                                } : function() {
                                    var a = this,
                                        t = arguments;
                                    C((function() {
                                        e.apply(a, t)
                                    }))
                                }
                            },
                            M = function(e) {
                                var a, n = 0,
                                    r = i.throttleDelay,
                                    s = i.ricTimeout,
                                    o = function() {
                                        a = !1, n = t.now(), e()
                                    },
                                    l = p && s > 49 ? function() {
                                        p(o, {
                                            timeout: s
                                        }), s !== i.ricTimeout && (s = i.ricTimeout)
                                    } : E((function() {
                                        d(o)
                                    }), !0);
                                return function(e) {
                                    var i;
                                    (e = !0 === e) && (s = 33), a || (a = !0, (i = r - (t.now() - n)) < 0 && (i = 0), e || i < 9 ? l() : d(l, i))
                                }
                            },
                            A = function(e) {
                                var a, n, i = 99,
                                    r = function() {
                                        a = null, e()
                                    },
                                    s = function() {
                                        var e = t.now() - n;
                                        e < i ? d(s, i - e) : (p || r)(r)
                                    };
                                return function() {
                                    n = t.now(), a || (a = d(s, i))
                                }
                            },
                            P = (Y = /^img$/i, X = /^iframe$/i, J = "onscroll" in e && !/(gle|ing)bot/.test(navigator.userAgent), U = 0, Z = 0, Q = 0, ee = -1, ae = function(e) {
                                Q--, (!e || Q < 0 || !e.target) && (Q = 0)
                            }, te = function(e) {
                                return null == _ && (_ = "hidden" == T(a.body, "visibility")), _ || !("hidden" == T(e.parentNode, "visibility") && "hidden" == T(e, "visibility"))
                            }, ne = function(e, t) {
                                var n, i = e,
                                    s = te(e);
                                for ($ -= t, F += t, V -= t, W += t; s && (i = i.offsetParent) && i != a.body && i != r;)(s = (T(i, "opacity") || 1) > 0) && "visible" != T(i, "overflow") && (n = i.getBoundingClientRect(), s = W > n.left && V < n.right && F > n.top - 1 && $ < n.bottom + 1);
                                return s
                            }, ie = function() {
                                var e, t, s, o, u, d, c, p, h, f, m, g, v = n.elements;
                                if ((H = i.loadMode) && Q < 8 && (e = v.length)) {
                                    for (t = 0, ee++; t < e; t++)
                                        if (v[t] && !v[t]._lazyRace)
                                            if (!J || n.prematureUnveil && n.prematureUnveil(v[t])) pe(v[t]);
                                            else if ((p = v[t][l]("data-expand")) && (d = 1 * p) || (d = Z), f || (f = !i.expand || i.expand < 1 ? r.clientHeight > 500 && r.clientWidth > 500 ? 500 : 370 : i.expand, n._defEx = f, m = f * i.expFactor, g = i.hFac, _ = null, Z < m && Q < 1 && ee > 2 && H > 2 && !a.hidden ? (Z = m, ee = 0) : Z = H > 1 && ee > 1 && Q < 6 ? f : U), h !== d && (q = innerWidth + d * g, K = innerHeight + d, c = -1 * d, h = d), s = v[t].getBoundingClientRect(), (F = s.bottom) >= c && ($ = s.top) <= K && (W = s.right) >= c * g && (V = s.left) <= q && (F || W || V || $) && (i.loadHidden || te(v[t])) && (O && Q < 3 && !p && (H < 3 || ee < 4) || ne(v[t], d))) {
                                        if (pe(v[t]), u = !0, Q > 9) break
                                    } else !u && O && !o && Q < 4 && ee < 4 && H > 2 && (I[0] || i.preloadAfterLoad) && (I[0] || !p && (F || W || V || $ || "auto" != v[t][l](i.sizesAttr))) && (o = I[0] || v[t]);
                                    o && !u && pe(o)
                                }
                            }, re = M(ie), se = function(e) {
                                var a = e.target;
                                a._lazyCache ? delete a._lazyCache : (ae(e), y(a, i.loadedClass), b(a, i.loadingClass), S(a, le), w(a, "lazyloaded"))
                            }, oe = E(se), le = function(e) {
                                oe({
                                    target: e.target
                                })
                            }, ue = function(e, a) {
                                var t = e.getAttribute("data-load-mode") || i.iframeLoadMode;
                                0 == t ? e.contentWindow.location.replace(a) : 1 == t && (e.src = a)
                            }, de = function(e) {
                                var a, t = e[l](i.srcsetAttr);
                                (a = i.customMedia[e[l]("data-media") || e[l]("media")]) && e.setAttribute("media", a), t && e.setAttribute("srcset", t)
                            }, ce = E((function(e, a, t, n, r) {
                                var s, o, u, c, p, f;
                                (p = w(e, "lazybeforeunveil", a)).defaultPrevented || (n && (t ? y(e, i.autosizesClass) : e.setAttribute("sizes", n)), o = e[l](i.srcsetAttr), s = e[l](i.srcAttr), r && (c = (u = e.parentNode) && h.test(u.nodeName || "")), f = a.firesLoad || "src" in e && (o || s || c), p = {
                                    target: e
                                }, y(e, i.loadingClass), f && (clearTimeout(R), R = d(ae, 2500), S(e, le, !0)), c && g.call(u.getElementsByTagName("source"), de), o ? e.setAttribute("srcset", o) : s && !c && (X.test(e.nodeName) ? ue(e, s) : e.src = s), r && (o || c) && k(e, {
                                    src: s
                                })), e._lazyRace && delete e._lazyRace, b(e, i.lazyClass), C((function() {
                                    var a = e.complete && e.naturalWidth > 1;
                                    f && !a || (a && y(e, i.fastLoadedClass), se(p), e._lazyCache = !0, d((function() {
                                        "_lazyCache" in e && delete e._lazyCache
                                    }), 9)), "lazy" == e.loading && Q--
                                }), !0)
                            })), pe = function(e) {
                                if (!e._lazyRace) {
                                    var a, t = Y.test(e.nodeName),
                                        n = t && (e[l](i.sizesAttr) || e[l]("sizes")),
                                        r = "auto" == n;
                                    (!r && O || !t || !e[l]("src") && !e.srcset || e.complete || v(e, i.errorClass) || !v(e, i.lazyClass)) && (a = w(e, "lazyunveilread").detail, r && L.updateElem(e, !0, e.offsetWidth), e._lazyRace = !0, Q++, ce(e, a, r, n, t))
                                }
                            }, he = A((function() {
                                i.loadMode = 3, re()
                            })), fe = function() {
                                3 == i.loadMode && (i.loadMode = 2), he()
                            }, me = function() {
                                O || (t.now() - G < 999 ? d(me, 999) : (O = !0, i.loadMode = 3, re(), u("scroll", fe, !0)))
                            }, {
                                _: function() {
                                    G = t.now(), n.elements = a.getElementsByClassName(i.lazyClass), I = a.getElementsByClassName(i.lazyClass + " " + i.preloadClass), u("scroll", re, !0), u("resize", re, !0), u("pageshow", (function(e) {
                                        if (e.persisted) {
                                            var t = a.querySelectorAll("." + i.loadingClass);
                                            t.length && t.forEach && c((function() {
                                                t.forEach((function(e) {
                                                    e.complete && pe(e)
                                                }))
                                            }))
                                        }
                                    })), e.MutationObserver ? new MutationObserver(re).observe(r, {
                                        childList: !0,
                                        subtree: !0,
                                        attributes: !0
                                    }) : (r[o]("DOMNodeInserted", re, !0), r[o]("DOMAttrModified", re, !0), setInterval(re, 999)), u("hashchange", re, !0), ["focus", "mouseover", "click", "load", "transitionend", "animationend"].forEach((function(e) {
                                        a[o](e, re, !0)
                                    })), /d$|^c/.test(a.readyState) ? me() : (u("load", me), a[o]("DOMContentLoaded", re), d(me, 2e4)), n.elements.length ? (ie(), C._lsFlush()) : re()
                                },
                                checkElems: re,
                                unveil: pe,
                                _aLSL: fe
                            }),
                            L = (N = E((function(e, a, t, n) {
                                var i, r, s;
                                if (e._lazysizesWidth = n, n += "px", e.setAttribute("sizes", n), h.test(a.nodeName || ""))
                                    for (r = 0, s = (i = a.getElementsByTagName("source")).length; r < s; r++) i[r].setAttribute("sizes", n);
                                t.detail.dataAttr || k(e, t.detail)
                            })), z = function(e, a, t) {
                                var n, i = e.parentNode;
                                i && (t = x(e, i, t), (n = w(e, "lazybeforesizes", {
                                    width: t,
                                    dataAttr: !!a
                                })).defaultPrevented || (t = n.detail.width) && t !== e._lazysizesWidth && N(e, i, n, t))
                            }, D = A((function() {
                                var e, a = B.length;
                                if (a)
                                    for (e = 0; e < a; e++) z(B[e])
                            })), {
                                _: function() {
                                    B = a.getElementsByClassName(i.autosizesClass), u("resize", D)
                                },
                                checkElems: D,
                                updateElem: z
                            }),
                            j = function() {
                                !j.i && a.getElementsByClassName && (j.i = !0, L._(), P._())
                            };
                        var B, N, z, D;
                        var I, O, R, H, G, q, K, $, V, W, F, _, Y, X, J, U, Z, Q, ee, ae, te, ne, ie, re, se, oe, le, ue, de, ce, pe, he, fe, me;
                        var ge, ve, ye, be, Se, we, ke;
                        return d((function() {
                            i.init && j()
                        })), n = {
                            cfg: i,
                            autoSizer: L,
                            loader: P,
                            init: j,
                            uP: k,
                            aC: y,
                            rC: b,
                            hC: v,
                            fire: w,
                            gW: x,
                            rAF: C
                        }
                    }(a, a.document, Date);
                    a.lazySizes = n, e.exports && (e.exports = n)
                }("undefined" != typeof window ? window : {})
            }
        },
        a = {};

    function t(n) {
        var i = a[n];
        if (void 0 !== i) return i.exports;
        var r = a[n] = {
            exports: {}
        };
        return e[n].call(r.exports, r, r.exports, t), r.exports
    }
    t.n = function(e) {
            var a = e && e.__esModule ? function() {
                return e.default
            } : function() {
                return e
            };
            return t.d(a, {
                a: a
            }), a
        }, t.d = function(e, a) {
            for (var n in a) t.o(a, n) && !t.o(e, n) && Object.defineProperty(e, n, {
                enumerable: !0,
                get: a[n]
            })
        }, t.o = function(e, a) {
            return Object.prototype.hasOwnProperty.call(e, a)
        },
        function() {
            "use strict";
            t(90), t(172);

            function e() {
                var e = document.getElementsByClassName("js-add-to-cart");
                console.log(e);
                for (var a = function(e) {
                        e.preventDefault(), e.stopPropagation();
                        var a = new FormData(e.target.form),
                            t = {};
                        a.forEach((function(e, a) {
                            t[a] = e
                        })), window.miniCart.addToCart([t])
                    }, t = 0; t < e.length; t++) e[t].addEventListener("click", a, !1)
            }

            function a(e) {
                return null !== e && "object" == typeof e && "constructor" in e && e.constructor === Object
            }

            function n(e = {}, t = {}) {
                Object.keys(t).forEach((i => {
                    void 0 === e[i] ? e[i] = t[i] : a(t[i]) && a(e[i]) && Object.keys(t[i]).length > 0 && n(e[i], t[i])
                }))
            }
            const i = {
                body: {},
                addEventListener() {},
                removeEventListener() {},
                activeElement: {
                    blur() {},
                    nodeName: ""
                },
                querySelector() {
                    return null
                },
                querySelectorAll() {
                    return []
                },
                getElementById() {
                    return null
                },
                createEvent() {
                    return {
                        initEvent() {}
                    }
                },
                createElement() {
                    return {
                        children: [],
                        childNodes: [],
                        style: {},
                        setAttribute() {},
                        getElementsByTagName() {
                            return []
                        }
                    }
                },
                createElementNS() {
                    return {}
                },
                importNode() {
                    return null
                },
                location: {
                    hash: "",
                    host: "",
                    hostname: "",
                    href: "",
                    origin: "",
                    pathname: "",
                    protocol: "",
                    search: ""
                }
            };

            function r() {
                const e = "undefined" != typeof document ? document : {};
                return n(e, i), e
            }
            const s = {
                document: i,
                navigator: {
                    userAgent: ""
                },
                location: {
                    hash: "",
                    host: "",
                    hostname: "",
                    href: "",
                    origin: "",
                    pathname: "",
                    protocol: "",
                    search: ""
                },
                history: {
                    replaceState() {},
                    pushState() {},
                    go() {},
                    back() {}
                },
                CustomEvent: function() {
                    return this
                },
                addEventListener() {},
                removeEventListener() {},
                getComputedStyle() {
                    return {
                        getPropertyValue() {
                            return ""
                        }
                    }
                },
                Image() {},
                Date() {},
                screen: {},
                setTimeout() {},
                clearTimeout() {},
                matchMedia() {
                    return {}
                },
                requestAnimationFrame(e) {
                    return "undefined" == typeof setTimeout ? (e(), null) : setTimeout(e, 0)
                },
                cancelAnimationFrame(e) {
                    "undefined" != typeof setTimeout && clearTimeout(e)
                }
            };

            function o() {
                const e = "undefined" != typeof window ? window : {};
                return n(e, s), e
            }

            function l(e, a = 0) {
                return setTimeout(e, a)
            }

            function u() {
                return Date.now()
            }

            function d(e, a = "x") {
                const t = o();
                let n, i, r;
                const s = function(e) {
                    const a = o();
                    let t;
                    return a.getComputedStyle && (t = a.getComputedStyle(e, null)), !t && e.currentStyle && (t = e.currentStyle), t || (t = e.style), t
                }(e);
                return t.WebKitCSSMatrix ? (i = s.transform || s.webkitTransform, i.split(",").length > 6 && (i = i.split(", ").map((e => e.replace(",", "."))).join(", ")), r = new t.WebKitCSSMatrix("none" === i ? "" : i)) : (r = s.MozTransform || s.OTransform || s.MsTransform || s.msTransform || s.transform || s.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,"), n = r.toString().split(",")), "x" === a && (i = t.WebKitCSSMatrix ? r.m41 : 16 === n.length ? parseFloat(n[12]) : parseFloat(n[4])), "y" === a && (i = t.WebKitCSSMatrix ? r.m42 : 16 === n.length ? parseFloat(n[13]) : parseFloat(n[5])), i || 0
            }

            function c(e) {
                return "object" == typeof e && null !== e && e.constructor && "Object" === Object.prototype.toString.call(e).slice(8, -1)
            }

            function p(...e) {
                const a = Object(e[0]),
                    t = ["__proto__", "constructor", "prototype"];
                for (let i = 1; i < e.length; i += 1) {
                    const r = e[i];
                    if (null != r && (n = r, !("undefined" != typeof window && void 0 !== window.HTMLElement ? n instanceof HTMLElement : n && (1 === n.nodeType || 11 === n.nodeType)))) {
                        const e = Object.keys(Object(r)).filter((e => t.indexOf(e) < 0));
                        for (let t = 0, n = e.length; t < n; t += 1) {
                            const n = e[t],
                                i = Object.getOwnPropertyDescriptor(r, n);
                            void 0 !== i && i.enumerable && (c(a[n]) && c(r[n]) ? r[n].__swiper__ ? a[n] = r[n] : p(a[n], r[n]) : !c(a[n]) && c(r[n]) ? (a[n] = {}, r[n].__swiper__ ? a[n] = r[n] : p(a[n], r[n])) : a[n] = r[n])
                        }
                    }
                }
                var n;
                return a
            }

            function h(e, a, t) {
                e.style.setProperty(a, t)
            }

            function f({
                swiper: e,
                targetPosition: a,
                side: t
            }) {
                const n = o(),
                    i = -e.translate;
                let r, s = null;
                const l = e.params.speed;
                e.wrapperEl.style.scrollSnapType = "none", n.cancelAnimationFrame(e.cssModeFrameID);
                const u = a > i ? "next" : "prev",
                    d = (e, a) => "next" === u && e >= a || "prev" === u && e <= a,
                    c = () => {
                        r = (new Date).getTime(), null === s && (s = r);
                        const o = Math.max(Math.min((r - s) / l, 1), 0),
                            u = .5 - Math.cos(o * Math.PI) / 2;
                        let p = i + u * (a - i);
                        if (d(p, a) && (p = a), e.wrapperEl.scrollTo({
                                [t]: p
                            }), d(p, a)) return e.wrapperEl.style.overflow = "hidden", e.wrapperEl.style.scrollSnapType = "", setTimeout((() => {
                            e.wrapperEl.style.overflow = "", e.wrapperEl.scrollTo({
                                [t]: p
                            })
                        })), void n.cancelAnimationFrame(e.cssModeFrameID);
                        e.cssModeFrameID = n.requestAnimationFrame(c)
                    };
                c()
            }

            function m(e) {
                return e.querySelector(".swiper-slide-transform") || e.shadowEl && e.shadowEl.querySelector(".swiper-slide-transform") || e
            }

            function g(e, a = "") {
                return [...e.children].filter((e => e.matches(a)))
            }

            function v(e, a = []) {
                const t = document.createElement(e);
                return t.classList.add(...Array.isArray(a) ? a : [a]), t
            }

            function y(e) {
                const a = o(),
                    t = r(),
                    n = e.getBoundingClientRect(),
                    i = t.body,
                    s = e.clientTop || i.clientTop || 0,
                    l = e.clientLeft || i.clientLeft || 0,
                    u = e === a ? a.scrollY : e.scrollTop,
                    d = e === a ? a.scrollX : e.scrollLeft;
                return {
                    top: n.top + u - s,
                    left: n.left + d - l
                }
            }

            function b(e, a) {
                return o().getComputedStyle(e, null).getPropertyValue(a)
            }

            function S(e) {
                let a, t = e;
                if (t) {
                    for (a = 0; null !== (t = t.previousSibling);) 1 === t.nodeType && (a += 1);
                    return a
                }
            }

            function w(e, a) {
                const t = [];
                let n = e.parentElement;
                for (; n;) a ? n.matches(a) && t.push(n) : t.push(n), n = n.parentElement;
                return t
            }

            function k(e, a) {
                a && e.addEventListener("transitionend", (function t(n) {
                    n.target === e && (a.call(e, n), e.removeEventListener("transitionend", t))
                }))
            }

            function T(e, a, t) {
                const n = o();
                return t ? e["width" === a ? "offsetWidth" : "offsetHeight"] + parseFloat(n.getComputedStyle(e, null).getPropertyValue("width" === a ? "margin-right" : "margin-top")) + parseFloat(n.getComputedStyle(e, null).getPropertyValue("width" === a ? "margin-left" : "margin-bottom")) : e.offsetWidth
            }
            let x, C, E;

            function M() {
                return x || (x = function() {
                    const e = o(),
                        a = r();
                    return {
                        smoothScroll: a.documentElement && "scrollBehavior" in a.documentElement.style,
                        touch: !!("ontouchstart" in e || e.DocumentTouch && a instanceof e.DocumentTouch)
                    }
                }()), x
            }

            function A(e = {}) {
                return C || (C = function({
                    userAgent: e
                } = {}) {
                    const a = M(),
                        t = o(),
                        n = t.navigator.platform,
                        i = e || t.navigator.userAgent,
                        r = {
                            ios: !1,
                            android: !1
                        },
                        s = t.screen.width,
                        l = t.screen.height,
                        u = i.match(/(Android);?[\s\/]+([\d.]+)?/);
                    let d = i.match(/(iPad).*OS\s([\d_]+)/);
                    const c = i.match(/(iPod)(.*OS\s([\d_]+))?/),
                        p = !d && i.match(/(iPhone\sOS|iOS)\s([\d_]+)/),
                        h = "Win32" === n;
                    let f = "MacIntel" === n;
                    return !d && f && a.touch && ["1024x1366", "1366x1024", "834x1194", "1194x834", "834x1112", "1112x834", "768x1024", "1024x768", "820x1180", "1180x820", "810x1080", "1080x810"].indexOf(`${s}x${l}`) >= 0 && (d = i.match(/(Version)\/([\d.]+)/), d || (d = [0, 1, "13_0_0"]), f = !1), u && !h && (r.os = "android", r.android = !0), (d || p || c) && (r.os = "ios", r.ios = !0), r
                }(e)), C
            }

            function P() {
                return E || (E = function() {
                    const e = o();
                    let a = !1;

                    function t() {
                        const a = e.navigator.userAgent.toLowerCase();
                        return a.indexOf("safari") >= 0 && a.indexOf("chrome") < 0 && a.indexOf("android") < 0
                    }
                    if (t()) {
                        const t = String(e.navigator.userAgent);
                        if (t.includes("Version/")) {
                            const [e, n] = t.split("Version/")[1].split(" ")[0].split(".").map((e => Number(e)));
                            a = e < 16 || 16 === e && n < 2
                        }
                    }
                    return {
                        isSafari: a || t(),
                        needPerspectiveFix: a,
                        isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(e.navigator.userAgent)
                    }
                }()), E
            }
            var L = {
                on(e, a, t) {
                    const n = this;
                    if (!n.eventsListeners || n.destroyed) return n;
                    if ("function" != typeof a) return n;
                    const i = t ? "unshift" : "push";
                    return e.split(" ").forEach((e => {
                        n.eventsListeners[e] || (n.eventsListeners[e] = []), n.eventsListeners[e][i](a)
                    })), n
                },
                once(e, a, t) {
                    const n = this;
                    if (!n.eventsListeners || n.destroyed) return n;
                    if ("function" != typeof a) return n;

                    function i(...t) {
                        n.off(e, i), i.__emitterProxy && delete i.__emitterProxy, a.apply(n, t)
                    }
                    return i.__emitterProxy = a, n.on(e, i, t)
                },
                onAny(e, a) {
                    const t = this;
                    if (!t.eventsListeners || t.destroyed) return t;
                    if ("function" != typeof e) return t;
                    const n = a ? "unshift" : "push";
                    return t.eventsAnyListeners.indexOf(e) < 0 && t.eventsAnyListeners[n](e), t
                },
                offAny(e) {
                    const a = this;
                    if (!a.eventsListeners || a.destroyed) return a;
                    if (!a.eventsAnyListeners) return a;
                    const t = a.eventsAnyListeners.indexOf(e);
                    return t >= 0 && a.eventsAnyListeners.splice(t, 1), a
                },
                off(e, a) {
                    const t = this;
                    return !t.eventsListeners || t.destroyed ? t : t.eventsListeners ? (e.split(" ").forEach((e => {
                        void 0 === a ? t.eventsListeners[e] = [] : t.eventsListeners[e] && t.eventsListeners[e].forEach(((n, i) => {
                            (n === a || n.__emitterProxy && n.__emitterProxy === a) && t.eventsListeners[e].splice(i, 1)
                        }))
                    })), t) : t
                },
                emit(...e) {
                    const a = this;
                    if (!a.eventsListeners || a.destroyed) return a;
                    if (!a.eventsListeners) return a;
                    let t, n, i;
                    "string" == typeof e[0] || Array.isArray(e[0]) ? (t = e[0], n = e.slice(1, e.length), i = a) : (t = e[0].events, n = e[0].data, i = e[0].context || a), n.unshift(i);
                    return (Array.isArray(t) ? t : t.split(" ")).forEach((e => {
                        a.eventsAnyListeners && a.eventsAnyListeners.length && a.eventsAnyListeners.forEach((a => {
                            a.apply(i, [e, ...n])
                        })), a.eventsListeners && a.eventsListeners[e] && a.eventsListeners[e].forEach((e => {
                            e.apply(i, n)
                        }))
                    })), a
                }
            };
            const j = (e, a) => {
                    if (!e || e.destroyed || !e.params) return;
                    const t = a.closest(e.isElement ? "swiper-slide" : `.${e.params.slideClass}`);
                    if (t) {
                        const a = t.querySelector(`.${e.params.lazyPreloaderClass}`);
                        a && a.remove()
                    }
                },
                B = (e, a) => {
                    if (!e.slides[a]) return;
                    const t = e.slides[a].querySelector('[loading="lazy"]');
                    t && t.removeAttribute("loading")
                },
                N = e => {
                    if (!e || e.destroyed || !e.params) return;
                    let a = e.params.lazyPreloadPrevNext;
                    const t = e.slides.length;
                    if (!t || !a || a < 0) return;
                    a = Math.min(a, t);
                    const n = "auto" === e.params.slidesPerView ? e.slidesPerViewDynamic() : Math.ceil(e.params.slidesPerView),
                        i = e.activeIndex,
                        r = i + n - 1;
                    if (e.params.rewind)
                        for (let n = i - a; n <= r + a; n += 1) {
                            const a = (n % t + t) % t;
                            a !== i && a > r && B(e, a)
                        } else
                            for (let n = Math.max(r - a, 0); n <= Math.min(r + a, t - 1); n += 1) n !== i && n > r && B(e, n)
                };
            var z = {
                updateSize: function() {
                    const e = this;
                    let a, t;
                    const n = e.el;
                    a = void 0 !== e.params.width && null !== e.params.width ? e.params.width : n.clientWidth, t = void 0 !== e.params.height && null !== e.params.height ? e.params.height : n.clientHeight, 0 === a && e.isHorizontal() || 0 === t && e.isVertical() || (a = a - parseInt(b(n, "padding-left") || 0, 10) - parseInt(b(n, "padding-right") || 0, 10), t = t - parseInt(b(n, "padding-top") || 0, 10) - parseInt(b(n, "padding-bottom") || 0, 10), Number.isNaN(a) && (a = 0), Number.isNaN(t) && (t = 0), Object.assign(e, {
                        width: a,
                        height: t,
                        size: e.isHorizontal() ? a : t
                    }))
                },
                updateSlides: function() {
                    const e = this;

                    function a(a) {
                        return e.isHorizontal() ? a : {
                            width: "height",
                            "margin-top": "margin-left",
                            "margin-bottom ": "margin-right",
                            "margin-left": "margin-top",
                            "margin-right": "margin-bottom",
                            "padding-left": "padding-top",
                            "padding-right": "padding-bottom",
                            marginRight: "marginBottom"
                        } [a]
                    }

                    function t(e, t) {
                        return parseFloat(e.getPropertyValue(a(t)) || 0)
                    }
                    const n = e.params,
                        {
                            wrapperEl: i,
                            slidesEl: r,
                            size: s,
                            rtlTranslate: o,
                            wrongRTL: l
                        } = e,
                        u = e.virtual && n.virtual.enabled,
                        d = u ? e.virtual.slides.length : e.slides.length,
                        c = g(r, `.${e.params.slideClass}, swiper-slide`),
                        p = u ? e.virtual.slides.length : c.length;
                    let f = [];
                    const m = [],
                        v = [];
                    let y = n.slidesOffsetBefore;
                    "function" == typeof y && (y = n.slidesOffsetBefore.call(e));
                    let S = n.slidesOffsetAfter;
                    "function" == typeof S && (S = n.slidesOffsetAfter.call(e));
                    const w = e.snapGrid.length,
                        k = e.slidesGrid.length;
                    let x = n.spaceBetween,
                        C = -y,
                        E = 0,
                        M = 0;
                    if (void 0 === s) return;
                    "string" == typeof x && x.indexOf("%") >= 0 && (x = parseFloat(x.replace("%", "")) / 100 * s), e.virtualSize = -x, c.forEach((e => {
                        o ? e.style.marginLeft = "" : e.style.marginRight = "", e.style.marginBottom = "", e.style.marginTop = ""
                    })), n.centeredSlides && n.cssMode && (h(i, "--swiper-centered-offset-before", ""), h(i, "--swiper-centered-offset-after", ""));
                    const A = n.grid && n.grid.rows > 1 && e.grid;
                    let P;
                    A && e.grid.initSlides(p);
                    const L = "auto" === n.slidesPerView && n.breakpoints && Object.keys(n.breakpoints).filter((e => void 0 !== n.breakpoints[e].slidesPerView)).length > 0;
                    for (let i = 0; i < p; i += 1) {
                        let r;
                        if (P = 0, c[i] && (r = c[i]), A && e.grid.updateSlide(i, r, p, a), !c[i] || "none" !== b(r, "display")) {
                            if ("auto" === n.slidesPerView) {
                                L && (c[i].style[a("width")] = "");
                                const s = getComputedStyle(r),
                                    o = r.style.transform,
                                    l = r.style.webkitTransform;
                                if (o && (r.style.transform = "none"), l && (r.style.webkitTransform = "none"), n.roundLengths) P = e.isHorizontal() ? T(r, "width", !0) : T(r, "height", !0);
                                else {
                                    const e = t(s, "width"),
                                        a = t(s, "padding-left"),
                                        n = t(s, "padding-right"),
                                        i = t(s, "margin-left"),
                                        o = t(s, "margin-right"),
                                        l = s.getPropertyValue("box-sizing");
                                    if (l && "border-box" === l) P = e + i + o;
                                    else {
                                        const {
                                            clientWidth: t,
                                            offsetWidth: s
                                        } = r;
                                        P = e + a + n + i + o + (s - t)
                                    }
                                }
                                o && (r.style.transform = o), l && (r.style.webkitTransform = l), n.roundLengths && (P = Math.floor(P))
                            } else P = (s - (n.slidesPerView - 1) * x) / n.slidesPerView, n.roundLengths && (P = Math.floor(P)), c[i] && (c[i].style[a("width")] = `${P}px`);
                            c[i] && (c[i].swiperSlideSize = P), v.push(P), n.centeredSlides ? (C = C + P / 2 + E / 2 + x, 0 === E && 0 !== i && (C = C - s / 2 - x), 0 === i && (C = C - s / 2 - x), Math.abs(C) < .001 && (C = 0), n.roundLengths && (C = Math.floor(C)), M % n.slidesPerGroup == 0 && f.push(C), m.push(C)) : (n.roundLengths && (C = Math.floor(C)), (M - Math.min(e.params.slidesPerGroupSkip, M)) % e.params.slidesPerGroup == 0 && f.push(C), m.push(C), C = C + P + x), e.virtualSize += P + x, E = P, M += 1
                        }
                    }
                    if (e.virtualSize = Math.max(e.virtualSize, s) + S, o && l && ("slide" === n.effect || "coverflow" === n.effect) && (i.style.width = `${e.virtualSize + n.spaceBetween}px`), n.setWrapperSize && (i.style[a("width")] = `${e.virtualSize + n.spaceBetween}px`), A && e.grid.updateWrapperSize(P, f, a), !n.centeredSlides) {
                        const a = [];
                        for (let t = 0; t < f.length; t += 1) {
                            let i = f[t];
                            n.roundLengths && (i = Math.floor(i)), f[t] <= e.virtualSize - s && a.push(i)
                        }
                        f = a, Math.floor(e.virtualSize - s) - Math.floor(f[f.length - 1]) > 1 && f.push(e.virtualSize - s)
                    }
                    if (u && n.loop) {
                        const a = v[0] + x;
                        if (n.slidesPerGroup > 1) {
                            const t = Math.ceil((e.virtual.slidesBefore + e.virtual.slidesAfter) / n.slidesPerGroup),
                                i = a * n.slidesPerGroup;
                            for (let e = 0; e < t; e += 1) f.push(f[f.length - 1] + i)
                        }
                        for (let t = 0; t < e.virtual.slidesBefore + e.virtual.slidesAfter; t += 1) 1 === n.slidesPerGroup && f.push(f[f.length - 1] + a), m.push(m[m.length - 1] + a), e.virtualSize += a
                    }
                    if (0 === f.length && (f = [0]), 0 !== n.spaceBetween) {
                        const t = e.isHorizontal() && o ? "marginLeft" : a("marginRight");
                        c.filter(((e, a) => !(n.cssMode && !n.loop) || a !== c.length - 1)).forEach((e => {
                            e.style[t] = `${x}px`
                        }))
                    }
                    if (n.centeredSlides && n.centeredSlidesBounds) {
                        let e = 0;
                        v.forEach((a => {
                            e += a + (n.spaceBetween ? n.spaceBetween : 0)
                        })), e -= n.spaceBetween;
                        const a = e - s;
                        f = f.map((e => e < 0 ? -y : e > a ? a + S : e))
                    }
                    if (n.centerInsufficientSlides) {
                        let e = 0;
                        if (v.forEach((a => {
                                e += a + (n.spaceBetween ? n.spaceBetween : 0)
                            })), e -= n.spaceBetween, e < s) {
                            const a = (s - e) / 2;
                            f.forEach(((e, t) => {
                                f[t] = e - a
                            })), m.forEach(((e, t) => {
                                m[t] = e + a
                            }))
                        }
                    }
                    if (Object.assign(e, {
                            slides: c,
                            snapGrid: f,
                            slidesGrid: m,
                            slidesSizesGrid: v
                        }), n.centeredSlides && n.cssMode && !n.centeredSlidesBounds) {
                        h(i, "--swiper-centered-offset-before", -f[0] + "px"), h(i, "--swiper-centered-offset-after", e.size / 2 - v[v.length - 1] / 2 + "px");
                        const a = -e.snapGrid[0],
                            t = -e.slidesGrid[0];
                        e.snapGrid = e.snapGrid.map((e => e + a)), e.slidesGrid = e.slidesGrid.map((e => e + t))
                    }
                    if (p !== d && e.emit("slidesLengthChange"), f.length !== w && (e.params.watchOverflow && e.checkOverflow(), e.emit("snapGridLengthChange")), m.length !== k && e.emit("slidesGridLengthChange"), n.watchSlidesProgress && e.updateSlidesOffset(), !(u || n.cssMode || "slide" !== n.effect && "fade" !== n.effect)) {
                        const a = `${n.containerModifierClass}backface-hidden`,
                            t = e.el.classList.contains(a);
                        p <= n.maxBackfaceHiddenSlides ? t || e.el.classList.add(a) : t && e.el.classList.remove(a)
                    }
                },
                updateAutoHeight: function(e) {
                    const a = this,
                        t = [],
                        n = a.virtual && a.params.virtual.enabled;
                    let i, r = 0;
                    "number" == typeof e ? a.setTransition(e) : !0 === e && a.setTransition(a.params.speed);
                    const s = e => n ? a.getSlideIndexByData(e) : a.slides[e];
                    if ("auto" !== a.params.slidesPerView && a.params.slidesPerView > 1)
                        if (a.params.centeredSlides)(a.visibleSlides || []).forEach((e => {
                            t.push(e)
                        }));
                        else
                            for (i = 0; i < Math.ceil(a.params.slidesPerView); i += 1) {
                                const e = a.activeIndex + i;
                                if (e > a.slides.length && !n) break;
                                t.push(s(e))
                            } else t.push(s(a.activeIndex));
                    for (i = 0; i < t.length; i += 1)
                        if (void 0 !== t[i]) {
                            const e = t[i].offsetHeight;
                            r = e > r ? e : r
                        }(r || 0 === r) && (a.wrapperEl.style.height = `${r}px`)
                },
                updateSlidesOffset: function() {
                    const e = this,
                        a = e.slides,
                        t = e.isElement ? e.isHorizontal() ? e.wrapperEl.offsetLeft : e.wrapperEl.offsetTop : 0;
                    for (let n = 0; n < a.length; n += 1) a[n].swiperSlideOffset = (e.isHorizontal() ? a[n].offsetLeft : a[n].offsetTop) - t
                },
                updateSlidesProgress: function(e = this && this.translate || 0) {
                    const a = this,
                        t = a.params,
                        {
                            slides: n,
                            rtlTranslate: i,
                            snapGrid: r
                        } = a;
                    if (0 === n.length) return;
                    void 0 === n[0].swiperSlideOffset && a.updateSlidesOffset();
                    let s = -e;
                    i && (s = e), n.forEach((e => {
                        e.classList.remove(t.slideVisibleClass)
                    })), a.visibleSlidesIndexes = [], a.visibleSlides = [];
                    for (let e = 0; e < n.length; e += 1) {
                        const o = n[e];
                        let l = o.swiperSlideOffset;
                        t.cssMode && t.centeredSlides && (l -= n[0].swiperSlideOffset);
                        const u = (s + (t.centeredSlides ? a.minTranslate() : 0) - l) / (o.swiperSlideSize + t.spaceBetween),
                            d = (s - r[0] + (t.centeredSlides ? a.minTranslate() : 0) - l) / (o.swiperSlideSize + t.spaceBetween),
                            c = -(s - l),
                            p = c + a.slidesSizesGrid[e];
                        (c >= 0 && c < a.size - 1 || p > 1 && p <= a.size || c <= 0 && p >= a.size) && (a.visibleSlides.push(o), a.visibleSlidesIndexes.push(e), n[e].classList.add(t.slideVisibleClass)), o.progress = i ? -u : u, o.originalProgress = i ? -d : d
                    }
                },
                updateProgress: function(e) {
                    const a = this;
                    if (void 0 === e) {
                        const t = a.rtlTranslate ? -1 : 1;
                        e = a && a.translate && a.translate * t || 0
                    }
                    const t = a.params,
                        n = a.maxTranslate() - a.minTranslate();
                    let {
                        progress: i,
                        isBeginning: r,
                        isEnd: s,
                        progressLoop: o
                    } = a;
                    const l = r,
                        u = s;
                    if (0 === n) i = 0, r = !0, s = !0;
                    else {
                        i = (e - a.minTranslate()) / n;
                        const t = Math.abs(e - a.minTranslate()) < 1,
                            o = Math.abs(e - a.maxTranslate()) < 1;
                        r = t || i <= 0, s = o || i >= 1, t && (i = 0), o && (i = 1)
                    }
                    if (t.loop) {
                        const t = a.getSlideIndexByData(0),
                            n = a.getSlideIndexByData(a.slides.length - 1),
                            i = a.slidesGrid[t],
                            r = a.slidesGrid[n],
                            s = a.slidesGrid[a.slidesGrid.length - 1],
                            l = Math.abs(e);
                        o = l >= i ? (l - i) / s : (l + s - r) / s, o > 1 && (o -= 1)
                    }
                    Object.assign(a, {
                        progress: i,
                        progressLoop: o,
                        isBeginning: r,
                        isEnd: s
                    }), (t.watchSlidesProgress || t.centeredSlides && t.autoHeight) && a.updateSlidesProgress(e), r && !l && a.emit("reachBeginning toEdge"), s && !u && a.emit("reachEnd toEdge"), (l && !r || u && !s) && a.emit("fromEdge"), a.emit("progress", i)
                },
                updateSlidesClasses: function() {
                    const e = this,
                        {
                            slides: a,
                            params: t,
                            slidesEl: n,
                            activeIndex: i
                        } = e,
                        r = e.virtual && t.virtual.enabled,
                        s = e => g(n, `.${t.slideClass}${e}, swiper-slide${e}`)[0];
                    let o;
                    if (a.forEach((e => {
                            e.classList.remove(t.slideActiveClass, t.slideNextClass, t.slidePrevClass)
                        })), r)
                        if (t.loop) {
                            let a = i - e.virtual.slidesBefore;
                            a < 0 && (a = e.virtual.slides.length + a), a >= e.virtual.slides.length && (a -= e.virtual.slides.length), o = s(`[data-swiper-slide-index="${a}"]`)
                        } else o = s(`[data-swiper-slide-index="${i}"]`);
                    else o = a[i];
                    if (o) {
                        o.classList.add(t.slideActiveClass);
                        let e = function(e, a) {
                            const t = [];
                            for (; e.nextElementSibling;) {
                                const n = e.nextElementSibling;
                                a ? n.matches(a) && t.push(n) : t.push(n), e = n
                            }
                            return t
                        }(o, `.${t.slideClass}, swiper-slide`)[0];
                        t.loop && !e && (e = a[0]), e && e.classList.add(t.slideNextClass);
                        let n = function(e, a) {
                            const t = [];
                            for (; e.previousElementSibling;) {
                                const n = e.previousElementSibling;
                                a ? n.matches(a) && t.push(n) : t.push(n), e = n
                            }
                            return t
                        }(o, `.${t.slideClass}, swiper-slide`)[0];
                        t.loop && 0 === !n && (n = a[a.length - 1]), n && n.classList.add(t.slidePrevClass)
                    }
                    e.emitSlidesClasses()
                },
                updateActiveIndex: function(e) {
                    const a = this,
                        t = a.rtlTranslate ? a.translate : -a.translate,
                        {
                            snapGrid: n,
                            params: i,
                            activeIndex: r,
                            realIndex: s,
                            snapIndex: o
                        } = a;
                    let l, u = e;
                    const d = e => {
                        let t = e - a.virtual.slidesBefore;
                        return t < 0 && (t = a.virtual.slides.length + t), t >= a.virtual.slides.length && (t -= a.virtual.slides.length), t
                    };
                    if (void 0 === u && (u = function(e) {
                            const {
                                slidesGrid: a,
                                params: t
                            } = e, n = e.rtlTranslate ? e.translate : -e.translate;
                            let i;
                            for (let e = 0; e < a.length; e += 1) void 0 !== a[e + 1] ? n >= a[e] && n < a[e + 1] - (a[e + 1] - a[e]) / 2 ? i = e : n >= a[e] && n < a[e + 1] && (i = e + 1) : n >= a[e] && (i = e);
                            return t.normalizeSlideIndex && (i < 0 || void 0 === i) && (i = 0), i
                        }(a)), n.indexOf(t) >= 0) l = n.indexOf(t);
                    else {
                        const e = Math.min(i.slidesPerGroupSkip, u);
                        l = e + Math.floor((u - e) / i.slidesPerGroup)
                    }
                    if (l >= n.length && (l = n.length - 1), u === r) return l !== o && (a.snapIndex = l, a.emit("snapIndexChange")), void(a.params.loop && a.virtual && a.params.virtual.enabled && (a.realIndex = d(u)));
                    let c;
                    c = a.virtual && i.virtual.enabled && i.loop ? d(u) : a.slides[u] ? parseInt(a.slides[u].getAttribute("data-swiper-slide-index") || u, 10) : u, Object.assign(a, {
                        snapIndex: l,
                        realIndex: c,
                        previousIndex: r,
                        activeIndex: u
                    }), a.initialized && N(a), a.emit("activeIndexChange"), a.emit("snapIndexChange"), s !== c && a.emit("realIndexChange"), (a.initialized || a.params.runCallbacksOnInit) && a.emit("slideChange")
                },
                updateClickedSlide: function(e) {
                    const a = this,
                        t = a.params,
                        n = e.closest(`.${t.slideClass}, swiper-slide`);
                    let i, r = !1;
                    if (n)
                        for (let e = 0; e < a.slides.length; e += 1)
                            if (a.slides[e] === n) {
                                r = !0, i = e;
                                break
                            } if (!n || !r) return a.clickedSlide = void 0, void(a.clickedIndex = void 0);
                    a.clickedSlide = n, a.virtual && a.params.virtual.enabled ? a.clickedIndex = parseInt(n.getAttribute("data-swiper-slide-index"), 10) : a.clickedIndex = i, t.slideToClickedSlide && void 0 !== a.clickedIndex && a.clickedIndex !== a.activeIndex && a.slideToClickedSlide()
                }
            };
            var D = {
                getTranslate: function(e = (this.isHorizontal() ? "x" : "y")) {
                    const {
                        params: a,
                        rtlTranslate: t,
                        translate: n,
                        wrapperEl: i
                    } = this;
                    if (a.virtualTranslate) return t ? -n : n;
                    if (a.cssMode) return n;
                    let r = d(i, e);
                    return t && (r = -r), r || 0
                },
                setTranslate: function(e, a) {
                    const t = this,
                        {
                            rtlTranslate: n,
                            params: i,
                            wrapperEl: r,
                            progress: s
                        } = t;
                    let o, l = 0,
                        u = 0;
                    t.isHorizontal() ? l = n ? -e : e : u = e, i.roundLengths && (l = Math.floor(l), u = Math.floor(u)), i.cssMode ? r[t.isHorizontal() ? "scrollLeft" : "scrollTop"] = t.isHorizontal() ? -l : -u : i.virtualTranslate || (r.style.transform = `translate3d(${l}px, ${u}px, 0px)`), t.previousTranslate = t.translate, t.translate = t.isHorizontal() ? l : u;
                    const d = t.maxTranslate() - t.minTranslate();
                    o = 0 === d ? 0 : (e - t.minTranslate()) / d, o !== s && t.updateProgress(e), t.emit("setTranslate", t.translate, a)
                },
                minTranslate: function() {
                    return -this.snapGrid[0]
                },
                maxTranslate: function() {
                    return -this.snapGrid[this.snapGrid.length - 1]
                },
                translateTo: function(e = 0, a = this.params.speed, t = !0, n = !0, i) {
                    const r = this,
                        {
                            params: s,
                            wrapperEl: o
                        } = r;
                    if (r.animating && s.preventInteractionOnTransition) return !1;
                    const l = r.minTranslate(),
                        u = r.maxTranslate();
                    let d;
                    if (d = n && e > l ? l : n && e < u ? u : e, r.updateProgress(d), s.cssMode) {
                        const e = r.isHorizontal();
                        if (0 === a) o[e ? "scrollLeft" : "scrollTop"] = -d;
                        else {
                            if (!r.support.smoothScroll) return f({
                                swiper: r,
                                targetPosition: -d,
                                side: e ? "left" : "top"
                            }), !0;
                            o.scrollTo({
                                [e ? "left" : "top"]: -d,
                                behavior: "smooth"
                            })
                        }
                        return !0
                    }
                    return 0 === a ? (r.setTransition(0), r.setTranslate(d), t && (r.emit("beforeTransitionStart", a, i), r.emit("transitionEnd"))) : (r.setTransition(a), r.setTranslate(d), t && (r.emit("beforeTransitionStart", a, i), r.emit("transitionStart")), r.animating || (r.animating = !0, r.onTranslateToWrapperTransitionEnd || (r.onTranslateToWrapperTransitionEnd = function(e) {
                        r && !r.destroyed && e.target === this && (r.wrapperEl.removeEventListener("transitionend", r.onTranslateToWrapperTransitionEnd), r.onTranslateToWrapperTransitionEnd = null, delete r.onTranslateToWrapperTransitionEnd, t && r.emit("transitionEnd"))
                    }), r.wrapperEl.addEventListener("transitionend", r.onTranslateToWrapperTransitionEnd))), !0
                }
            };

            function I({
                swiper: e,
                runCallbacks: a,
                direction: t,
                step: n
            }) {
                const {
                    activeIndex: i,
                    previousIndex: r
                } = e;
                let s = t;
                if (s || (s = i > r ? "next" : i < r ? "prev" : "reset"), e.emit(`transition${n}`), a && i !== r) {
                    if ("reset" === s) return void e.emit(`slideResetTransition${n}`);
                    e.emit(`slideChangeTransition${n}`), "next" === s ? e.emit(`slideNextTransition${n}`) : e.emit(`slidePrevTransition${n}`)
                }
            }
            var O = {
                slideTo: function(e = 0, a = this.params.speed, t = !0, n, i) {
                    "string" == typeof e && (e = parseInt(e, 10));
                    const r = this;
                    let s = e;
                    s < 0 && (s = 0);
                    const {
                        params: o,
                        snapGrid: l,
                        slidesGrid: u,
                        previousIndex: d,
                        activeIndex: c,
                        rtlTranslate: p,
                        wrapperEl: h,
                        enabled: m
                    } = r;
                    if (r.animating && o.preventInteractionOnTransition || !m && !n && !i) return !1;
                    const g = Math.min(r.params.slidesPerGroupSkip, s);
                    let v = g + Math.floor((s - g) / r.params.slidesPerGroup);
                    v >= l.length && (v = l.length - 1);
                    const y = -l[v];
                    if (o.normalizeSlideIndex)
                        for (let e = 0; e < u.length; e += 1) {
                            const a = -Math.floor(100 * y),
                                t = Math.floor(100 * u[e]),
                                n = Math.floor(100 * u[e + 1]);
                            void 0 !== u[e + 1] ? a >= t && a < n - (n - t) / 2 ? s = e : a >= t && a < n && (s = e + 1) : a >= t && (s = e)
                        }
                    if (r.initialized && s !== c) {
                        if (!r.allowSlideNext && y < r.translate && y < r.minTranslate()) return !1;
                        if (!r.allowSlidePrev && y > r.translate && y > r.maxTranslate() && (c || 0) !== s) return !1
                    }
                    let b;
                    if (s !== (d || 0) && t && r.emit("beforeSlideChangeStart"), r.updateProgress(y), b = s > c ? "next" : s < c ? "prev" : "reset", p && -y === r.translate || !p && y === r.translate) return r.updateActiveIndex(s), o.autoHeight && r.updateAutoHeight(), r.updateSlidesClasses(), "slide" !== o.effect && r.setTranslate(y), "reset" !== b && (r.transitionStart(t, b), r.transitionEnd(t, b)), !1;
                    if (o.cssMode) {
                        const e = r.isHorizontal(),
                            t = p ? y : -y;
                        if (0 === a) {
                            const a = r.virtual && r.params.virtual.enabled;
                            a && (r.wrapperEl.style.scrollSnapType = "none", r._immediateVirtual = !0), a && !r._cssModeVirtualInitialSet && r.params.initialSlide > 0 ? (r._cssModeVirtualInitialSet = !0, requestAnimationFrame((() => {
                                h[e ? "scrollLeft" : "scrollTop"] = t
                            }))) : h[e ? "scrollLeft" : "scrollTop"] = t, a && requestAnimationFrame((() => {
                                r.wrapperEl.style.scrollSnapType = "", r._immediateVirtual = !1
                            }))
                        } else {
                            if (!r.support.smoothScroll) return f({
                                swiper: r,
                                targetPosition: t,
                                side: e ? "left" : "top"
                            }), !0;
                            h.scrollTo({
                                [e ? "left" : "top"]: t,
                                behavior: "smooth"
                            })
                        }
                        return !0
                    }
                    return r.setTransition(a), r.setTranslate(y), r.updateActiveIndex(s), r.updateSlidesClasses(), r.emit("beforeTransitionStart", a, n), r.transitionStart(t, b), 0 === a ? r.transitionEnd(t, b) : r.animating || (r.animating = !0, r.onSlideToWrapperTransitionEnd || (r.onSlideToWrapperTransitionEnd = function(e) {
                        r && !r.destroyed && e.target === this && (r.wrapperEl.removeEventListener("transitionend", r.onSlideToWrapperTransitionEnd), r.onSlideToWrapperTransitionEnd = null, delete r.onSlideToWrapperTransitionEnd, r.transitionEnd(t, b))
                    }), r.wrapperEl.addEventListener("transitionend", r.onSlideToWrapperTransitionEnd)), !0
                },
                slideToLoop: function(e = 0, a = this.params.speed, t = !0, n) {
                    if ("string" == typeof e) {
                        e = parseInt(e, 10)
                    }
                    const i = this;
                    let r = e;
                    return i.params.loop && (i.virtual && i.params.virtual.enabled ? r += i.virtual.slidesBefore : r = i.getSlideIndexByData(r)), i.slideTo(r, a, t, n)
                },
                slideNext: function(e = this.params.speed, a = !0, t) {
                    const n = this,
                        {
                            enabled: i,
                            params: r,
                            animating: s
                        } = n;
                    if (!i) return n;
                    let o = r.slidesPerGroup;
                    "auto" === r.slidesPerView && 1 === r.slidesPerGroup && r.slidesPerGroupAuto && (o = Math.max(n.slidesPerViewDynamic("current", !0), 1));
                    const l = n.activeIndex < r.slidesPerGroupSkip ? 1 : o,
                        u = n.virtual && r.virtual.enabled;
                    if (r.loop) {
                        if (s && !u && r.loopPreventsSliding) return !1;
                        n.loopFix({
                            direction: "next"
                        }), n._clientLeft = n.wrapperEl.clientLeft
                    }
                    return r.rewind && n.isEnd ? n.slideTo(0, e, a, t) : n.slideTo(n.activeIndex + l, e, a, t)
                },
                slidePrev: function(e = this.params.speed, a = !0, t) {
                    const n = this,
                        {
                            params: i,
                            snapGrid: r,
                            slidesGrid: s,
                            rtlTranslate: o,
                            enabled: l,
                            animating: u
                        } = n;
                    if (!l) return n;
                    const d = n.virtual && i.virtual.enabled;
                    if (i.loop) {
                        if (u && !d && i.loopPreventsSliding) return !1;
                        n.loopFix({
                            direction: "prev"
                        }), n._clientLeft = n.wrapperEl.clientLeft
                    }

                    function c(e) {
                        return e < 0 ? -Math.floor(Math.abs(e)) : Math.floor(e)
                    }
                    const p = c(o ? n.translate : -n.translate),
                        h = r.map((e => c(e)));
                    let f = r[h.indexOf(p) - 1];
                    if (void 0 === f && i.cssMode) {
                        let e;
                        r.forEach(((a, t) => {
                            p >= a && (e = t)
                        })), void 0 !== e && (f = r[e > 0 ? e - 1 : e])
                    }
                    let m = 0;
                    if (void 0 !== f && (m = s.indexOf(f), m < 0 && (m = n.activeIndex - 1), "auto" === i.slidesPerView && 1 === i.slidesPerGroup && i.slidesPerGroupAuto && (m = m - n.slidesPerViewDynamic("previous", !0) + 1, m = Math.max(m, 0))), i.rewind && n.isBeginning) {
                        const i = n.params.virtual && n.params.virtual.enabled && n.virtual ? n.virtual.slides.length - 1 : n.slides.length - 1;
                        return n.slideTo(i, e, a, t)
                    }
                    return n.slideTo(m, e, a, t)
                },
                slideReset: function(e = this.params.speed, a = !0, t) {
                    return this.slideTo(this.activeIndex, e, a, t)
                },
                slideToClosest: function(e = this.params.speed, a = !0, t, n = .5) {
                    const i = this;
                    let r = i.activeIndex;
                    const s = Math.min(i.params.slidesPerGroupSkip, r),
                        o = s + Math.floor((r - s) / i.params.slidesPerGroup),
                        l = i.rtlTranslate ? i.translate : -i.translate;
                    if (l >= i.snapGrid[o]) {
                        const e = i.snapGrid[o];
                        l - e > (i.snapGrid[o + 1] - e) * n && (r += i.params.slidesPerGroup)
                    } else {
                        const e = i.snapGrid[o - 1];
                        l - e <= (i.snapGrid[o] - e) * n && (r -= i.params.slidesPerGroup)
                    }
                    return r = Math.max(r, 0), r = Math.min(r, i.slidesGrid.length - 1), i.slideTo(r, e, a, t)
                },
                slideToClickedSlide: function() {
                    const e = this,
                        {
                            params: a,
                            slidesEl: t
                        } = e,
                        n = "auto" === a.slidesPerView ? e.slidesPerViewDynamic() : a.slidesPerView;
                    let i, r = e.clickedIndex;
                    const s = e.isElement ? "swiper-slide" : `.${a.slideClass}`;
                    if (a.loop) {
                        if (e.animating) return;
                        i = parseInt(e.clickedSlide.getAttribute("data-swiper-slide-index"), 10), a.centeredSlides ? r < e.loopedSlides - n / 2 || r > e.slides.length - e.loopedSlides + n / 2 ? (e.loopFix(), r = e.getSlideIndex(g(t, `${s}[data-swiper-slide-index="${i}"]`)[0]), l((() => {
                            e.slideTo(r)
                        }))) : e.slideTo(r) : r > e.slides.length - n ? (e.loopFix(), r = e.getSlideIndex(g(t, `${s}[data-swiper-slide-index="${i}"]`)[0]), l((() => {
                            e.slideTo(r)
                        }))) : e.slideTo(r)
                    } else e.slideTo(r)
                }
            };
            var R = {
                loopCreate: function(e) {
                    const a = this,
                        {
                            params: t,
                            slidesEl: n
                        } = a;
                    if (!t.loop || a.virtual && a.params.virtual.enabled) return;
                    g(n, `.${t.slideClass}, swiper-slide`).forEach(((e, a) => {
                        e.setAttribute("data-swiper-slide-index", a)
                    })), a.loopFix({
                        slideRealIndex: e,
                        direction: t.centeredSlides ? void 0 : "next"
                    })
                },
                loopFix: function({
                    slideRealIndex: e,
                    slideTo: a = !0,
                    direction: t,
                    setTranslate: n,
                    activeSlideIndex: i,
                    byController: r,
                    byMousewheel: s
                } = {}) {
                    const o = this;
                    if (!o.params.loop) return;
                    o.emit("beforeLoopFix");
                    const {
                        slides: l,
                        allowSlidePrev: u,
                        allowSlideNext: d,
                        slidesEl: c,
                        params: p
                    } = o;
                    if (o.allowSlidePrev = !0, o.allowSlideNext = !0, o.virtual && p.virtual.enabled) return a && (p.centeredSlides || 0 !== o.snapIndex ? p.centeredSlides && o.snapIndex < p.slidesPerView ? o.slideTo(o.virtual.slides.length + o.snapIndex, 0, !1, !0) : o.snapIndex === o.snapGrid.length - 1 && o.slideTo(o.virtual.slidesBefore, 0, !1, !0) : o.slideTo(o.virtual.slides.length, 0, !1, !0)), o.allowSlidePrev = u, o.allowSlideNext = d, void o.emit("loopFix");
                    const h = "auto" === p.slidesPerView ? o.slidesPerViewDynamic() : Math.ceil(parseFloat(p.slidesPerView, 10));
                    let f = p.loopedSlides || h;
                    f % p.slidesPerGroup != 0 && (f += p.slidesPerGroup - f % p.slidesPerGroup), o.loopedSlides = f;
                    const m = [],
                        g = [];
                    let v = o.activeIndex;
                    void 0 === i ? i = o.getSlideIndex(o.slides.filter((e => e.classList.contains(p.slideActiveClass)))[0]) : v = i;
                    const y = "next" === t || !t,
                        b = "prev" === t || !t;
                    let S = 0,
                        w = 0;
                    if (i < f) {
                        S = Math.max(f - i, p.slidesPerGroup);
                        for (let e = 0; e < f - i; e += 1) {
                            const a = e - Math.floor(e / l.length) * l.length;
                            m.push(l.length - a - 1)
                        }
                    } else if (i > o.slides.length - 2 * f) {
                        w = Math.max(i - (o.slides.length - 2 * f), p.slidesPerGroup);
                        for (let e = 0; e < w; e += 1) {
                            const a = e - Math.floor(e / l.length) * l.length;
                            g.push(a)
                        }
                    }
                    if (b && m.forEach((e => {
                            c.prepend(o.slides[e])
                        })), y && g.forEach((e => {
                            c.append(o.slides[e])
                        })), o.recalcSlides(), p.watchSlidesProgress && o.updateSlidesOffset(), a)
                        if (m.length > 0 && b)
                            if (void 0 === e) {
                                const e = o.slidesGrid[v],
                                    a = o.slidesGrid[v + S] - e;
                                s ? o.setTranslate(o.translate - a) : (o.slideTo(v + S, 0, !1, !0), n && (o.touches[o.isHorizontal() ? "startX" : "startY"] += a))
                            } else n && o.slideToLoop(e, 0, !1, !0);
                    else if (g.length > 0 && y)
                        if (void 0 === e) {
                            const e = o.slidesGrid[v],
                                a = o.slidesGrid[v - w] - e;
                            s ? o.setTranslate(o.translate - a) : (o.slideTo(v - w, 0, !1, !0), n && (o.touches[o.isHorizontal() ? "startX" : "startY"] += a))
                        } else o.slideToLoop(e, 0, !1, !0);
                    if (o.allowSlidePrev = u, o.allowSlideNext = d, o.controller && o.controller.control && !r) {
                        const a = {
                            slideRealIndex: e,
                            slideTo: !1,
                            direction: t,
                            setTranslate: n,
                            activeSlideIndex: i,
                            byController: !0
                        };
                        Array.isArray(o.controller.control) ? o.controller.control.forEach((e => {
                            !e.destroyed && e.params.loop && e.loopFix(a)
                        })) : o.controller.control instanceof o.constructor && o.controller.control.params.loop && o.controller.control.loopFix(a)
                    }
                    o.emit("loopFix")
                },
                loopDestroy: function() {
                    const e = this,
                        {
                            params: a,
                            slidesEl: t
                        } = e;
                    if (!a.loop || e.virtual && e.params.virtual.enabled) return;
                    e.recalcSlides();
                    const n = [];
                    e.slides.forEach((e => {
                        const a = void 0 === e.swiperSlideIndex ? 1 * e.getAttribute("data-swiper-slide-index") : e.swiperSlideIndex;
                        n[a] = e
                    })), e.slides.forEach((e => {
                        e.removeAttribute("data-swiper-slide-index")
                    })), n.forEach((e => {
                        t.append(e)
                    })), e.recalcSlides(), e.slideTo(e.realIndex, 0)
                }
            };

            function H(e) {
                const a = this,
                    t = r(),
                    n = o(),
                    i = a.touchEventsData;
                i.evCache.push(e);
                const {
                    params: s,
                    touches: l,
                    enabled: d
                } = a;
                if (!d) return;
                if (!s.simulateTouch && "mouse" === e.pointerType) return;
                if (a.animating && s.preventInteractionOnTransition) return;
                !a.animating && s.cssMode && s.loop && a.loopFix();
                let c = e;
                c.originalEvent && (c = c.originalEvent);
                let p = c.target;
                if ("wrapper" === s.touchEventsTarget && !a.wrapperEl.contains(p)) return;
                if ("which" in c && 3 === c.which) return;
                if ("button" in c && c.button > 0) return;
                if (i.isTouched && i.isMoved) return;
                const h = !!s.noSwipingClass && "" !== s.noSwipingClass,
                    f = e.composedPath ? e.composedPath() : e.path;
                h && c.target && c.target.shadowRoot && f && (p = f[0]);
                const m = s.noSwipingSelector ? s.noSwipingSelector : `.${s.noSwipingClass}`,
                    g = !(!c.target || !c.target.shadowRoot);
                if (s.noSwiping && (g ? function(e, a = this) {
                        return function a(t) {
                            if (!t || t === r() || t === o()) return null;
                            t.assignedSlot && (t = t.assignedSlot);
                            const n = t.closest(e);
                            return n || t.getRootNode ? n || a(t.getRootNode().host) : null
                        }(a)
                    }(m, p) : p.closest(m))) return void(a.allowClick = !0);
                if (s.swipeHandler && !p.closest(s.swipeHandler)) return;
                l.currentX = c.pageX, l.currentY = c.pageY;
                const v = l.currentX,
                    y = l.currentY,
                    b = s.edgeSwipeDetection || s.iOSEdgeSwipeDetection,
                    S = s.edgeSwipeThreshold || s.iOSEdgeSwipeThreshold;
                if (b && (v <= S || v >= n.innerWidth - S)) {
                    if ("prevent" !== b) return;
                    e.preventDefault()
                }
                Object.assign(i, {
                    isTouched: !0,
                    isMoved: !1,
                    allowTouchCallbacks: !0,
                    isScrolling: void 0,
                    startMoving: void 0
                }), l.startX = v, l.startY = y, i.touchStartTime = u(), a.allowClick = !0, a.updateSize(), a.swipeDirection = void 0, s.threshold > 0 && (i.allowThresholdMove = !1);
                let w = !0;
                p.matches(i.focusableElements) && (w = !1, "SELECT" === p.nodeName && (i.isTouched = !1)), t.activeElement && t.activeElement.matches(i.focusableElements) && t.activeElement !== p && t.activeElement.blur();
                const k = w && a.allowTouchMove && s.touchStartPreventDefault;
                !s.touchStartForcePreventDefault && !k || p.isContentEditable || c.preventDefault(), a.params.freeMode && a.params.freeMode.enabled && a.freeMode && a.animating && !s.cssMode && a.freeMode.onTouchStart(), a.emit("touchStart", c)
            }

            function G(e) {
                const a = r(),
                    t = this,
                    n = t.touchEventsData,
                    {
                        params: i,
                        touches: s,
                        rtlTranslate: o,
                        enabled: l
                    } = t;
                if (!l) return;
                if (!i.simulateTouch && "mouse" === e.pointerType) return;
                let d = e;
                if (d.originalEvent && (d = d.originalEvent), !n.isTouched) return void(n.startMoving && n.isScrolling && t.emit("touchMoveOpposite", d));
                const c = n.evCache.findIndex((e => e.pointerId === d.pointerId));
                c >= 0 && (n.evCache[c] = d);
                const p = n.evCache.length > 1 ? n.evCache[0] : d,
                    h = p.pageX,
                    f = p.pageY;
                if (d.preventedByNestedSwiper) return s.startX = h, void(s.startY = f);
                if (!t.allowTouchMove) return d.target.matches(n.focusableElements) || (t.allowClick = !1), void(n.isTouched && (Object.assign(s, {
                    startX: h,
                    startY: f,
                    prevX: t.touches.currentX,
                    prevY: t.touches.currentY,
                    currentX: h,
                    currentY: f
                }), n.touchStartTime = u()));
                if (i.touchReleaseOnEdges && !i.loop)
                    if (t.isVertical()) {
                        if (f < s.startY && t.translate <= t.maxTranslate() || f > s.startY && t.translate >= t.minTranslate()) return n.isTouched = !1, void(n.isMoved = !1)
                    } else if (h < s.startX && t.translate <= t.maxTranslate() || h > s.startX && t.translate >= t.minTranslate()) return;
                if (a.activeElement && d.target === a.activeElement && d.target.matches(n.focusableElements)) return n.isMoved = !0, void(t.allowClick = !1);
                if (n.allowTouchCallbacks && t.emit("touchMove", d), d.targetTouches && d.targetTouches.length > 1) return;
                s.currentX = h, s.currentY = f;
                const m = s.currentX - s.startX,
                    g = s.currentY - s.startY;
                if (t.params.threshold && Math.sqrt(m ** 2 + g ** 2) < t.params.threshold) return;
                if (void 0 === n.isScrolling) {
                    let e;
                    t.isHorizontal() && s.currentY === s.startY || t.isVertical() && s.currentX === s.startX ? n.isScrolling = !1 : m * m + g * g >= 25 && (e = 180 * Math.atan2(Math.abs(g), Math.abs(m)) / Math.PI, n.isScrolling = t.isHorizontal() ? e > i.touchAngle : 90 - e > i.touchAngle)
                }
                if (n.isScrolling && t.emit("touchMoveOpposite", d), void 0 === n.startMoving && (s.currentX === s.startX && s.currentY === s.startY || (n.startMoving = !0)), n.isScrolling || t.zoom && t.params.zoom && t.params.zoom.enabled && n.evCache.length > 1) return void(n.isTouched = !1);
                if (!n.startMoving) return;
                t.allowClick = !1, !i.cssMode && d.cancelable && d.preventDefault(), i.touchMoveStopPropagation && !i.nested && d.stopPropagation();
                let v = t.isHorizontal() ? m : g,
                    y = t.isHorizontal() ? s.currentX - s.previousX : s.currentY - s.previousY;
                i.oneWayMovement && (v = Math.abs(v) * (o ? 1 : -1), y = Math.abs(y) * (o ? 1 : -1)), s.diff = v, v *= i.touchRatio, o && (v = -v, y = -y);
                const b = t.touchesDirection;
                t.swipeDirection = v > 0 ? "prev" : "next", t.touchesDirection = y > 0 ? "prev" : "next";
                const S = t.params.loop && !i.cssMode;
                if (!n.isMoved) {
                    if (S && t.loopFix({
                            direction: t.swipeDirection
                        }), n.startTranslate = t.getTranslate(), t.setTransition(0), t.animating) {
                        const e = new window.CustomEvent("transitionend", {
                            bubbles: !0,
                            cancelable: !0
                        });
                        t.wrapperEl.dispatchEvent(e)
                    }
                    n.allowMomentumBounce = !1, !i.grabCursor || !0 !== t.allowSlideNext && !0 !== t.allowSlidePrev || t.setGrabCursor(!0), t.emit("sliderFirstMove", d)
                }
                let w;
                n.isMoved && b !== t.touchesDirection && S && Math.abs(v) >= 1 && (t.loopFix({
                    direction: t.swipeDirection,
                    setTranslate: !0
                }), w = !0), t.emit("sliderMove", d), n.isMoved = !0, n.currentTranslate = v + n.startTranslate;
                let k = !0,
                    T = i.resistanceRatio;
                if (i.touchReleaseOnEdges && (T = 0), v > 0 ? (S && !w && n.currentTranslate > (i.centeredSlides ? t.minTranslate() - t.size / 2 : t.minTranslate()) && t.loopFix({
                        direction: "prev",
                        setTranslate: !0,
                        activeSlideIndex: 0
                    }), n.currentTranslate > t.minTranslate() && (k = !1, i.resistance && (n.currentTranslate = t.minTranslate() - 1 + (-t.minTranslate() + n.startTranslate + v) ** T))) : v < 0 && (S && !w && n.currentTranslate < (i.centeredSlides ? t.maxTranslate() + t.size / 2 : t.maxTranslate()) && t.loopFix({
                        direction: "next",
                        setTranslate: !0,
                        activeSlideIndex: t.slides.length - ("auto" === i.slidesPerView ? t.slidesPerViewDynamic() : Math.ceil(parseFloat(i.slidesPerView, 10)))
                    }), n.currentTranslate < t.maxTranslate() && (k = !1, i.resistance && (n.currentTranslate = t.maxTranslate() + 1 - (t.maxTranslate() - n.startTranslate - v) ** T))), k && (d.preventedByNestedSwiper = !0), !t.allowSlideNext && "next" === t.swipeDirection && n.currentTranslate < n.startTranslate && (n.currentTranslate = n.startTranslate), !t.allowSlidePrev && "prev" === t.swipeDirection && n.currentTranslate > n.startTranslate && (n.currentTranslate = n.startTranslate), t.allowSlidePrev || t.allowSlideNext || (n.currentTranslate = n.startTranslate), i.threshold > 0) {
                    if (!(Math.abs(v) > i.threshold || n.allowThresholdMove)) return void(n.currentTranslate = n.startTranslate);
                    if (!n.allowThresholdMove) return n.allowThresholdMove = !0, s.startX = s.currentX, s.startY = s.currentY, n.currentTranslate = n.startTranslate, void(s.diff = t.isHorizontal() ? s.currentX - s.startX : s.currentY - s.startY)
                }
                i.followFinger && !i.cssMode && ((i.freeMode && i.freeMode.enabled && t.freeMode || i.watchSlidesProgress) && (t.updateActiveIndex(), t.updateSlidesClasses()), t.params.freeMode && i.freeMode.enabled && t.freeMode && t.freeMode.onTouchMove(), t.updateProgress(n.currentTranslate), t.setTranslate(n.currentTranslate))
            }

            function q(e) {
                const a = this,
                    t = a.touchEventsData,
                    n = t.evCache.findIndex((a => a.pointerId === e.pointerId));
                if (n >= 0 && t.evCache.splice(n, 1), ["pointercancel", "pointerout", "pointerleave"].includes(e.type)) {
                    if (!("pointercancel" === e.type && (a.browser.isSafari || a.browser.isWebView))) return
                }
                const {
                    params: i,
                    touches: r,
                    rtlTranslate: s,
                    slidesGrid: o,
                    enabled: d
                } = a;
                if (!d) return;
                if (!i.simulateTouch && "mouse" === e.pointerType) return;
                let c = e;
                if (c.originalEvent && (c = c.originalEvent), t.allowTouchCallbacks && a.emit("touchEnd", c), t.allowTouchCallbacks = !1, !t.isTouched) return t.isMoved && i.grabCursor && a.setGrabCursor(!1), t.isMoved = !1, void(t.startMoving = !1);
                i.grabCursor && t.isMoved && t.isTouched && (!0 === a.allowSlideNext || !0 === a.allowSlidePrev) && a.setGrabCursor(!1);
                const p = u(),
                    h = p - t.touchStartTime;
                if (a.allowClick) {
                    const e = c.path || c.composedPath && c.composedPath();
                    a.updateClickedSlide(e && e[0] || c.target), a.emit("tap click", c), h < 300 && p - t.lastClickTime < 300 && a.emit("doubleTap doubleClick", c)
                }
                if (t.lastClickTime = u(), l((() => {
                        a.destroyed || (a.allowClick = !0)
                    })), !t.isTouched || !t.isMoved || !a.swipeDirection || 0 === r.diff || t.currentTranslate === t.startTranslate) return t.isTouched = !1, t.isMoved = !1, void(t.startMoving = !1);
                let f;
                if (t.isTouched = !1, t.isMoved = !1, t.startMoving = !1, f = i.followFinger ? s ? a.translate : -a.translate : -t.currentTranslate, i.cssMode) return;
                if (a.params.freeMode && i.freeMode.enabled) return void a.freeMode.onTouchEnd({
                    currentPos: f
                });
                let m = 0,
                    g = a.slidesSizesGrid[0];
                for (let e = 0; e < o.length; e += e < i.slidesPerGroupSkip ? 1 : i.slidesPerGroup) {
                    const a = e < i.slidesPerGroupSkip - 1 ? 1 : i.slidesPerGroup;
                    void 0 !== o[e + a] ? f >= o[e] && f < o[e + a] && (m = e, g = o[e + a] - o[e]) : f >= o[e] && (m = e, g = o[o.length - 1] - o[o.length - 2])
                }
                let v = null,
                    y = null;
                i.rewind && (a.isBeginning ? y = a.params.virtual && a.params.virtual.enabled && a.virtual ? a.virtual.slides.length - 1 : a.slides.length - 1 : a.isEnd && (v = 0));
                const b = (f - o[m]) / g,
                    S = m < i.slidesPerGroupSkip - 1 ? 1 : i.slidesPerGroup;
                if (h > i.longSwipesMs) {
                    if (!i.longSwipes) return void a.slideTo(a.activeIndex);
                    "next" === a.swipeDirection && (b >= i.longSwipesRatio ? a.slideTo(i.rewind && a.isEnd ? v : m + S) : a.slideTo(m)), "prev" === a.swipeDirection && (b > 1 - i.longSwipesRatio ? a.slideTo(m + S) : null !== y && b < 0 && Math.abs(b) > i.longSwipesRatio ? a.slideTo(y) : a.slideTo(m))
                } else {
                    if (!i.shortSwipes) return void a.slideTo(a.activeIndex);
                    a.navigation && (c.target === a.navigation.nextEl || c.target === a.navigation.prevEl) ? c.target === a.navigation.nextEl ? a.slideTo(m + S) : a.slideTo(m) : ("next" === a.swipeDirection && a.slideTo(null !== v ? v : m + S), "prev" === a.swipeDirection && a.slideTo(null !== y ? y : m))
                }
            }
            let K;

            function $() {
                const e = this,
                    {
                        params: a,
                        el: t
                    } = e;
                if (t && 0 === t.offsetWidth) return;
                a.breakpoints && e.setBreakpoint();
                const {
                    allowSlideNext: n,
                    allowSlidePrev: i,
                    snapGrid: r
                } = e, s = e.virtual && e.params.virtual.enabled;
                e.allowSlideNext = !0, e.allowSlidePrev = !0, e.updateSize(), e.updateSlides(), e.updateSlidesClasses();
                const o = s && a.loop;
                !("auto" === a.slidesPerView || a.slidesPerView > 1) || !e.isEnd || e.isBeginning || e.params.centeredSlides || o ? e.params.loop && !s ? e.slideToLoop(e.realIndex, 0, !1, !0) : e.slideTo(e.activeIndex, 0, !1, !0) : e.slideTo(e.slides.length - 1, 0, !1, !0), e.autoplay && e.autoplay.running && e.autoplay.paused && (clearTimeout(K), K = setTimeout((() => {
                    e.autoplay && e.autoplay.running && e.autoplay.paused && e.autoplay.resume()
                }), 500)), e.allowSlidePrev = i, e.allowSlideNext = n, e.params.watchOverflow && r !== e.snapGrid && e.checkOverflow()
            }

            function V(e) {
                const a = this;
                a.enabled && (a.allowClick || (a.params.preventClicks && e.preventDefault(), a.params.preventClicksPropagation && a.animating && (e.stopPropagation(), e.stopImmediatePropagation())))
            }

            function W() {
                const e = this,
                    {
                        wrapperEl: a,
                        rtlTranslate: t,
                        enabled: n
                    } = e;
                if (!n) return;
                let i;
                e.previousTranslate = e.translate, e.isHorizontal() ? e.translate = -a.scrollLeft : e.translate = -a.scrollTop, 0 === e.translate && (e.translate = 0), e.updateActiveIndex(), e.updateSlidesClasses();
                const r = e.maxTranslate() - e.minTranslate();
                i = 0 === r ? 0 : (e.translate - e.minTranslate()) / r, i !== e.progress && e.updateProgress(t ? -e.translate : e.translate), e.emit("setTranslate", e.translate, !1)
            }

            function F(e) {
                j(this, e.target), this.update()
            }
            let _ = !1;

            function Y() {}
            const X = (e, a) => {
                const t = r(),
                    {
                        params: n,
                        el: i,
                        wrapperEl: s,
                        device: o
                    } = e,
                    l = !!n.nested,
                    u = "on" === a ? "addEventListener" : "removeEventListener",
                    d = a;
                i[u]("pointerdown", e.onTouchStart, {
                    passive: !1
                }), t[u]("pointermove", e.onTouchMove, {
                    passive: !1,
                    capture: l
                }), t[u]("pointerup", e.onTouchEnd, {
                    passive: !0
                }), t[u]("pointercancel", e.onTouchEnd, {
                    passive: !0
                }), t[u]("pointerout", e.onTouchEnd, {
                    passive: !0
                }), t[u]("pointerleave", e.onTouchEnd, {
                    passive: !0
                }), (n.preventClicks || n.preventClicksPropagation) && i[u]("click", e.onClick, !0), n.cssMode && s[u]("scroll", e.onScroll), n.updateOnWindowResize ? e[d](o.ios || o.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", $, !0) : e[d]("observerUpdate", $, !0), i[u]("load", e.onLoad, {
                    capture: !0
                })
            };
            const J = (e, a) => e.grid && a.grid && a.grid.rows > 1;
            var U = {
                setBreakpoint: function() {
                    const e = this,
                        {
                            realIndex: a,
                            initialized: t,
                            params: n,
                            el: i
                        } = e,
                        r = n.breakpoints;
                    if (!r || r && 0 === Object.keys(r).length) return;
                    const s = e.getBreakpoint(r, e.params.breakpointsBase, e.el);
                    if (!s || e.currentBreakpoint === s) return;
                    const o = (s in r ? r[s] : void 0) || e.originalParams,
                        l = J(e, n),
                        u = J(e, o),
                        d = n.enabled;
                    l && !u ? (i.classList.remove(`${n.containerModifierClass}grid`, `${n.containerModifierClass}grid-column`), e.emitContainerClasses()) : !l && u && (i.classList.add(`${n.containerModifierClass}grid`), (o.grid.fill && "column" === o.grid.fill || !o.grid.fill && "column" === n.grid.fill) && i.classList.add(`${n.containerModifierClass}grid-column`), e.emitContainerClasses()), ["navigation", "pagination", "scrollbar"].forEach((a => {
                        const t = n[a] && n[a].enabled,
                            i = o[a] && o[a].enabled;
                        t && !i && e[a].disable(), !t && i && e[a].enable()
                    }));
                    const c = o.direction && o.direction !== n.direction,
                        h = n.loop && (o.slidesPerView !== n.slidesPerView || c);
                    c && t && e.changeDirection(), p(e.params, o);
                    const f = e.params.enabled;
                    Object.assign(e, {
                        allowTouchMove: e.params.allowTouchMove,
                        allowSlideNext: e.params.allowSlideNext,
                        allowSlidePrev: e.params.allowSlidePrev
                    }), d && !f ? e.disable() : !d && f && e.enable(), e.currentBreakpoint = s, e.emit("_beforeBreakpoint", o), h && t && (e.loopDestroy(), e.loopCreate(a), e.updateSlides()), e.emit("breakpoint", o)
                },
                getBreakpoint: function(e, a = "window", t) {
                    if (!e || "container" === a && !t) return;
                    let n = !1;
                    const i = o(),
                        r = "window" === a ? i.innerHeight : t.clientHeight,
                        s = Object.keys(e).map((e => {
                            if ("string" == typeof e && 0 === e.indexOf("@")) {
                                const a = parseFloat(e.substr(1));
                                return {
                                    value: r * a,
                                    point: e
                                }
                            }
                            return {
                                value: e,
                                point: e
                            }
                        }));
                    s.sort(((e, a) => parseInt(e.value, 10) - parseInt(a.value, 10)));
                    for (let e = 0; e < s.length; e += 1) {
                        const {
                            point: r,
                            value: o
                        } = s[e];
                        "window" === a ? i.matchMedia(`(min-width: ${o}px)`).matches && (n = r) : o <= t.clientWidth && (n = r)
                    }
                    return n || "max"
                }
            };
            var Z = {
                init: !0,
                direction: "horizontal",
                oneWayMovement: !1,
                touchEventsTarget: "wrapper",
                initialSlide: 0,
                speed: 300,
                cssMode: !1,
                updateOnWindowResize: !0,
                resizeObserver: !0,
                nested: !1,
                createElements: !1,
                enabled: !0,
                focusableElements: "input, select, option, textarea, button, video, label",
                width: null,
                height: null,
                preventInteractionOnTransition: !1,
                userAgent: null,
                url: null,
                edgeSwipeDetection: !1,
                edgeSwipeThreshold: 20,
                autoHeight: !1,
                setWrapperSize: !1,
                virtualTranslate: !1,
                effect: "slide",
                breakpoints: void 0,
                breakpointsBase: "window",
                spaceBetween: 0,
                slidesPerView: 1,
                loop: true,
                slidesPerGroup: 1,
                slidesPerGroupSkip: 0,
                slidesPerGroupAuto: !1,
                centeredSlides: !1,
                centeredSlidesBounds: !1,
                slidesOffsetBefore: 0,
                slidesOffsetAfter: 0,
                normalizeSlideIndex: !0,
                centerInsufficientSlides: !1,
                watchOverflow: !0,
                roundLengths: !1,
                touchRatio: 1,
                touchAngle: 45,
                simulateTouch: !0,
                shortSwipes: !0,
                longSwipes: !0,
                longSwipesRatio: .5,
                longSwipesMs: 300,
                followFinger: !0,
                allowTouchMove: !0,
                threshold: 5,
                touchMoveStopPropagation: !1,
                touchStartPreventDefault: !0,
                touchStartForcePreventDefault: !1,
                touchReleaseOnEdges: !1,
                uniqueNavElements: !0,
                resistance: !0,
                resistanceRatio: .85,
                watchSlidesProgress: !1,
                grabCursor: !1,
                preventClicks: !0,
                preventClicksPropagation: !0,
                slideToClickedSlide: !1,
                loop: !1,
                loopedSlides: null,
                loopPreventsSliding: !0,
                rewind: !1,
                allowSlidePrev: !0,
                allowSlideNext: !0,
                swipeHandler: null,
                noSwiping: !0,
                noSwipingClass: "swiper-no-swiping",
                noSwipingSelector: null,
                passiveListeners: !0,
                maxBackfaceHiddenSlides: 10,
                containerModifierClass: "swiper-",
                slideClass: "swiper-slide",
                slideActiveClass: "swiper-slide-active",
                slideVisibleClass: "swiper-slide-visible",
                slideNextClass: "swiper-slide-next",
                slidePrevClass: "swiper-slide-prev",
                wrapperClass: "swiper-wrapper",
                lazyPreloaderClass: "swiper-lazy-preloader",
                lazyPreloadPrevNext: 0,
                runCallbacksOnInit: !0,
                _emitClasses: !1
            };

            function Q(e, a) {
                return function(t = {}) {
                    const n = Object.keys(t)[0],
                        i = t[n];
                    "object" == typeof i && null !== i ? (["navigation", "pagination", "scrollbar"].indexOf(n) >= 0 && !0 === e[n] && (e[n] = {
                        auto: !0
                    }), n in e && "enabled" in i ? (!0 === e[n] && (e[n] = {
                        enabled: !0
                    }), "object" != typeof e[n] || "enabled" in e[n] || (e[n].enabled = !0), e[n] || (e[n] = {
                        enabled: !1
                    }), p(a, t)) : p(a, t)) : p(a, t)
                }
            }
            const ee = {
                    eventsEmitter: L,
                    update: z,
                    translate: D,
                    transition: {
                        setTransition: function(e, a) {
                            const t = this;
                            t.params.cssMode || (t.wrapperEl.style.transitionDuration = `${e}ms`), t.emit("setTransition", e, a)
                        },
                        transitionStart: function(e = !0, a) {
                            const t = this,
                                {
                                    params: n
                                } = t;
                            n.cssMode || (n.autoHeight && t.updateAutoHeight(), I({
                                swiper: t,
                                runCallbacks: e,
                                direction: a,
                                step: "Start"
                            }))
                        },
                        transitionEnd: function(e = !0, a) {
                            const t = this,
                                {
                                    params: n
                                } = t;
                            t.animating = !1, n.cssMode || (t.setTransition(0), I({
                                swiper: t,
                                runCallbacks: e,
                                direction: a,
                                step: "End"
                            }))
                        }
                    },
                    slide: O,
                    loop: R,
                    grabCursor: {
                        setGrabCursor: function(e) {
                            const a = this;
                            if (!a.params.simulateTouch || a.params.watchOverflow && a.isLocked || a.params.cssMode) return;
                            const t = "container" === a.params.touchEventsTarget ? a.el : a.wrapperEl;
                            a.isElement && (a.__preventObserver__ = !0), t.style.cursor = "move", t.style.cursor = e ? "grabbing" : "grab", a.isElement && requestAnimationFrame((() => {
                                a.__preventObserver__ = !1
                            }))
                        },
                        unsetGrabCursor: function() {
                            const e = this;
                            e.params.watchOverflow && e.isLocked || e.params.cssMode || (e.isElement && (e.__preventObserver__ = !0), e["container" === e.params.touchEventsTarget ? "el" : "wrapperEl"].style.cursor = "", e.isElement && requestAnimationFrame((() => {
                                e.__preventObserver__ = !1
                            })))
                        }
                    },
                    events: {
                        attachEvents: function() {
                            const e = this,
                                a = r(),
                                {
                                    params: t
                                } = e;
                            e.onTouchStart = H.bind(e), e.onTouchMove = G.bind(e), e.onTouchEnd = q.bind(e), t.cssMode && (e.onScroll = W.bind(e)), e.onClick = V.bind(e), e.onLoad = F.bind(e), _ || (a.addEventListener("touchstart", Y), _ = !0), X(e, "on")
                        },
                        detachEvents: function() {
                            X(this, "off")
                        }
                    },
                    breakpoints: U,
                    checkOverflow: {
                        checkOverflow: function() {
                            const e = this,
                                {
                                    isLocked: a,
                                    params: t
                                } = e,
                                {
                                    slidesOffsetBefore: n
                                } = t;
                            if (n) {
                                const a = e.slides.length - 1,
                                    t = e.slidesGrid[a] + e.slidesSizesGrid[a] + 2 * n;
                                e.isLocked = e.size > t
                            } else e.isLocked = 1 === e.snapGrid.length;
                            !0 === t.allowSlideNext && (e.allowSlideNext = !e.isLocked), !0 === t.allowSlidePrev && (e.allowSlidePrev = !e.isLocked), a && a !== e.isLocked && (e.isEnd = !1), a !== e.isLocked && e.emit(e.isLocked ? "lock" : "unlock")
                        }
                    },
                    classes: {
                        addClasses: function() {
                            const e = this,
                                {
                                    classNames: a,
                                    params: t,
                                    rtl: n,
                                    el: i,
                                    device: r
                                } = e,
                                s = function(e, a) {
                                    const t = [];
                                    return e.forEach((e => {
                                        "object" == typeof e ? Object.keys(e).forEach((n => {
                                            e[n] && t.push(a + n)
                                        })) : "string" == typeof e && t.push(a + e)
                                    })), t
                                }(["initialized", t.direction, {
                                    "free-mode": e.params.freeMode && t.freeMode.enabled
                                }, {
                                    autoheight: t.autoHeight
                                }, {
                                    rtl: n
                                }, {
                                    grid: t.grid && t.grid.rows > 1
                                }, {
                                    "grid-column": t.grid && t.grid.rows > 1 && "column" === t.grid.fill
                                }, {
                                    android: r.android
                                }, {
                                    ios: r.ios
                                }, {
                                    "css-mode": t.cssMode
                                }, {
                                    centered: t.cssMode && t.centeredSlides
                                }, {
                                    "watch-progress": t.watchSlidesProgress
                                }], t.containerModifierClass);
                            a.push(...s), i.classList.add(...a), e.emitContainerClasses()
                        },
                        removeClasses: function() {
                            const {
                                el: e,
                                classNames: a
                            } = this;
                            e.classList.remove(...a), this.emitContainerClasses()
                        }
                    }
                },
                ae = {};
            class te {
                constructor(...e) {
                    let a, t;
                    1 === e.length && e[0].constructor && "Object" === Object.prototype.toString.call(e[0]).slice(8, -1) ? t = e[0] : [a, t] = e, t || (t = {}), t = p({}, t), a && !t.el && (t.el = a);
                    const n = r();
                    if (t.el && "string" == typeof t.el && n.querySelectorAll(t.el).length > 1) {
                        const e = [];
                        return n.querySelectorAll(t.el).forEach((a => {
                            const n = p({}, t, {
                                el: a
                            });
                            e.push(new te(n))
                        })), e
                    }
                    const i = this;
                    i.__swiper__ = !0, i.support = M(), i.device = A({
                        userAgent: t.userAgent
                    }), i.browser = P(), i.eventsListeners = {}, i.eventsAnyListeners = [], i.modules = [...i.__modules__], t.modules && Array.isArray(t.modules) && i.modules.push(...t.modules);
                    const s = {};
                    i.modules.forEach((e => {
                        e({
                            params: t,
                            swiper: i,
                            extendParams: Q(t, s),
                            on: i.on.bind(i),
                            once: i.once.bind(i),
                            off: i.off.bind(i),
                            emit: i.emit.bind(i)
                        })
                    }));
                    const o = p({}, Z, s);
                    return i.params = p({}, o, ae, t), i.originalParams = p({}, i.params), i.passedParams = p({}, t), i.params && i.params.on && Object.keys(i.params.on).forEach((e => {
                        i.on(e, i.params.on[e])
                    })), i.params && i.params.onAny && i.onAny(i.params.onAny), Object.assign(i, {
                        enabled: i.params.enabled,
                        el: a,
                        classNames: [],
                        slides: [],
                        slidesGrid: [],
                        snapGrid: [],
                        slidesSizesGrid: [],
                        isHorizontal() {
                            return "horizontal" === i.params.direction
                        },
                        isVertical() {
                            return "vertical" === i.params.direction
                        },
                        activeIndex: 0,
                        realIndex: 0,
                        isBeginning: !0,
                        isEnd: !1,
                        translate: 0,
                        previousTranslate: 0,
                        progress: 0,
                        velocity: 0,
                        animating: !1,
                        allowSlideNext: i.params.allowSlideNext,
                        allowSlidePrev: i.params.allowSlidePrev,
                        touchEventsData: {
                            isTouched: void 0,
                            isMoved: void 0,
                            allowTouchCallbacks: void 0,
                            touchStartTime: void 0,
                            isScrolling: void 0,
                            currentTranslate: void 0,
                            startTranslate: void 0,
                            allowThresholdMove: void 0,
                            focusableElements: i.params.focusableElements,
                            lastClickTime: 0,
                            clickTimeout: void 0,
                            velocities: [],
                            allowMomentumBounce: void 0,
                            startMoving: void 0,
                            evCache: []
                        },
                        allowClick: !0,
                        allowTouchMove: i.params.allowTouchMove,
                        touches: {
                            startX: 0,
                            startY: 0,
                            currentX: 0,
                            currentY: 0,
                            diff: 0
                        },
                        imagesToLoad: [],
                        imagesLoaded: 0
                    }), i.emit("_swiper"), i.params.init && i.init(), i
                }
                getSlideIndex(e) {
                    const {
                        slidesEl: a,
                        params: t
                    } = this, n = S(g(a, `.${t.slideClass}, swiper-slide`)[0]);
                    return S(e) - n
                }
                getSlideIndexByData(e) {
                    return this.getSlideIndex(this.slides.filter((a => 1 * a.getAttribute("data-swiper-slide-index") === e))[0])
                }
                recalcSlides() {
                    const {
                        slidesEl: e,
                        params: a
                    } = this;
                    this.slides = g(e, `.${a.slideClass}, swiper-slide`)
                }
                enable() {
                    const e = this;
                    e.enabled || (e.enabled = !0, e.params.grabCursor && e.setGrabCursor(), e.emit("enable"))
                }
                disable() {
                    const e = this;
                    e.enabled && (e.enabled = !1, e.params.grabCursor && e.unsetGrabCursor(), e.emit("disable"))
                }
                setProgress(e, a) {
                    const t = this;
                    e = Math.min(Math.max(e, 0), 1);
                    const n = t.minTranslate(),
                        i = (t.maxTranslate() - n) * e + n;
                    t.translateTo(i, void 0 === a ? 0 : a), t.updateActiveIndex(), t.updateSlidesClasses()
                }
                emitContainerClasses() {
                    const e = this;
                    if (!e.params._emitClasses || !e.el) return;
                    const a = e.el.className.split(" ").filter((a => 0 === a.indexOf("swiper") || 0 === a.indexOf(e.params.containerModifierClass)));
                    e.emit("_containerClasses", a.join(" "))
                }
                getSlideClasses(e) {
                    const a = this;
                    return a.destroyed ? "" : e.className.split(" ").filter((e => 0 === e.indexOf("swiper-slide") || 0 === e.indexOf(a.params.slideClass))).join(" ")
                }
                emitSlidesClasses() {
                    const e = this;
                    if (!e.params._emitClasses || !e.el) return;
                    const a = [];
                    e.slides.forEach((t => {
                        const n = e.getSlideClasses(t);
                        a.push({
                            slideEl: t,
                            classNames: n
                        }), e.emit("_slideClass", t, n)
                    })), e.emit("_slideClasses", a)
                }
                slidesPerViewDynamic(e = "current", a = !1) {
                    const {
                        params: t,
                        slides: n,
                        slidesGrid: i,
                        slidesSizesGrid: r,
                        size: s,
                        activeIndex: o
                    } = this;
                    let l = 1;
                    if (t.centeredSlides) {
                        let e, a = n[o].swiperSlideSize;
                        for (let t = o + 1; t < n.length; t += 1) n[t] && !e && (a += n[t].swiperSlideSize, l += 1, a > s && (e = !0));
                        for (let t = o - 1; t >= 0; t -= 1) n[t] && !e && (a += n[t].swiperSlideSize, l += 1, a > s && (e = !0))
                    } else if ("current" === e)
                        for (let e = o + 1; e < n.length; e += 1) {
                            (a ? i[e] + r[e] - i[o] < s : i[e] - i[o] < s) && (l += 1)
                        } else
                            for (let e = o - 1; e >= 0; e -= 1) {
                                i[o] - i[e] < s && (l += 1)
                            }
                    return l
                }
                update() {
                    const e = this;
                    if (!e || e.destroyed) return;
                    const {
                        snapGrid: a,
                        params: t
                    } = e;

                    function n() {
                        const a = e.rtlTranslate ? -1 * e.translate : e.translate,
                            t = Math.min(Math.max(a, e.maxTranslate()), e.minTranslate());
                        e.setTranslate(t), e.updateActiveIndex(), e.updateSlidesClasses()
                    }
                    let i;
                    t.breakpoints && e.setBreakpoint(), [...e.el.querySelectorAll('[loading="lazy"]')].forEach((a => {
                        a.complete && j(e, a)
                    })), e.updateSize(), e.updateSlides(), e.updateProgress(), e.updateSlidesClasses(), e.params.freeMode && e.params.freeMode.enabled ? (n(), e.params.autoHeight && e.updateAutoHeight()) : (i = ("auto" === e.params.slidesPerView || e.params.slidesPerView > 1) && e.isEnd && !e.params.centeredSlides ? e.slideTo(e.slides.length - 1, 0, !1, !0) : e.slideTo(e.activeIndex, 0, !1, !0), i || n()), t.watchOverflow && a !== e.snapGrid && e.checkOverflow(), e.emit("update")
                }
                changeDirection(e, a = !0) {
                    const t = this,
                        n = t.params.direction;
                    return e || (e = "horizontal" === n ? "vertical" : "horizontal"), e === n || "horizontal" !== e && "vertical" !== e || (t.el.classList.remove(`${t.params.containerModifierClass}${n}`), t.el.classList.add(`${t.params.containerModifierClass}${e}`), t.emitContainerClasses(), t.params.direction = e, t.slides.forEach((a => {
                        "vertical" === e ? a.style.width = "" : a.style.height = ""
                    })), t.emit("changeDirection"), a && t.update()), t
                }
                changeLanguageDirection(e) {
                    const a = this;
                    a.rtl && "rtl" === e || !a.rtl && "ltr" === e || (a.rtl = "rtl" === e, a.rtlTranslate = "horizontal" === a.params.direction && a.rtl, a.rtl ? (a.el.classList.add(`${a.params.containerModifierClass}rtl`), a.el.dir = "rtl") : (a.el.classList.remove(`${a.params.containerModifierClass}rtl`), a.el.dir = "ltr"), a.update())
                }
                mount(e) {
                    const a = this;
                    if (a.mounted) return !0;
                    let t = e || a.params.el;
                    if ("string" == typeof t && (t = document.querySelector(t)), !t) return !1;
                    t.swiper = a, t.shadowEl && (a.isElement = !0);
                    const n = () => `.${(a.params.wrapperClass || "").trim().split(" ").join(".")}`;
                    let i = (() => {
                        if (t && t.shadowRoot && t.shadowRoot.querySelector) {
                            return t.shadowRoot.querySelector(n())
                        }
                        return g(t, n())[0]
                    })();
                    return !i && a.params.createElements && (i = v("div", a.params.wrapperClass), t.append(i), g(t, `.${a.params.slideClass}`).forEach((e => {
                        i.append(e)
                    }))), Object.assign(a, {
                        el: t,
                        wrapperEl: i,
                        slidesEl: a.isElement ? t : i,
                        mounted: !0,
                        rtl: "rtl" === t.dir.toLowerCase() || "rtl" === b(t, "direction"),
                        rtlTranslate: "horizontal" === a.params.direction && ("rtl" === t.dir.toLowerCase() || "rtl" === b(t, "direction")),
                        wrongRTL: "-webkit-box" === b(i, "display")
                    }), !0
                }
                init(e) {
                    const a = this;
                    if (a.initialized) return a;
                    return !1 === a.mount(e) || (a.emit("beforeInit"), a.params.breakpoints && a.setBreakpoint(), a.addClasses(), a.updateSize(), a.updateSlides(), a.params.watchOverflow && a.checkOverflow(), a.params.grabCursor && a.enabled && a.setGrabCursor(), a.params.loop && a.virtual && a.params.virtual.enabled ? a.slideTo(a.params.initialSlide + a.virtual.slidesBefore, 0, a.params.runCallbacksOnInit, !1, !0) : a.slideTo(a.params.initialSlide, 0, a.params.runCallbacksOnInit, !1, !0), a.params.loop && a.loopCreate(), a.attachEvents(), [...a.el.querySelectorAll('[loading="lazy"]')].forEach((e => {
                        e.complete ? j(a, e) : e.addEventListener("load", (e => {
                            j(a, e.target)
                        }))
                    })), N(a), a.initialized = !0, N(a), a.emit("init"), a.emit("afterInit")), a
                }
                destroy(e = !0, a = !0) {
                    const t = this,
                        {
                            params: n,
                            el: i,
                            wrapperEl: r,
                            slides: s
                        } = t;
                    return void 0 === t.params || t.destroyed || (t.emit("beforeDestroy"), t.initialized = !1, t.detachEvents(), n.loop && t.loopDestroy(), a && (t.removeClasses(), i.removeAttribute("style"), r.removeAttribute("style"), s && s.length && s.forEach((e => {
                        e.classList.remove(n.slideVisibleClass, n.slideActiveClass, n.slideNextClass, n.slidePrevClass), e.removeAttribute("style"), e.removeAttribute("data-swiper-slide-index")
                    }))), t.emit("destroy"), Object.keys(t.eventsListeners).forEach((e => {
                        t.off(e)
                    })), !1 !== e && (t.el.swiper = null, function(e) {
                        const a = e;
                        Object.keys(a).forEach((e => {
                            try {
                                a[e] = null
                            } catch (e) {}
                            try {
                                delete a[e]
                            } catch (e) {}
                        }))
                    }(t)), t.destroyed = !0), null
                }
                static extendDefaults(e) {
                    p(ae, e)
                }
                static get extendedDefaults() {
                    return ae
                }
                static get defaults() {
                    return Z
                }
                static installModule(e) {
                    te.prototype.__modules__ || (te.prototype.__modules__ = []);
                    const a = te.prototype.__modules__;
                    "function" == typeof e && a.indexOf(e) < 0 && a.push(e)
                }
                static use(e) {
                    return Array.isArray(e) ? (e.forEach((e => te.installModule(e))), te) : (te.installModule(e), te)
                }
            }
            Object.keys(ee).forEach((e => {
                Object.keys(ee[e]).forEach((a => {
                    te.prototype[a] = ee[e][a]
                }))
            })), te.use([function({
                swiper: e,
                on: a,
                emit: t
            }) {
                const n = o();
                let i = null,
                    r = null;
                const s = () => {
                        e && !e.destroyed && e.initialized && (t("beforeResize"), t("resize"))
                    },
                    l = () => {
                        e && !e.destroyed && e.initialized && t("orientationchange")
                    };
                a("init", (() => {
                    e.params.resizeObserver && void 0 !== n.ResizeObserver ? e && !e.destroyed && e.initialized && (i = new ResizeObserver((a => {
                        r = n.requestAnimationFrame((() => {
                            const {
                                width: t,
                                height: n
                            } = e;
                            let i = t,
                                r = n;
                            a.forEach((({
                                contentBoxSize: a,
                                contentRect: t,
                                target: n
                            }) => {
                                n && n !== e.el || (i = t ? t.width : (a[0] || a).inlineSize, r = t ? t.height : (a[0] || a).blockSize)
                            })), i === t && r === n || s()
                        }))
                    })), i.observe(e.el)) : (n.addEventListener("resize", s), n.addEventListener("orientationchange", l))
                })), a("destroy", (() => {
                    r && n.cancelAnimationFrame(r), i && i.unobserve && e.el && (i.unobserve(e.el), i = null), n.removeEventListener("resize", s), n.removeEventListener("orientationchange", l)
                }))
            }, function({
                swiper: e,
                extendParams: a,
                on: t,
                emit: n
            }) {
                const i = [],
                    r = o(),
                    s = (a, t = {}) => {
                        const s = new(r.MutationObserver || r.WebkitMutationObserver)((a => {
                            if (e.__preventObserver__) return;
                            if (1 === a.length) return void n("observerUpdate", a[0]);
                            const t = function() {
                                n("observerUpdate", a[0])
                            };
                            r.requestAnimationFrame ? r.requestAnimationFrame(t) : r.setTimeout(t, 0)
                        }));
                        s.observe(a, {
                            attributes: void 0 === t.attributes || t.attributes,
                            childList: void 0 === t.childList || t.childList,
                            characterData: void 0 === t.characterData || t.characterData
                        }), i.push(s)
                    };
                a({
                    observer: !1,
                    observeParents: !1,
                    observeSlideChildren: !1
                }), t("init", (() => {
                    if (e.params.observer) {
                        if (e.params.observeParents) {
                            const a = w(e.el);
                            for (let e = 0; e < a.length; e += 1) s(a[e])
                        }
                        s(e.el, {
                            childList: e.params.observeSlideChildren
                        }), s(e.wrapperEl, {
                            attributes: !1
                        })
                    }
                })), t("destroy", (() => {
                    i.forEach((e => {
                        e.disconnect()
                    })), i.splice(0, i.length)
                }))
            }]);
            var ne = te;

            function ie(e, a, t, n) {
                return e.params.createElements && Object.keys(n).forEach((i => {
                    if (!t[i] && !0 === t.auto) {
                        let r = g(e.el, `.${n[i]}`)[0];
                        r || (r = v("div", n[i]), r.className = n[i], e.el.append(r)), t[i] = r, a[i] = r
                    }
                })), t
            }

            function re(e = "") {
                return `.${e.trim().replace(/([\.:!+\/])/g, "\\$1").replace(/ /g, ".")}`
            }

            function se(e) {
                const {
                    effect: a,
                    swiper: t,
                    on: n,
                    setTranslate: i,
                    setTransition: r,
                    overwriteParams: s,
                    perspective: o,
                    recreateShadows: l,
                    getEffectParams: u
                } = e;
                let d;
                n("beforeInit", (() => {
                    if (t.params.effect !== a) return;
                    t.classNames.push(`${t.params.containerModifierClass}${a}`), o && o() && t.classNames.push(`${t.params.containerModifierClass}3d`);
                    const e = s ? s() : {};
                    Object.assign(t.params, e), Object.assign(t.originalParams, e)
                })), n("setTranslate", (() => {
                    t.params.effect === a && i()
                })), n("setTransition", ((e, n) => {
                    t.params.effect === a && r(n)
                })), n("transitionEnd", (() => {
                    if (t.params.effect === a && l) {
                        if (!u || !u().slideShadows) return;
                        t.slides.forEach((e => {
                            e.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((e => e.remove()))
                        })), l()
                    }
                })), n("virtualUpdate", (() => {
                    t.params.effect === a && (t.slides.length || (d = !0), requestAnimationFrame((() => {
                        d && t.slides && t.slides.length && (i(), d = !1)
                    })))
                }))
            }

            function oe(e, a) {
                const t = m(a);
                return t !== a && (t.style.backfaceVisibility = "hidden", t.style["-webkit-backface-visibility"] = "hidden"), t
            }

            function le({
                swiper: e,
                duration: a,
                transformElements: t,
                allSlides: n
            }) {
                const {
                    activeIndex: i
                } = e;
                if (e.params.virtualTranslate && 0 !== a) {
                    let a, r = !1;
                    a = n ? t : t.filter((a => {
                        const t = a.classList.contains("swiper-slide-transform") ? (a => {
                            if (!a.parentElement) return e.slides.filter((e => e.shadowEl && e.shadowEl === a.parentNode))[0];
                            return a.parentElement
                        })(a) : a;
                        return e.getSlideIndex(t) === i
                    })), a.forEach((a => {
                        k(a, (() => {
                            if (r) return;
                            if (!e || e.destroyed) return;
                            r = !0, e.animating = !1;
                            const a = new window.CustomEvent("transitionend", {
                                bubbles: !0,
                                cancelable: !0
                            });
                            e.wrapperEl.dispatchEvent(a)
                        }))
                    }))
                }
            }

            function ue(e, a, t) {
                const n = "swiper-slide-shadow" + (t ? `-${t}` : ""),
                    i = m(a);
                let r = i.querySelector(`.${n}`);
                return r || (r = v("div", "swiper-slide-shadow" + (t ? `-${t}` : "")), i.append(r)), r
            }

            function de(e, a) {
                var t = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                if (!t) {
                    if (Array.isArray(e) || (t = function(e, a) {
                            if (!e) return;
                            if ("string" == typeof e) return ce(e, a);
                            var t = Object.prototype.toString.call(e).slice(8, -1);
                            "Object" === t && e.constructor && (t = e.constructor.name);
                            if ("Map" === t || "Set" === t) return Array.from(e);
                            if ("Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t)) return ce(e, a)
                        }(e)) || a && e && "number" == typeof e.length) {
                        t && (e = t);
                        var n = 0,
                            i = function() {};
                        return {
                            s: i,
                            n: function() {
                                return n >= e.length ? {
                                    done: !0
                                } : {
                                    done: !1,
                                    value: e[n++]
                                }
                            },
                            e: function(e) {
                                throw e
                            },
                            f: i
                        }
                    }
                    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")
                }
                var r, s = !0,
                    o = !1;
                return {
                    s: function() {
                        t = t.call(e)
                    },
                    n: function() {
                        var e = t.next();
                        return s = e.done, e
                    },
                    e: function(e) {
                        o = !0, r = e
                    },
                    f: function() {
                        try {
                            s || null == t.return || t.return()
                        } finally {
                            if (o) throw r
                        }
                    }
                }
            }

            function ce(e, a) {
                (null == a || a > e.length) && (a = e.length);
                for (var t = 0, n = new Array(a); t < a; t++) n[t] = e[t];
                return n
            }
            var pe = t(755),
                he = t.n(pe);
            var fe = function() {
                var e = he()(".shop-collections-grid__li"),
                    a = he()(".js-shop-collections-hover");
                a.on("mouseover", (function() {
                    var a = he()(this).data("handle"),
                        t = he()('.shop-collections-grid__li[data-handle="'.concat(a, '"]'));
                    e.css("opacity", ".5"), t.css("opacity", "1")
                })), a.on("mouseleave", (function() {
                    e.css("opacity", ".5")
                })), a.each((function(a, t) {
                    var n = he()(t).data("handle");
                    console.log("hoverElem", t, "handle", n);
                    var i = he()('.shop-collections-grid__li[data-handle="'.concat(n, '"]'));
                    console.log("matchingImage", i), i[0].addEventListener("mouseover", (function() {
                        e.css("opacity", ".5"), i.css("opacity", "1"), t.style.color = "#000"
                    })), i[0].addEventListener("mouseleave", (function() {
                        e.css("opacity", ".5"), t.style.color = ""
                    }))
                }))
            };
            var me = function() {
                var e = he()("body");
                he()(window).on("scroll", (function() {
                    var a = he()(".header").height();
                    window.scrollY > a ? e.addClass("scrolled") : e.removeClass("scrolled")
                }))
            };

            function ge(e) {
                const a = this,
                    {
                        params: t,
                        slidesEl: n
                    } = a;
                t.loop && a.loopDestroy();
                const i = e => {
                    if ("string" == typeof e) {
                        const a = document.createElement("div");
                        a.innerHTML = e, n.append(a.children[0]), a.innerHTML = ""
                    } else n.append(e)
                };
                if ("object" == typeof e && "length" in e)
                    for (let a = 0; a < e.length; a += 1) e[a] && i(e[a]);
                else i(e);
                a.recalcSlides(), t.loop && a.loopCreate(), t.observer && !a.isElement || a.update()
            }

            function ve(e) {
                const a = this,
                    {
                        params: t,
                        activeIndex: n,
                        slidesEl: i
                    } = a;
                t.loop && a.loopDestroy();
                let r = n + 1;
                const s = e => {
                    if ("string" == typeof e) {
                        const a = document.createElement("div");
                        a.innerHTML = e, i.prepend(a.children[0]), a.innerHTML = ""
                    } else i.prepend(e)
                };
                if ("object" == typeof e && "length" in e) {
                    for (let a = 0; a < e.length; a += 1) e[a] && s(e[a]);
                    r = n + e.length
                } else s(e);
                a.recalcSlides(), t.loop && a.loopCreate(), t.observer && !a.isElement || a.update(), a.slideTo(r, 0, !1)
            }

            function ye(e, a) {
                const t = this,
                    {
                        params: n,
                        activeIndex: i,
                        slidesEl: r
                    } = t;
                let s = i;
                n.loop && (s -= t.loopedSlides, t.loopDestroy(), t.recalcSlides());
                const o = t.slides.length;
                if (e <= 0) return void t.prependSlide(a);
                if (e >= o) return void t.appendSlide(a);
                let l = s > e ? s + 1 : s;
                const u = [];
                for (let a = o - 1; a >= e; a -= 1) {
                    const e = t.slides[a];
                    e.remove(), u.unshift(e)
                }
                if ("object" == typeof a && "length" in a) {
                    for (let e = 0; e < a.length; e += 1) a[e] && r.append(a[e]);
                    l = s > e ? s + a.length : s
                } else r.append(a);
                for (let e = 0; e < u.length; e += 1) r.append(u[e]);
                t.recalcSlides(), n.loop && t.loopCreate(), n.observer && !t.isElement || t.update(), n.loop ? t.slideTo(l + t.loopedSlides, 0, !1) : t.slideTo(l, 0, !1)
            }

            function be(e) {
                const a = this,
                    {
                        params: t,
                        activeIndex: n
                    } = a;
                let i = n;
                t.loop && (i -= a.loopedSlides, a.loopDestroy());
                let r, s = i;
                if ("object" == typeof e && "length" in e) {
                    for (let t = 0; t < e.length; t += 1) r = e[t], a.slides[r] && a.slides[r].remove(), r < s && (s -= 1);
                    s = Math.max(s, 0)
                } else r = e, a.slides[r] && a.slides[r].remove(), r < s && (s -= 1), s = Math.max(s, 0);
                a.recalcSlides(), t.loop && a.loopCreate(), t.observer && !a.isElement || a.update(), t.loop ? a.slideTo(s + a.loopedSlides, 0, !1) : a.slideTo(s, 0, !1)
            }

            function Se() {
                const e = this,
                    a = [];
                for (let t = 0; t < e.slides.length; t += 1) a.push(t);
                e.removeSlide(a)
            }
            const we = [function({
                swiper: e,
                extendParams: a,
                on: t,
                emit: n
            }) {
                let i;
                a({
                    virtual: {
                        enabled: !1,
                        slides: [],
                        cache: !0,
                        renderSlide: null,
                        renderExternal: null,
                        renderExternalUpdate: !0,
                        addSlidesBefore: 0,
                        addSlidesAfter: 0
                    }
                });
                const s = r();
                e.virtual = {
                    cache: {},
                    from: void 0,
                    to: void 0,
                    slides: [],
                    offset: 0,
                    slidesGrid: []
                };
                const o = s.createElement("div");

                function l(a, t) {
                    const n = e.params.virtual;
                    if (n.cache && e.virtual.cache[t]) return e.virtual.cache[t];
                    let i;
                    return n.renderSlide ? (i = n.renderSlide.call(e, a, t), "string" == typeof i && (o.innerHTML = i, i = o.children[0])) : i = e.isElement ? v("swiper-slide") : v("div", e.params.slideClass), i.setAttribute("data-swiper-slide-index", t), n.renderSlide || (i.innerHTML = a), n.cache && (e.virtual.cache[t] = i), i
                }

                function u(a) {
                    const {
                        slidesPerView: t,
                        slidesPerGroup: i,
                        centeredSlides: r,
                        loop: s
                    } = e.params, {
                        addSlidesBefore: o,
                        addSlidesAfter: u
                    } = e.params.virtual, {
                        from: d,
                        to: c,
                        slides: p,
                        slidesGrid: h,
                        offset: f
                    } = e.virtual;
                    e.params.cssMode || e.updateActiveIndex();
                    const m = e.activeIndex || 0;
                    let v, y, b;
                    v = e.rtlTranslate ? "right" : e.isHorizontal() ? "left" : "top", r ? (y = Math.floor(t / 2) + i + u, b = Math.floor(t / 2) + i + o) : (y = t + (i - 1) + u, b = (s ? t : i) + o);
                    let S = m - b,
                        w = m + y;
                    s || (S = Math.max(S, 0), w = Math.min(w, p.length - 1));
                    let k = (e.slidesGrid[S] || 0) - (e.slidesGrid[0] || 0);

                    function T() {
                        e.updateSlides(), e.updateProgress(), e.updateSlidesClasses(), n("virtualUpdate")
                    }
                    if (s && m >= b ? (S -= b, r || (k += e.slidesGrid[0])) : s && m < b && (S = -b, r && (k += e.slidesGrid[0])), Object.assign(e.virtual, {
                            from: S,
                            to: w,
                            offset: k,
                            slidesGrid: e.slidesGrid,
                            slidesBefore: b,
                            slidesAfter: y
                        }), d === S && c === w && !a) return e.slidesGrid !== h && k !== f && e.slides.forEach((e => {
                        e.style[v] = `${k}px`
                    })), e.updateProgress(), void n("virtualUpdate");
                    if (e.params.virtual.renderExternal) return e.params.virtual.renderExternal.call(e, {
                        offset: k,
                        from: S,
                        to: w,
                        slides: function() {
                            const e = [];
                            for (let a = S; a <= w; a += 1) e.push(p[a]);
                            return e
                        }()
                    }), void(e.params.virtual.renderExternalUpdate ? T() : n("virtualUpdate"));
                    const x = [],
                        C = [],
                        E = e => {
                            let a = e;
                            return e < 0 ? a = p.length + e : a >= p.length && (a -= p.length), a
                        };
                    if (a) e.slidesEl.querySelectorAll(`.${e.params.slideClass}, swiper-slide`).forEach((e => {
                        e.remove()
                    }));
                    else
                        for (let a = d; a <= c; a += 1)
                            if (a < S || a > w) {
                                const t = E(a);
                                e.slidesEl.querySelectorAll(`.${e.params.slideClass}[data-swiper-slide-index="${t}"], swiper-slide[data-swiper-slide-index="${t}"]`).forEach((e => {
                                    e.remove()
                                }))
                            } const M = s ? -p.length : 0,
                        A = s ? 2 * p.length : p.length;
                    for (let e = M; e < A; e += 1)
                        if (e >= S && e <= w) {
                            const t = E(e);
                            void 0 === c || a ? C.push(t) : (e > c && C.push(t), e < d && x.push(t))
                        } if (C.forEach((a => {
                            e.slidesEl.append(l(p[a], a))
                        })), s)
                        for (let a = x.length - 1; a >= 0; a -= 1) {
                            const t = x[a];
                            e.slidesEl.prepend(l(p[t], t))
                        } else x.sort(((e, a) => a - e)), x.forEach((a => {
                            e.slidesEl.prepend(l(p[a], a))
                        }));
                    g(e.slidesEl, ".swiper-slide, swiper-slide").forEach((e => {
                        e.style[v] = `${k}px`
                    })), T()
                }
                t("beforeInit", (() => {
                    if (!e.params.virtual.enabled) return;
                    let a;
                    if (void 0 === e.passedParams.virtual.slides) {
                        const t = [...e.slidesEl.children].filter((a => a.matches(`.${e.params.slideClass}, swiper-slide`)));
                        t && t.length && (e.virtual.slides = [...t], a = !0, t.forEach(((a, t) => {
                            a.setAttribute("data-swiper-slide-index", t), e.virtual.cache[t] = a, a.remove()
                        })))
                    }
                    a || (e.virtual.slides = e.params.virtual.slides), e.classNames.push(`${e.params.containerModifierClass}virtual`), e.params.watchSlidesProgress = !0, e.originalParams.watchSlidesProgress = !0, e.params.initialSlide || u()
                })), t("setTranslate", (() => {
                    e.params.virtual.enabled && (e.params.cssMode && !e._immediateVirtual ? (clearTimeout(i), i = setTimeout((() => {
                        u()
                    }), 100)) : u())
                })), t("init update resize", (() => {
                    e.params.virtual.enabled && e.params.cssMode && h(e.wrapperEl, "--swiper-virtual-size", `${e.virtualSize}px`)
                })), Object.assign(e.virtual, {
                    appendSlide: function(a) {
                        if ("object" == typeof a && "length" in a)
                            for (let t = 0; t < a.length; t += 1) a[t] && e.virtual.slides.push(a[t]);
                        else e.virtual.slides.push(a);
                        u(!0)
                    },
                    prependSlide: function(a) {
                        const t = e.activeIndex;
                        let n = t + 1,
                            i = 1;
                        if (Array.isArray(a)) {
                            for (let t = 0; t < a.length; t += 1) a[t] && e.virtual.slides.unshift(a[t]);
                            n = t + a.length, i = a.length
                        } else e.virtual.slides.unshift(a);
                        if (e.params.virtual.cache) {
                            const a = e.virtual.cache,
                                t = {};
                            Object.keys(a).forEach((e => {
                                const n = a[e],
                                    r = n.getAttribute("data-swiper-slide-index");
                                r && n.setAttribute("data-swiper-slide-index", parseInt(r, 10) + i), t[parseInt(e, 10) + i] = n
                            })), e.virtual.cache = t
                        }
                        u(!0), e.slideTo(n, 0)
                    },
                    removeSlide: function(a) {
                        if (null == a) return;
                        let t = e.activeIndex;
                        if (Array.isArray(a))
                            for (let n = a.length - 1; n >= 0; n -= 1) e.virtual.slides.splice(a[n], 1), e.params.virtual.cache && delete e.virtual.cache[a[n]], a[n] < t && (t -= 1), t = Math.max(t, 0);
                        else e.virtual.slides.splice(a, 1), e.params.virtual.cache && delete e.virtual.cache[a], a < t && (t -= 1), t = Math.max(t, 0);
                        u(!0), e.slideTo(t, 0)
                    },
                    removeAllSlides: function() {
                        e.virtual.slides = [], e.params.virtual.cache && (e.virtual.cache = {}), u(!0), e.slideTo(0, 0)
                    },
                    update: u
                })
            }, function({
                swiper: e,
                extendParams: a,
                on: t,
                emit: n
            }) {
                const i = r(),
                    s = o();

                function l(a) {
                    if (!e.enabled) return;
                    const {
                        rtlTranslate: t
                    } = e;
                    let r = a;
                    r.originalEvent && (r = r.originalEvent);
                    const o = r.keyCode || r.charCode,
                        l = e.params.keyboard.pageUpDown,
                        u = l && 33 === o,
                        d = l && 34 === o,
                        c = 37 === o,
                        p = 39 === o,
                        h = 38 === o,
                        f = 40 === o;
                    if (!e.allowSlideNext && (e.isHorizontal() && p || e.isVertical() && f || d)) return !1;
                    if (!e.allowSlidePrev && (e.isHorizontal() && c || e.isVertical() && h || u)) return !1;
                    if (!(r.shiftKey || r.altKey || r.ctrlKey || r.metaKey || i.activeElement && i.activeElement.nodeName && ("input" === i.activeElement.nodeName.toLowerCase() || "textarea" === i.activeElement.nodeName.toLowerCase()))) {
                        if (e.params.keyboard.onlyInViewport && (u || d || c || p || h || f)) {
                            let a = !1;
                            if (w(e.el, `.${e.params.slideClass}, swiper-slide`).length > 0 && 0 === w(e.el, `.${e.params.slideActiveClass}`).length) return;
                            const n = e.el,
                                i = n.clientWidth,
                                r = n.clientHeight,
                                o = s.innerWidth,
                                l = s.innerHeight,
                                u = y(n);
                            t && (u.left -= n.scrollLeft);
                            const d = [
                                [u.left, u.top],
                                [u.left + i, u.top],
                                [u.left, u.top + r],
                                [u.left + i, u.top + r]
                            ];
                            for (let e = 0; e < d.length; e += 1) {
                                const t = d[e];
                                if (t[0] >= 0 && t[0] <= o && t[1] >= 0 && t[1] <= l) {
                                    if (0 === t[0] && 0 === t[1]) continue;
                                    a = !0
                                }
                            }
                            if (!a) return
                        }
                        e.isHorizontal() ? ((u || d || c || p) && (r.preventDefault ? r.preventDefault() : r.returnValue = !1), ((d || p) && !t || (u || c) && t) && e.slideNext(), ((u || c) && !t || (d || p) && t) && e.slidePrev()) : ((u || d || h || f) && (r.preventDefault ? r.preventDefault() : r.returnValue = !1), (d || f) && e.slideNext(), (u || h) && e.slidePrev()), n("keyPress", o)
                    }
                }

                function u() {
                    e.keyboard.enabled || (i.addEventListener("keydown", l), e.keyboard.enabled = !0)
                }

                function d() {
                    e.keyboard.enabled && (i.removeEventListener("keydown", l), e.keyboard.enabled = !1)
                }
                e.keyboard = {
                    enabled: !1
                }, a({
                    keyboard: {
                        enabled: !1,
                        onlyInViewport: !0,
                        pageUpDown: !0
                    }
                }), t("init", (() => {
                    e.params.keyboard.enabled && u()
                })), t("destroy", (() => {
                    e.keyboard.enabled && d()
                })), Object.assign(e.keyboard, {
                    enable: u,
                    disable: d
                })
            }, function({
                swiper: e,
                extendParams: a,
                on: t,
                emit: n
            }) {
                const i = o();
                let r;
                a({
                    mousewheel: {
                        enabled: !1,
                        releaseOnEdges: !1,
                        invert: !1,
                        forceToAxis: !1,
                        sensitivity: 1,
                        eventsTarget: "container",
                        thresholdDelta: null,
                        thresholdTime: null
                    }
                }), e.mousewheel = {
                    enabled: !1
                };
                let s, d = u();
                const c = [];

                function p() {
                    e.enabled && (e.mouseEntered = !0)
                }

                function h() {
                    e.enabled && (e.mouseEntered = !1)
                }

                function f(a) {
                    return !(e.params.mousewheel.thresholdDelta && a.delta < e.params.mousewheel.thresholdDelta) && (!(e.params.mousewheel.thresholdTime && u() - d < e.params.mousewheel.thresholdTime) && (a.delta >= 6 && u() - d < 60 || (a.direction < 0 ? e.isEnd && !e.params.loop || e.animating || (e.slideNext(), n("scroll", a.raw)) : e.isBeginning && !e.params.loop || e.animating || (e.slidePrev(), n("scroll", a.raw)), d = (new i.Date).getTime(), !1)))
                }

                function m(a) {
                    let t = a,
                        i = !0;
                    if (!e.enabled) return;
                    const o = e.params.mousewheel;
                    e.params.cssMode && t.preventDefault();
                    let d = e.el;
                    "container" !== e.params.mousewheel.eventsTarget && (d = document.querySelector(e.params.mousewheel.eventsTarget));
                    const p = d && d.contains(t.target);
                    if (!e.mouseEntered && !p && !o.releaseOnEdges) return !0;
                    t.originalEvent && (t = t.originalEvent);
                    let h = 0;
                    const m = e.rtlTranslate ? -1 : 1,
                        g = function(e) {
                            let a = 0,
                                t = 0,
                                n = 0,
                                i = 0;
                            return "detail" in e && (t = e.detail), "wheelDelta" in e && (t = -e.wheelDelta / 120), "wheelDeltaY" in e && (t = -e.wheelDeltaY / 120), "wheelDeltaX" in e && (a = -e.wheelDeltaX / 120), "axis" in e && e.axis === e.HORIZONTAL_AXIS && (a = t, t = 0), n = 10 * a, i = 10 * t, "deltaY" in e && (i = e.deltaY), "deltaX" in e && (n = e.deltaX), e.shiftKey && !n && (n = i, i = 0), (n || i) && e.deltaMode && (1 === e.deltaMode ? (n *= 40, i *= 40) : (n *= 800, i *= 800)), n && !a && (a = n < 1 ? -1 : 1), i && !t && (t = i < 1 ? -1 : 1), {
                                spinX: a,
                                spinY: t,
                                pixelX: n,
                                pixelY: i
                            }
                        }(t);
                    if (o.forceToAxis)
                        if (e.isHorizontal()) {
                            if (!(Math.abs(g.pixelX) > Math.abs(g.pixelY))) return !0;
                            h = -g.pixelX * m
                        } else {
                            if (!(Math.abs(g.pixelY) > Math.abs(g.pixelX))) return !0;
                            h = -g.pixelY
                        }
                    else h = Math.abs(g.pixelX) > Math.abs(g.pixelY) ? -g.pixelX * m : -g.pixelY;
                    if (0 === h) return !0;
                    o.invert && (h = -h);
                    let v = e.getTranslate() + h * o.sensitivity;
                    if (v >= e.minTranslate() && (v = e.minTranslate()), v <= e.maxTranslate() && (v = e.maxTranslate()), i = !!e.params.loop || !(v === e.minTranslate() || v === e.maxTranslate()), i && e.params.nested && t.stopPropagation(), e.params.freeMode && e.params.freeMode.enabled) {
                        const a = {
                                time: u(),
                                delta: Math.abs(h),
                                direction: Math.sign(h)
                            },
                            i = s && a.time < s.time + 500 && a.delta <= s.delta && a.direction === s.direction;
                        if (!i) {
                            s = void 0;
                            let u = e.getTranslate() + h * o.sensitivity;
                            const d = e.isBeginning,
                                p = e.isEnd;
                            if (u >= e.minTranslate() && (u = e.minTranslate()), u <= e.maxTranslate() && (u = e.maxTranslate()), e.setTransition(0), e.setTranslate(u), e.updateProgress(), e.updateActiveIndex(), e.updateSlidesClasses(), (!d && e.isBeginning || !p && e.isEnd) && e.updateSlidesClasses(), e.params.loop && e.loopFix({
                                    direction: a.direction < 0 ? "next" : "prev",
                                    byMousewheel: !0
                                }), e.params.freeMode.sticky) {
                                clearTimeout(r), r = void 0, c.length >= 15 && c.shift();
                                const t = c.length ? c[c.length - 1] : void 0,
                                    n = c[0];
                                if (c.push(a), t && (a.delta > t.delta || a.direction !== t.direction)) c.splice(0);
                                else if (c.length >= 15 && a.time - n.time < 500 && n.delta - a.delta >= 1 && a.delta <= 6) {
                                    const t = h > 0 ? .8 : .2;
                                    s = a, c.splice(0), r = l((() => {
                                        e.slideToClosest(e.params.speed, !0, void 0, t)
                                    }), 0)
                                }
                                r || (r = l((() => {
                                    s = a, c.splice(0), e.slideToClosest(e.params.speed, !0, void 0, .5)
                                }), 500))
                            }
                            if (i || n("scroll", t), e.params.autoplay && e.params.autoplayDisableOnInteraction && e.autoplay.stop(), u === e.minTranslate() || u === e.maxTranslate()) return !0
                        }
                    } else {
                        const t = {
                            time: u(),
                            delta: Math.abs(h),
                            direction: Math.sign(h),
                            raw: a
                        };
                        c.length >= 2 && c.shift();
                        const n = c.length ? c[c.length - 1] : void 0;
                        if (c.push(t), n ? (t.direction !== n.direction || t.delta > n.delta || t.time > n.time + 150) && f(t) : f(t), function(a) {
                                const t = e.params.mousewheel;
                                if (a.direction < 0) {
                                    if (e.isEnd && !e.params.loop && t.releaseOnEdges) return !0
                                } else if (e.isBeginning && !e.params.loop && t.releaseOnEdges) return !0;
                                return !1
                            }(t)) return !0
                    }
                    return t.preventDefault ? t.preventDefault() : t.returnValue = !1, !1
                }

                function g(a) {
                    let t = e.el;
                    "container" !== e.params.mousewheel.eventsTarget && (t = document.querySelector(e.params.mousewheel.eventsTarget)), t[a]("mouseenter", p), t[a]("mouseleave", h), t[a]("wheel", m)
                }

                function v() {
                    return e.params.cssMode ? (e.wrapperEl.removeEventListener("wheel", m), !0) : !e.mousewheel.enabled && (g("addEventListener"), e.mousewheel.enabled = !0, !0)
                }

                function y() {
                    return e.params.cssMode ? (e.wrapperEl.addEventListener(event, m), !0) : !!e.mousewheel.enabled && (g("removeEventListener"), e.mousewheel.enabled = !1, !0)
                }
                t("init", (() => {
                    !e.params.mousewheel.enabled && e.params.cssMode && y(), e.params.mousewheel.enabled && v()
                })), t("destroy", (() => {
                    e.params.cssMode && v(), e.mousewheel.enabled && y()
                })), Object.assign(e.mousewheel, {
                    enable: v,
                    disable: y
                })
            }, function({
                swiper: e,
                extendParams: a,
                on: t,
                emit: n
            }) {
                a({
                    navigation: {
                        nextEl: null,
                        prevEl: null,
                        hideOnClick: !1,
                        disabledClass: "swiper-button-disabled",
                        hiddenClass: "swiper-button-hidden",
                        lockClass: "swiper-button-lock",
                        navigationDisabledClass: "swiper-navigation-disabled"
                    }
                }), e.navigation = {
                    nextEl: null,
                    prevEl: null
                };
                const i = e => (Array.isArray(e) || (e = [e].filter((e => !!e))), e);

                function r(a) {
                    let t;
                    return a && "string" == typeof a && e.isElement && (t = e.el.shadowRoot.querySelector(a), t) ? t : (a && ("string" == typeof a && (t = [...document.querySelectorAll(a)]), e.params.uniqueNavElements && "string" == typeof a && t.length > 1 && 1 === e.el.querySelectorAll(a).length && (t = e.el.querySelector(a))), a && !t ? a : t)
                }

                function s(a, t) {
                    const n = e.params.navigation;
                    (a = i(a)).forEach((a => {
                        a && (a.classList[t ? "add" : "remove"](...n.disabledClass.split(" ")), "BUTTON" === a.tagName && (a.disabled = t), e.params.watchOverflow && e.enabled && a.classList[e.isLocked ? "add" : "remove"](n.lockClass))
                    }))
                }

                function o() {
                    const {
                        nextEl: a,
                        prevEl: t
                    } = e.navigation;
                    if (e.params.loop) return s(t, !1), void s(a, !1);
                    s(t, e.isBeginning && !e.params.rewind), s(a, e.isEnd && !e.params.rewind)
                }

                function l(a) {
                    a.preventDefault(), (!e.isBeginning || e.params.loop || e.params.rewind) && (e.slidePrev(), n("navigationPrev"))
                }

                function u(a) {
                    a.preventDefault(), (!e.isEnd || e.params.loop || e.params.rewind) && (e.slideNext(), n("navigationNext"))
                }

                function d() {
                    const a = e.params.navigation;
                    if (e.params.navigation = ie(e, e.originalParams.navigation, e.params.navigation, {
                            nextEl: "swiper-button-next",
                            prevEl: "swiper-button-prev"
                        }), !a.nextEl && !a.prevEl) return;
                    let t = r(a.nextEl),
                        n = r(a.prevEl);
                    Object.assign(e.navigation, {
                        nextEl: t,
                        prevEl: n
                    }), t = i(t), n = i(n);
                    const s = (t, n) => {
                        t && t.addEventListener("click", "next" === n ? u : l), !e.enabled && t && t.classList.add(...a.lockClass.split(" "))
                    };
                    t.forEach((e => s(e, "next"))), n.forEach((e => s(e, "prev")))
                }

                function c() {
                    let {
                        nextEl: a,
                        prevEl: t
                    } = e.navigation;
                    a = i(a), t = i(t);
                    const n = (a, t) => {
                        a.removeEventListener("click", "next" === t ? u : l), a.classList.remove(...e.params.navigation.disabledClass.split(" "))
                    };
                    a.forEach((e => n(e, "next"))), t.forEach((e => n(e, "prev")))
                }
                t("init", (() => {
                    !1 === e.params.navigation.enabled ? p() : (d(), o())
                })), t("toEdge fromEdge lock unlock", (() => {
                    o()
                })), t("destroy", (() => {
                    c()
                })), t("enable disable", (() => {
                    let {
                        nextEl: a,
                        prevEl: t
                    } = e.navigation;
                    a = i(a), t = i(t), [...a, ...t].filter((e => !!e)).forEach((a => a.classList[e.enabled ? "remove" : "add"](e.params.navigation.lockClass)))
                })), t("click", ((a, t) => {
                    let {
                        nextEl: r,
                        prevEl: s
                    } = e.navigation;
                    r = i(r), s = i(s);
                    const o = t.target;
                    if (e.params.navigation.hideOnClick && !s.includes(o) && !r.includes(o)) {
                        if (e.pagination && e.params.pagination && e.params.pagination.clickable && (e.pagination.el === o || e.pagination.el.contains(o))) return;
                        let a;
                        r.length ? a = r[0].classList.contains(e.params.navigation.hiddenClass) : s.length && (a = s[0].classList.contains(e.params.navigation.hiddenClass)), n(!0 === a ? "navigationShow" : "navigationHide"), [...r, ...s].filter((e => !!e)).forEach((a => a.classList.toggle(e.params.navigation.hiddenClass)))
                    }
                }));
                const p = () => {
                    e.el.classList.add(...e.params.navigation.navigationDisabledClass.split(" ")), c()
                };
                Object.assign(e.navigation, {
                    enable: () => {
                        e.el.classList.remove(...e.params.navigation.navigationDisabledClass.split(" ")), d(), o()
                    },
                    disable: p,
                    update: o,
                    init: d,
                    destroy: c
                })
            }, function({
                swiper: e,
                extendParams: a,
                on: t,
                emit: n
            }) {
                const i = "swiper-pagination";
                let r;
                a({
                    pagination: {
                        el: null,
                        bulletElement: "span",
                        clickable: !1,
                        hideOnClick: !1,
                        renderBullet: null,
                        renderProgressbar: null,
                        renderFraction: null,
                        renderCustom: null,
                        progressbarOpposite: !1,
                        type: "bullets",
                        dynamicBullets: !1,
                        dynamicMainBullets: 1,
                        formatFractionCurrent: e => e,
                        formatFractionTotal: e => e,
                        bulletClass: `${i}-bullet`,
                        bulletActiveClass: `${i}-bullet-active`,
                        modifierClass: `${i}-`,
                        currentClass: `${i}-current`,
                        totalClass: `${i}-total`,
                        hiddenClass: `${i}-hidden`,
                        progressbarFillClass: `${i}-progressbar-fill`,
                        progressbarOppositeClass: `${i}-progressbar-opposite`,
                        clickableClass: `${i}-clickable`,
                        lockClass: `${i}-lock`,
                        horizontalClass: `${i}-horizontal`,
                        verticalClass: `${i}-vertical`,
                        paginationDisabledClass: `${i}-disabled`
                    }
                }), e.pagination = {
                    el: null,
                    bullets: []
                };
                let s = 0;
                const o = e => (Array.isArray(e) || (e = [e].filter((e => !!e))), e);

                function l() {
                    return !e.params.pagination.el || !e.pagination.el || Array.isArray(e.pagination.el) && 0 === e.pagination.el.length
                }

                function u(a, t) {
                    const {
                        bulletActiveClass: n
                    } = e.params.pagination;
                    a && (a = a[("prev" === t ? "previous" : "next") + "ElementSibling"]) && (a.classList.add(`${n}-${t}`), (a = a[("prev" === t ? "previous" : "next") + "ElementSibling"]) && a.classList.add(`${n}-${t}-${t}`))
                }

                function d(a) {
                    const t = a.target.closest(re(e.params.pagination.bulletClass));
                    if (!t) return;
                    a.preventDefault();
                    const n = S(t) * e.params.slidesPerGroup;
                    if (e.params.loop) {
                        if (e.realIndex === n) return;
                        (n < e.loopedSlides || n > e.slides.length - e.loopedSlides) && e.loopFix({
                            direction: n < e.loopedSlides ? "prev" : "next",
                            activeSlideIndex: n,
                            slideTo: !1
                        }), e.slideToLoop(n)
                    } else e.slideTo(n)
                }

                function c() {
                    const a = e.rtl,
                        t = e.params.pagination;
                    if (l()) return;
                    let i, d = e.pagination.el;
                    d = o(d);
                    const c = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.slides.length,
                        p = e.params.loop ? Math.ceil(c / e.params.slidesPerGroup) : e.snapGrid.length;
                    if (i = e.params.loop ? e.params.slidesPerGroup > 1 ? Math.floor(e.realIndex / e.params.slidesPerGroup) : e.realIndex : void 0 !== e.snapIndex ? e.snapIndex : e.activeIndex || 0, "bullets" === t.type && e.pagination.bullets && e.pagination.bullets.length > 0) {
                        const n = e.pagination.bullets;
                        let o, l, c;
                        if (t.dynamicBullets && (r = T(n[0], e.isHorizontal() ? "width" : "height", !0), d.forEach((a => {
                                a.style[e.isHorizontal() ? "width" : "height"] = r * (t.dynamicMainBullets + 4) + "px"
                            })), t.dynamicMainBullets > 1 && void 0 !== e.previousIndex && (s += i - (e.previousIndex || 0), s > t.dynamicMainBullets - 1 ? s = t.dynamicMainBullets - 1 : s < 0 && (s = 0)), o = Math.max(i - s, 0), l = o + (Math.min(n.length, t.dynamicMainBullets) - 1), c = (l + o) / 2), n.forEach((e => {
                                const a = [...["", "-next", "-next-next", "-prev", "-prev-prev", "-main"].map((e => `${t.bulletActiveClass}${e}`))].map((e => "string" == typeof e && e.includes(" ") ? e.split(" ") : e)).flat();
                                e.classList.remove(...a)
                            })), d.length > 1) n.forEach((e => {
                            const a = S(e);
                            a === i && e.classList.add(...t.bulletActiveClass.split(" ")), t.dynamicBullets && (a >= o && a <= l && e.classList.add(...`${t.bulletActiveClass}-main`.split(" ")), a === o && u(e, "prev"), a === l && u(e, "next"))
                        }));
                        else {
                            const e = n[i];
                            if (e && e.classList.add(...t.bulletActiveClass.split(" ")), t.dynamicBullets) {
                                const e = n[o],
                                    a = n[l];
                                for (let e = o; e <= l; e += 1) n[e] && n[e].classList.add(...`${t.bulletActiveClass}-main`.split(" "));
                                u(e, "prev"), u(a, "next")
                            }
                        }
                        if (t.dynamicBullets) {
                            const i = Math.min(n.length, t.dynamicMainBullets + 4),
                                s = (r * i - r) / 2 - c * r,
                                o = a ? "right" : "left";
                            n.forEach((a => {
                                a.style[e.isHorizontal() ? o : "top"] = `${s}px`
                            }))
                        }
                    }
                    d.forEach(((a, r) => {
                        if ("fraction" === t.type && (a.querySelectorAll(re(t.currentClass)).forEach((e => {
                                e.textContent = t.formatFractionCurrent(i + 1)
                            })), a.querySelectorAll(re(t.totalClass)).forEach((e => {
                                e.textContent = t.formatFractionTotal(p)
                            }))), "progressbar" === t.type) {
                            let n;
                            n = t.progressbarOpposite ? e.isHorizontal() ? "vertical" : "horizontal" : e.isHorizontal() ? "horizontal" : "vertical";
                            const r = (i + 1) / p;
                            let s = 1,
                                o = 1;
                            "horizontal" === n ? s = r : o = r, a.querySelectorAll(re(t.progressbarFillClass)).forEach((a => {
                                a.style.transform = `translate3d(0,0,0) scaleX(${s}) scaleY(${o})`, a.style.transitionDuration = `${e.params.speed}ms`
                            }))
                        }
                        "custom" === t.type && t.renderCustom ? (a.innerHTML = t.renderCustom(e, i + 1, p), 0 === r && n("paginationRender", a)) : (0 === r && n("paginationRender", a), n("paginationUpdate", a)), e.params.watchOverflow && e.enabled && a.classList[e.isLocked ? "add" : "remove"](t.lockClass)
                    }))
                }

                function p() {
                    const a = e.params.pagination;
                    if (l()) return;
                    const t = e.virtual && e.params.virtual.enabled ? e.virtual.slides.length : e.slides.length;
                    let i = e.pagination.el;
                    i = o(i);
                    let r = "";
                    if ("bullets" === a.type) {
                        let n = e.params.loop ? Math.ceil(t / e.params.slidesPerGroup) : e.snapGrid.length;
                        e.params.freeMode && e.params.freeMode.enabled && n > t && (n = t);
                        for (let t = 0; t < n; t += 1) a.renderBullet ? r += a.renderBullet.call(e, t, a.bulletClass) : r += `<${a.bulletElement} class="${a.bulletClass}"></${a.bulletElement}>`
                    }
                    "fraction" === a.type && (r = a.renderFraction ? a.renderFraction.call(e, a.currentClass, a.totalClass) : `<span class="${a.currentClass}"></span> / <span class="${a.totalClass}"></span>`), "progressbar" === a.type && (r = a.renderProgressbar ? a.renderProgressbar.call(e, a.progressbarFillClass) : `<span class="${a.progressbarFillClass}"></span>`), e.pagination.bullets = [], i.forEach((t => {
                        "custom" !== a.type && (t.innerHTML = r || ""), "bullets" === a.type && e.pagination.bullets.push(...t.querySelectorAll(re(a.bulletClass)))
                    })), "custom" !== a.type && n("paginationRender", i[0])
                }

                function h() {
                    e.params.pagination = ie(e, e.originalParams.pagination, e.params.pagination, {
                        el: "swiper-pagination"
                    });
                    const a = e.params.pagination;
                    if (!a.el) return;
                    let t;
                    "string" == typeof a.el && e.isElement && (t = e.el.shadowRoot.querySelector(a.el)), t || "string" != typeof a.el || (t = [...document.querySelectorAll(a.el)]), t || (t = a.el), t && 0 !== t.length && (e.params.uniqueNavElements && "string" == typeof a.el && Array.isArray(t) && t.length > 1 && (t = [...e.el.querySelectorAll(a.el)], t.length > 1 && (t = t.filter((a => w(a, ".swiper")[0] === e.el))[0])), Array.isArray(t) && 1 === t.length && (t = t[0]), Object.assign(e.pagination, {
                        el: t
                    }), t = o(t), t.forEach((t => {
                        "bullets" === a.type && a.clickable && t.classList.add(a.clickableClass), t.classList.add(a.modifierClass + a.type), t.classList.add(e.isHorizontal() ? a.horizontalClass : a.verticalClass), "bullets" === a.type && a.dynamicBullets && (t.classList.add(`${a.modifierClass}${a.type}-dynamic`), s = 0, a.dynamicMainBullets < 1 && (a.dynamicMainBullets = 1)), "progressbar" === a.type && a.progressbarOpposite && t.classList.add(a.progressbarOppositeClass), a.clickable && t.addEventListener("click", d), e.enabled || t.classList.add(a.lockClass)
                    })))
                }

                function f() {
                    const a = e.params.pagination;
                    if (l()) return;
                    let t = e.pagination.el;
                    t && (t = o(t), t.forEach((t => {
                        t.classList.remove(a.hiddenClass), t.classList.remove(a.modifierClass + a.type), t.classList.remove(e.isHorizontal() ? a.horizontalClass : a.verticalClass), a.clickable && t.removeEventListener("click", d)
                    }))), e.pagination.bullets && e.pagination.bullets.forEach((e => e.classList.remove(...a.bulletActiveClass.split(" "))))
                }
                t("init", (() => {
                    !1 === e.params.pagination.enabled ? m() : (h(), p(), c())
                })), t("activeIndexChange", (() => {
                    void 0 === e.snapIndex && c()
                })), t("snapIndexChange", (() => {
                    c()
                })), t("snapGridLengthChange", (() => {
                    p(), c()
                })), t("destroy", (() => {
                    f()
                })), t("enable disable", (() => {
                    let {
                        el: a
                    } = e.pagination;
                    a && (a = o(a), a.forEach((a => a.classList[e.enabled ? "remove" : "add"](e.params.pagination.lockClass))))
                })), t("lock unlock", (() => {
                    c()
                })), t("click", ((a, t) => {
                    const i = t.target;
                    let {
                        el: r
                    } = e.pagination;
                    if (Array.isArray(r) || (r = [r].filter((e => !!e))), e.params.pagination.el && e.params.pagination.hideOnClick && r && r.length > 0 && !i.classList.contains(e.params.pagination.bulletClass)) {
                        if (e.navigation && (e.navigation.nextEl && i === e.navigation.nextEl || e.navigation.prevEl && i === e.navigation.prevEl)) return;
                        const a = r[0].classList.contains(e.params.pagination.hiddenClass);
                        n(!0 === a ? "paginationShow" : "paginationHide"), r.forEach((a => a.classList.toggle(e.params.pagination.hiddenClass)))
                    }
                }));
                const m = () => {
                    e.el.classList.add(e.params.pagination.paginationDisabledClass);
                    let {
                        el: a
                    } = e.pagination;
                    a && (a = o(a), a.forEach((a => a.classList.add(e.params.pagination.paginationDisabledClass)))), f()
                };
                Object.assign(e.pagination, {
                    enable: () => {
                        e.el.classList.remove(e.params.pagination.paginationDisabledClass);
                        let {
                            el: a
                        } = e.pagination;
                        a && (a = o(a), a.forEach((a => a.classList.remove(e.params.pagination.paginationDisabledClass)))), h(), p(), c()
                    },
                    disable: m,
                    render: p,
                    update: c,
                    init: h,
                    destroy: f
                })
            }, function({
                swiper: e,
                extendParams: a,
                on: t,
                emit: n
            }) {
                const i = r();
                let s, o, u, d, c = !1,
                    p = null,
                    h = null;

                function f() {
                    if (!e.params.scrollbar.el || !e.scrollbar.el) return;
                    const {
                        scrollbar: a,
                        rtlTranslate: t
                    } = e, {
                        dragEl: n,
                        el: i
                    } = a, r = e.params.scrollbar, s = e.params.loop ? e.progressLoop : e.progress;
                    let l = o,
                        d = (u - o) * s;
                    t ? (d = -d, d > 0 ? (l = o - d, d = 0) : -d + o > u && (l = u + d)) : d < 0 ? (l = o + d, d = 0) : d + o > u && (l = u - d), e.isHorizontal() ? (n.style.transform = `translate3d(${d}px, 0, 0)`, n.style.width = `${l}px`) : (n.style.transform = `translate3d(0px, ${d}px, 0)`, n.style.height = `${l}px`), r.hide && (clearTimeout(p), i.style.opacity = 1, p = setTimeout((() => {
                        i.style.opacity = 0, i.style.transitionDuration = "400ms"
                    }), 1e3))
                }

                function m() {
                    if (!e.params.scrollbar.el || !e.scrollbar.el) return;
                    const {
                        scrollbar: a
                    } = e, {
                        dragEl: t,
                        el: n
                    } = a;
                    t.style.width = "", t.style.height = "", u = e.isHorizontal() ? n.offsetWidth : n.offsetHeight, d = e.size / (e.virtualSize + e.params.slidesOffsetBefore - (e.params.centeredSlides ? e.snapGrid[0] : 0)), o = "auto" === e.params.scrollbar.dragSize ? u * d : parseInt(e.params.scrollbar.dragSize, 10), e.isHorizontal() ? t.style.width = `${o}px` : t.style.height = `${o}px`, n.style.display = d >= 1 ? "none" : "", e.params.scrollbar.hide && (n.style.opacity = 0), e.params.watchOverflow && e.enabled && a.el.classList[e.isLocked ? "add" : "remove"](e.params.scrollbar.lockClass)
                }

                function g(a) {
                    return e.isHorizontal() ? a.clientX : a.clientY
                }

                function b(a) {
                    const {
                        scrollbar: t,
                        rtlTranslate: n
                    } = e, {
                        el: i
                    } = t;
                    let r;
                    r = (g(a) - y(i)[e.isHorizontal() ? "left" : "top"] - (null !== s ? s : o / 2)) / (u - o), r = Math.max(Math.min(r, 1), 0), n && (r = 1 - r);
                    const l = e.minTranslate() + (e.maxTranslate() - e.minTranslate()) * r;
                    e.updateProgress(l), e.setTranslate(l), e.updateActiveIndex(), e.updateSlidesClasses()
                }

                function S(a) {
                    const t = e.params.scrollbar,
                        {
                            scrollbar: i,
                            wrapperEl: r
                        } = e,
                        {
                            el: o,
                            dragEl: l
                        } = i;
                    c = !0, s = a.target === l ? g(a) - a.target.getBoundingClientRect()[e.isHorizontal() ? "left" : "top"] : null, a.preventDefault(), a.stopPropagation(), r.style.transitionDuration = "100ms", l.style.transitionDuration = "100ms", b(a), clearTimeout(h), o.style.transitionDuration = "0ms", t.hide && (o.style.opacity = 1), e.params.cssMode && (e.wrapperEl.style["scroll-snap-type"] = "none"), n("scrollbarDragStart", a)
                }

                function w(a) {
                    const {
                        scrollbar: t,
                        wrapperEl: i
                    } = e, {
                        el: r,
                        dragEl: s
                    } = t;
                    c && (a.preventDefault ? a.preventDefault() : a.returnValue = !1, b(a), i.style.transitionDuration = "0ms", r.style.transitionDuration = "0ms", s.style.transitionDuration = "0ms", n("scrollbarDragMove", a))
                }

                function k(a) {
                    const t = e.params.scrollbar,
                        {
                            scrollbar: i,
                            wrapperEl: r
                        } = e,
                        {
                            el: s
                        } = i;
                    c && (c = !1, e.params.cssMode && (e.wrapperEl.style["scroll-snap-type"] = "", r.style.transitionDuration = ""), t.hide && (clearTimeout(h), h = l((() => {
                        s.style.opacity = 0, s.style.transitionDuration = "400ms"
                    }), 1e3)), n("scrollbarDragEnd", a), t.snapOnRelease && e.slideToClosest())
                }

                function T(a) {
                    const {
                        scrollbar: t,
                        params: n
                    } = e, r = t.el;
                    if (!r) return;
                    const s = r,
                        o = !!n.passiveListeners && {
                            passive: !1,
                            capture: !1
                        },
                        l = !!n.passiveListeners && {
                            passive: !0,
                            capture: !1
                        };
                    if (!s) return;
                    const u = "on" === a ? "addEventListener" : "removeEventListener";
                    s[u]("pointerdown", S, o), i[u]("pointermove", w, o), i[u]("pointerup", k, l)
                }

                function x() {
                    const {
                        scrollbar: a,
                        el: t
                    } = e;
                    e.params.scrollbar = ie(e, e.originalParams.scrollbar, e.params.scrollbar, {
                        el: "swiper-scrollbar"
                    });
                    const n = e.params.scrollbar;
                    if (!n.el) return;
                    let r, s;
                    "string" == typeof n.el && e.isElement && (r = e.el.shadowRoot.querySelector(n.el)), r || "string" != typeof n.el ? r || (r = n.el) : r = i.querySelectorAll(n.el), e.params.uniqueNavElements && "string" == typeof n.el && r.length > 1 && 1 === t.querySelectorAll(n.el).length && (r = t.querySelector(n.el)), r.length > 0 && (r = r[0]), r.classList.add(e.isHorizontal() ? n.horizontalClass : n.verticalClass), r && (s = r.querySelector(`.${e.params.scrollbar.dragClass}`), s || (s = v("div", e.params.scrollbar.dragClass), r.append(s))), Object.assign(a, {
                        el: r,
                        dragEl: s
                    }), n.draggable && e.params.scrollbar.el && e.scrollbar.el && T("on"), r && r.classList[e.enabled ? "remove" : "add"](e.params.scrollbar.lockClass)
                }

                function C() {
                    const a = e.params.scrollbar,
                        t = e.scrollbar.el;
                    t && t.classList.remove(e.isHorizontal() ? a.horizontalClass : a.verticalClass), e.params.scrollbar.el && e.scrollbar.el && T("off")
                }
                a({
                    scrollbar: {
                        el: null,
                        dragSize: "auto",
                        hide: !1,
                        draggable: !1,
                        snapOnRelease: !0,
                        lockClass: "swiper-scrollbar-lock",
                        dragClass: "swiper-scrollbar-drag",
                        scrollbarDisabledClass: "swiper-scrollbar-disabled",
                        horizontalClass: "swiper-scrollbar-horizontal",
                        verticalClass: "swiper-scrollbar-vertical"
                    }
                }), e.scrollbar = {
                    el: null,
                    dragEl: null
                }, t("init", (() => {
                    !1 === e.params.scrollbar.enabled ? E() : (x(), m(), f())
                })), t("update resize observerUpdate lock unlock", (() => {
                    m()
                })), t("setTranslate", (() => {
                    f()
                })), t("setTransition", ((a, t) => {
                    ! function(a) {
                        e.params.scrollbar.el && e.scrollbar.el && (e.scrollbar.dragEl.style.transitionDuration = `${a}ms`)
                    }(t)
                })), t("enable disable", (() => {
                    const {
                        el: a
                    } = e.scrollbar;
                    a && a.classList[e.enabled ? "remove" : "add"](e.params.scrollbar.lockClass)
                })), t("destroy", (() => {
                    C()
                }));
                const E = () => {
                    e.el.classList.add(e.params.scrollbar.scrollbarDisabledClass), e.scrollbar.el && e.scrollbar.el.classList.add(e.params.scrollbar.scrollbarDisabledClass), C()
                };
                Object.assign(e.scrollbar, {
                    enable: () => {
                        e.el.classList.remove(e.params.scrollbar.scrollbarDisabledClass), e.scrollbar.el && e.scrollbar.el.classList.remove(e.params.scrollbar.scrollbarDisabledClass), x(), m(), f()
                    },
                    disable: E,
                    updateSize: m,
                    setTranslate: f,
                    init: x,
                    destroy: C
                })
            }, function({
                swiper: e,
                extendParams: a,
                on: t
            }) {
                a({
                    parallax: {
                        enabled: !1
                    }
                });
                const n = (a, t) => {
                        const {
                            rtl: n
                        } = e, i = n ? -1 : 1, r = a.getAttribute("data-swiper-parallax") || "0";
                        let s = a.getAttribute("data-swiper-parallax-x"),
                            o = a.getAttribute("data-swiper-parallax-y");
                        const l = a.getAttribute("data-swiper-parallax-scale"),
                            u = a.getAttribute("data-swiper-parallax-opacity"),
                            d = a.getAttribute("data-swiper-parallax-rotate");
                        if (s || o ? (s = s || "0", o = o || "0") : e.isHorizontal() ? (s = r, o = "0") : (o = r, s = "0"), s = s.indexOf("%") >= 0 ? parseInt(s, 10) * t * i + "%" : s * t * i + "px", o = o.indexOf("%") >= 0 ? parseInt(o, 10) * t + "%" : o * t + "px", null != u) {
                            const e = u - (u - 1) * (1 - Math.abs(t));
                            a.style.opacity = e
                        }
                        let c = `translate3d(${s}, ${o}, 0px)`;
                        if (null != l) {
                            c += ` scale(${l - (l - 1) * (1 - Math.abs(t))})`
                        }
                        if (d && null != d) {
                            c += ` rotate(${d * t * -1}deg)`
                        }
                        a.style.transform = c
                    },
                    i = () => {
                        const {
                            el: a,
                            slides: t,
                            progress: i,
                            snapGrid: r
                        } = e;
                        g(a, "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").forEach((e => {
                            n(e, i)
                        })), t.forEach(((a, t) => {
                            let s = a.progress;
                            e.params.slidesPerGroup > 1 && "auto" !== e.params.slidesPerView && (s += Math.ceil(t / 2) - i * (r.length - 1)), s = Math.min(Math.max(s, -1), 1), a.querySelectorAll("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale], [data-swiper-parallax-rotate]").forEach((e => {
                                n(e, s)
                            }))
                        }))
                    };
                t("beforeInit", (() => {
                    e.params.parallax.enabled && (e.params.watchSlidesProgress = !0, e.originalParams.watchSlidesProgress = !0)
                })), t("init", (() => {
                    e.params.parallax.enabled && i()
                })), t("setTranslate", (() => {
                    e.params.parallax.enabled && i()
                })), t("setTransition", ((a, t) => {
                    e.params.parallax.enabled && ((a = e.params.speed) => {
                        const {
                            el: t
                        } = e;
                        t.querySelectorAll("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").forEach((e => {
                            let t = parseInt(e.getAttribute("data-swiper-parallax-duration"), 10) || a;
                            0 === a && (t = 0), e.style.transitionDuration = `${t}ms`
                        }))
                    })(t)
                }))
            }, function({
                swiper: e,
                extendParams: a,
                on: t,
                emit: n
            }) {
                const i = o();
                a({
                    zoom: {
                        enabled: !1,
                        maxRatio: 3,
                        minRatio: 1,
                        toggle: !0,
                        containerClass: "swiper-zoom-container",
                        zoomedSlideClass: "swiper-slide-zoomed"
                    }
                }), e.zoom = {
                    enabled: !1
                };
                let r, s, l = 1,
                    u = !1;
                const c = [],
                    p = {
                        originX: 0,
                        originY: 0,
                        slideEl: void 0,
                        slideWidth: void 0,
                        slideHeight: void 0,
                        imageEl: void 0,
                        imageWrapEl: void 0,
                        maxRatio: 3
                    },
                    h = {
                        isTouched: void 0,
                        isMoved: void 0,
                        currentX: void 0,
                        currentY: void 0,
                        minX: void 0,
                        minY: void 0,
                        maxX: void 0,
                        maxY: void 0,
                        width: void 0,
                        height: void 0,
                        startX: void 0,
                        startY: void 0,
                        touchesStart: {},
                        touchesCurrent: {}
                    },
                    f = {
                        x: void 0,
                        y: void 0,
                        prevPositionX: void 0,
                        prevPositionY: void 0,
                        prevTime: void 0
                    };
                let m = 1;

                function v() {
                    if (c.length < 2) return 1;
                    const e = c[0].pageX,
                        a = c[0].pageY,
                        t = c[1].pageX,
                        n = c[1].pageY;
                    return Math.sqrt((t - e) ** 2 + (n - a) ** 2)
                }

                function b(a) {
                    const t = e.isElement ? "swiper-slide" : `.${e.params.slideClass}`;
                    return !!a.target.matches(t) || e.slides.filter((e => e.contains(a.target))).length > 0
                }

                function S(a) {
                    if ("mouse" === a.pointerType && c.splice(0, c.length), !b(a)) return;
                    const t = e.params.zoom;
                    if (r = !1, s = !1, c.push(a), !(c.length < 2)) {
                        if (r = !0, p.scaleStart = v(), !p.slideEl) {
                            p.slideEl = a.target.closest(`.${e.params.slideClass}, swiper-slide`), p.slideEl || (p.slideEl = e.slides[e.activeIndex]);
                            let n = p.slideEl.querySelector(`.${t.containerClass}`);
                            if (n && (n = n.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]), p.imageEl = n, p.imageWrapEl = n ? w(p.imageEl, `.${t.containerClass}`)[0] : void 0, !p.imageWrapEl) return void(p.imageEl = void 0);
                            p.maxRatio = p.imageWrapEl.getAttribute("data-swiper-zoom") || t.maxRatio
                        }
                        if (p.imageEl) {
                            const [e, a] = function() {
                                if (c.length < 2) return {
                                    x: null,
                                    y: null
                                };
                                const e = p.imageEl.getBoundingClientRect();
                                return [(c[0].pageX + (c[1].pageX - c[0].pageX) / 2 - e.x) / l, (c[0].pageY + (c[1].pageY - c[0].pageY) / 2 - e.y) / l]
                            }();
                            p.originX = e, p.originY = a, p.imageEl.style.transitionDuration = "0ms"
                        }
                        u = !0
                    }
                }

                function k(a) {
                    if (!b(a)) return;
                    const t = e.params.zoom,
                        n = e.zoom,
                        i = c.findIndex((e => e.pointerId === a.pointerId));
                    i >= 0 && (c[i] = a), c.length < 2 || (s = !0, p.scaleMove = v(), p.imageEl && (n.scale = p.scaleMove / p.scaleStart * l, n.scale > p.maxRatio && (n.scale = p.maxRatio - 1 + (n.scale - p.maxRatio + 1) ** .5), n.scale < t.minRatio && (n.scale = t.minRatio + 1 - (t.minRatio - n.scale + 1) ** .5), p.imageEl.style.transform = `translate3d(0,0,0) scale(${n.scale})`))
                }

                function T(a) {
                    if (!b(a)) return;
                    if ("mouse" === a.pointerType && "pointerout" === a.type) return;
                    const t = e.params.zoom,
                        n = e.zoom,
                        i = c.findIndex((e => e.pointerId === a.pointerId));
                    i >= 0 && c.splice(i, 1), r && s && (r = !1, s = !1, p.imageEl && (n.scale = Math.max(Math.min(n.scale, p.maxRatio), t.minRatio), p.imageEl.style.transitionDuration = `${e.params.speed}ms`, p.imageEl.style.transform = `translate3d(0,0,0) scale(${n.scale})`, l = n.scale, u = !1, n.scale > 1 && p.slideEl ? p.slideEl.classList.add(`${t.zoomedSlideClass}`) : n.scale <= 1 && p.slideEl && p.slideEl.classList.remove(`${t.zoomedSlideClass}`), 1 === n.scale && (p.originX = 0, p.originY = 0, p.slideEl = void 0)))
                }

                function x(a) {
                    if (!b(a) || ! function(a) {
                            const t = `.${e.params.zoom.containerClass}`;
                            return !!a.target.matches(t) || [...e.el.querySelectorAll(t)].filter((e => e.contains(a.target))).length > 0
                        }(a)) return;
                    const t = e.zoom;
                    if (!p.imageEl) return;
                    if (!h.isTouched || !p.slideEl) return;
                    h.isMoved || (h.width = p.imageEl.offsetWidth, h.height = p.imageEl.offsetHeight, h.startX = d(p.imageWrapEl, "x") || 0, h.startY = d(p.imageWrapEl, "y") || 0, p.slideWidth = p.slideEl.offsetWidth, p.slideHeight = p.slideEl.offsetHeight, p.imageWrapEl.style.transitionDuration = "0ms");
                    const n = h.width * t.scale,
                        i = h.height * t.scale;
                    if (n < p.slideWidth && i < p.slideHeight) return;
                    h.minX = Math.min(p.slideWidth / 2 - n / 2, 0), h.maxX = -h.minX, h.minY = Math.min(p.slideHeight / 2 - i / 2, 0), h.maxY = -h.minY, h.touchesCurrent.x = c.length > 0 ? c[0].pageX : a.pageX, h.touchesCurrent.y = c.length > 0 ? c[0].pageY : a.pageY;
                    if (Math.max(Math.abs(h.touchesCurrent.x - h.touchesStart.x), Math.abs(h.touchesCurrent.y - h.touchesStart.y)) > 5 && (e.allowClick = !1), !h.isMoved && !u) {
                        if (e.isHorizontal() && (Math.floor(h.minX) === Math.floor(h.startX) && h.touchesCurrent.x < h.touchesStart.x || Math.floor(h.maxX) === Math.floor(h.startX) && h.touchesCurrent.x > h.touchesStart.x)) return void(h.isTouched = !1);
                        if (!e.isHorizontal() && (Math.floor(h.minY) === Math.floor(h.startY) && h.touchesCurrent.y < h.touchesStart.y || Math.floor(h.maxY) === Math.floor(h.startY) && h.touchesCurrent.y > h.touchesStart.y)) return void(h.isTouched = !1)
                    }
                    a.cancelable && a.preventDefault(), a.stopPropagation(), h.isMoved = !0;
                    const r = (t.scale - l) / (p.maxRatio - e.params.zoom.minRatio),
                        {
                            originX: s,
                            originY: o
                        } = p;
                    h.currentX = h.touchesCurrent.x - h.touchesStart.x + h.startX + r * (h.width - 2 * s), h.currentY = h.touchesCurrent.y - h.touchesStart.y + h.startY + r * (h.height - 2 * o), h.currentX < h.minX && (h.currentX = h.minX + 1 - (h.minX - h.currentX + 1) ** .8), h.currentX > h.maxX && (h.currentX = h.maxX - 1 + (h.currentX - h.maxX + 1) ** .8), h.currentY < h.minY && (h.currentY = h.minY + 1 - (h.minY - h.currentY + 1) ** .8), h.currentY > h.maxY && (h.currentY = h.maxY - 1 + (h.currentY - h.maxY + 1) ** .8), f.prevPositionX || (f.prevPositionX = h.touchesCurrent.x), f.prevPositionY || (f.prevPositionY = h.touchesCurrent.y), f.prevTime || (f.prevTime = Date.now()), f.x = (h.touchesCurrent.x - f.prevPositionX) / (Date.now() - f.prevTime) / 2, f.y = (h.touchesCurrent.y - f.prevPositionY) / (Date.now() - f.prevTime) / 2, Math.abs(h.touchesCurrent.x - f.prevPositionX) < 2 && (f.x = 0), Math.abs(h.touchesCurrent.y - f.prevPositionY) < 2 && (f.y = 0), f.prevPositionX = h.touchesCurrent.x, f.prevPositionY = h.touchesCurrent.y, f.prevTime = Date.now(), p.imageWrapEl.style.transform = `translate3d(${h.currentX}px, ${h.currentY}px,0)`
                }

                function C() {
                    const a = e.zoom;
                    p.slideEl && e.activeIndex !== e.slides.indexOf(p.slideEl) && (p.imageEl && (p.imageEl.style.transform = "translate3d(0,0,0) scale(1)"), p.imageWrapEl && (p.imageWrapEl.style.transform = "translate3d(0,0,0)"), p.slideEl.classList.remove(`${e.params.zoom.zoomedSlideClass}`), a.scale = 1, l = 1, p.slideEl = void 0, p.imageEl = void 0, p.imageWrapEl = void 0, p.originX = 0, p.originY = 0)
                }

                function E(a) {
                    const t = e.zoom,
                        n = e.params.zoom;
                    if (!p.slideEl) {
                        a && a.target && (p.slideEl = a.target.closest(`.${e.params.slideClass}, swiper-slide`)), p.slideEl || (e.params.virtual && e.params.virtual.enabled && e.virtual ? p.slideEl = g(e.slidesEl, `.${e.params.slideActiveClass}`)[0] : p.slideEl = e.slides[e.activeIndex]);
                        let t = p.slideEl.querySelector(`.${n.containerClass}`);
                        t && (t = t.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]), p.imageEl = t, p.imageWrapEl = t ? w(p.imageEl, `.${n.containerClass}`)[0] : void 0
                    }
                    if (!p.imageEl || !p.imageWrapEl) return;
                    let r, s, o, u, d, c, f, m, v, b, S, k, T, x, C, E, M, A;
                    e.params.cssMode && (e.wrapperEl.style.overflow = "hidden", e.wrapperEl.style.touchAction = "none"), p.slideEl.classList.add(`${n.zoomedSlideClass}`), void 0 === h.touchesStart.x && a ? (r = a.pageX, s = a.pageY) : (r = h.touchesStart.x, s = h.touchesStart.y);
                    const P = "number" == typeof a ? a : null;
                    1 === l && P && (r = void 0, s = void 0), t.scale = P || p.imageWrapEl.getAttribute("data-swiper-zoom") || n.maxRatio, l = P || p.imageWrapEl.getAttribute("data-swiper-zoom") || n.maxRatio, !a || 1 === l && P ? (f = 0, m = 0) : (M = p.slideEl.offsetWidth, A = p.slideEl.offsetHeight, o = y(p.slideEl).left + i.scrollX, u = y(p.slideEl).top + i.scrollY, d = o + M / 2 - r, c = u + A / 2 - s, v = p.imageEl.offsetWidth, b = p.imageEl.offsetHeight, S = v * t.scale, k = b * t.scale, T = Math.min(M / 2 - S / 2, 0), x = Math.min(A / 2 - k / 2, 0), C = -T, E = -x, f = d * t.scale, m = c * t.scale, f < T && (f = T), f > C && (f = C), m < x && (m = x), m > E && (m = E)), P && 1 === t.scale && (p.originX = 0, p.originY = 0), p.imageWrapEl.style.transitionDuration = "300ms", p.imageWrapEl.style.transform = `translate3d(${f}px, ${m}px,0)`, p.imageEl.style.transitionDuration = "300ms", p.imageEl.style.transform = `translate3d(0,0,0) scale(${t.scale})`
                }

                function M() {
                    const a = e.zoom,
                        t = e.params.zoom;
                    if (!p.slideEl) {
                        e.params.virtual && e.params.virtual.enabled && e.virtual ? p.slideEl = g(e.slidesEl, `.${e.params.slideActiveClass}`)[0] : p.slideEl = e.slides[e.activeIndex];
                        let a = p.slideEl.querySelector(`.${t.containerClass}`);
                        a && (a = a.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0]), p.imageEl = a, p.imageWrapEl = a ? w(p.imageEl, `.${t.containerClass}`)[0] : void 0
                    }
                    p.imageEl && p.imageWrapEl && (e.params.cssMode && (e.wrapperEl.style.overflow = "", e.wrapperEl.style.touchAction = ""), a.scale = 1, l = 1, p.imageWrapEl.style.transitionDuration = "300ms", p.imageWrapEl.style.transform = "translate3d(0,0,0)", p.imageEl.style.transitionDuration = "300ms", p.imageEl.style.transform = "translate3d(0,0,0) scale(1)", p.slideEl.classList.remove(`${t.zoomedSlideClass}`), p.slideEl = void 0, p.originX = 0, p.originY = 0)
                }

                function A(a) {
                    const t = e.zoom;
                    t.scale && 1 !== t.scale ? M() : E(a)
                }

                function P() {
                    return {
                        passiveListener: !!e.params.passiveListeners && {
                            passive: !0,
                            capture: !1
                        },
                        activeListenerWithCapture: !e.params.passiveListeners || {
                            passive: !1,
                            capture: !0
                        }
                    }
                }

                function L() {
                    const a = e.zoom;
                    if (a.enabled) return;
                    a.enabled = !0;
                    const {
                        passiveListener: t,
                        activeListenerWithCapture: n
                    } = P();
                    e.wrapperEl.addEventListener("pointerdown", S, t), e.wrapperEl.addEventListener("pointermove", k, n), ["pointerup", "pointercancel", "pointerout"].forEach((a => {
                        e.wrapperEl.addEventListener(a, T, t)
                    })), e.wrapperEl.addEventListener("pointermove", x, n)
                }

                function j() {
                    const a = e.zoom;
                    if (!a.enabled) return;
                    a.enabled = !1;
                    const {
                        passiveListener: t,
                        activeListenerWithCapture: n
                    } = P();
                    e.wrapperEl.removeEventListener("pointerdown", S, t), e.wrapperEl.removeEventListener("pointermove", k, n), ["pointerup", "pointercancel", "pointerout"].forEach((a => {
                        e.wrapperEl.removeEventListener(a, T, t)
                    })), e.wrapperEl.removeEventListener("pointermove", x, n)
                }
                Object.defineProperty(e.zoom, "scale", {
                    get() {
                        return m
                    },
                    set(e) {
                        if (m !== e) {
                            const a = p.imageEl,
                                t = p.slideEl;
                            n("zoomChange", e, a, t)
                        }
                        m = e
                    }
                }), t("init", (() => {
                    e.params.zoom.enabled && L()
                })), t("destroy", (() => {
                    j()
                })), t("touchStart", ((a, t) => {
                    e.zoom.enabled && function(a) {
                        const t = e.device;
                        if (!p.imageEl) return;
                        if (h.isTouched) return;
                        t.android && a.cancelable && a.preventDefault(), h.isTouched = !0;
                        const n = c.length > 0 ? c[0] : a;
                        h.touchesStart.x = n.pageX, h.touchesStart.y = n.pageY
                    }(t)
                })), t("touchEnd", ((a, t) => {
                    e.zoom.enabled && function() {
                        const a = e.zoom;
                        if (!p.imageEl) return;
                        if (!h.isTouched || !h.isMoved) return h.isTouched = !1, void(h.isMoved = !1);
                        h.isTouched = !1, h.isMoved = !1;
                        let t = 300,
                            n = 300;
                        const i = f.x * t,
                            r = h.currentX + i,
                            s = f.y * n,
                            o = h.currentY + s;
                        0 !== f.x && (t = Math.abs((r - h.currentX) / f.x)), 0 !== f.y && (n = Math.abs((o - h.currentY) / f.y));
                        const l = Math.max(t, n);
                        h.currentX = r, h.currentY = o;
                        const u = h.width * a.scale,
                            d = h.height * a.scale;
                        h.minX = Math.min(p.slideWidth / 2 - u / 2, 0), h.maxX = -h.minX, h.minY = Math.min(p.slideHeight / 2 - d / 2, 0), h.maxY = -h.minY, h.currentX = Math.max(Math.min(h.currentX, h.maxX), h.minX), h.currentY = Math.max(Math.min(h.currentY, h.maxY), h.minY), p.imageWrapEl.style.transitionDuration = `${l}ms`, p.imageWrapEl.style.transform = `translate3d(${h.currentX}px, ${h.currentY}px,0)`
                    }()
                })), t("doubleTap", ((a, t) => {
                    !e.animating && e.params.zoom.enabled && e.zoom.enabled && e.params.zoom.toggle && A(t)
                })), t("transitionEnd", (() => {
                    e.zoom.enabled && e.params.zoom.enabled && C()
                })), t("slideChange", (() => {
                    e.zoom.enabled && e.params.zoom.enabled && e.params.cssMode && C()
                })), Object.assign(e.zoom, {
                    enable: L,
                    disable: j,
                    in: E,
                    out: M,
                    toggle: A
                })
            }, function({
                swiper: e,
                extendParams: a,
                on: t
            }) {
                function n(e, a) {
                    const t = function() {
                        let e, a, t;
                        return (n, i) => {
                            for (a = -1, e = n.length; e - a > 1;) t = e + a >> 1, n[t] <= i ? a = t : e = t;
                            return e
                        }
                    }();
                    let n, i;
                    return this.x = e, this.y = a, this.lastIndex = e.length - 1, this.interpolate = function(e) {
                        return e ? (i = t(this.x, e), n = i - 1, (e - this.x[n]) * (this.y[i] - this.y[n]) / (this.x[i] - this.x[n]) + this.y[n]) : 0
                    }, this
                }

                function i() {
                    e.controller.control && e.controller.spline && (e.controller.spline = void 0, delete e.controller.spline)
                }
                a({
                    controller: {
                        control: void 0,
                        inverse: !1,
                        by: "slide"
                    }
                }), e.controller = {
                    control: void 0
                }, t("beforeInit", (() => {
                    if ("undefined" != typeof window && ("string" == typeof e.params.controller.control || e.params.controller.control instanceof HTMLElement)) {
                        const a = document.querySelector(e.params.controller.control);
                        if (a && a.swiper) e.controller.control = a.swiper;
                        else if (a) {
                            const t = n => {
                                e.controller.control = n.detail[0], e.update(), a.removeEventListener("init", t)
                            };
                            a.addEventListener("init", t)
                        }
                    } else e.controller.control = e.params.controller.control
                })), t("update", (() => {
                    i()
                })), t("resize", (() => {
                    i()
                })), t("observerUpdate", (() => {
                    i()
                })), t("setTranslate", ((a, t, n) => {
                    e.controller.control && e.controller.setTranslate(t, n)
                })), t("setTransition", ((a, t, n) => {
                    e.controller.control && e.controller.setTransition(t, n)
                })), Object.assign(e.controller, {
                    setTranslate: function(a, t) {
                        const i = e.controller.control;
                        let r, s;
                        const o = e.constructor;

                        function l(a) {
                            if (a.destroyed) return;
                            const t = e.rtlTranslate ? -e.translate : e.translate;
                            "slide" === e.params.controller.by && (! function(a) {
                                e.controller.spline || (e.controller.spline = e.params.loop ? new n(e.slidesGrid, a.slidesGrid) : new n(e.snapGrid, a.snapGrid))
                            }(a), s = -e.controller.spline.interpolate(-t)), s && "container" !== e.params.controller.by || (r = (a.maxTranslate() - a.minTranslate()) / (e.maxTranslate() - e.minTranslate()), s = (t - e.minTranslate()) * r + a.minTranslate()), e.params.controller.inverse && (s = a.maxTranslate() - s), a.updateProgress(s), a.setTranslate(s, e), a.updateActiveIndex(), a.updateSlidesClasses()
                        }
                        if (Array.isArray(i))
                            for (let e = 0; e < i.length; e += 1) i[e] !== t && i[e] instanceof o && l(i[e]);
                        else i instanceof o && t !== i && l(i)
                    },
                    setTransition: function(a, t) {
                        const n = e.constructor,
                            i = e.controller.control;
                        let r;

                        function s(t) {
                            t.destroyed || (t.setTransition(a, e), 0 !== a && (t.transitionStart(), t.params.autoHeight && l((() => {
                                t.updateAutoHeight()
                            })), k(t.wrapperEl, (() => {
                                i && t.transitionEnd()
                            }))))
                        }
                        if (Array.isArray(i))
                            for (r = 0; r < i.length; r += 1) i[r] !== t && i[r] instanceof n && s(i[r]);
                        else i instanceof n && t !== i && s(i)
                    }
                })
            }, function({
                swiper: e,
                extendParams: a,
                on: t
            }) {
                a({
                    a11y: {
                        enabled: !0,
                        notificationClass: "swiper-notification",
                        prevSlideMessage: "Previous slide",
                        nextSlideMessage: "Next slide",
                        firstSlideMessage: "This is the first slide",
                        lastSlideMessage: "This is the last slide",
                        paginationBulletMessage: "Go to slide {{index}}",
                        slideLabelMessage: "{{index}} / {{slidesLength}}",
                        containerMessage: null,
                        containerRoleDescriptionMessage: null,
                        itemRoleDescriptionMessage: null,
                        slideRole: "group",
                        id: null
                    }
                }), e.a11y = {
                    clicked: !1
                };
                let n = null;

                function i(e) {
                    const a = n;
                    0 !== a.length && (a.innerHTML = "", a.innerHTML = e)
                }
                const r = e => (Array.isArray(e) || (e = [e].filter((e => !!e))), e);

                function s(e) {
                    (e = r(e)).forEach((e => {
                        e.setAttribute("tabIndex", "0")
                    }))
                }

                function o(e) {
                    (e = r(e)).forEach((e => {
                        e.setAttribute("tabIndex", "-1")
                    }))
                }

                function l(e, a) {
                    (e = r(e)).forEach((e => {
                        e.setAttribute("role", a)
                    }))
                }

                function u(e, a) {
                    (e = r(e)).forEach((e => {
                        e.setAttribute("aria-roledescription", a)
                    }))
                }

                function d(e, a) {
                    (e = r(e)).forEach((e => {
                        e.setAttribute("aria-label", a)
                    }))
                }

                function c(e) {
                    (e = r(e)).forEach((e => {
                        e.setAttribute("aria-disabled", !0)
                    }))
                }

                function p(e) {
                    (e = r(e)).forEach((e => {
                        e.setAttribute("aria-disabled", !1)
                    }))
                }

                function h(a) {
                    if (13 !== a.keyCode && 32 !== a.keyCode) return;
                    const t = e.params.a11y,
                        n = a.target;
                    e.pagination && e.pagination.el && (n === e.pagination.el || e.pagination.el.contains(a.target)) && !a.target.matches(re(e.params.pagination.bulletClass)) || (e.navigation && e.navigation.nextEl && n === e.navigation.nextEl && (e.isEnd && !e.params.loop || e.slideNext(), e.isEnd ? i(t.lastSlideMessage) : i(t.nextSlideMessage)), e.navigation && e.navigation.prevEl && n === e.navigation.prevEl && (e.isBeginning && !e.params.loop || e.slidePrev(), e.isBeginning ? i(t.firstSlideMessage) : i(t.prevSlideMessage)), e.pagination && n.matches(re(e.params.pagination.bulletClass)) && n.click())
                }

                function f() {
                    return e.pagination && e.pagination.bullets && e.pagination.bullets.length
                }

                function m() {
                    return f() && e.params.pagination.clickable
                }
                const g = (e, a, t) => {
                        s(e), "BUTTON" !== e.tagName && (l(e, "button"), e.addEventListener("keydown", h)), d(e, t),
                            function(e, a) {
                                (e = r(e)).forEach((e => {
                                    e.setAttribute("aria-controls", a)
                                }))
                            }(e, a)
                    },
                    y = () => {
                        e.a11y.clicked = !0
                    },
                    b = () => {
                        requestAnimationFrame((() => {
                            requestAnimationFrame((() => {
                                e.destroyed || (e.a11y.clicked = !1)
                            }))
                        }))
                    },
                    w = a => {
                        if (e.a11y.clicked) return;
                        const t = a.target.closest(`.${e.params.slideClass}, swiper-slide`);
                        if (!t || !e.slides.includes(t)) return;
                        const n = e.slides.indexOf(t) === e.activeIndex,
                            i = e.params.watchSlidesProgress && e.visibleSlides && e.visibleSlides.includes(t);
                        n || i || a.sourceCapabilities && a.sourceCapabilities.firesTouchEvents || (e.isHorizontal() ? e.el.scrollLeft = 0 : e.el.scrollTop = 0, e.slideTo(e.slides.indexOf(t), 0))
                    },
                    k = () => {
                        const a = e.params.a11y;
                        a.itemRoleDescriptionMessage && u(e.slides, a.itemRoleDescriptionMessage), a.slideRole && l(e.slides, a.slideRole);
                        const t = e.slides.length;
                        a.slideLabelMessage && e.slides.forEach(((n, i) => {
                            const r = e.params.loop ? parseInt(n.getAttribute("data-swiper-slide-index"), 10) : i;
                            d(n, a.slideLabelMessage.replace(/\{\{index\}\}/, r + 1).replace(/\{\{slidesLength\}\}/, t))
                        }))
                    },
                    T = () => {
                        const a = e.params.a11y;
                        e.el.append(n);
                        const t = e.el;
                        a.containerRoleDescriptionMessage && u(t, a.containerRoleDescriptionMessage), a.containerMessage && d(t, a.containerMessage);
                        const i = e.wrapperEl,
                            s = a.id || i.getAttribute("id") || `swiper-wrapper-${function (e = 16) { return "x".repeat(e).replace(/x/g, (() => Math.round(16 * Math.random()).toString(16))) }(16)}`,
                            o = e.params.autoplay && e.params.autoplay.enabled ? "off" : "polite";
                        var l;
                        l = s, r(i).forEach((e => {
                                e.setAttribute("id", l)
                            })),
                            function(e, a) {
                                (e = r(e)).forEach((e => {
                                    e.setAttribute("aria-live", a)
                                }))
                            }(i, o), k();
                        let {
                            nextEl: c,
                            prevEl: p
                        } = e.navigation ? e.navigation : {};
                        if (c = r(c), p = r(p), c && c.forEach((e => g(e, s, a.nextSlideMessage))), p && p.forEach((e => g(e, s, a.prevSlideMessage))), m()) {
                            (Array.isArray(e.pagination.el) ? e.pagination.el : [e.pagination.el]).forEach((e => {
                                e.addEventListener("keydown", h)
                            }))
                        }
                        e.el.addEventListener("focus", w, !0), e.el.addEventListener("pointerdown", y, !0), e.el.addEventListener("pointerup", b, !0)
                    };
                t("beforeInit", (() => {
                    n = v("span", e.params.a11y.notificationClass), n.setAttribute("aria-live", "assertive"), n.setAttribute("aria-atomic", "true"), e.isElement && n.setAttribute("slot", "container-end")
                })), t("afterInit", (() => {
                    e.params.a11y.enabled && T()
                })), t("slidesLengthChange snapGridLengthChange slidesGridLengthChange", (() => {
                    e.params.a11y.enabled && k()
                })), t("fromEdge toEdge afterInit lock unlock", (() => {
                    e.params.a11y.enabled && function() {
                        if (e.params.loop || e.params.rewind || !e.navigation) return;
                        const {
                            nextEl: a,
                            prevEl: t
                        } = e.navigation;
                        t && (e.isBeginning ? (c(t), o(t)) : (p(t), s(t))), a && (e.isEnd ? (c(a), o(a)) : (p(a), s(a)))
                    }()
                })), t("paginationUpdate", (() => {
                    e.params.a11y.enabled && function() {
                        const a = e.params.a11y;
                        f() && e.pagination.bullets.forEach((t => {
                            e.params.pagination.clickable && (s(t), e.params.pagination.renderBullet || (l(t, "button"), d(t, a.paginationBulletMessage.replace(/\{\{index\}\}/, S(t) + 1)))), t.matches(re(e.params.pagination.bulletActiveClass)) ? t.setAttribute("aria-current", "true") : t.removeAttribute("aria-current")
                        }))
                    }()
                })), t("destroy", (() => {
                    e.params.a11y.enabled && function() {
                        n && n.length > 0 && n.remove();
                        let {
                            nextEl: a,
                            prevEl: t
                        } = e.navigation ? e.navigation : {};
                        a = r(a), t = r(t), a && a.forEach((e => e.removeEventListener("keydown", h))), t && t.forEach((e => e.removeEventListener("keydown", h))), m() && (Array.isArray(e.pagination.el) ? e.pagination.el : [e.pagination.el]).forEach((e => {
                            e.removeEventListener("keydown", h)
                        }));
                        e.el.removeEventListener("focus", w, !0), e.el.removeEventListener("pointerdown", y, !0), e.el.removeEventListener("pointerup", b, !0)
                    }()
                }))
            }, function({
                swiper: e,
                extendParams: a,
                on: t
            }) {
                a({
                    history: {
                        enabled: !1,
                        root: "",
                        replaceState: !1,
                        key: "slides",
                        keepQuery: !1
                    }
                });
                let n = !1,
                    i = {};
                const r = e => e.toString().replace(/\s+/g, "-").replace(/[^\w-]+/g, "").replace(/--+/g, "-").replace(/^-+/, "").replace(/-+$/, ""),
                    s = e => {
                        const a = o();
                        let t;
                        t = e ? new URL(e) : a.location;
                        const n = t.pathname.slice(1).split("/").filter((e => "" !== e)),
                            i = n.length;
                        return {
                            key: n[i - 2],
                            value: n[i - 1]
                        }
                    },
                    l = (a, t) => {
                        const i = o();
                        if (!n || !e.params.history.enabled) return;
                        let s;
                        s = e.params.url ? new URL(e.params.url) : i.location;
                        const l = e.slides[t];
                        let u = r(l.getAttribute("data-history"));
                        if (e.params.history.root.length > 0) {
                            let t = e.params.history.root;
                            "/" === t[t.length - 1] && (t = t.slice(0, t.length - 1)), u = `${t}/${a ? `${a}/` : ""}${u}`
                        } else s.pathname.includes(a) || (u = `${a ? `${a}/` : ""}${u}`);
                        e.params.history.keepQuery && (u += s.search);
                        const d = i.history.state;
                        d && d.value === u || (e.params.history.replaceState ? i.history.replaceState({
                            value: u
                        }, null, u) : i.history.pushState({
                            value: u
                        }, null, u))
                    },
                    u = (a, t, n) => {
                        if (t)
                            for (let i = 0, s = e.slides.length; i < s; i += 1) {
                                const s = e.slides[i];
                                if (r(s.getAttribute("data-history")) === t) {
                                    const t = e.getSlideIndex(s);
                                    e.slideTo(t, a, n)
                                }
                            } else e.slideTo(0, a, n)
                    },
                    d = () => {
                        i = s(e.params.url), u(e.params.speed, i.value, !1)
                    };
                t("init", (() => {
                    e.params.history.enabled && (() => {
                        const a = o();
                        if (e.params.history) {
                            if (!a.history || !a.history.pushState) return e.params.history.enabled = !1, void(e.params.hashNavigation.enabled = !0);
                            n = !0, i = s(e.params.url), i.key || i.value ? (u(0, i.value, e.params.runCallbacksOnInit), e.params.history.replaceState || a.addEventListener("popstate", d)) : e.params.history.replaceState || a.addEventListener("popstate", d)
                        }
                    })()
                })), t("destroy", (() => {
                    e.params.history.enabled && (() => {
                        const a = o();
                        e.params.history.replaceState || a.removeEventListener("popstate", d)
                    })()
                })), t("transitionEnd _freeModeNoMomentumRelease", (() => {
                    n && l(e.params.history.key, e.activeIndex)
                })), t("slideChange", (() => {
                    n && e.params.cssMode && l(e.params.history.key, e.activeIndex)
                }))
            }, function({
                swiper: e,
                extendParams: a,
                emit: t,
                on: n
            }) {
                let i = !1;
                const s = r(),
                    l = o();
                a({
                    hashNavigation: {
                        enabled: !1,
                        replaceState: !1,
                        watchState: !1
                    }
                });
                const u = () => {
                        t("hashChange");
                        const a = s.location.hash.replace("#", "");
                        if (a !== e.slides[e.activeIndex].getAttribute("data-hash")) {
                            const t = e.getSlideIndex(g(e.slidesEl, `.${e.params.slideClass}[data-hash="${a}"], swiper-slide[data-hash="${a}"]`)[0]);
                            if (void 0 === t) return;
                            e.slideTo(t)
                        }
                    },
                    d = () => {
                        if (i && e.params.hashNavigation.enabled)
                            if (e.params.hashNavigation.replaceState && l.history && l.history.replaceState) l.history.replaceState(null, null, `#${e.slides[e.activeIndex].getAttribute("data-hash")}` || ""), t("hashSet");
                            else {
                                const a = e.slides[e.activeIndex],
                                    n = a.getAttribute("data-hash") || a.getAttribute("data-history");
                                s.location.hash = n || "", t("hashSet")
                            }
                    };
                n("init", (() => {
                    e.params.hashNavigation.enabled && (() => {
                        if (!e.params.hashNavigation.enabled || e.params.history && e.params.history.enabled) return;
                        i = !0;
                        const a = s.location.hash.replace("#", "");
                        if (a) {
                            const t = 0;
                            for (let n = 0, i = e.slides.length; n < i; n += 1) {
                                const i = e.slides[n];
                                if ((i.getAttribute("data-hash") || i.getAttribute("data-history")) === a) {
                                    const a = e.getSlideIndex(i);
                                    e.slideTo(a, t, e.params.runCallbacksOnInit, !0)
                                }
                            }
                        }
                        e.params.hashNavigation.watchState && l.addEventListener("hashchange", u)
                    })()
                })), n("destroy", (() => {
                    e.params.hashNavigation.enabled && e.params.hashNavigation.watchState && l.removeEventListener("hashchange", u)
                })), n("transitionEnd _freeModeNoMomentumRelease", (() => {
                    i && d()
                })), n("slideChange", (() => {
                    i && e.params.cssMode && d()
                }))
            }, function({
                swiper: e,
                extendParams: a,
                on: t,
                emit: n,
                params: i
            }) {
                let s, o;
                e.autoplay = {
                    running: !1,
                    paused: !1,
                    timeLeft: 0
                }, a({
                    autoplay: {
                        enabled: !1,
                        delay: 3e3,
                        waitForTransition: !0,
                        disableOnInteraction: !0,
                        stopOnLastSlide: !1,
                        reverseDirection: !1,
                        pauseOnMouseEnter: !1
                    }
                });
                let l, u, d, c, p, h, f, m = i && i.autoplay ? i.autoplay.delay : 3e3,
                    g = i && i.autoplay ? i.autoplay.delay : 3e3,
                    v = (new Date).getTime;

                function y(a) {
                    e && !e.destroyed && e.wrapperEl && a.target === e.wrapperEl && (e.wrapperEl.removeEventListener("transitionend", y), x())
                }
                const b = () => {
                        if (e.destroyed || !e.autoplay.running) return;
                        e.autoplay.paused ? u = !0 : u && (g = l, u = !1);
                        const a = e.autoplay.paused ? l : v + g - (new Date).getTime();
                        e.autoplay.timeLeft = a, n("autoplayTimeLeft", a, a / m), o = requestAnimationFrame((() => {
                            b()
                        }))
                    },
                    S = a => {
                        if (e.destroyed || !e.autoplay.running) return;
                        cancelAnimationFrame(o), b();
                        let t = void 0 === a ? e.params.autoplay.delay : a;
                        m = e.params.autoplay.delay, g = e.params.autoplay.delay;
                        const i = (() => {
                            let a;
                            if (a = e.virtual && e.params.virtual.enabled ? e.slides.filter((e => e.classList.contains("swiper-slide-active")))[0] : e.slides[e.activeIndex], !a) return;
                            return parseInt(a.getAttribute("data-swiper-autoplay"), 10)
                        })();
                        !Number.isNaN(i) && i > 0 && void 0 === a && (t = i, m = i, g = i), l = t;
                        const r = e.params.speed,
                            u = () => {
                                e && !e.destroyed && (e.params.autoplay.reverseDirection ? !e.isBeginning || e.params.loop || e.params.rewind ? (e.slidePrev(r, !0, !0), n("autoplay")) : e.params.autoplay.stopOnLastSlide || (e.slideTo(e.slides.length - 1, r, !0, !0), n("autoplay")) : !e.isEnd || e.params.loop || e.params.rewind ? (e.slideNext(r, !0, !0), n("autoplay")) : e.params.autoplay.stopOnLastSlide || (e.slideTo(0, r, !0, !0), n("autoplay")), e.params.cssMode && (v = (new Date).getTime(), requestAnimationFrame((() => {
                                    S()
                                }))))
                            };
                        return t > 0 ? (clearTimeout(s), s = setTimeout((() => {
                            u()
                        }), t)) : requestAnimationFrame((() => {
                            u()
                        })), t
                    },
                    w = () => {
                        e.autoplay.running = !0, S(), n("autoplayStart")
                    },
                    k = () => {
                        e.autoplay.running = !1, clearTimeout(s), cancelAnimationFrame(o), n("autoplayStop")
                    },
                    T = (a, t) => {
                        if (e.destroyed || !e.autoplay.running) return;
                        clearTimeout(s), a || (f = !0);
                        const i = () => {
                            n("autoplayPause"), e.params.autoplay.waitForTransition ? e.wrapperEl.addEventListener("transitionend", y) : x()
                        };
                        if (e.autoplay.paused = !0, t) return h && (l = e.params.autoplay.delay), h = !1, void i();
                        const r = l || e.params.autoplay.delay;
                        l = r - ((new Date).getTime() - v), e.isEnd && l < 0 && !e.params.loop || (l < 0 && (l = 0), i())
                    },
                    x = () => {
                        e.isEnd && l < 0 && !e.params.loop || e.destroyed || !e.autoplay.running || (v = (new Date).getTime(), f ? (f = !1, S(l)) : S(), e.autoplay.paused = !1, n("autoplayResume"))
                    },
                    C = () => {
                        if (e.destroyed || !e.autoplay.running) return;
                        const a = r();
                        "hidden" === a.visibilityState && (f = !0, T(!0)), "visible" === a.visibilityState && x()
                    },
                    E = e => {
                        "mouse" === e.pointerType && (f = !0, T(!0))
                    },
                    M = a => {
                        "mouse" === a.pointerType && e.autoplay.paused && x()
                    };
                t("init", (() => {
                    e.params.autoplay.enabled && (e.params.autoplay.pauseOnMouseEnter && (e.el.addEventListener("pointerenter", E), e.el.addEventListener("pointerleave", M)), r().addEventListener("visibilitychange", C), v = (new Date).getTime(), w())
                })), t("destroy", (() => {
                    e.el.removeEventListener("pointerenter", E), e.el.removeEventListener("pointerleave", M), r().removeEventListener("visibilitychange", C), e.autoplay.running && k()
                })), t("beforeTransitionStart", ((a, t, n) => {
                    !e.destroyed && e.autoplay.running && (n || !e.params.autoplay.disableOnInteraction ? T(!0, !0) : k())
                })), t("sliderFirstMove", (() => {
                    !e.destroyed && e.autoplay.running && (e.params.autoplay.disableOnInteraction ? k() : (d = !0, c = !1, f = !1, p = setTimeout((() => {
                        f = !0, c = !0, T(!0)
                    }), 200)))
                })), t("touchEnd", (() => {
                    if (!e.destroyed && e.autoplay.running && d) {
                        if (clearTimeout(p), clearTimeout(s), e.params.autoplay.disableOnInteraction) return c = !1, void(d = !1);
                        c && e.params.cssMode && x(), c = !1, d = !1
                    }
                })), t("slideChange", (() => {
                    !e.destroyed && e.autoplay.running && (h = !0)
                })), Object.assign(e.autoplay, {
                    start: w,
                    stop: k,
                    pause: T,
                    resume: x
                })
            }, function({
                swiper: e,
                extendParams: a,
                on: t
            }) {
                a({
                    thumbs: {
                        swiper: null,
                        multipleActiveThumbs: !0,
                        autoScrollOffset: 0,
                        slideThumbActiveClass: "swiper-slide-thumb-active",
                        thumbsContainerClass: "swiper-thumbs"
                    }
                });
                let n = !1,
                    i = !1;

                function s() {
                    const a = e.thumbs.swiper;
                    if (!a || a.destroyed) return;
                    const t = a.clickedIndex,
                        n = a.clickedSlide;
                    if (n && n.classList.contains(e.params.thumbs.slideThumbActiveClass)) return;
                    if (null == t) return;
                    let i;
                    i = a.params.loop ? parseInt(a.clickedSlide.getAttribute("data-swiper-slide-index"), 10) : t, e.params.loop ? e.slideToLoop(i) : e.slideTo(i)
                }

                function o() {
                    const {
                        thumbs: a
                    } = e.params;
                    if (n) return !1;
                    n = !0;
                    const t = e.constructor;
                    if (a.swiper instanceof t) e.thumbs.swiper = a.swiper, Object.assign(e.thumbs.swiper.originalParams, {
                        watchSlidesProgress: !0,
                        slideToClickedSlide: !1
                    }), Object.assign(e.thumbs.swiper.params, {
                        watchSlidesProgress: !0,
                        slideToClickedSlide: !1
                    }), e.thumbs.swiper.update();
                    else if (c(a.swiper)) {
                        const n = Object.assign({}, a.swiper);
                        Object.assign(n, {
                            watchSlidesProgress: !0,
                            slideToClickedSlide: !1
                        }), e.thumbs.swiper = new t(n), i = !0
                    }
                    return e.thumbs.swiper.el.classList.add(e.params.thumbs.thumbsContainerClass), e.thumbs.swiper.on("tap", s), !0
                }

                function l(a) {
                    const t = e.thumbs.swiper;
                    if (!t || t.destroyed) return;
                    const n = "auto" === t.params.slidesPerView ? t.slidesPerViewDynamic() : t.params.slidesPerView;
                    let i = 1;
                    const r = e.params.thumbs.slideThumbActiveClass;
                    if (e.params.slidesPerView > 1 && !e.params.centeredSlides && (i = e.params.slidesPerView), e.params.thumbs.multipleActiveThumbs || (i = 1), i = Math.floor(i), t.slides.forEach((e => e.classList.remove(r))), t.params.loop || t.params.virtual && t.params.virtual.enabled)
                        for (let a = 0; a < i; a += 1) g(t.slidesEl, `[data-swiper-slide-index="${e.realIndex + a}"]`).forEach((e => {
                            e.classList.add(r)
                        }));
                    else
                        for (let a = 0; a < i; a += 1) t.slides[e.realIndex + a] && t.slides[e.realIndex + a].classList.add(r);
                    const s = e.params.thumbs.autoScrollOffset,
                        o = s && !t.params.loop;
                    if (e.realIndex !== t.realIndex || o) {
                        const i = t.activeIndex;
                        let r, l;
                        if (t.params.loop) {
                            const a = t.slides.filter((a => a.getAttribute("data-swiper-slide-index") === `${e.realIndex}`))[0];
                            r = t.slides.indexOf(a), l = e.activeIndex > e.previousIndex ? "next" : "prev"
                        } else r = e.realIndex, l = r > e.previousIndex ? "next" : "prev";
                        o && (r += "next" === l ? s : -1 * s), t.visibleSlidesIndexes && t.visibleSlidesIndexes.indexOf(r) < 0 && (t.params.centeredSlides ? r = r > i ? r - Math.floor(n / 2) + 1 : r + Math.floor(n / 2) - 1 : r > i && t.params.slidesPerGroup, t.slideTo(r, a ? 0 : void 0))
                    }
                }
                e.thumbs = {
                    swiper: null
                }, t("beforeInit", (() => {
                    const {
                        thumbs: a
                    } = e.params;
                    if (a && a.swiper)
                        if ("string" == typeof a.swiper || a.swiper instanceof HTMLElement) {
                            const t = r(),
                                n = () => {
                                    const n = "string" == typeof a.swiper ? t.querySelector(a.swiper) : a.swiper;
                                    if (n && n.swiper) a.swiper = n.swiper, o(), l(!0);
                                    else if (n) {
                                        const t = i => {
                                            a.swiper = i.detail[0], n.removeEventListener("init", t), o(), l(!0), a.swiper.update(), e.update()
                                        };
                                        n.addEventListener("init", t)
                                    }
                                    return n
                                },
                                i = () => {
                                    if (e.destroyed) return;
                                    n() || requestAnimationFrame(i)
                                };
                            requestAnimationFrame(i)
                        } else o(), l(!0)
                })), t("slideChange update resize observerUpdate", (() => {
                    l()
                })), t("setTransition", ((a, t) => {
                    const n = e.thumbs.swiper;
                    n && !n.destroyed && n.setTransition(t)
                })), t("beforeDestroy", (() => {
                    const a = e.thumbs.swiper;
                    a && !a.destroyed && i && a.destroy()
                })), Object.assign(e.thumbs, {
                    init: o,
                    update: l
                })
            }, function({
                swiper: e,
                extendParams: a,
                emit: t,
                once: n
            }) {
                a({
                    freeMode: {
                        enabled: !1,
                        momentum: !0,
                        momentumRatio: 1,
                        momentumBounce: !0,
                        momentumBounceRatio: 1,
                        momentumVelocityRatio: 1,
                        sticky: !1,
                        minimumVelocity: .02
                    }
                }), Object.assign(e, {
                    freeMode: {
                        onTouchStart: function() {
                            const a = e.getTranslate();
                            e.setTranslate(a), e.setTransition(0), e.touchEventsData.velocities.length = 0, e.freeMode.onTouchEnd({
                                currentPos: e.rtl ? e.translate : -e.translate
                            })
                        },
                        onTouchMove: function() {
                            const {
                                touchEventsData: a,
                                touches: t
                            } = e;
                            0 === a.velocities.length && a.velocities.push({
                                position: t[e.isHorizontal() ? "startX" : "startY"],
                                time: a.touchStartTime
                            }), a.velocities.push({
                                position: t[e.isHorizontal() ? "currentX" : "currentY"],
                                time: u()
                            })
                        },
                        onTouchEnd: function({
                            currentPos: a
                        }) {
                            const {
                                params: i,
                                wrapperEl: r,
                                rtlTranslate: s,
                                snapGrid: o,
                                touchEventsData: l
                            } = e, d = u() - l.touchStartTime;
                            if (a < -e.minTranslate()) e.slideTo(e.activeIndex);
                            else if (a > -e.maxTranslate()) e.slides.length < o.length ? e.slideTo(o.length - 1) : e.slideTo(e.slides.length - 1);
                            else {
                                if (i.freeMode.momentum) {
                                    if (l.velocities.length > 1) {
                                        const a = l.velocities.pop(),
                                            t = l.velocities.pop(),
                                            n = a.position - t.position,
                                            r = a.time - t.time;
                                        e.velocity = n / r, e.velocity /= 2, Math.abs(e.velocity) < i.freeMode.minimumVelocity && (e.velocity = 0), (r > 150 || u() - a.time > 300) && (e.velocity = 0)
                                    } else e.velocity = 0;
                                    e.velocity *= i.freeMode.momentumVelocityRatio, l.velocities.length = 0;
                                    let a = 1e3 * i.freeMode.momentumRatio;
                                    const d = e.velocity * a;
                                    let c = e.translate + d;
                                    s && (c = -c);
                                    let p, h = !1;
                                    const f = 20 * Math.abs(e.velocity) * i.freeMode.momentumBounceRatio;
                                    let m;
                                    if (c < e.maxTranslate()) i.freeMode.momentumBounce ? (c + e.maxTranslate() < -f && (c = e.maxTranslate() - f), p = e.maxTranslate(), h = !0, l.allowMomentumBounce = !0) : c = e.maxTranslate(), i.loop && i.centeredSlides && (m = !0);
                                    else if (c > e.minTranslate()) i.freeMode.momentumBounce ? (c - e.minTranslate() > f && (c = e.minTranslate() + f), p = e.minTranslate(), h = !0, l.allowMomentumBounce = !0) : c = e.minTranslate(), i.loop && i.centeredSlides && (m = !0);
                                    else if (i.freeMode.sticky) {
                                        let a;
                                        for (let e = 0; e < o.length; e += 1)
                                            if (o[e] > -c) {
                                                a = e;
                                                break
                                            } c = Math.abs(o[a] - c) < Math.abs(o[a - 1] - c) || "next" === e.swipeDirection ? o[a] : o[a - 1], c = -c
                                    }
                                    if (m && n("transitionEnd", (() => {
                                            e.loopFix()
                                        })), 0 !== e.velocity) {
                                        if (a = s ? Math.abs((-c - e.translate) / e.velocity) : Math.abs((c - e.translate) / e.velocity), i.freeMode.sticky) {
                                            const t = Math.abs((s ? -c : c) - e.translate),
                                                n = e.slidesSizesGrid[e.activeIndex];
                                            a = t < n ? i.speed : t < 2 * n ? 1.5 * i.speed : 2.5 * i.speed
                                        }
                                    } else if (i.freeMode.sticky) return void e.slideToClosest();
                                    i.freeMode.momentumBounce && h ? (e.updateProgress(p), e.setTransition(a), e.setTranslate(c), e.transitionStart(!0, e.swipeDirection), e.animating = !0, k(r, (() => {
                                        e && !e.destroyed && l.allowMomentumBounce && (t("momentumBounce"), e.setTransition(i.speed), setTimeout((() => {
                                            e.setTranslate(p), k(r, (() => {
                                                e && !e.destroyed && e.transitionEnd()
                                            }))
                                        }), 0))
                                    }))) : e.velocity ? (t("_freeModeNoMomentumRelease"), e.updateProgress(c), e.setTransition(a), e.setTranslate(c), e.transitionStart(!0, e.swipeDirection), e.animating || (e.animating = !0, k(r, (() => {
                                        e && !e.destroyed && e.transitionEnd()
                                    })))) : e.updateProgress(c), e.updateActiveIndex(), e.updateSlidesClasses()
                                } else {
                                    if (i.freeMode.sticky) return void e.slideToClosest();
                                    i.freeMode && t("_freeModeNoMomentumRelease")
                                }(!i.freeMode.momentum || d >= i.longSwipesMs) && (e.updateProgress(), e.updateActiveIndex(), e.updateSlidesClasses())
                            }
                        }
                    }
                })
            }, function({
                swiper: e,
                extendParams: a
            }) {
                let t, n, i;
                a({
                    grid: {
                        rows: 1,
                        fill: "column"
                    }
                }), e.grid = {
                    initSlides: a => {
                        const {
                            slidesPerView: r
                        } = e.params, {
                            rows: s,
                            fill: o
                        } = e.params.grid;
                        n = t / s, i = Math.floor(a / s), t = Math.floor(a / s) === a / s ? a : Math.ceil(a / s) * s, "auto" !== r && "row" === o && (t = Math.max(t, r * s))
                    },
                    updateSlide: (a, r, s, o) => {
                        const {
                            slidesPerGroup: l,
                            spaceBetween: u
                        } = e.params, {
                            rows: d,
                            fill: c
                        } = e.params.grid;
                        let p, h, f;
                        if ("row" === c && l > 1) {
                            const e = Math.floor(a / (l * d)),
                                n = a - d * l * e,
                                i = 0 === e ? l : Math.min(Math.ceil((s - e * d * l) / d), l);
                            f = Math.floor(n / i), h = n - f * i + e * l, p = h + f * t / d, r.style.order = p
                        } else "column" === c ? (h = Math.floor(a / d), f = a - h * d, (h > i || h === i && f === d - 1) && (f += 1, f >= d && (f = 0, h += 1))) : (f = Math.floor(a / n), h = a - f * n);
                        r.style[o("margin-top")] = 0 !== f ? u && `${u}px` : ""
                    },
                    updateWrapperSize: (a, n, i) => {
                        const {
                            spaceBetween: r,
                            centeredSlides: s,
                            roundLengths: o
                        } = e.params, {
                            rows: l
                        } = e.params.grid;
                        if (e.virtualSize = (a + r) * t, e.virtualSize = Math.ceil(e.virtualSize / l) - r, e.wrapperEl.style[i("width")] = `${e.virtualSize + r}px`, s) {
                            const a = [];
                            for (let t = 0; t < n.length; t += 1) {
                                let i = n[t];
                                o && (i = Math.floor(i)), n[t] < e.virtualSize + n[0] && a.push(i)
                            }
                            n.splice(0, n.length), n.push(...a)
                        }
                    }
                }
            }, function({
                swiper: e
            }) {
                Object.assign(e, {
                    appendSlide: ge.bind(e),
                    prependSlide: ve.bind(e),
                    addSlide: ye.bind(e),
                    removeSlide: be.bind(e),
                    removeAllSlides: Se.bind(e)
                })
            }, function({
                swiper: e,
                extendParams: a,
                on: t
            }) {
                a({
                    fadeEffect: {
                        crossFade: !1
                    }
                }), se({
                    effect: "fade",
                    swiper: e,
                    on: t,
                    setTranslate: () => {
                        const {
                            slides: a
                        } = e;
                        e.params.fadeEffect;
                        for (let t = 0; t < a.length; t += 1) {
                            const a = e.slides[t];
                            let n = -a.swiperSlideOffset;
                            e.params.virtualTranslate || (n -= e.translate);
                            let i = 0;
                            e.isHorizontal() || (i = n, n = 0);
                            const r = e.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(a.progress), 0) : 1 + Math.min(Math.max(a.progress, -1), 0),
                                s = oe(0, a);
                            s.style.opacity = r, s.style.transform = `translate3d(${n}px, ${i}px, 0px)`
                        }
                    },
                    setTransition: a => {
                        const t = e.slides.map((e => m(e)));
                        t.forEach((e => {
                            e.style.transitionDuration = `${a}ms`
                        })), le({
                            swiper: e,
                            duration: a,
                            transformElements: t,
                            allSlides: !0
                        })
                    },
                    overwriteParams: () => ({
                        slidesPerView: 1,
                        loop: true,
                        slidesPerGroup: 1,
                        watchSlidesProgress: !0,
                        spaceBetween: 0,
                        virtualTranslate: !e.params.cssMode
                    })
                })
            }, function({
                swiper: e,
                extendParams: a,
                on: t
            }) {
                a({
                    cubeEffect: {
                        slideShadows: !0,
                        shadow: !0,
                        shadowOffset: 20,
                        shadowScale: .94
                    }
                });
                const n = (e, a, t) => {
                    let n = t ? e.querySelector(".swiper-slide-shadow-left") : e.querySelector(".swiper-slide-shadow-top"),
                        i = t ? e.querySelector(".swiper-slide-shadow-right") : e.querySelector(".swiper-slide-shadow-bottom");
                    n || (n = v("div", "swiper-slide-shadow-" + (t ? "left" : "top")), e.append(n)), i || (i = v("div", "swiper-slide-shadow-" + (t ? "right" : "bottom")), e.append(i)), n && (n.style.opacity = Math.max(-a, 0)), i && (i.style.opacity = Math.max(a, 0))
                };
                se({
                    effect: "cube",
                    swiper: e,
                    on: t,
                    setTranslate: () => {
                        const {
                            el: a,
                            wrapperEl: t,
                            slides: i,
                            width: r,
                            height: s,
                            rtlTranslate: o,
                            size: l,
                            browser: u
                        } = e, d = e.params.cubeEffect, c = e.isHorizontal(), p = e.virtual && e.params.virtual.enabled;
                        let h, f = 0;
                        d.shadow && (c ? (h = e.slidesEl.querySelector(".swiper-cube-shadow"), h || (h = v("div", "swiper-cube-shadow"), e.slidesEl.append(h)), h.style.height = `${r}px`) : (h = a.querySelector(".swiper-cube-shadow"), h || (h = v("div", "swiper-cube-shadow"), a.append(h))));
                        for (let e = 0; e < i.length; e += 1) {
                            const a = i[e];
                            let t = e;
                            p && (t = parseInt(a.getAttribute("data-swiper-slide-index"), 10));
                            let r = 90 * t,
                                s = Math.floor(r / 360);
                            o && (r = -r, s = Math.floor(-r / 360));
                            const u = Math.max(Math.min(a.progress, 1), -1);
                            let h = 0,
                                m = 0,
                                g = 0;
                            t % 4 == 0 ? (h = 4 * -s * l, g = 0) : (t - 1) % 4 == 0 ? (h = 0, g = 4 * -s * l) : (t - 2) % 4 == 0 ? (h = l + 4 * s * l, g = l) : (t - 3) % 4 == 0 && (h = -l, g = 3 * l + 4 * l * s), o && (h = -h), c || (m = h, h = 0);
                            const v = `rotateX(${c ? 0 : -r}deg) rotateY(${c ? r : 0}deg) translate3d(${h}px, ${m}px, ${g}px)`;
                            u <= 1 && u > -1 && (f = 90 * t + 90 * u, o && (f = 90 * -t - 90 * u)), a.style.transform = v, d.slideShadows && n(a, u, c)
                        }
                        if (t.style.transformOrigin = `50% 50% -${l / 2}px`, t.style["-webkit-transform-origin"] = `50% 50% -${l / 2}px`, d.shadow)
                            if (c) h.style.transform = `translate3d(0px, ${r / 2 + d.shadowOffset}px, ${-r / 2}px) rotateX(90deg) rotateZ(0deg) scale(${d.shadowScale})`;
                            else {
                                const e = Math.abs(f) - 90 * Math.floor(Math.abs(f) / 90),
                                    a = 1.5 - (Math.sin(2 * e * Math.PI / 360) / 2 + Math.cos(2 * e * Math.PI / 360) / 2),
                                    t = d.shadowScale,
                                    n = d.shadowScale / a,
                                    i = d.shadowOffset;
                                h.style.transform = `scale3d(${t}, 1, ${n}) translate3d(0px, ${s / 2 + i}px, ${-s / 2 / n}px) rotateX(-90deg)`
                            } const m = (u.isSafari || u.isWebView) && u.needPerspectiveFix ? -l / 2 : 0;
                        t.style.transform = `translate3d(0px,0,${m}px) rotateX(${e.isHorizontal() ? 0 : f}deg) rotateY(${e.isHorizontal() ? -f : 0}deg)`, t.style.setProperty("--swiper-cube-translate-z", `${m}px`)
                    },
                    setTransition: a => {
                        const {
                            el: t,
                            slides: n
                        } = e;
                        if (n.forEach((e => {
                                e.style.transitionDuration = `${a}ms`, e.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((e => {
                                    e.style.transitionDuration = `${a}ms`
                                }))
                            })), e.params.cubeEffect.shadow && !e.isHorizontal()) {
                            const e = t.querySelector(".swiper-cube-shadow");
                            e && (e.style.transitionDuration = `${a}ms`)
                        }
                    },
                    recreateShadows: () => {
                        const a = e.isHorizontal();
                        e.slides.forEach((e => {
                            const t = Math.max(Math.min(e.progress, 1), -1);
                            n(e, t, a)
                        }))
                    },
                    getEffectParams: () => e.params.cubeEffect,
                    perspective: () => !0,
                    overwriteParams: () => ({
                        slidesPerView: 1,
                        loop: true,
                        slidesPerGroup: 1,
                        watchSlidesProgress: !0,
                        resistanceRatio: 0,
                        spaceBetween: 0,
                        centeredSlides: !1,
                        virtualTranslate: !0
                    })
                })
            }, function({
                swiper: e,
                extendParams: a,
                on: t
            }) {
                a({
                    flipEffect: {
                        slideShadows: !0,
                        limitRotation: !0
                    }
                });
                const n = (a, t, n) => {
                    let i = e.isHorizontal() ? a.querySelector(".swiper-slide-shadow-left") : a.querySelector(".swiper-slide-shadow-top"),
                        r = e.isHorizontal() ? a.querySelector(".swiper-slide-shadow-right") : a.querySelector(".swiper-slide-shadow-bottom");
                    i || (i = ue(0, a, e.isHorizontal() ? "left" : "top")), r || (r = ue(0, a, e.isHorizontal() ? "right" : "bottom")), i && (i.style.opacity = Math.max(-t, 0)), r && (r.style.opacity = Math.max(t, 0))
                };
                se({
                    effect: "flip",
                    swiper: e,
                    on: t,
                    setTranslate: () => {
                        const {
                            slides: a,
                            rtlTranslate: t
                        } = e, i = e.params.flipEffect;
                        for (let r = 0; r < a.length; r += 1) {
                            const s = a[r];
                            let o = s.progress;
                            e.params.flipEffect.limitRotation && (o = Math.max(Math.min(s.progress, 1), -1));
                            const l = s.swiperSlideOffset;
                            let u = -180 * o,
                                d = 0,
                                c = e.params.cssMode ? -l - e.translate : -l,
                                p = 0;
                            e.isHorizontal() ? t && (u = -u) : (p = c, c = 0, d = -u, u = 0), s.style.zIndex = -Math.abs(Math.round(o)) + a.length, i.slideShadows && n(s, o);
                            const h = `translate3d(${c}px, ${p}px, 0px) rotateX(${d}deg) rotateY(${u}deg)`;
                            oe(0, s).style.transform = h
                        }
                    },
                    setTransition: a => {
                        const t = e.slides.map((e => m(e)));
                        t.forEach((e => {
                            e.style.transitionDuration = `${a}ms`, e.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((e => {
                                e.style.transitionDuration = `${a}ms`
                            }))
                        })), le({
                            swiper: e,
                            duration: a,
                            transformElements: t
                        })
                    },
                    recreateShadows: () => {
                        e.params.flipEffect;
                        e.slides.forEach((a => {
                            let t = a.progress;
                            e.params.flipEffect.limitRotation && (t = Math.max(Math.min(a.progress, 1), -1)), n(a, t)
                        }))
                    },
                    getEffectParams: () => e.params.flipEffect,
                    perspective: () => !0,
                    overwriteParams: () => ({
                        slidesPerView: 1,
                        loop: true,
                        slidesPerGroup: 1,
                        watchSlidesProgress: !0,
                        spaceBetween: 0,
                        virtualTranslate: !e.params.cssMode
                    })
                })
            }, function({
                swiper: e,
                extendParams: a,
                on: t
            }) {
                a({
                    coverflowEffect: {
                        rotate: 50,
                        stretch: 0,
                        depth: 100,
                        scale: 1,
                        modifier: 1,
                        slideShadows: !0
                    }
                }), se({
                    effect: "coverflow",
                    swiper: e,
                    on: t,
                    setTranslate: () => {
                        const {
                            width: a,
                            height: t,
                            slides: n,
                            slidesSizesGrid: i
                        } = e, r = e.params.coverflowEffect, s = e.isHorizontal(), o = e.translate, l = s ? a / 2 - o : t / 2 - o, u = s ? r.rotate : -r.rotate, d = r.depth;
                        for (let e = 0, a = n.length; e < a; e += 1) {
                            const a = n[e],
                                t = i[e],
                                o = (l - a.swiperSlideOffset - t / 2) / t,
                                c = "function" == typeof r.modifier ? r.modifier(o) : o * r.modifier;
                            let p = s ? u * c : 0,
                                h = s ? 0 : u * c,
                                f = -d * Math.abs(c),
                                m = r.stretch;
                            "string" == typeof m && -1 !== m.indexOf("%") && (m = parseFloat(r.stretch) / 100 * t);
                            let g = s ? 0 : m * c,
                                v = s ? m * c : 0,
                                y = 1 - (1 - r.scale) * Math.abs(c);
                            Math.abs(v) < .001 && (v = 0), Math.abs(g) < .001 && (g = 0), Math.abs(f) < .001 && (f = 0), Math.abs(p) < .001 && (p = 0), Math.abs(h) < .001 && (h = 0), Math.abs(y) < .001 && (y = 0);
                            const b = `translate3d(${v}px,${g}px,${f}px)  rotateX(${h}deg) rotateY(${p}deg) scale(${y})`;
                            if (oe(0, a).style.transform = b, a.style.zIndex = 1 - Math.abs(Math.round(c)), r.slideShadows) {
                                let e = s ? a.querySelector(".swiper-slide-shadow-left") : a.querySelector(".swiper-slide-shadow-top"),
                                    t = s ? a.querySelector(".swiper-slide-shadow-right") : a.querySelector(".swiper-slide-shadow-bottom");
                                e || (e = ue(0, a, s ? "left" : "top")), t || (t = ue(0, a, s ? "right" : "bottom")), e && (e.style.opacity = c > 0 ? c : 0), t && (t.style.opacity = -c > 0 ? -c : 0)
                            }
                        }
                    },
                    setTransition: a => {
                        e.slides.map((e => m(e))).forEach((e => {
                            e.style.transitionDuration = `${a}ms`, e.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach((e => {
                                e.style.transitionDuration = `${a}ms`
                            }))
                        }))
                    },
                    perspective: () => !0,
                    overwriteParams: () => ({
                        watchSlidesProgress: !0
                    })
                })
            }, function({
                swiper: e,
                extendParams: a,
                on: t
            }) {
                a({
                    creativeEffect: {
                        limitProgress: 1,
                        shadowPerProgress: !1,
                        progressMultiplier: 1,
                        perspective: !0,
                        prev: {
                            translate: [0, 0, 0],
                            rotate: [0, 0, 0],
                            opacity: 1,
                            scale: 1
                        },
                        next: {
                            translate: [0, 0, 0],
                            rotate: [0, 0, 0],
                            opacity: 1,
                            scale: 1
                        }
                    }
                });
                const n = e => "string" == typeof e ? e : `${e}px`;
                se({
                    effect: "creative",
                    swiper: e,
                    on: t,
                    setTranslate: () => {
                        const {
                            slides: a,
                            wrapperEl: t,
                            slidesSizesGrid: i
                        } = e, r = e.params.creativeEffect, {
                            progressMultiplier: s
                        } = r, o = e.params.centeredSlides;
                        if (o) {
                            const a = i[0] / 2 - e.params.slidesOffsetBefore || 0;
                            t.style.transform = `translateX(calc(50% - ${a}px))`
                        }
                        for (let t = 0; t < a.length; t += 1) {
                            const i = a[t],
                                l = i.progress,
                                u = Math.min(Math.max(i.progress, -r.limitProgress), r.limitProgress);
                            let d = u;
                            o || (d = Math.min(Math.max(i.originalProgress, -r.limitProgress), r.limitProgress));
                            const c = i.swiperSlideOffset,
                                p = [e.params.cssMode ? -c - e.translate : -c, 0, 0],
                                h = [0, 0, 0];
                            let f = !1;
                            e.isHorizontal() || (p[1] = p[0], p[0] = 0);
                            let m = {
                                translate: [0, 0, 0],
                                rotate: [0, 0, 0],
                                scale: 1,
                                opacity: 1
                            };
                            u < 0 ? (m = r.next, f = !0) : u > 0 && (m = r.prev, f = !0), p.forEach(((e, a) => {
                                p[a] = `calc(${e}px + (${n(m.translate[a])} * ${Math.abs(u * s)}))`
                            })), h.forEach(((e, a) => {
                                h[a] = m.rotate[a] * Math.abs(u * s)
                            })), i.style.zIndex = -Math.abs(Math.round(l)) + a.length;
                            const g = p.join(", "),
                                v = `rotateX(${h[0]}deg) rotateY(${h[1]}deg) rotateZ(${h[2]}deg)`,
                                y = d < 0 ? `scale(${1 + (1 - m.scale) * d * s})` : `scale(${1 - (1 - m.scale) * d * s})`,
                                b = d < 0 ? 1 + (1 - m.opacity) * d * s : 1 - (1 - m.opacity) * d * s,
                                S = `translate3d(${g}) ${v} ${y}`;
                            if (f && m.shadow || !f) {
                                let e = i.querySelector(".swiper-slide-shadow");
                                if (!e && m.shadow && (e = ue(0, i)), e) {
                                    const a = r.shadowPerProgress ? u * (1 / r.limitProgress) : u;
                                    e.style.opacity = Math.min(Math.max(Math.abs(a), 0), 1)
                                }
                            }
                            const w = oe(0, i);
                            w.style.transform = S, w.style.opacity = b, m.origin && (w.style.transformOrigin = m.origin)
                        }
                    },
                    setTransition: a => {
                        const t = e.slides.map((e => m(e)));
                        t.forEach((e => {
                            e.style.transitionDuration = `${a}ms`, e.querySelectorAll(".swiper-slide-shadow").forEach((e => {
                                e.style.transitionDuration = `${a}ms`
                            }))
                        })), le({
                            swiper: e,
                            duration: a,
                            transformElements: t,
                            allSlides: !0
                        })
                    },
                    perspective: () => e.params.creativeEffect.perspective,
                    overwriteParams: () => ({
                        watchSlidesProgress: !0,
                        virtualTranslate: !e.params.cssMode
                    })
                })
            }, function({
                swiper: e,
                extendParams: a,
                on: t
            }) {
                a({
                    cardsEffect: {
                        slideShadows: !0,
                        rotate: !0,
                        perSlideRotate: 2,
                        perSlideOffset: 8
                    }
                }), se({
                    effect: "cards",
                    swiper: e,
                    on: t,
                    setTranslate: () => {
                        const {
                            slides: a,
                            activeIndex: t
                        } = e, n = e.params.cardsEffect, {
                            startTranslate: i,
                            isTouched: r
                        } = e.touchEventsData, s = e.translate;
                        for (let o = 0; o < a.length; o += 1) {
                            const l = a[o],
                                u = l.progress,
                                d = Math.min(Math.max(u, -4), 4);
                            let c = l.swiperSlideOffset;
                            e.params.centeredSlides && !e.params.cssMode && (e.wrapperEl.style.transform = `translateX(${e.minTranslate()}px)`), e.params.centeredSlides && e.params.cssMode && (c -= a[0].swiperSlideOffset);
                            let p = e.params.cssMode ? -c - e.translate : -c,
                                h = 0;
                            const f = -100 * Math.abs(d);
                            let m = 1,
                                g = -n.perSlideRotate * d,
                                v = n.perSlideOffset - .75 * Math.abs(d);
                            const y = e.virtual && e.params.virtual.enabled ? e.virtual.from + o : o,
                                b = (y === t || y === t - 1) && d > 0 && d < 1 && (r || e.params.cssMode) && s < i,
                                S = (y === t || y === t + 1) && d < 0 && d > -1 && (r || e.params.cssMode) && s > i;
                            if (b || S) {
                                const e = (1 - Math.abs((Math.abs(d) - .5) / .5)) ** .5;
                                g += -28 * d * e, m += -.5 * e, v += 96 * e, h = -25 * e * Math.abs(d) + "%"
                            }
                            if (p = d < 0 ? `calc(${p}px + (${v * Math.abs(d)}%))` : d > 0 ? `calc(${p}px + (-${v * Math.abs(d)}%))` : `${p}px`, !e.isHorizontal()) {
                                const e = h;
                                h = p, p = e
                            }
                            const w = d < 0 ? "" + (1 + (1 - m) * d) : "" + (1 - (1 - m) * d),
                                k = `\n        translate3d(${p}, ${h}, ${f}px)\n        rotateZ(${n.rotate ? g : 0}deg)\n        scale(${w})\n      `;
                            if (n.slideShadows) {
                                let e = l.querySelector(".swiper-slide-shadow");
                                e || (e = ue(0, l)), e && (e.style.opacity = Math.min(Math.max((Math.abs(d) - .5) / .5, 0), 1))
                            }
                            l.style.zIndex = -Math.abs(Math.round(u)) + a.length;
                            oe(0, l).style.transform = k
                        }
                    },
                    setTransition: a => {
                        const t = e.slides.map((e => m(e)));
                        t.forEach((e => {
                            e.style.transitionDuration = `${a}ms`, e.querySelectorAll(".swiper-slide-shadow").forEach((e => {
                                e.style.transitionDuration = `${a}ms`
                            }))
                        })), le({
                            swiper: e,
                            duration: a,
                            transformElements: t
                        })
                    },
                    perspective: () => !0,
                    overwriteParams: () => ({
                        watchSlidesProgress: !0,
                        virtualTranslate: !e.params.cssMode
                    })
                })
            }];
            ne.use(we);
            var ke = function() {
                console.log("reviewsSwiper=============");
                var e = document.querySelectorAll(".js-reviews-swiper");
                e.length && e.forEach((function(e, a) {
                    function t() {
                        if (window.innerWidth < 768 && e.querySelector(".swiper-button-prev")) {
                            var a = e.querySelector(".swiper-slide.swiper-slide-active"),
                                t = a.querySelector(".js-figure-main"),
                                n = (a.offsetHeight - t.offsetHeight) / 2;
                            e.querySelector(".swiper-button-prev").style.top = n + t.offsetHeight + "px", e.querySelector(".swiper-button-next").style.top = n + t.offsetHeight + "px"
                        }
                    }
                    e.classList.add("s".concat(a));
                    new ne(".js-reviews-swiper.s".concat(a), {
                        slidesPerView: 1,
                        loop: true,
                        autoHeight: !0,
                        a11y: !0,
                        spaceBetween: 0,
                        grabCursor: !0,
                        navigation: {
                            nextEl: ".js-reviews-swiper.s".concat(a, " .swiper-button-next"),
                            prevEl: ".js-reviews-swiper.s".concat(a, " .swiper-button-prev")
                        },
                        pagination: {
                            el: ".js-reviews-swiper.s".concat(a, " .swiper-pagination"),
                            clickable: !0
                        },
                        on: {
                            init: function() {
                                t()
                            },
                            slideChangeTransitionEnd: function() {
                                t()
                            },
                            resize: function() {
                                t()
                            }
                        }
                    })
                }))
            };
            var Te = function() {
                var e = document.querySelectorAll(".js-fullbleed-swiper");
                e.length && e.forEach((function(e, a) {
                    e.classList.add("s".concat(a));
                    new ne(".js-fullbleed-swiper.s".concat(a), {
                        slidesPerView: 1,
                        a11y: !0,
                        spaceBetween: 0,
                        grabCursor: !0,
                        pagination: {
                            el: ".js-fullbleed-swiper.s".concat(a, " .swiper-pagination"),
                            clickable: !0
                        }
                    })
                }));
                var a = document.querySelectorAll(".js-fullbleed-swiper-global");
                a.length && a.forEach((function(e, a) {
                    e.classList.add("s".concat(a));
                    new ne(".js-fullbleed-swiper-global.s".concat(a), {
                        slidesPerView: 1,
                        loop: true,
                        a11y: !0,
                        spaceBetween: 0,
                        grabCursor: !0,
                        navigation: {
                            nextEl: ".js-fullbleed-swiper-global.s".concat(a, " .swiper-button-next"),
                            prevEl: ".js-fullbleed-swiper-global.s".concat(a, " .swiper-button-prev")
                        },
                        pagination: {
                            el: ".js-fullbleed-swiper-global.s".concat(a, " .swiper-pagination"),
                            clickable: !0
                        }
                    })
                }))
            };
            t(360);

            function xe() {
                var e = new Array("Afghanistan", "Albania", "Algeria", "American Samoa", "Angola", "Anguilla", "Antartica", "Antigua and Barbuda", "Argentina", "Armenia", "Aruba", "Ashmore and Cartier Island", "Australia", "Austria", "Azerbaijan", "Bahamas", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia", "Bosnia and Herzegovina", "Botswana", "Brazil", "British Virgin Islands", "Brunei", "Bulgaria", "Burkina Faso", "Burma", "Burundi", "Cambodia", "Cameroon", "Canada", "Cape Verde", "Cayman Islands", "Central African Republic", "Chad", "Chile", "China", "Christmas Island", "Clipperton Island", "Cocos (Keeling) Islands", "Colombia", "Comoros", "Congo, Democratic Republic of the", "Congo, Republic of the", "Cook Islands", "Costa Rica", "Cote d'Ivoire", "Croatia", "Cuba", "Cyprus", "Czeck Republic", "Denmark", "Djibouti", "Dominica", "Dominican Republic", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Ethiopia", "Europa Island", "Falkland Islands (Islas Malvinas)", "Faroe Islands", "Fiji", "Finland", "France", "French Guiana", "French Polynesia", "French Southern and Antarctic Lands", "Gabon", "Gambia, The", "Gaza Strip", "Georgia", "Germany", "Ghana", "Gibraltar", "Glorioso Islands", "Greece", "Greenland", "Grenada", "Guadeloupe", "Guam", "Guatemala", "Guernsey", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Heard Island and McDonald Islands", "Holy See (Vatican City)", "Honduras", "Hong Kong", "Howland Island", "Hungary", "Iceland", "India", "Indonesia", "Iran", "Iraq", "Ireland", "Ireland, Northern", "Israel", "Italy", "Jamaica", "Jan Mayen", "Japan", "Jarvis Island", "Jersey", "Johnston Atoll", "Jordan", "Juan de Nova Island", "Kazakhstan", "Kenya", "Kiribati", "Korea, North", "Korea, South", "Kuwait", "Kyrgyzstan", "Laos", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Macau", "Macedonia, Former Yugoslav Republic of", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Man, Isle of", "Marshall Islands", "Martinique", "Mauritania", "Mauritius", "Mayotte", "Mexico", "Micronesia, Federated States of", "Midway Islands", "Moldova", "Monaco", "Mongolia", "Montserrat", "Morocco", "Mozambique", "Namibia", "Nauru", "Nepal", "Netherlands", "Netherlands Antilles", "New Caledonia", "New Zealand", "Nicaragua", "Niger", "Nigeria", "Niue", "Norfolk Island", "Northern Mariana Islands", "Norway", "Oman", "Pakistan", "Palau", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines", "Pitcaim Islands", "Poland", "Portugal", "Puerto Rico", "Qatar", "Reunion", "Romainia", "Russia", "Rwanda", "Saint Helena", "Saint Kitts and Nevis", "Saint Lucia", "Saint Pierre and Miquelon", "Saint Vincent and the Grenadines", "Samoa", "San Marino", "Sao Tome and Principe", "Saudi Arabia", "Scotland", "Senegal", "Seychelles", "Sierra Leone", "Singapore", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Georgia and South Sandwich Islands", "Spain", "Spratly Islands", "Sri Lanka", "Sudan", "Suriname", "Svalbard", "Swaziland", "Sweden", "Switzerland", "Syria", "Taiwan", "Tajikistan", "Tanzania", "Thailand", "Tobago", "Toga", "Tokelau", "Tonga", "Trinidad", "Tunisia", "Turkey", "Turkmenistan", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates", "United Kingdom", "Uruguay", "USA", "Uzbekistan", "Vanuatu", "Venezuela", "Vietnam", "Virgin Islands", "Wales", "Wallis and Futuna", "West Bank", "Western Sahara", "Yemen", "Yugoslavia", "Zambia", "Zimbabwe"),
                    a = new Array;
                a[0] = "", a[1] = "Badakhshan|Badghis|Baghlan|Balkh|Bamian|Farah|Faryab|Ghazni|Ghowr|Helmand|Herat|Jowzjan|Kabol|Kandahar|Kapisa|Konar|Kondoz|Laghman|Lowgar|Nangarhar|Nimruz|Oruzgan|Paktia|Paktika|Parvan|Samangan|Sar-e Pol|Takhar|Vardak|Zabol", a[2] = "Berat|Bulqize|Delvine|Devoll (Bilisht)|Diber (Peshkopi)|Durres|Elbasan|Fier|Gjirokaster|Gramsh|Has (Krume)|Kavaje|Kolonje (Erseke)|Korce|Kruje|Kucove|Kukes|Kurbin|Lezhe|Librazhd|Lushnje|Malesi e Madhe (Koplik)|Mallakaster (Ballsh)|Mat (Burrel)|Mirdite (Rreshen)|Peqin|Permet|Pogradec|Puke|Sarande|Shkoder|Skrapar (Corovode)|Tepelene|Tirane (Tirana)|Tirane (Tirana)|Tropoje (Bajram Curri)|Vlore", a[3] = "Adrar|Ain Defla|Ain Temouchent|Alger|Annaba|Batna|Bechar|Bejaia|Biskra|Blida|Bordj Bou Arreridj|Bouira|Boumerdes|Chlef|Constantine|Djelfa|El Bayadh|El Oued|El Tarf|Ghardaia|Guelma|Illizi|Jijel|Khenchela|Laghouat|M'Sila|Mascara|Medea|Mila|Mostaganem|Naama|Oran|Ouargla|Oum el Bouaghi|Relizane|Saida|Setif|Sidi Bel Abbes|Skikda|Souk Ahras|Tamanghasset|Tebessa|Tiaret|Tindouf|Tipaza|Tissemsilt|Tizi Ouzou|Tlemcen", a[4] = "Eastern|Manu'a|Rose Island|Swains Island|Western", a[5] = "Andorra la Vella|Bengo|Benguela|Bie|Cabinda|Canillo|Cuando Cubango|Cuanza Norte|Cuanza Sul|Cunene|Encamp|Escaldes-Engordany|Huambo|Huila|La Massana|Luanda|Lunda Norte|Lunda Sul|Malanje|Moxico|Namibe|Ordino|Sant Julia de Loria|Uige|Zaire", a[6] = "Anguilla", a[7] = "Antartica", a[8] = "Barbuda|Redonda|Saint George|Saint John|Saint Mary|Saint Paul|Saint Peter|Saint Philip", a[9] = "Antartica e Islas del Atlantico Sur|Buenos Aires|Buenos Aires Capital Federal|Catamarca|Chaco|Chubut|Cordoba|Corrientes|Entre Rios|Formosa|Jujuy|La Pampa|La Rioja|Mendoza|Misiones|Neuquen|Rio Negro|Salta|San Juan|San Luis|Santa Cruz|Santa Fe|Santiago del Estero|Tierra del Fuego|Tucuman", a[10] = "Aragatsotn|Ararat|Armavir|Geghark'unik'|Kotayk'|Lorri|Shirak|Syunik'|Tavush|Vayots' Dzor|Yerevan", a[11] = "Aruba", a[12] = "Ashmore and Cartier Island", a[13] = "Australian Capital Territory|New South Wales|Northern Territory|Queensland|South Australia|Tasmania|Victoria|Western Australia", a[14] = "Burgenland|Kaernten|Niederoesterreich|Oberoesterreich|Salzburg|Steiermark|Tirol|Vorarlberg|Wien", a[15] = "Abseron Rayonu|Agcabadi Rayonu|Agdam Rayonu|Agdas Rayonu|Agstafa Rayonu|Agsu Rayonu|Ali Bayramli Sahari|Astara Rayonu|Baki Sahari|Balakan Rayonu|Barda Rayonu|Beylaqan Rayonu|Bilasuvar Rayonu|Cabrayil Rayonu|Calilabad Rayonu|Daskasan Rayonu|Davaci Rayonu|Fuzuli Rayonu|Gadabay Rayonu|Ganca Sahari|Goranboy Rayonu|Goycay Rayonu|Haciqabul Rayonu|Imisli Rayonu|Ismayilli Rayonu|Kalbacar Rayonu|Kurdamir Rayonu|Lacin Rayonu|Lankaran Rayonu|Lankaran Sahari|Lerik Rayonu|Masalli Rayonu|Mingacevir Sahari|Naftalan Sahari|Naxcivan Muxtar Respublikasi|Neftcala Rayonu|Oguz Rayonu|Qabala Rayonu|Qax Rayonu|Qazax Rayonu|Qobustan Rayonu|Quba Rayonu|Qubadli Rayonu|Qusar Rayonu|Saatli Rayonu|Sabirabad Rayonu|Saki Rayonu|Saki Sahari|Salyan Rayonu|Samaxi Rayonu|Samkir Rayonu|Samux Rayonu|Siyazan Rayonu|Sumqayit Sahari|Susa Rayonu|Susa Sahari|Tartar Rayonu|Tovuz Rayonu|Ucar Rayonu|Xacmaz Rayonu|Xankandi Sahari|Xanlar Rayonu|Xizi Rayonu|Xocali Rayonu|Xocavand Rayonu|Yardimli Rayonu|Yevlax Rayonu|Yevlax Sahari|Zangilan Rayonu|Zaqatala Rayonu|Zardab Rayonu", a[16] = "Acklins and Crooked Islands|Bimini|Cat Island|Exuma|Freeport|Fresh Creek|Governor's Harbour|Green Turtle Cay|Harbour Island|High Rock|Inagua|Kemps Bay|Long Island|Marsh Harbour|Mayaguana|New Providence|Nicholls Town and Berry Islands|Ragged Island|Rock Sound|San Salvador and Rum Cay|Sandy Point", a[17] = "Al Hadd|Al Manamah|Al Mintaqah al Gharbiyah|Al Mintaqah al Wusta|Al Mintaqah ash Shamaliyah|Al Muharraq|Ar Rifa' wa al Mintaqah al Janubiyah|Jidd Hafs|Juzur Hawar|Madinat 'Isa|Madinat Hamad|Sitrah", a[18] = "Barguna|Barisal|Bhola|Jhalokati|Patuakhali|Pirojpur|Bandarban|Brahmanbaria|Chandpur|Chittagong|Comilla|Cox's Bazar|Feni|Khagrachari|Lakshmipur|Noakhali|Rangamati|Dhaka|Faridpur|Gazipur|Gopalganj|Jamalpur|Kishoreganj|Madaripur|Manikganj|Munshiganj|Mymensingh|Narayanganj|Narsingdi|Netrokona|Rajbari|Shariatpur|Sherpur|Tangail|Bagerhat|Chuadanga|Jessore|Jhenaidah|Khulna|Kushtia|Magura|Meherpur|Narail|Satkhira|Bogra|Dinajpur|Gaibandha|Jaipurhat|Kurigram|Lalmonirhat|Naogaon|Natore|Nawabganj|Nilphamari|Pabna|Panchagarh|Rajshahi|Rangpur|Sirajganj|Thakurgaon|Habiganj|Maulvi bazar|Sunamganj|Sylhet", a[19] = "Bridgetown|Christ Church|Saint Andrew|Saint George|Saint James|Saint John|Saint Joseph|Saint Lucy|Saint Michael|Saint Peter|Saint Philip|Saint Thomas", a[20] = "Brestskaya (Brest)|Homyel'skaya (Homyel')|Horad Minsk|Hrodzyenskaya (Hrodna)|Mahilyowskaya (Mahilyow)|Minskaya|Vitsyebskaya (Vitsyebsk)", a[21] = "Antwerpen|Brabant Wallon|Brussels Capitol Region|Hainaut|Liege|Limburg|Luxembourg|Namur|Oost-Vlaanderen|Vlaams Brabant|West-Vlaanderen", a[22] = "Belize|Cayo|Corozal|Orange Walk|Stann Creek|Toledo", a[23] = "Alibori|Atakora|Atlantique|Borgou|Collines|Couffo|Donga|Littoral|Mono|Oueme|Plateau|Zou", a[24] = "Devonshire|Hamilton|Hamilton|Paget|Pembroke|Saint George|Saint Georges|Sandys|Smiths|Southampton|Warwick", a[25] = "Bumthang|Chhukha|Chirang|Daga|Geylegphug|Ha|Lhuntshi|Mongar|Paro|Pemagatsel|Punakha|Samchi|Samdrup Jongkhar|Shemgang|Tashigang|Thimphu|Tongsa|Wangdi Phodrang", a[26] = "Beni|Chuquisaca|Cochabamba|La Paz|Oruro|Pando|Potosi|Santa Cruz|Tarija", a[27] = "Federation of Bosnia and Herzegovina|Republika Srpska", a[28] = "Central|Chobe|Francistown|Gaborone|Ghanzi|Kgalagadi|Kgatleng|Kweneng|Lobatse|Ngamiland|North-East|Selebi-Pikwe|South-East|Southern", a[29] = "Acre|Alagoas|Amapa|Amazonas|Bahia|Ceara|Distrito Federal|Espirito Santo|Goias|Maranhao|Mato Grosso|Mato Grosso do Sul|Minas Gerais|Para|Paraiba|Parana|Pernambuco|Piaui|Rio de Janeiro|Rio Grande do Norte|Rio Grande do Sul|Rondonia|Roraima|Santa Catarina|Sao Paulo|Sergipe|Tocantins", a[30] = "Anegada|Jost Van Dyke|Tortola|Virgin Gorda", a[31] = "Belait|Brunei and Muara|Temburong|Tutong", a[32] = "Blagoevgrad|Burgas|Dobrich|Gabrovo|Khaskovo|Kurdzhali|Kyustendil|Lovech|Montana|Pazardzhik|Pernik|Pleven|Plovdiv|Razgrad|Ruse|Shumen|Silistra|Sliven|Smolyan|Sofiya|Sofiya-Grad|Stara Zagora|Turgovishte|Varna|Veliko Turnovo|Vidin|Vratsa|Yambol", a[33] = "Bale|Bam|Banwa|Bazega|Bougouriba|Boulgou|Boulkiemde|Comoe|Ganzourgou|Gnagna|Gourma|Houet|Ioba|Kadiogo|Kenedougou|Komandjari|Kompienga|Kossi|Koupelogo|Kouritenga|Kourweogo|Leraba|Loroum|Mouhoun|Nahouri|Namentenga|Naumbiel|Nayala|Oubritenga|Oudalan|Passore|Poni|Samentenga|Sanguie|Seno|Sissili|Soum|Sourou|Tapoa|Tuy|Yagha|Yatenga|Ziro|Zondomo|Zoundweogo", a[34] = "Ayeyarwady|Bago|Chin State|Kachin State|Kayah State|Kayin State|Magway|Mandalay|Mon State|Rakhine State|Sagaing|Shan State|Tanintharyi|Yangon", a[35] = "Bubanza|Bujumbura|Bururi|Cankuzo|Cibitoke|Gitega|Karuzi|Kayanza|Kirundo|Makamba|Muramvya|Muyinga|Mwaro|Ngozi|Rutana|Ruyigi", a[36] = "Banteay Mean Cheay|Batdambang|Kampong Cham|Kampong Chhnang|Kampong Spoe|Kampong Thum|Kampot|Kandal|Kaoh Kong|Keb|Kracheh|Mondol Kiri|Otdar Mean Cheay|Pailin|Phnum Penh|Pouthisat|Preah Seihanu (Sihanoukville)|Preah Vihear|Prey Veng|Rotanah Kiri|Siem Reab|Stoeng Treng|Svay Rieng|Takev", a[37] = "Adamaoua|Centre|Est|Extreme-Nord|Littoral|Nord|Nord-Ouest|Ouest|Sud|Sud-Ouest", a[38] = "Alberta|British Columbia|Manitoba|New Brunswick|Newfoundland|Northwest Territories|Nova Scotia|Nunavut|Ontario|Prince Edward Island|Quebec|Saskatchewan|Yukon Territory", a[39] = "Boa Vista|Brava|Maio|Mosteiros|Paul|Porto Novo|Praia|Ribeira Grande|Sal|Santa Catarina|Santa Cruz|Sao Domingos|Sao Filipe|Sao Nicolau|Sao Vicente|Tarrafal", a[40] = "Creek|Eastern|Midland|South Town|Spot Bay|Stake Bay|West End|Western", a[41] = "Bamingui-Bangoran|Bangui|Basse-Kotto|Gribingui|Haut-Mbomou|Haute-Kotto|Haute-Sangha|Kemo-Gribingui|Lobaye|Mbomou|Nana-Mambere|Ombella-Mpoko|Ouaka|Ouham|Ouham-Pende|Sangha|Vakaga", a[42] = "Batha|Biltine|Borkou-Ennedi-Tibesti|Chari-Baguirmi|Guera|Kanem|Lac|Logone Occidental|Logone Oriental|Mayo-Kebbi|Moyen-Chari|Ouaddai|Salamat|Tandjile", a[43] = "Aisen del General Carlos Ibanez del Campo|Antofagasta|Araucania|Atacama|Bio-Bio|Coquimbo|Libertador General Bernardo O'Higgins|Los Lagos|Magallanes y de la Antartica Chilena|Maule|Region Metropolitana (Santiago)|Tarapaca|Valparaiso", a[44] = "Anhui|Beijing|Chongqing|Fujian|Gansu|Guangdong|Guangxi|Guizhou|Hainan|Hebei|Heilongjiang|Henan|Hubei|Hunan|Jiangsu|Jiangxi|Jilin|Liaoning|Nei Mongol|Ningxia|Qinghai|Shaanxi|Shandong|Shanghai|Shanxi|Sichuan|Tianjin|Xinjiang|Xizang (Tibet)|Yunnan|Zhejiang", a[45] = "Christmas Island", a[46] = "Clipperton Island", a[47] = "Direction Island|Home Island|Horsburgh Island|North Keeling Island|South Island|West Island", a[48] = "Amazonas|Antioquia|Arauca|Atlantico|Bolivar|Boyaca|Caldas|Caqueta|Casanare|Cauca|Cesar|Choco|Cordoba|Cundinamarca|Distrito Capital de Santa Fe de Bogota|Guainia|Guaviare|Huila|La Guajira|Magdalena|Meta|Narino|Norte de Santander|Putumayo|Quindio|Risaralda|San Andres y Providencia|Santander|Sucre|Tolima|Valle del Cauca|Vaupes|Vichada", a[49] = "Anjouan (Nzwani)|Domoni|Fomboni|Grande Comore (Njazidja)|Moheli (Mwali)|Moroni|Moutsamoudou", a[50] = "Bandundu|Bas-Congo|Equateur|Kasai-Occidental|Kasai-Oriental|Katanga|Kinshasa|Maniema|Nord-Kivu|Orientale|Sud-Kivu", a[51] = "Bouenza|Brazzaville|Cuvette|Kouilou|Lekoumou|Likouala|Niari|Plateaux|Pool|Sangha", a[52] = "Aitutaki|Atiu|Avarua|Mangaia|Manihiki|Manuae|Mauke|Mitiaro|Nassau Island|Palmerston|Penrhyn|Pukapuka|Rakahanga|Rarotonga|Suwarrow|Takutea", a[53] = "Alajuela|Cartago|Guanacaste|Heredia|Limon|Puntarenas|San Jose", a[54] = "Abengourou|Abidjan|Aboisso|Adiake'|Adzope|Agboville|Agnibilekrou|Ale'pe'|Bangolo|Beoumi|Biankouma|Bocanda|Bondoukou|Bongouanou|Bouafle|Bouake|Bouna|Boundiali|Dabakala|Dabon|Daloa|Danane|Daoukro|Dimbokro|Divo|Duekoue|Ferkessedougou|Gagnoa|Grand Bassam|Grand-Lahou|Guiglo|Issia|Jacqueville|Katiola|Korhogo|Lakota|Man|Mankono|Mbahiakro|Odienne|Oume|Sakassou|San-Pedro|Sassandra|Seguela|Sinfra|Soubre|Tabou|Tanda|Tiassale|Tiebissou|Tingrela|Touba|Toulepleu|Toumodi|Vavoua|Yamoussoukro|Zuenoula", a[55] = "Bjelovarsko-Bilogorska Zupanija|Brodsko-Posavska Zupanija|Dubrovacko-Neretvanska Zupanija|Istarska Zupanija|Karlovacka Zupanija|Koprivnicko-Krizevacka Zupanija|Krapinsko-Zagorska Zupanija|Licko-Senjska Zupanija|Medimurska Zupanija|Osjecko-Baranjska Zupanija|Pozesko-Slavonska Zupanija|Primorsko-Goranska Zupanija|Sibensko-Kninska Zupanija|Sisacko-Moslavacka Zupanija|Splitsko-Dalmatinska Zupanija|Varazdinska Zupanija|Viroviticko-Podravska Zupanija|Vukovarsko-Srijemska Zupanija|Zadarska Zupanija|Zagreb|Zagrebacka Zupanija", a[56] = "Camaguey|Ciego de Avila|Cienfuegos|Ciudad de La Habana|Granma|Guantanamo|Holguin|Isla de la Juventud|La Habana|Las Tunas|Matanzas|Pinar del Rio|Sancti Spiritus|Santiago de Cuba|Villa Clara", a[57] = "Famagusta|Kyrenia|Larnaca|Limassol|Nicosia|Paphos", a[58] = "Brnensky|Budejovicky|Jihlavsky|Karlovarsky|Kralovehradecky|Liberecky|Olomoucky|Ostravsky|Pardubicky|Plzensky|Praha|Stredocesky|Ustecky|Zlinsky", a[59] = "Arhus|Bornholm|Fredericksberg|Frederiksborg|Fyn|Kobenhavn|Kobenhavns|Nordjylland|Ribe|Ringkobing|Roskilde|Sonderjylland|Storstrom|Vejle|Vestsjalland|Viborg", a[60] = "'Ali Sabih|Dikhil|Djibouti|Obock|Tadjoura", a[61] = "Saint Andrew|Saint David|Saint George|Saint John|Saint Joseph|Saint Luke|Saint Mark|Saint Patrick|Saint Paul|Saint Peter", a[62] = "Azua|Baoruco|Barahona|Dajabon|Distrito Nacional|Duarte|El Seibo|Elias Pina|Espaillat|Hato Mayor|Independencia|La Altagracia|La Romana|La Vega|Maria Trinidad Sanchez|Monsenor Nouel|Monte Cristi|Monte Plata|Pedernales|Peravia|Puerto Plata|Salcedo|Samana|San Cristobal|San Juan|San Pedro de Macoris|Sanchez Ramirez|Santiago|Santiago Rodriguez|Valverde", a[63] = "Azuay|Bolivar|Canar|Carchi|Chimborazo|Cotopaxi|El Oro|Esmeraldas|Galapagos|Guayas|Imbabura|Loja|Los Rios|Manabi|Morona-Santiago|Napo|Orellana|Pastaza|Pichincha|Sucumbios|Tungurahua|Zamora-Chinchipe", a[64] = "Ad Daqahliyah|Al Bahr al Ahmar|Al Buhayrah|Al Fayyum|Al Gharbiyah|Al Iskandariyah|Al Isma'iliyah|Al Jizah|Al Minufiyah|Al Minya|Al Qahirah|Al Qalyubiyah|Al Wadi al Jadid|As Suways|Ash Sharqiyah|Aswan|Asyut|Bani Suwayf|Bur Sa'id|Dumyat|Janub Sina'|Kafr ash Shaykh|Matruh|Qina|Shamal Sina'|Suhaj", a[65] = "Ahuachapan|Cabanas|Chalatenango|Cuscatlan|La Libertad|La Paz|La Union|Morazan|San Miguel|San Salvador|San Vicente|Santa Ana|Sonsonate|Usulutan", a[66] = "Annobon|Bioko Norte|Bioko Sur|Centro Sur|Kie-Ntem|Litoral|Wele-Nzas", a[67] = "Akale Guzay|Barka|Denkel|Hamasen|Sahil|Semhar|Senhit|Seraye", a[68] = "Harjumaa (Tallinn)|Hiiumaa (Kardla)|Ida-Virumaa (Johvi)|Jarvamaa (Paide)|Jogevamaa (Jogeva)|Laane-Virumaa (Rakvere)|Laanemaa (Haapsalu)|Parnumaa (Parnu)|Polvamaa (Polva)|Raplamaa (Rapla)|Saaremaa (Kuessaare)|Tartumaa (Tartu)|Valgamaa (Valga)|Viljandimaa (Viljandi)|Vorumaa (Voru)", a[69] = "Adis Abeba (Addis Ababa)|Afar|Amara|Dire Dawa|Gambela Hizboch|Hareri Hizb|Oromiya|Sumale|Tigray|YeDebub Biheroch Bihereseboch na Hizboch", a[70] = "Europa Island", a[71] = "Falkland Islands (Islas Malvinas)", a[72] = "Bordoy|Eysturoy|Mykines|Sandoy|Skuvoy|Streymoy|Suduroy|Tvoroyri|Vagar", a[73] = "Central|Eastern|Northern|Rotuma|Western", a[74] = "Aland|Etela-Suomen Laani|Ita-Suomen Laani|Lansi-Suomen Laani|Lappi|Oulun Laani", a[75] = "Alsace|Aquitaine|Auvergne|Basse-Normandie|Bourgogne|Bretagne|Centre|Champagne-Ardenne|Corse|Franche-Comte|Haute-Normandie|Ile-de-France|Languedoc-Roussillon|Limousin|Lorraine|Midi-Pyrenees|Nord-Pas-de-Calais|Pays de la Loire|Picardie|Poitou-Charentes|Provence-Alpes-Cote d'Azur|Rhone-Alpes", a[76] = "French Guiana", a[77] = "Archipel des Marquises|Archipel des Tuamotu|Archipel des Tubuai|Iles du Vent|Iles Sous-le-Vent", a[78] = "Adelie Land|Ile Crozet|Iles Kerguelen|Iles Saint-Paul et Amsterdam", a[79] = "Estuaire|Haut-Ogooue|Moyen-Ogooue|Ngounie|Nyanga|Ogooue-Ivindo|Ogooue-Lolo|Ogooue-Maritime|Woleu-Ntem", a[80] = "Banjul|Central River|Lower River|North Bank|Upper River|Western", a[81] = "Gaza Strip", a[82] = "Abashis|Abkhazia or Ap'khazet'is Avtonomiuri Respublika (Sokhumi)|Adigenis|Ajaria or Acharis Avtonomiuri Respublika (Bat'umi)|Akhalgoris|Akhalk'alak'is|Akhalts'ikhis|Akhmetis|Ambrolauris|Aspindzis|Baghdat'is|Bolnisis|Borjomis|Ch'khorotsqus|Ch'okhatauris|Chiat'ura|Dedop'listsqaros|Dmanisis|Dushet'is|Gardabanis|Gori|Goris|Gurjaanis|Javis|K'arelis|K'ut'aisi|Kaspis|Kharagaulis|Khashuris|Khobis|Khonis|Lagodekhis|Lanch'khut'is|Lentekhis|Marneulis|Martvilis|Mestiis|Mts'khet'is|Ninotsmindis|Onis|Ozurget'is|P'ot'i|Qazbegis|Qvarlis|Rust'avi|Sach'kheris|Sagarejos|Samtrediis|Senakis|Sighnaghis|T'bilisi|T'elavis|T'erjolis|T'et'ritsqaros|T'ianet'is|Tqibuli|Ts'ageris|Tsalenjikhis|Tsalkis|Tsqaltubo|Vanis|Zestap'onis|Zugdidi|Zugdidis", a[83] = "Baden-Wuerttemberg|Bayern|Berlin|Brandenburg|Bremen|Hamburg|Hessen|Mecklenburg-Vorpommern|Niedersachsen|Nordrhein-Westfalen|Rheinland-Pfalz|Saarland|Sachsen|Sachsen-Anhalt|Schleswig-Holstein|Thueringen", a[84] = "Ashanti|Brong-Ahafo|Central|Eastern|Greater Accra|Northern|Upper East|Upper West|Volta|Western", a[85] = "Gibraltar", a[86] = "Ile du Lys|Ile Glorieuse", a[87] = "Aitolia kai Akarnania|Akhaia|Argolis|Arkadhia|Arta|Attiki|Ayion Oros (Mt. Athos)|Dhodhekanisos|Drama|Evritania|Evros|Evvoia|Florina|Fokis|Fthiotis|Grevena|Ilia|Imathia|Ioannina|Irakleion|Kardhitsa|Kastoria|Kavala|Kefallinia|Kerkyra|Khalkidhiki|Khania|Khios|Kikladhes|Kilkis|Korinthia|Kozani|Lakonia|Larisa|Lasithi|Lesvos|Levkas|Magnisia|Messinia|Pella|Pieria|Preveza|Rethimni|Rodhopi|Samos|Serrai|Thesprotia|Thessaloniki|Trikala|Voiotia|Xanthi|Zakinthos", a[88] = "Avannaa (Nordgronland)|Kitaa (Vestgronland)|Tunu (Ostgronland)", a[89] = "Carriacou and Petit Martinique|Saint Andrew|Saint David|Saint George|Saint John|Saint Mark|Saint Patrick", a[90] = "Basse-Terre|Grande-Terre|Iles de la Petite Terre|Iles des Saintes|Marie-Galante", a[91] = "Guam", a[92] = "Alta Verapaz|Baja Verapaz|Chimaltenango|Chiquimula|El Progreso|Escuintla|Guatemala|Huehuetenango|Izabal|Jalapa|Jutiapa|Peten|Quetzaltenango|Quiche|Retalhuleu|Sacatepequez|San Marcos|Santa Rosa|Solola|Suchitepequez|Totonicapan|Zacapa", a[93] = "Castel|Forest|St. Andrew|St. Martin|St. Peter Port|St. Pierre du Bois|St. Sampson|St. Saviour|Torteval|Vale", a[94] = "Beyla|Boffa|Boke|Conakry|Coyah|Dabola|Dalaba|Dinguiraye|Dubreka|Faranah|Forecariah|Fria|Gaoual|Gueckedou|Kankan|Kerouane|Kindia|Kissidougou|Koubia|Koundara|Kouroussa|Labe|Lelouma|Lola|Macenta|Mali|Mamou|Mandiana|Nzerekore|Pita|Siguiri|Telimele|Tougue|Yomou", a[95] = "Bafata|Biombo|Bissau|Bolama-Bijagos|Cacheu|Gabu|Oio|Quinara|Tombali", a[96] = "Barima-Waini|Cuyuni-Mazaruni|Demerara-Mahaica|East Berbice-Corentyne|Essequibo Islands-West Demerara|Mahaica-Berbice|Pomeroon-Supenaam|Potaro-Siparuni|Upper Demerara-Berbice|Upper Takutu-Upper Essequibo", a[97] = "Artibonite|Centre|Grand'Anse|Nord|Nord-Est|Nord-Ouest|Ouest|Sud|Sud-Est", a[98] = "Heard Island and McDonald Islands", a[99] = "Holy See (Vatican City)", a[100] = "Atlantida|Choluteca|Colon|Comayagua|Copan|Cortes|El Paraiso|Francisco Morazan|Gracias a Dios|Intibuca|Islas de la Bahia|La Paz|Lempira|Ocotepeque|Olancho|Santa Barbara|Valle|Yoro", a[101] = "Hong Kong", a[102] = "Howland Island", a[103] = "Bacs-Kiskun|Baranya|Bekes|Bekescsaba|Borsod-Abauj-Zemplen|Budapest|Csongrad|Debrecen|Dunaujvaros|Eger|Fejer|Gyor|Gyor-Moson-Sopron|Hajdu-Bihar|Heves|Hodmezovasarhely|Jasz-Nagykun-Szolnok|Kaposvar|Kecskemet|Komarom-Esztergom|Miskolc|Nagykanizsa|Nograd|Nyiregyhaza|Pecs|Pest|Somogy|Sopron|Szabolcs-Szatmar-Bereg|Szeged|Szekesfehervar|Szolnok|Szombathely|Tatabanya|Tolna|Vas|Veszprem|Veszprem|Zala|Zalaegerszeg", a[104] = "Akranes|Akureyri|Arnessysla|Austur-Bardhastrandarsysla|Austur-Hunavatnssysla|Austur-Skaftafellssysla|Borgarfjardharsysla|Dalasysla|Eyjafjardharsysla|Gullbringusysla|Hafnarfjordhur|Husavik|Isafjordhur|Keflavik|Kjosarsysla|Kopavogur|Myrasysla|Neskaupstadhur|Nordhur-Isafjardharsysla|Nordhur-Mulasys-la|Nordhur-Thingeyjarsysla|Olafsfjordhur|Rangarvallasysla|Reykjavik|Saudharkrokur|Seydhisfjordhur|Siglufjordhur|Skagafjardharsysla|Snaefellsnes-og Hnappadalssysla|Strandasysla|Sudhur-Mulasysla|Sudhur-Thingeyjarsysla|Vesttmannaeyjar|Vestur-Bardhastrandarsysla|Vestur-Hunavatnssysla|Vestur-Isafjardharsysla|Vestur-Skaftafellssysla", a[105] = "Andaman and Nicobar Islands|Andhra Pradesh|Arunachal Pradesh|Assam|Bihar|Chandigarh|Chhattisgarh|Dadra and Nagar Haveli|Daman and Diu|Delhi|Goa|Gujarat|Haryana|Himachal Pradesh|Jammu and Kashmir|Jharkhand|Karnataka|Kerala|Lakshadweep|Madhya Pradesh|Maharashtra|Manipur|Meghalaya|Mizoram|Nagaland|Orissa|Pondicherry|Punjab|Rajasthan|Sikkim|Tamil Nadu|Tripura|Uttar Pradesh|Uttaranchal|West Bengal", a[106] = "Aceh|Bali|Banten|Bengkulu|East Timor|Gorontalo|Irian Jaya|Jakarta Raya|Jambi|Jawa Barat|Jawa Tengah|Jawa Timur|Kalimantan Barat|Kalimantan Selatan|Kalimantan Tengah|Kalimantan Timur|Kepulauan Bangka Belitung|Lampung|Maluku|Maluku Utara|Nusa Tenggara Barat|Nusa Tenggara Timur|Riau|Sulawesi Selatan|Sulawesi Tengah|Sulawesi Tenggara|Sulawesi Utara|Sumatera Barat|Sumatera Selatan|Sumatera Utara|Yogyakarta", a[107] = "Ardabil|Azarbayjan-e Gharbi|Azarbayjan-e Sharqi|Bushehr|Chahar Mahall va Bakhtiari|Esfahan|Fars|Gilan|Golestan|Hamadan|Hormozgan|Ilam|Kerman|Kermanshah|Khorasan|Khuzestan|Kohgiluyeh va Buyer Ahmad|Kordestan|Lorestan|Markazi|Mazandaran|Qazvin|Qom|Semnan|Sistan va Baluchestan|Tehran|Yazd|Zanjan", a[108] = "Al Anbar|Al Basrah|Al Muthanna|Al Qadisiyah|An Najaf|Arbil|As Sulaymaniyah|At Ta'mim|Babil|Baghdad|Dahuk|Dhi Qar|Diyala|Karbala'|Maysan|Ninawa|Salah ad Din|Wasit", a[109] = "Carlow|Cavan|Clare|Cork|Donegal|Dublin|Galway|Kerry|Kildare|Kilkenny|Laois|Leitrim|Limerick|Longford|Louth|Mayo|Meath|Monaghan|Offaly|Roscommon|Sligo|Tipperary|Waterford|Westmeath|Wexford|Wicklow", a[110] = "Antrim|Ards|Armagh|Ballymena|Ballymoney|Banbridge|Belfast|Carrickfergus|Castlereagh|Coleraine|Cookstown|Craigavon|Derry|Down|Dungannon|Fermanagh|Larne|Limavady|Lisburn|Magherafelt|Moyle|Newry and Mourne|Newtownabbey|North Down|Omagh|Strabane", a[111] = "Central|Haifa|Jerusalem|Northern|Southern|Tel Aviv", a[112] = "Abruzzi|Basilicata|Calabria|Campania|Emilia-Romagna|Friuli-Venezia Giulia|Lazio|Liguria|Lombardia|Marche|Molise|Piemonte|Puglia|Sardegna|Sicilia|Toscana|Trentino-Alto Adige|Umbria|Valle d'Aosta|Veneto", a[113] = "Clarendon|Hanover|Kingston|Manchester|Portland|Saint Andrew|Saint Ann|Saint Catherine|Saint Elizabeth|Saint James|Saint Mary|Saint Thomas|Trelawny|Westmoreland", a[114] = "Jan Mayen", a[115] = "Aichi|Akita|Aomori|Chiba|Ehime|Fukui|Fukuoka|Fukushima|Gifu|Gumma|Hiroshima|Hokkaido|Hyogo|Ibaraki|Ishikawa|Iwate|Kagawa|Kagoshima|Kanagawa|Kochi|Kumamoto|Kyoto|Mie|Miyagi|Miyazaki|Nagano|Nagasaki|Nara|Niigata|Oita|Okayama|Okinawa|Osaka|Saga|Saitama|Shiga|Shimane|Shizuoka|Tochigi|Tokushima|Tokyo|Tottori|Toyama|Wakayama|Yamagata|Yamaguchi|Yamanashi", a[116] = "Jarvis Island", a[117] = "Jersey", a[118] = "Johnston Atoll", a[119] = "'Amman|Ajlun|Al 'Aqabah|Al Balqa'|Al Karak|Al Mafraq|At Tafilah|Az Zarqa'|Irbid|Jarash|Ma'an|Madaba", a[120] = "Juan de Nova Island", a[121] = "Almaty|Aqmola|Aqtobe|Astana|Atyrau|Batys Qazaqstan|Bayqongyr|Mangghystau|Ongtustik Qazaqstan|Pavlodar|Qaraghandy|Qostanay|Qyzylorda|Shyghys Qazaqstan|Soltustik Qazaqstan|Zhambyl", a[122] = "Central|Coast|Eastern|Nairobi Area|North Eastern|Nyanza|Rift Valley|Western", a[123] = "Abaiang|Abemama|Aranuka|Arorae|Banaba|Banaba|Beru|Butaritari|Central Gilberts|Gilbert Islands|Kanton|Kiritimati|Kuria|Line Islands|Line Islands|Maiana|Makin|Marakei|Nikunau|Nonouti|Northern Gilberts|Onotoa|Phoenix Islands|Southern Gilberts|Tabiteuea|Tabuaeran|Tamana|Tarawa|Tarawa|Teraina", a[124] = "Chagang-do (Chagang Province)|Hamgyong-bukto (North Hamgyong Province)|Hamgyong-namdo (South Hamgyong Province)|Hwanghae-bukto (North Hwanghae Province)|Hwanghae-namdo (South Hwanghae Province)|Kaesong-si (Kaesong City)|Kangwon-do (Kangwon Province)|Namp'o-si (Namp'o City)|P'yongan-bukto (North P'yongan Province)|P'yongan-namdo (South P'yongan Province)|P'yongyang-si (P'yongyang City)|Yanggang-do (Yanggang Province)", a[125] = "Ch'ungch'ong-bukto|Ch'ungch'ong-namdo|Cheju-do|Cholla-bukto|Cholla-namdo|Inch'on-gwangyoksi|Kangwon-do|Kwangju-gwangyoksi|Kyonggi-do|Kyongsang-bukto|Kyongsang-namdo|Pusan-gwangyoksi|Soul-t'ukpyolsi|Taegu-gwangyoksi|Taejon-gwangyoksi|Ulsan-gwangyoksi", a[126] = "Al 'Asimah|Al Ahmadi|Al Farwaniyah|Al Jahra'|Hawalli", a[127] = "Batken Oblasty|Bishkek Shaary|Chuy Oblasty (Bishkek)|Jalal-Abad Oblasty|Naryn Oblasty|Osh Oblasty|Talas Oblasty|Ysyk-Kol Oblasty (Karakol)", a[128] = "Attapu|Bokeo|Bolikhamxai|Champasak|Houaphan|Khammouan|Louangnamtha|Louangphabang|Oudomxai|Phongsali|Salavan|Savannakhet|Viangchan|Viangchan|Xaignabouli|Xaisomboun|Xekong|Xiangkhoang", a[129] = "Aizkraukles Rajons|Aluksnes Rajons|Balvu Rajons|Bauskas Rajons|Cesu Rajons|Daugavpils|Daugavpils Rajons|Dobeles Rajons|Gulbenes Rajons|Jekabpils Rajons|Jelgava|Jelgavas Rajons|Jurmala|Kraslavas Rajons|Kuldigas Rajons|Leipaja|Liepajas Rajons|Limbazu Rajons|Ludzas Rajons|Madonas Rajons|Ogres Rajons|Preilu Rajons|Rezekne|Rezeknes Rajons|Riga|Rigas Rajons|Saldus Rajons|Talsu Rajons|Tukuma Rajons|Valkas Rajons|Valmieras Rajons|Ventspils|Ventspils Rajons", a[130] = "Beyrouth|Ech Chimal|Ej Jnoub|El Bekaa|Jabal Loubnane", a[131] = "Berea|Butha-Buthe|Leribe|Mafeteng|Maseru|Mohales Hoek|Mokhotlong|Qacha's Nek|Quthing|Thaba-Tseka", a[132] = "Bomi|Bong|Grand Bassa|Grand Cape Mount|Grand Gedeh|Grand Kru|Lofa|Margibi|Maryland|Montserrado|Nimba|River Cess|Sinoe", a[133] = "Ajdabiya|Al 'Aziziyah|Al Fatih|Al Jabal al Akhdar|Al Jufrah|Al Khums|Al Kufrah|An Nuqat al Khams|Ash Shati'|Awbari|Az Zawiyah|Banghazi|Darnah|Ghadamis|Gharyan|Misratah|Murzuq|Sabha|Sawfajjin|Surt|Tarabulus|Tarhunah|Tubruq|Yafran|Zlitan", a[134] = "Balzers|Eschen|Gamprin|Mauren|Planken|Ruggell|Schaan|Schellenberg|Triesen|Triesenberg|Vaduz", a[135] = "Akmenes Rajonas|Alytaus Rajonas|Alytus|Anyksciu Rajonas|Birstonas|Birzu Rajonas|Druskininkai|Ignalinos Rajonas|Jonavos Rajonas|Joniskio Rajonas|Jurbarko Rajonas|Kaisiadoriu Rajonas|Kaunas|Kauno Rajonas|Kedainiu Rajonas|Kelmes Rajonas|Klaipeda|Klaipedos Rajonas|Kretingos Rajonas|Kupiskio Rajonas|Lazdiju Rajonas|Marijampole|Marijampoles Rajonas|Mazeikiu Rajonas|Moletu Rajonas|Neringa Pakruojo Rajonas|Palanga|Panevezio Rajonas|Panevezys|Pasvalio Rajonas|Plunges Rajonas|Prienu Rajonas|Radviliskio Rajonas|Raseiniu Rajonas|Rokiskio Rajonas|Sakiu Rajonas|Salcininku Rajonas|Siauliai|Siauliu Rajonas|Silales Rajonas|Silutes Rajonas|Sirvintu Rajonas|Skuodo Rajonas|Svencioniu Rajonas|Taurages Rajonas|Telsiu Rajonas|Traku Rajonas|Ukmerges Rajonas|Utenos Rajonas|Varenos Rajonas|Vilkaviskio Rajonas|Vilniaus Rajonas|Vilnius|Zarasu Rajonas", a[136] = "Diekirch|Grevenmacher|Luxembourg", a[137] = "Macau", a[138] = "Aracinovo|Bac|Belcista|Berovo|Bistrica|Bitola|Blatec|Bogdanci|Bogomila|Bogovinje|Bosilovo|Brvenica|Cair (Skopje)|Capari|Caska|Cegrane|Centar (Skopje)|Centar Zupa|Cesinovo|Cucer-Sandevo|Debar|Delcevo|Delogozdi|Demir Hisar|Demir Kapija|Dobrusevo|Dolna Banjica|Dolneni|Dorce Petrov (Skopje)|Drugovo|Dzepciste|Gazi Baba (Skopje)|Gevgelija|Gostivar|Gradsko|Ilinden|Izvor|Jegunovce|Kamenjane|Karbinci|Karpos (Skopje)|Kavadarci|Kicevo|Kisela Voda (Skopje)|Klecevce|Kocani|Konce|Kondovo|Konopiste|Kosel|Kratovo|Kriva Palanka|Krivogastani|Krusevo|Kuklis|Kukurecani|Kumanovo|Labunista|Lipkovo|Lozovo|Lukovo|Makedonska Kamenica|Makedonski Brod|Mavrovi Anovi|Meseista|Miravci|Mogila|Murtino|Negotino|Negotino-Poloska|Novaci|Novo Selo|Oblesevo|Ohrid|Orasac|Orizari|Oslomej|Pehcevo|Petrovec|Plasnia|Podares|Prilep|Probistip|Radovis|Rankovce|Resen|Rosoman|Rostusa|Samokov|Saraj|Sipkovica|Sopiste|Sopotnika|Srbinovo|Star Dojran|Staravina|Staro Nagoricane|Stip|Struga|Strumica|Studenicani|Suto Orizari (Skopje)|Sveti Nikole|Tearce|Tetovo|Topolcani|Valandovo|Vasilevo|Veles|Velesta|Vevcani|Vinica|Vitoliste|Vranestica|Vrapciste|Vratnica|Vrutok|Zajas|Zelenikovo|Zileno|Zitose|Zletovo|Zrnovci", a[139] = "Antananarivo|Antsiranana|Fianarantsoa|Mahajanga|Toamasina|Toliara", a[140] = "Balaka|Blantyre|Chikwawa|Chiradzulu|Chitipa|Dedza|Dowa|Karonga|Kasungu|Likoma|Lilongwe|Machinga (Kasupe)|Mangochi|Mchinji|Mulanje|Mwanza|Mzimba|Nkhata Bay|Nkhotakota|Nsanje|Ntcheu|Ntchisi|Phalombe|Rumphi|Salima|Thyolo|Zomba", a[141] = "Johor|Kedah|Kelantan|Labuan|Melaka|Negeri Sembilan|Pahang|Perak|Perlis|Pulau Pinang|Sabah|Sarawak|Selangor|Terengganu|Wilayah Persekutuan", a[142] = "Alifu|Baa|Dhaalu|Faafu|Gaafu Alifu|Gaafu Dhaalu|Gnaviyani|Haa Alifu|Haa Dhaalu|Kaafu|Laamu|Lhaviyani|Maale|Meemu|Noonu|Raa|Seenu|Shaviyani|Thaa|Vaavu", a[143] = "Gao|Kayes|Kidal|Koulikoro|Mopti|Segou|Sikasso|Tombouctou", a[144] = "Valletta", a[145] = "Man, Isle of", a[146] = "Ailinginae|Ailinglaplap|Ailuk|Arno|Aur|Bikar|Bikini|Bokak|Ebon|Enewetak|Erikub|Jabat|Jaluit|Jemo|Kili|Kwajalein|Lae|Lib|Likiep|Majuro|Maloelap|Mejit|Mili|Namorik|Namu|Rongelap|Rongrik|Toke|Ujae|Ujelang|Utirik|Wotho|Wotje", a[147] = "Martinique", a[148] = "Adrar|Assaba|Brakna|Dakhlet Nouadhibou|Gorgol|Guidimaka|Hodh Ech Chargui|Hodh El Gharbi|Inchiri|Nouakchott|Tagant|Tiris Zemmour|Trarza", a[149] = "Agalega Islands|Black River|Cargados Carajos Shoals|Flacq|Grand Port|Moka|Pamplemousses|Plaines Wilhems|Port Louis|Riviere du Rempart|Rodrigues|Savanne", a[150] = "Mayotte", a[151] = "Aguascalientes|Baja California|Baja California Sur|Campeche|Chiapas|Chihuahua|Coahuila de Zaragoza|Colima|Distrito Federal|Durango|Guanajuato|Guerrero|Hidalgo|Jalisco|Mexico|Michoacan de Ocampo|Morelos|Nayarit|Nuevo Leon|Oaxaca|Puebla|Queretaro de Arteaga|Quintana Roo|San Luis Potosi|Sinaloa|Sonora|Tabasco|Tamaulipas|Tlaxcala|Veracruz-Llave|Yucatan|Zacatecas", a[152] = "Chuuk (Truk)|Kosrae|Pohnpei|Yap", a[153] = "Midway Islands", a[154] = "Balti|Cahul|Chisinau|Chisinau|Dubasari|Edinet|Gagauzia|Lapusna|Orhei|Soroca|Tighina|Ungheni", a[155] = "Fontvieille|La Condamine|Monaco-Ville|Monte-Carlo", a[156] = "Arhangay|Bayan-Olgiy|Bayanhongor|Bulgan|Darhan|Dornod|Dornogovi|Dundgovi|Dzavhan|Erdenet|Govi-Altay|Hentiy|Hovd|Hovsgol|Omnogovi|Ovorhangay|Selenge|Suhbaatar|Tov|Ulaanbaatar|Uvs", a[157] = "Saint Anthony|Saint Georges|Saint Peter's", a[158] = "Agadir|Al Hoceima|Azilal|Ben Slimane|Beni Mellal|Boulemane|Casablanca|Chaouen|El Jadida|El Kelaa des Srarhna|Er Rachidia|Essaouira|Fes|Figuig|Guelmim|Ifrane|Kenitra|Khemisset|Khenifra|Khouribga|Laayoune|Larache|Marrakech|Meknes|Nador|Ouarzazate|Oujda|Rabat-Sale|Safi|Settat|Sidi Kacem|Tan-Tan|Tanger|Taounate|Taroudannt|Tata|Taza|Tetouan|Tiznit", a[159] = "Cabo Delgado|Gaza|Inhambane|Manica|Maputo|Nampula|Niassa|Sofala|Tete|Zambezia", a[160] = "Caprivi|Erongo|Hardap|Karas|Khomas|Kunene|Ohangwena|Okavango|Omaheke|Omusati|Oshana|Oshikoto|Otjozondjupa", a[161] = "Aiwo|Anabar|Anetan|Anibare|Baiti|Boe|Buada|Denigomodu|Ewa|Ijuw|Meneng|Nibok|Uaboe|Yaren", a[162] = "Bagmati|Bheri|Dhawalagiri|Gandaki|Janakpur|Karnali|Kosi|Lumbini|Mahakali|Mechi|Narayani|Rapti|Sagarmatha|Seti", a[163] = "Drenthe|Flevoland|Friesland|Gelderland|Groningen|Limburg|Noord-Brabant|Noord-Holland|Overijssel|Utrecht|Zeeland|Zuid-Holland", a[164] = "Netherlands Antilles", a[165] = "Iles Loyaute|Nord|Sud", a[166] = "Akaroa|Amuri|Ashburton|Bay of Islands|Bruce|Buller|Chatham Islands|Cheviot|Clifton|Clutha|Cook|Dannevirke|Egmont|Eketahuna|Ellesmere|Eltham|Eyre|Featherston|Franklin|Golden Bay|Great Barrier Island|Grey|Hauraki Plains|Hawera|Hawke's Bay|Heathcote|Hikurangi|Hobson|Hokianga|Horowhenua|Hurunui|Hutt|Inangahua|Inglewood|Kaikoura|Kairanga|Kiwitea|Lake|Mackenzie|Malvern|Manaia|Manawatu|Mangonui|Maniototo|Marlborough|Masterton|Matamata|Mount Herbert|Ohinemuri|Opotiki|Oroua|Otamatea|Otorohanga|Oxford|Pahiatua|Paparua|Patea|Piako|Pohangina|Raglan|Rangiora|Rangitikei|Rodney|Rotorua|Runanga|Saint Kilda|Silverpeaks|Southland|Stewart Island|Stratford|Strathallan|Taranaki|Taumarunui|Taupo|Tauranga|Thames-Coromandel|Tuapeka|Vincent|Waiapu|Waiheke|Waihemo|Waikato|Waikohu|Waimairi|Waimarino|Waimate|Waimate West|Waimea|Waipa|Waipawa|Waipukurau|Wairarapa South|Wairewa|Wairoa|Waitaki|Waitomo|Waitotara|Wallace|Wanganui|Waverley|Westland|Whakatane|Whangarei|Whangaroa|Woodville", a[167] = "Atlantico Norte|Atlantico Sur|Boaco|Carazo|Chinandega|Chontales|Esteli|Granada|Jinotega|Leon|Madriz|Managua|Masaya|Matagalpa|Nueva Segovia|Rio San Juan|Rivas", a[168] = "Agadez|Diffa|Dosso|Maradi|Niamey|Tahoua|Tillaberi|Zinder", a[169] = "Abia|Abuja Federal Capital Territory|Adamawa|Akwa Ibom|Anambra|Bauchi|Bayelsa|Benue|Borno|Cross River|Delta|Ebonyi|Edo|Ekiti|Enugu|Gombe|Imo|Jigawa|Kaduna|Kano|Katsina|Kebbi|Kogi|Kwara|Lagos|Nassarawa|Niger|Ogun|Ondo|Osun|Oyo|Plateau|Rivers|Sokoto|Taraba|Yobe|Zamfara", a[170] = "Niue", a[171] = "Norfolk Island", a[172] = "Northern Islands|Rota|Saipan|Tinian", a[173] = "Akershus|Aust-Agder|Buskerud|Finnmark|Hedmark|Hordaland|More og Romsdal|Nord-Trondelag|Nordland|Oppland|Oslo|Ostfold|Rogaland|Sogn og Fjordane|Sor-Trondelag|Telemark|Troms|Vest-Agder|Vestfold", a[174] = "Ad Dakhiliyah|Al Batinah|Al Wusta|Ash Sharqiyah|Az Zahirah|Masqat|Musandam|Zufar", a[175] = "Balochistan|Federally Administered Tribal Areas|Islamabad Capital Territory|North-West Frontier Province|Punjab|Sindh", a[176] = "Aimeliik|Airai|Angaur|Hatobohei|Kayangel|Koror|Melekeok|Ngaraard|Ngarchelong|Ngardmau|Ngatpang|Ngchesar|Ngeremlengui|Ngiwal|Palau Island|Peleliu|Sonsoral|Tobi", a[177] = "Bocas del Toro|Chiriqui|Cocle|Colon|Darien|Herrera|Los Santos|Panama|San Blas|Veraguas", a[178] = "Bougainville|Central|Chimbu|East New Britain|East Sepik|Eastern Highlands|Enga|Gulf|Madang|Manus|Milne Bay|Morobe|National Capital|New Ireland|Northern|Sandaun|Southern Highlands|West New Britain|Western|Western Highlands", a[179] = "Alto Paraguay|Alto Parana|Amambay|Asuncion (city)|Boqueron|Caaguazu|Caazapa|Canindeyu|Central|Concepcion|Cordillera|Guaira|Itapua|Misiones|Neembucu|Paraguari|Presidente Hayes|San Pedro", a[180] = "Amazonas|Ancash|Apurimac|Arequipa|Ayacucho|Cajamarca|Callao|Cusco|Huancavelica|Huanuco|Ica|Junin|La Libertad|Lambayeque|Lima|Loreto|Madre de Dios|Moquegua|Pasco|Piura|Puno|San Martin|Tacna|Tumbes|Ucayali", a[181] = "Abra|Agusan del Norte|Agusan del Sur|Aklan|Albay|Angeles|Antique|Aurora|Bacolod|Bago|Baguio|Bais|Basilan|Basilan City|Bataan|Batanes|Batangas|Batangas City|Benguet|Bohol|Bukidnon|Bulacan|Butuan|Cabanatuan|Cadiz|Cagayan|Cagayan de Oro|Calbayog|Caloocan|Camarines Norte|Camarines Sur|Camiguin|Canlaon|Capiz|Catanduanes|Cavite|Cavite City|Cebu|Cebu City|Cotabato|Dagupan|Danao|Dapitan|Davao City Davao|Davao del Sur|Davao Oriental|Dipolog|Dumaguete|Eastern Samar|General Santos|Gingoog|Ifugao|Iligan|Ilocos Norte|Ilocos Sur|Iloilo|Iloilo City|Iriga|Isabela|Kalinga-Apayao|La Carlota|La Union|Laguna|Lanao del Norte|Lanao del Sur|Laoag|Lapu-Lapu|Legaspi|Leyte|Lipa|Lucena|Maguindanao|Mandaue|Manila|Marawi|Marinduque|Masbate|Mindoro Occidental|Mindoro Oriental|Misamis Occidental|Misamis Oriental|Mountain|Naga|Negros Occidental|Negros Oriental|North Cotabato|Northern Samar|Nueva Ecija|Nueva Vizcaya|Olongapo|Ormoc|Oroquieta|Ozamis|Pagadian|Palawan|Palayan|Pampanga|Pangasinan|Pasay|Puerto Princesa|Quezon|Quezon City|Quirino|Rizal|Romblon|Roxas|Samar|San Carlos (in Negros Occidental)|San Carlos (in Pangasinan)|San Jose|San Pablo|Silay|Siquijor|Sorsogon|South Cotabato|Southern Leyte|Sultan Kudarat|Sulu|Surigao|Surigao del Norte|Surigao del Sur|Tacloban|Tagaytay|Tagbilaran|Tangub|Tarlac|Tawitawi|Toledo|Trece Martires|Zambales|Zamboanga|Zamboanga del Norte|Zamboanga del Sur", a[182] = "Pitcaim Islands", a[183] = "Dolnoslaskie|Kujawsko-Pomorskie|Lodzkie|Lubelskie|Lubuskie|Malopolskie|Mazowieckie|Opolskie|Podkarpackie|Podlaskie|Pomorskie|Slaskie|Swietokrzyskie|Warminsko-Mazurskie|Wielkopolskie|Zachodniopomorskie", a[184] = "Acores (Azores)|Aveiro|Beja|Braga|Braganca|Castelo Branco|Coimbra|Evora|Faro|Guarda|Leiria|Lisboa|Madeira|Portalegre|Porto|Santarem|Setubal|Viana do Castelo|Vila Real|Viseu", a[185] = "Adjuntas|Aguada|Aguadilla|Aguas Buenas|Aibonito|Anasco|Arecibo|Arroyo|Barceloneta|Barranquitas|Bayamon|Cabo Rojo|Caguas|Camuy|Canovanas|Carolina|Catano|Cayey|Ceiba|Ciales|Cidra|Coamo|Comerio|Corozal|Culebra|Dorado|Fajardo|Florida|Guanica|Guayama|Guayanilla|Guaynabo|Gurabo|Hatillo|Hormigueros|Humacao|Isabela|Jayuya|Juana Diaz|Juncos|Lajas|Lares|Las Marias|Las Piedras|Loiza|Luquillo|Manati|Maricao|Maunabo|Mayaguez|Moca|Morovis|Naguabo|Naranjito|Orocovis|Patillas|Penuelas|Ponce|Quebradillas|Rincon|Rio Grande|Sabana Grande|Salinas|San German|San Juan|San Lorenzo|San Sebastian|Santa Isabel|Toa Alta|Toa Baja|Trujillo Alto|Utuado|Vega Alta|Vega Baja|Vieques|Villalba|Yabucoa|Yauco", a[186] = "Ad Dawhah|Al Ghuwayriyah|Al Jumayliyah|Al Khawr|Al Wakrah|Ar Rayyan|Jarayan al Batinah|Madinat ash Shamal|Umm Salal", a[187] = "Reunion", a[188] = "Alba|Arad|Arges|Bacau|Bihor|Bistrita-Nasaud|Botosani|Braila|Brasov|Bucuresti|Buzau|Calarasi|Caras-Severin|Cluj|Constanta|Covasna|Dimbovita|Dolj|Galati|Giurgiu|Gorj|Harghita|Hunedoara|Ialomita|Iasi|Maramures|Mehedinti|Mures|Neamt|Olt|Prahova|Salaj|Satu Mare|Sibiu|Suceava|Teleorman|Timis|Tulcea|Vaslui|Vilcea|Vrancea", a[189] = "Adygeya (Maykop)|Aginskiy Buryatskiy (Aginskoye)|Altay (Gorno-Altaysk)|Altayskiy (Barnaul)|Amurskaya (Blagoveshchensk)|Arkhangel'skaya|Astrakhanskaya|Bashkortostan (Ufa)|Belgorodskaya|Bryanskaya|Buryatiya (Ulan-Ude)|Chechnya (Groznyy)|Chelyabinskaya|Chitinskaya|Chukotskiy (Anadyr')|Chuvashiya (Cheboksary)|Dagestan (Makhachkala)|Evenkiyskiy (Tura)|Ingushetiya (Nazran')|Irkutskaya|Ivanovskaya|Kabardino-Balkariya (Nal'chik)|Kaliningradskaya|Kalmykiya (Elista)|Kaluzhskaya|Kamchatskaya (Petropavlovsk-Kamchatskiy)|Karachayevo-Cherkesiya (Cherkessk)|Kareliya (Petrozavodsk)|Kemerovskaya|Khabarovskiy|Khakasiya (Abakan)|Khanty-Mansiyskiy (Khanty-Mansiysk)|Kirovskaya|Komi (Syktyvkar)|Komi-Permyatskiy (Kudymkar)|Koryakskiy (Palana)|Kostromskaya|Krasnodarskiy|Krasnoyarskiy|Kurganskaya|Kurskaya|Leningradskaya|Lipetskaya|Magadanskaya|Mariy-El (Yoshkar-Ola)|Mordoviya (Saransk)|Moskovskaya|Moskva (Moscow)|Murmanskaya|Nenetskiy (Nar'yan-Mar)|Nizhegorodskaya|Novgorodskaya|Novosibirskaya|Omskaya|Orenburgskaya|Orlovskaya (Orel)|Penzenskaya|Permskaya|Primorskiy (Vladivostok)|Pskovskaya|Rostovskaya|Ryazanskaya|Sakha (Yakutsk)|Sakhalinskaya (Yuzhno-Sakhalinsk)|Samarskaya|Sankt-Peterburg (Saint Petersburg)|Saratovskaya|Severnaya Osetiya-Alaniya [North Ossetia] (Vladikavkaz)|Smolenskaya|Stavropol'skiy|Sverdlovskaya (Yekaterinburg)|Tambovskaya|Tatarstan (Kazan')|Taymyrskiy (Dudinka)|Tomskaya|Tul'skaya|Tverskaya|Tyumenskaya|Tyva (Kyzyl)|Udmurtiya (Izhevsk)|Ul'yanovskaya|Ust'-Ordynskiy Buryatskiy (Ust'-Ordynskiy)|Vladimirskaya|Volgogradskaya|Vologodskaya|Voronezhskaya|Yamalo-Nenetskiy (Salekhard)|Yaroslavskaya|Yevreyskaya", a[190] = "Butare|Byumba|Cyangugu|Gikongoro|Gisenyi|Gitarama|Kibungo|Kibuye|Kigali Rurale|Kigali-ville|Ruhengeri|Umutara", a[191] = "Ascension|Saint Helena|Tristan da Cunha", a[192] = "Christ Church Nichola Town|Saint Anne Sandy Point|Saint George Basseterre|Saint George Gingerland|Saint James Windward|Saint John Capisterre|Saint John Figtree|Saint Mary Cayon|Saint Paul Capisterre|Saint Paul Charlestown|Saint Peter Basseterre|Saint Thomas Lowland|Saint Thomas Middle Island|Trinity Palmetto Point", a[193] = "Anse-la-Raye|Castries|Choiseul|Dauphin|Dennery|Gros Islet|Laborie|Micoud|Praslin|Soufriere|Vieux Fort", a[194] = "Miquelon|Saint Pierre", a[195] = "Charlotte|Grenadines|Saint Andrew|Saint David|Saint George|Saint Patrick", a[196] = "A'ana|Aiga-i-le-Tai|Atua|Fa'asaleleaga|Gaga'emauga|Gagaifomauga|Palauli|Satupa'itea|Tuamasaga|Va'a-o-Fonoti|Vaisigano", a[197] = "Acquaviva|Borgo Maggiore|Chiesanuova|Domagnano|Faetano|Fiorentino|Monte Giardino|San Marino|Serravalle", a[198] = "Principe|Sao Tome", a[199] = "'Asir|Al Bahah|Al Hudud ash Shamaliyah|Al Jawf|Al Madinah|Al Qasim|Ar Riyad|Ash Sharqiyah (Eastern Province)|Ha'il|Jizan|Makkah|Najran|Tabuk", a[200] = "Aberdeen City|Aberdeenshire|Angus|Argyll and Bute|City of Edinburgh|Clackmannanshire|Dumfries and Galloway|Dundee City|East Ayrshire|East Dunbartonshire|East Lothian|East Renfrewshire|Eilean Siar (Western Isles)|Falkirk|Fife|Glasgow City|Highland|Inverclyde|Midlothian|Moray|North Ayrshire|North Lanarkshire|Orkney Islands|Perth and Kinross|Renfrewshire|Shetland Islands|South Ayrshire|South Lanarkshire|Stirling|The Scottish Borders|West Dunbartonshire|West Lothian", a[201] = "Dakar|Diourbel|Fatick|Kaolack|Kolda|Louga|Saint-Louis|Tambacounda|Thies|Ziguinchor", a[202] = "Anse aux Pins|Anse Boileau|Anse Etoile|Anse Louis|Anse Royale|Baie Lazare|Baie Sainte Anne|Beau Vallon|Bel Air|Bel Ombre|Cascade|Glacis|Grand' Anse (on Mahe)|Grand' Anse (on Praslin)|La Digue|La Riviere Anglaise|Mont Buxton|Mont Fleuri|Plaisance|Pointe La Rue|Port Glaud|Saint Louis|Takamaka", a[203] = "Eastern|Northern|Southern|Western", a[204] = "Singapore", a[205] = "Banskobystricky|Bratislavsky|Kosicky|Nitriansky|Presovsky|Trenciansky|Trnavsky|Zilinsky", a[206] = "Ajdovscina|Beltinci|Bled|Bohinj|Borovnica|Bovec|Brda|Brezice|Brezovica|Cankova-Tisina|Celje|Cerklje na Gorenjskem|Cerknica|Cerkno|Crensovci|Crna na Koroskem|Crnomelj|Destrnik-Trnovska Vas|Divaca|Dobrepolje|Dobrova-Horjul-Polhov Gradec|Dol pri Ljubljani|Domzale|Dornava|Dravograd|Duplek|Gorenja Vas-Poljane|Gorisnica|Gornja Radgona|Gornji Grad|Gornji Petrovci|Grosuplje|Hodos Salovci|Hrastnik|Hrpelje-Kozina|Idrija|Ig|Ilirska Bistrica|Ivancna Gorica|Izola|Jesenice|Jursinci|Kamnik|Kanal|Kidricevo|Kobarid|Kobilje|Kocevje|Komen|Koper|Kozje|Kranj|Kranjska Gora|Krsko|Kungota|Kuzma|Lasko|Lenart|Lendava|Litija|Ljubljana|Ljubno|Ljutomer|Logatec|Loska Dolina|Loski Potok|Luce|Lukovica|Majsperk|Maribor|Medvode|Menges|Metlika|Mezica|Miren-Kostanjevica|Mislinja|Moravce|Moravske Toplice|Mozirje|Murska Sobota|Muta|Naklo|Nazarje|Nova Gorica|Novo Mesto|Odranci|Ormoz|Osilnica|Pesnica|Piran|Pivka|Podcetrtek|Podvelka-Ribnica|Postojna|Preddvor|Ptuj|Puconci|Race-Fram|Radece|Radenci|Radlje ob Dravi|Radovljica|Ravne-Prevalje|Ribnica|Rogasevci|Rogaska Slatina|Rogatec|Ruse|Semic|Sencur|Sentilj|Sentjernej|Sentjur pri Celju|Sevnica|Sezana|Skocjan|Skofja Loka|Skofljica|Slovenj Gradec|Slovenska Bistrica|Slovenske Konjice|Smarje pri Jelsah|Smartno ob Paki|Sostanj|Starse|Store|Sveti Jurij|Tolmin|Trbovlje|Trebnje|Trzic|Turnisce|Velenje|Velike Lasce|Videm|Vipava|Vitanje|Vodice|Vojnik|Vrhnika|Vuzenica|Zagorje ob Savi|Zalec|Zavrc|Zelezniki|Ziri|Zrece", a[207] = "Bellona|Central|Choiseul (Lauru)|Guadalcanal|Honiara|Isabel|Makira|Malaita|Rennell|Temotu|Western", a[208] = "Awdal|Bakool|Banaadir|Bari|Bay|Galguduud|Gedo|Hiiraan|Jubbada Dhexe|Jubbada Hoose|Mudug|Nugaal|Sanaag|Shabeellaha Dhexe|Shabeellaha Hoose|Sool|Togdheer|Woqooyi Galbeed", a[209] = "Eastern Cape|Free State|Gauteng|KwaZulu-Natal|Mpumalanga|North-West|Northern Cape|Northern Province|Western Cape", a[210] = "Bird Island|Bristol Island|Clerke Rocks|Montagu Island|Saunders Island|South Georgia|Southern Thule|Traversay Islands", a[211] = "Andalucia|Aragon|Asturias|Baleares (Balearic Islands)|Canarias (Canary Islands)|Cantabria|Castilla y Leon|Castilla-La Mancha|Cataluna|Ceuta|Communidad Valencian|Extremadura|Galicia|Islas Chafarinas|La Rioja|Madrid|Melilla|Murcia|Navarra|Pais Vasco (Basque Country)|Penon de Alhucemas|Penon de Velez de la Gomera", a[212] = "Spratly Islands", a[213] = "Central|Eastern|North Central|North Eastern|North Western|Northern|Sabaragamuwa|Southern|Uva|Western", a[214] = "A'ali an Nil|Al Bahr al Ahmar|Al Buhayrat|Al Jazirah|Al Khartum|Al Qadarif|Al Wahdah|An Nil al Abyad|An Nil al Azraq|Ash Shamaliyah|Bahr al Jabal|Gharb al Istiwa'iyah|Gharb Bahr al Ghazal|Gharb Darfur|Gharb Kurdufan|Janub Darfur|Janub Kurdufan|Junqali|Kassala|Nahr an Nil|Shamal Bahr al Ghazal|Shamal Darfur|Shamal Kurdufan|Sharq al Istiwa'iyah|Sinnar|Warab", a[215] = "Brokopondo|Commewijne|Coronie|Marowijne|Nickerie|Para|Paramaribo|Saramacca|Sipaliwini|Wanica", a[216] = "Barentsoya|Bjornoya|Edgeoya|Hopen|Kvitoya|Nordaustandet|Prins Karls Forland|Spitsbergen", a[217] = "Hhohho|Lubombo|Manzini|Shiselweni", a[218] = "Blekinge|Dalarnas|Gavleborgs|Gotlands|Hallands|Jamtlands|Jonkopings|Kalmar|Kronobergs|Norrbottens|Orebro|Ostergotlands|Skane|Sodermanlands|Stockholms|Uppsala|Varmlands|Vasterbottens|Vasternorrlands|Vastmanlands|Vastra Gotalands", a[219] = "Aargau|Ausser-Rhoden|Basel-Landschaft|Basel-Stadt|Bern|Fribourg|Geneve|Glarus|Graubunden|Inner-Rhoden|Jura|Luzern|Neuchatel|Nidwalden|Obwalden|Sankt Gallen|Schaffhausen|Schwyz|Solothurn|Thurgau|Ticino|Uri|Valais|Vaud|Zug|Zurich", a[220] = "Al Hasakah|Al Ladhiqiyah|Al Qunaytirah|Ar Raqqah|As Suwayda'|Dar'a|Dayr az Zawr|Dimashq|Halab|Hamah|Hims|Idlib|Rif Dimashq|Tartus", a[221] = "Chang-hua|Chi-lung|Chia-i|Chia-i|Chung-hsing-hsin-ts'un|Hsin-chu|Hsin-chu|Hua-lien|I-lan|Kao-hsiung|Kao-hsiung|Miao-li|Nan-t'ou|P'eng-hu|P'ing-tung|T'ai-chung|T'ai-chung|T'ai-nan|T'ai-nan|T'ai-pei|T'ai-pei|T'ai-tung|T'ao-yuan|Yun-lin", a[222] = "Viloyati Khatlon|Viloyati Leninobod|Viloyati Mukhtori Kuhistoni Badakhshon", a[223] = "Arusha|Dar es Salaam|Dodoma|Iringa|Kagera|Kigoma|Kilimanjaro|Lindi|Mara|Mbeya|Morogoro|Mtwara|Mwanza|Pemba North|Pemba South|Pwani|Rukwa|Ruvuma|Shinyanga|Singida|Tabora|Tanga|Zanzibar Central/South|Zanzibar North|Zanzibar Urban/West", a[224] = "Amnat Charoen|Ang Thong|Buriram|Chachoengsao|Chai Nat|Chaiyaphum|Chanthaburi|Chiang Mai|Chiang Rai|Chon Buri|Chumphon|Kalasin|Kamphaeng Phet|Kanchanaburi|Khon Kaen|Krabi|Krung Thep Mahanakhon (Bangkok)|Lampang|Lamphun|Loei|Lop Buri|Mae Hong Son|Maha Sarakham|Mukdahan|Nakhon Nayok|Nakhon Pathom|Nakhon Phanom|Nakhon Ratchasima|Nakhon Sawan|Nakhon Si Thammarat|Nan|Narathiwat|Nong Bua Lamphu|Nong Khai|Nonthaburi|Pathum Thani|Pattani|Phangnga|Phatthalung|Phayao|Phetchabun|Phetchaburi|Phichit|Phitsanulok|Phra Nakhon Si Ayutthaya|Phrae|Phuket|Prachin Buri|Prachuap Khiri Khan|Ranong|Ratchaburi|Rayong|Roi Et|Sa Kaeo|Sakon Nakhon|Samut Prakan|Samut Sakhon|Samut Songkhram|Sara Buri|Satun|Sing Buri|Sisaket|Songkhla|Sukhothai|Suphan Buri|Surat Thani|Surin|Tak|Trang|Trat|Ubon Ratchathani|Udon Thani|Uthai Thani|Uttaradit|Yala|Yasothon", a[225] = "Tobago", a[226] = "De La Kara|Des Plateaux|Des Savanes|Du Centre|Maritime", a[227] = "Atafu|Fakaofo|Nukunonu", a[228] = "Ha'apai|Tongatapu|Vava'u", a[229] = "Arima|Caroni|Mayaro|Nariva|Port-of-Spain|Saint Andrew|Saint David|Saint George|Saint Patrick|San Fernando|Victoria", a[230] = "Ariana|Beja|Ben Arous|Bizerte|El Kef|Gabes|Gafsa|Jendouba|Kairouan|Kasserine|Kebili|Mahdia|Medenine|Monastir|Nabeul|Sfax|Sidi Bou Zid|Siliana|Sousse|Tataouine|Tozeur|Tunis|Zaghouan", a[231] = "Adana|Adiyaman|Afyon|Agri|Aksaray|Amasya|Ankara|Antalya|Ardahan|Artvin|Aydin|Balikesir|Bartin|Batman|Bayburt|Bilecik|Bingol|Bitlis|Bolu|Burdur|Bursa|Canakkale|Cankiri|Corum|Denizli|Diyarbakir|Duzce|Edirne|Elazig|Erzincan|Erzurum|Eskisehir|Gaziantep|Giresun|Gumushane|Hakkari|Hatay|Icel|Igdir|Isparta|Istanbul|Izmir|Kahramanmaras|Karabuk|Karaman|Kars|Kastamonu|Kayseri|Kilis|Kirikkale|Kirklareli|Kirsehir|Kocaeli|Konya|Kutahya|Malatya|Manisa|Mardin|Mugla|Mus|Nevsehir|Nigde|Ordu|Osmaniye|Rize|Sakarya|Samsun|Sanliurfa|Siirt|Sinop|Sirnak|Sivas|Tekirdag|Tokat|Trabzon|Tunceli|Usak|Van|Yalova|Yozgat|Zonguldak", a[232] = "Ahal Welayaty|Balkan Welayaty|Dashhowuz Welayaty|Lebap Welayaty|Mary Welayaty", a[233] = "Tuvalu", a[234] = "Adjumani|Apac|Arua|Bugiri|Bundibugyo|Bushenyi|Busia|Gulu|Hoima|Iganga|Jinja|Kabale|Kabarole|Kalangala|Kampala|Kamuli|Kapchorwa|Kasese|Katakwi|Kibale|Kiboga|Kisoro|Kitgum|Kotido|Kumi|Lira|Luwero|Masaka|Masindi|Mbale|Mbarara|Moroto|Moyo|Mpigi|Mubende|Mukono|Nakasongola|Nebbi|Ntungamo|Pallisa|Rakai|Rukungiri|Sembabule|Soroti|Tororo", a[235] = "Avtonomna Respublika Krym (Simferopol')|Cherkas'ka (Cherkasy)|Chernihivs'ka (Chernihiv)|Chernivets'ka (Chernivtsi)|Dnipropetrovs'ka (Dnipropetrovs'k)|Donets'ka (Donets'k)|Ivano-Frankivs'ka (Ivano-Frankivs'k)|Kharkivs'ka (Kharkiv)|Khersons'ka (Kherson)|Khmel'nyts'ka (Khmel'nyts'kyy)|Kirovohrads'ka (Kirovohrad)|Kyyiv|Kyyivs'ka (Kiev)|L'vivs'ka (L'viv)|Luhans'ka (Luhans'k)|Mykolayivs'ka (Mykolayiv)|Odes'ka (Odesa)|Poltavs'ka (Poltava)|Rivnens'ka (Rivne)|Sevastopol'|Sums'ka (Sumy)|Ternopil's'ka (Ternopil')|Vinnyts'ka (Vinnytsya)|Volyns'ka (Luts'k)|Zakarpats'ka (Uzhhorod)|Zaporiz'ka (Zaporizhzhya)|Zhytomyrs'ka (Zhytomyr)", a[236] = "'Ajman|Abu Zaby (Abu Dhabi)|Al Fujayrah|Ash Shariqah (Sharjah)|Dubayy (Dubai)|Ra's al Khaymah|Umm al Qaywayn", a[237] = "Barking and Dagenham|Barnet|Barnsley|Bath and North East Somerset|Bedfordshire|Bexley|Birmingham|Blackburn with Darwen|Blackpool|Bolton|Bournemouth|Bracknell Forest|Bradford|Brent|Brighton and Hove|Bromley|Buckinghamshire|Bury|Calderdale|Cambridgeshire|Camden|Cheshire|City of Bristol|City of Kingston upon Hull|City of London|Cornwall|Coventry|Croydon|Cumbria|Darlington|Derby|Derbyshire|Devon|Doncaster|Dorset|Dudley|Durham|Ealing|East Riding of Yorkshire|East Sussex|Enfield|Essex|Gateshead|Gloucestershire|Greenwich|Hackney|Halton|Hammersmith and Fulham|Hampshire|Haringey|Harrow|Hartlepool|Havering|Herefordshire|Hertfordshire|Hillingdon|Hounslow|Isle of Wight|Islington|Kensington and Chelsea|Kent|Kingston upon Thames|Kirklees|Knowsley|Lambeth|Lancashire|Leeds|Leicester|Leicestershire|Lewisham|Lincolnshire|Liverpool|Luton|Manchester|Medway|Merton|Middlesbrough|Milton Keynes|Newcastle upon Tyne|Newham|Norfolk|North East Lincolnshire|North Lincolnshire|North Somerset|North Tyneside|North Yorkshire|Northamptonshire|Northumberland|Nottingham|Nottinghamshire|Oldham|Oxfordshire|Peterborough|Plymouth|Poole|Portsmouth|Reading|Redbridge|Redcar and Cleveland|Richmond upon Thames|Rochdale|Rotherham|Rutland|Salford|Sandwell|Sefton|Sheffield|Shropshire|Slough|Solihull|Somerset|South Gloucestershire|South Tyneside|Southampton|Southend-on-Sea|Southwark|St. Helens|Staffordshire|Stockport|Stockton-on-Tees|Stoke-on-Trent|Suffolk|Sunderland|Surrey|Sutton|Swindon|Tameside|Telford and Wrekin|Thurrock|Torbay|Tower Hamlets|Trafford|Wakefield|Walsall|Waltham Forest|Wandsworth|Warrington|Warwickshire|West Berkshire|West Sussex|Westminster|Wigan|Wiltshire|Windsor and Maidenhead|Wirral|Wokingham|Wolverhampton|Worcestershire|York", a[238] = "Artigas|Canelones|Cerro Largo|Colonia|Durazno|Flores|Florida|Lavalleja|Maldonado|Montevideo|Paysandu|Rio Negro|Rivera|Rocha|Salto|San Jose|Soriano|Tacuarembo|Treinta y Tres", a[239] = "Alabama|Alaska|Arizona|Arkansas|California|Colorado|Connecticut|Delaware|District of Columbia|Florida|Georgia|Hawaii|Idaho|Illinois|Indiana|Iowa|Kansas|Kentucky|Louisiana|Maine|Maryland|Massachusetts|Michigan|Minnesota|Mississippi|Missouri|Montana|Nebraska|Nevada|New Hampshire|New Jersey|New Mexico|New York|North Carolina|North Dakota|Ohio|Oklahoma|Oregon|Pennsylvania|Rhode Island|South Carolina|South Dakota|Tennessee|Texas|Utah|Vermont|Virginia|Washington|West Virginia|Wisconsin|Wyoming", a[240] = "Andijon Wiloyati|Bukhoro Wiloyati|Farghona Wiloyati|Jizzakh Wiloyati|Khorazm Wiloyati (Urganch)|Namangan Wiloyati|Nawoiy Wiloyati|Qashqadaryo Wiloyati (Qarshi)|Qoraqalpoghiston (Nukus)|Samarqand Wiloyati|Sirdaryo Wiloyati (Guliston)|Surkhondaryo Wiloyati (Termiz)|Toshkent Shahri|Toshkent Wiloyati", a[241] = "Malampa|Penama|Sanma|Shefa|Tafea|Torba", a[242] = "Amazonas|Anzoategui|Apure|Aragua|Barinas|Bolivar|Carabobo|Cojedes|Delta Amacuro|Dependencias Federales|Distrito Federal|Falcon|Guarico|Lara|Merida|Miranda|Monagas|Nueva Esparta|Portuguesa|Sucre|Tachira|Trujillo|Vargas|Yaracuy|Zulia", a[243] = "An Giang|Ba Ria-Vung Tau|Bac Giang|Bac Kan|Bac Lieu|Bac Ninh|Ben Tre|Binh Dinh|Binh Duong|Binh Phuoc|Binh Thuan|Ca Mau|Can Tho|Cao Bang|Da Nang|Dac Lak|Dong Nai|Dong Thap|Gia Lai|Ha Giang|Ha Nam|Ha Noi|Ha Tay|Ha Tinh|Hai Duong|Hai Phong|Ho Chi Minh|Hoa Binh|Hung Yen|Khanh Hoa|Kien Giang|Kon Tum|Lai Chau|Lam Dong|Lang Son|Lao Cai|Long An|Nam Dinh|Nghe An|Ninh Binh|Ninh Thuan|Phu Tho|Phu Yen|Quang Binh|Quang Nam|Quang Ngai|Quang Ninh|Quang Tri|Soc Trang|Son La|Tay Ninh|Thai Binh|Thai Nguyen|Thanh Hoa|Thua Thien-Hue|Tien Giang|Tra Vinh|Tuyen Quang|Vinh Long|Vinh Phuc|Yen Bai", a[244] = "Saint Croix|Saint John|Saint Thomas", a[245] = "Blaenau Gwent|Bridgend|Caerphilly|Cardiff|Carmarthenshire|Ceredigion|Conwy|Denbighshire|Flintshire|Gwynedd|Isle of Anglesey|Merthyr Tydfil|Monmouthshire|Neath Port Talbot|Newport|Pembrokeshire|Powys|Rhondda Cynon Taff|Swansea|The Vale of Glamorgan|Torfaen|Wrexham", a[246] = "Alo|Sigave|Wallis", a[247] = "West Bank", a[248] = "Western Sahara", a[249] = "'Adan|'Ataq|Abyan|Al Bayda'|Al Hudaydah|Al Jawf|Al Mahrah|Al Mahwit|Dhamar|Hadhramawt|Hajjah|Ibb|Lahij|Ma'rib|Sa'dah|San'a'|Ta'izz", a[250] = "Kosovo|Montenegro|Serbia|Vojvodina", a[251] = "Central|Copperbelt|Eastern|Luapula|Lusaka|North-Western|Northern|Southern|Western", a[252] = "Bulawayo|Harare|ManicalandMashonaland Central|Mashonaland East|Mashonaland West|Masvingo|Matabeleland North|Matabeleland South|Midlands", document.querySelector("#country-select") && (! function(a) {
                    var t, n = document.getElementById(a),
                        i = 0;
                    for (t in console.log(n), e) {
                        var r = new Option(e[t], e[t]);
                        r && (n.options[i++] = r)
                    }
                }("country-select"), document.querySelector("#country-select").addEventListener("change", (function() {
                    ! function(e, t) {
                        var n, i = document.getElementById(e),
                            r = 0;
                        t++, console.log(a[t]);
                        var s = a[t].split("|");
                        for (n in s) {
                            var o = new Option(s[n], s[n]);
                            o && (i.options[r++] = o)
                        }
                    }("state-select", this.selectedIndex)
                })))
            }

            function Ce(e) {
                return Ce = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                    return typeof e
                } : function(e) {
                    return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
                }, Ce(e)
            }
            t(979), t(696), t(335), t(793);

            function Ee(e) {
                var a = function(e, a) {
                    if ("object" !== Ce(e) || null === e) return e;
                    var t = e[Symbol.toPrimitive];
                    if (void 0 !== t) {
                        var n = t.call(e, a || "default");
                        if ("object" !== Ce(n)) return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.")
                    }
                    return ("string" === a ? String : Number)(e)
                }(e, "string");
                return "symbol" === Ce(a) ? a : String(a)
            }

            function Me(e, a) {
                for (var t = 0; t < a.length; t++) {
                    var n = a[t];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, Ee(n.key), n)
                }
            }

            function Ae(e) {
                if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e
            }

            function Pe(e, a) {
                return Pe = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, a) {
                    return e.__proto__ = a, e
                }, Pe(e, a)
            }

            function Le(e) {
                return Le = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                    return e.__proto__ || Object.getPrototypeOf(e)
                }, Le(e)
            }

            function je(e, a, t) {
                return je = function() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function() {}))), !0
                    } catch (e) {
                        return !1
                    }
                }() ? Reflect.construct.bind() : function(e, a, t) {
                    var n = [null];
                    n.push.apply(n, a);
                    var i = new(Function.bind.apply(e, n));
                    return t && Pe(i, t.prototype), i
                }, je.apply(null, arguments)
            }

            function Be(e) {
                var a = "function" == typeof Map ? new Map : void 0;
                return Be = function(e) {
                    if (null === e || (t = e, -1 === Function.toString.call(t).indexOf("[native code]"))) return e;
                    var t;
                    if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
                    if (void 0 !== a) {
                        if (a.has(e)) return a.get(e);
                        a.set(e, n)
                    }

                    function n() {
                        return je(e, arguments, Le(this).constructor)
                    }
                    return n.prototype = Object.create(e.prototype, {
                        constructor: {
                            value: n,
                            enumerable: !1,
                            writable: !0,
                            configurable: !0
                        }
                    }), Pe(n, e)
                }, Be(e)
            }

            function Ne(e) {
                var a = function() {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], (function() {}))), !0
                    } catch (e) {
                        return !1
                    }
                }();
                return function() {
                    var t, n = Le(e);
                    if (a) {
                        var i = Le(this).constructor;
                        t = Reflect.construct(n, arguments, i)
                    } else t = n.apply(this, arguments);
                    return function(e, a) {
                        if (a && ("object" === Ce(a) || "function" == typeof a)) return a;
                        if (void 0 !== a) throw new TypeError("Derived constructors may only return object or undefined");
                        return Ae(e)
                    }(this, t)
                }
            }
            var ze = function(a) {
                ! function(e, a) {
                    if ("function" != typeof a && null !== a) throw new TypeError("Super expression must either be null or a function");
                    e.prototype = Object.create(a && a.prototype, {
                        constructor: {
                            value: e,
                            writable: !0,
                            configurable: !0
                        }
                    }), Object.defineProperty(e, "prototype", {
                        writable: !1
                    }), a && Pe(e, a)
                }(s, a);
                var t, n, i, r = Ne(s);

                function s() {
                    var a;
                    ! function(e, a) {
                        if (!(e instanceof a)) throw new TypeError("Cannot call a class as a function")
                    }(this, s), a = r.call(this);
                    return new IntersectionObserver(function(t, n) {
                        t[0].isIntersecting && (n.unobserve(Ae(a)), fetch(a.dataset.url).then((function(e) {
                            return e.text()
                        })).then((function(t) {
                            var n = document.createElement("div");
                            n.innerHTML = t;
                            var i = n.querySelector("product-recommendations");
                            i && i.innerHTML.trim().length && (a.innerHTML = i.innerHTML, e())
                        })).catch((function(e) {
                            console.error(e)
                        })))
                    }.bind(Ae(a)), {
                        rootMargin: "0px 0px 200px 0px"
                    }).observe(Ae(a)), a
                }
                return t = s, n && Me(t.prototype, n), i && Me(t, i), Object.defineProperty(t, "prototype", {
                    writable: !1
                }), t
            }(Be(HTMLElement));
            customElements.define("product-recommendations", ze);
            var De = ze,
                Ie = document.querySelectorAll(".js-toggle-widget"),
                Oe = document.querySelectorAll(".js-widget-blocker");
            he()(document).on("click", ".js-mb-tab", (function(e) {
                e.preventDefault();
                var a = he()(this).data("index"),
                    t = this.closest(".mindbody-widgets"),
                    n = he()(".js-mb-tab"),
                    i = he()('.mindbody-desc-tab[data-index="'.concat(a, '"]')),
                    r = he()(".mindbody-desc-tab"),
                    s = he()(".mindbody-widgets-grid"),
                    o = he()('.mindbody-widgets-grid[data-index="'.concat(a, '"]'));
                n.each((function() {
                    this.getAttribute("data-section-id") == t.getAttribute("data-section-id") && he()(this).removeClass("active")
                })), r.each((function() {
                    this.getAttribute("data-section-id") == t.getAttribute("data-section-id") && he()(this).removeClass("active")
                })), s.each((function() {
                    this.getAttribute("data-section-id") == t.getAttribute("data-section-id") && he()(this).removeClass("active")
                })), he()(this).addClass("active"), i.addClass("active"), o.addClass("active")
            }));
            for (var Re = function() {
                    var e = this.getAttribute("aria-controls"),
                        a = document.querySelectorAll(".js-widget-modal"),
                        t = document.getElementById("".concat(e)),
                        n = document.querySelector('[data-modal-blocker="'.concat(this.dataset.modalId, '"]'));
                    a.forEach((function(e, a) {
                        e.setAttribute("aria-hidden", !0), e.classList.remove("active")
                    })), Oe.forEach((function(e, a) {
                        e.classList.remove("active")
                    })), this.classList.add("active"), null == t || t.classList.add("active"), document.body.classList.add("widget-modal-open"), document.documentElement.classList.add("widget-modal-open"), null != t && t.classList.contains("active") ? (null == t || t.setAttribute("aria-hidden", !1), n.classList.add("active"), this.closest("header.header") && this.closest("header.header").classList.add("widget-in-header")) : (null == t || t.setAttribute("aria-hidden", !0), n && n.classList.remove("active"), document.body.classList.remove("widget-modal-open"), document.documentElement.classList.remove("widget-modal-open"), this.closest("header.header") && this.closest("header.header").classList.remove("widget-in-header"))
                }, He = 0; He < Ie.length; He++) Ie[He].addEventListener("click", Re, !1);
            for (var Ge = document.querySelectorAll(".js-read-more"), qe = function(e) {
                    var a = e.target.closest("[data-less]"),
                        t = document.querySelector('[data-full="'.concat(a.dataset.less, '"]'));
                    e.target.classList.add("hidden"), a.classList.add("hidden"), t.classList.remove("hidden"), t.setAttribute("aria-hidden", !1)
                }, Ke = 0; Ke < Ge.length; Ke++) Ge[Ke].addEventListener("click", qe, {
                once: !0
            });
            document.onkeydown = function(e) {
                ("key" in (e = e || window.event) ? "Escape" === e.key || "Esc" === e.key : 27 === e.keyCode) && (document.querySelectorAll(".js-widget-modal").forEach((function(e, a) {
                    Oe[a].classList.remove("active"), e.classList.remove("active")
                })), document.body.classList.remove("widget-modal-open"), document.documentElement.classList.remove("widget-modal-open"), document.querySelector("header.header").classList.remove("widget-in-header"))
            };
            t(62);
            var $e = function() {
                var e = document.getElementById("js-announcement-swiper");
                if (null != e) {
                    var a = parseInt(e.getAttribute("data-time"));
                    console.log(a);
                    new ne("#js-announcement-swiper", {
                        slidesPerView: 1,
                        loop: true,
                        autoHeight: !0,
                        a11y: !0,
                        spaceBetween: 0,
                        grabCursor: !0,
                        speed: 1e3,
                        autoplay: {
                            delay: 1e3 * a,
                            pauseOnMouseEnter: !0
                        }
                    })
                }
            };
            he()(document).on("change", '.formspark-form select[name="type"]', (function() {
                var e = he()(this).val();
                he()(this).parents(".formspark-form").find("[data-form_type]").each((function() {
                    var a = he()(this).attr("data-form_type");
                    a && !a.includes(e) ? (he()(this).addClass("hidden"), he()(this).find("input, textarea, select").each((function(e) {
                        he()(this).attr("disabled", "disabled")
                    }))) : (he()(this).removeClass("hidden"), he()(this).find("input, textarea, select").each((function(e) {
                        he()(this).removeAttr("disabled")
                    })))
                }))
            })), he()(document).on("submit", ".formspark-form", (function(e) {
                e.preventDefault();
                var a = he()(this),
                    t = a.find(".js-form-spark").data("form-id"),
                    n = a.find("input, textarea, select"),
                    i = [];
                n.each((function(e) {
                    if (he()(this).attr("disabled"));
                    else if ("type" == he()(this).attr("name")) t = he()(this).find("option:selected").attr("data-id");
                    else {
                        console.log(he()(this).attr("name"), he()(this).val());
                        var a = he()(this).attr("name"),
                            n = he()(this).val();
                        i.push("".concat(a, " : ").concat(n)), console.log(i)
                    }
                })), fetch("https://submit-form.com/".concat(t), {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Accept: "application/json"
                    },
                    body: JSON.stringify(i)
                }).then((function(e) {
                    console.log(e), a.find(".message").removeClass("hidden")
                })).catch((function(e) {
                    console.error(e), alert("Any error occured, please try again.")
                })), this.reset()
            }));
            var Ve, We, Fe, _e, Ye, Xe, Je, Ue, Ze, Qe, ea, aa = function() {
                var e = document.querySelectorAll(".js-home-hero-swiper");
                e.length && e.forEach((function(e, a) {
                    var t = "true" === e.dataset.autoplay,
                        n = e.dataset.delay ? 1e3 * e.dataset.delay : 3e3;
                    e.classList.add("s".concat(a));
                    new ne(".js-home-hero-swiper.s".concat(a), {
                        slidesPerView: 1,
                        a11y: !0,
                        spaceBetween: 0,
                        grabCursor: !0,
                        navigation: {
                            nextEl: ".js-home-hero-swiper.s".concat(a, " .swiper-button-next"),
                            prevEl: ".js-home-hero-swiper.s".concat(a, " .swiper-button-prev")
                        },
                        pagination: {
                            el: ".js-home-hero-swiper.s".concat(a, " .swiper-pagination"),
                            clickable: !0
                        },
                        loop: !0,
                        autoplay: !!t && {
                            delay: n
                        }
                    })
                }))
            };
            $e(), e(),
                function() {
                    var e = document.querySelectorAll("[data-main-handle]"),
                        a = document.querySelectorAll("[data-mega-menu]"),
                        t = document.querySelectorAll("[data-sub-menu]");
                    if (a || t || a.length || t.length)
                        for (var n = function(e) {
                                e.preventDefault();
                                var a = this.getAttribute("data-main-handle"),
                                    t = document.querySelector('[data-mega-menu="'.concat(a, '"]')),
                                    n = document.querySelector('[data-sub-menu="'.concat(a, '"]'));
                                t ? (t.classList.toggle("hidden"), this.classList.toggle("active")) : n && (n.classList.toggle("hidden"), this.classList.toggle("active"))
                            }, i = 0; i < e.length; i++) e[i].addEventListener("click", n, !1)
                }(), fe(), me(), Ve = setInterval((function() {
                    console.log("typeof(window.KlaviyoSubscribe)", Ce(window.KlaviyoSubscribe)), "object" === Ce(window.KlaviyoSubscribe) && (window.KlaviyoSubscribe.attachToForms(".js-klaviyo-form", {
                        hide_form_on_success: !0,
                        success_message: "Thank you for subscribing!",
                        error_message: "ERROR: Email is required",
                        extra_properties: {
                            $source: "$embed",
                            $method_type: "Klaviyo Form",
                            $method_id: "embed",
                            $consent_version: "Embed default text"
                        },
                        success: function(e) {}
                    }), clearInterval(Ve))
                }), 1e3), ke(), Te(), me(), We = document.querySelector(".js-cart-count"), window.miniCart = new window.Vue({
                    el: "#mini-cart",
                    delimiters: ["<%", "%>"],
                    data: {
                        cart: [],
                        checkoutUrl: "",
                        freeShippingEnabled: window.globals.freeShippingEnabled,
                        freeShippingThreshold: window.globals.freeShippingThreshold || 0,
                        freeShippingQualified: window.globals.freeShippingQualified || "",
                        freeShippingText: window.globals.freeShippingNotice || "",
                        quantity: 0,
                        hasGiftMessage: !1,
                        addGiftMessage: !1,
                        giftMessage: "",
                        giftMessageInterval: 1e3,
                        isGiftNoteUpdating: !1,
                        graphQlEndPoint: "https://sage-sound.myshopify.com/api/2023-01/graphql.json",
                        graphQlHeaders: {
                            "Content-Type": "application/json",
                            "X-Shopify-Storefront-Access-Token": "c4265a71598b9f3557823dbec1f73b81"
                        },
                        upsellEnabled: window.globals.upsellEnabled || !1,
                        upsellTitle: window.globals.upsellTitle || "",
                        upsellProducts: [],
                        barsTitle: window.globals.barsTitle,
                        barsMessage: window.globals.barsMessage
                    },
                    mounted: function() {
                        this.getCart(), this.toggleMiniCart()
                    },
                    filters: {
                        truncateCharacters: function(e, a) {
                            return e.length > a ? e.substring(0, a) + "..." : e
                        },
                        strippedContent: function(e) {
                            return e.replace(/<\/?[^>]+>/gi, " ").split(" - ")[0]
                        },
                        currencydecimal: function(e) {
                            return Math.round(parseFloat(e / 100).toFixed(2))
                        },
                        freeShippingCurrencydecimal: function(e) {
                            return e.toFixed(2)
                        },
                        imageSrcset: function(e) {
                            var a = e.substring(0, e.lastIndexOf(".") + 1).slice(0, -1),
                                t = e.substring(e.lastIndexOf(".") + 1, e.length);
                            return a + "_150x." + t + ", " + a + "_150x@2x." + t + " 2x, " + a + "_150x@3x." + t + " 3x"
                        }
                    },
                    methods: {
                        freeShippingPercent: function(e) {
                            var a = 100 * parseInt(this.freeShippingThreshold);
                            console.log("saodsapdpsapodasdasdopas", a);
                            var t = parseFloat(e);
                            return 100 * t / a > 100 ? 100 : 100 * t / a
                        },
                        toggleMiniCart: function() {
                            var e = document.querySelectorAll(".js-toggle-cart"),
                                a = document.querySelector(".mini-cart");
                            e.forEach((function(e) {
                                e.addEventListener("click", (function(e) {
                                    document.body.classList.toggle("mini-cart-open"), document.body.classList.remove("nav-open"), document.body.classList.remove("search-open"), document.body.classList.remove("filter-open"), a.scrollTo(0, 0)
                                }))
                            }))
                        },
                        openMiniCart: function() {
                            var e = document.querySelector(".mini-cart");
                            document.body.classList.add("mini-cart-open"), document.body.classList.remove("nav-open"), document.body.classList.remove("search-open"), document.body.classList.remove("filter-open"), e.scrollTo(0, 0)
                        },
                        closeMiniCart: function() {
                            document.body.classList.remove("mini-cart-open"), console.log("closing minicart")
                        },
                        giftNoteKeyup: function() {
                            var e = this;
                            clearInterval(e.giftMessageInterval), e.giftMessageInterval = setInterval((function() {
                                e.addGiftNote(), clearInterval(e.giftMessageInterval)
                            }), 1e3)
                        },
                        getCart: function() {
                            var e = this,
                                a = [];
                            fetch("/cart.js", {
                                method: "GET"
                            }).then((function(e) {
                                return e.json()
                            })).then((function(t) {
                                t.items.forEach((function(e) {
                                    a.push("gid://shopify/Product/" + e.product_id)
                                })), console.log(a), e.cart = t, e.getCartProductsDetails(a), e.setCartItemCount(), e.determineIfGift(t), console.log(t), setTimeout((function() {
                                    var e = document.querySelector(".mini-cart__footer");
                                    console.log(e);
                                    var a = new MutationObserver((function(e, a) {
                                        var t, n = de(e);
                                        try {
                                            for (n.s(); !(t = n.n()).done;) {
                                                var i, r;
                                                "childList" === t.value.type && (console.log("A child node has been added or removed."), document.getElementById("embedDiscountMate__original-price") ? (document.getElementById("customDiscount").innerHTML = null === (i = document.getElementById("embedDiscountMate__original-price")) || void 0 === i ? void 0 : i.nextElementSibling.innerHTML.replace("(", "").replace(")", ""), document.getElementById("customTotal").innerHTML = null === (r = document.getElementById("embedDiscountMate__original-price")) || void 0 === r ? void 0 : r.innerHTML, document.getElementById("cartAppTotal") && (document.getElementById("cartAppTotal").style.display = "block")) : document.getElementById("cartAppTotal") && (document.getElementById("cartAppTotal").style.display = "none"))
                                            }
                                        } catch (e) {
                                            n.e(e)
                                        } finally {
                                            n.f()
                                        }
                                    }));
                                    e && a.observe(e, {
                                        childList: !0,
                                        subtree: !0
                                    })
                                }))
                            }), 500).catch((function(a) {
                                e.errored = !0
                            }))
                        },
                        addToCart: function(e) {
                            var a = this;
                            fetch("/cart/add.js", {
                                method: "POST",
                                credentials: "same-origin",
                                headers: {
                                    "Content-Type": "application/json",
                                    "X-Requested-With": "xmlhttprequest"
                                },
                                body: JSON.stringify({
                                    items: e
                                })
                            }).then((function(e) {
                                return e.json()
                            })).then((function(e) {
                                422 == e.status ? alert(e.description) : (a.getCart(), document.body.classList.add("mini-cart-open"))
                            })).catch((function(e) {
                                console.error("Error:", e)
                            }))
                        },
                        emptyCart: function() {
                            var e = this;
                            fetch("/cart/clear.js", {
                                method: "POST"
                            }).then((function(e) {
                                return e.json()
                            })).then((function(a) {
                                e.getCart()
                            })).catch((function(a) {
                                e.errored = !0
                            }))
                        },
                        updateLineItem: function(e, a) {
                            var t = this;
                            console.log("Update Lien Item called...."), fetch("/cart/change.js", {
                                method: "POST",
                                credentials: "same-origin",
                                headers: {
                                    "Content-Type": "application/json",
                                    "X-Requested-With": "xmlhttprequest"
                                },
                                body: JSON.stringify({
                                    line: e,
                                    quantity: a
                                })
                            }).then((function(e) {
                                return e.json()
                            })).then((function(e) {
                                t.getCart()
                            }))
                        },
                        updateItemSelling: function(e, a, t, n) {
                            var i = this;
                            fetch("/cart/change.js", {
                                method: "POST",
                                credentials: "same-origin",
                                headers: {
                                    "Content-Type": "application/json",
                                    "X-Requested-With": "xmlhttprequest"
                                },
                                body: JSON.stringify({
                                    quantity: 0,
                                    line: e
                                })
                            }).then((function(e) {
                                i.addToCart([{
                                    quantity: "".concat(a),
                                    selling_plan: t ? "".concat(t) : "",
                                    id: "".concat(n)
                                }])
                            }))
                        },
                        checkIfContainsOptions: function(e) {
                            return e.length > 1 || (e[0].name, !1)
                        },
                        getCartProductsDetails: function(e) {
                            var a = this,
                                t = [],
                                n = {
                                    ids: e
                                };
                            console.log(n), fetch(this.graphQlEndPoint, {
                                headers: this.graphQlHeaders,
                                method: "POST",
                                body: JSON.stringify({
                                    query: 'query productByIds($ids: [ID!]!) {\n            nodes(ids: $ids) {\n              ... on Product {\n                id\n                title\n                handle\n                availableForSale\n                variants(first: 10) {\n                  edges {\n                    node {\n                      id\n                      quantityAvailable\n                      title\n                      sku\n                      priceV2 {\n                        amount\n                        currencyCode\n                      }\n                      sellingPlanAllocations(first: 10) {\n                        edges {\n                          node {\n                            priceAdjustments {\n                              price {\n                                amount\n                                currencyCode\n                              }\n                            }\n                            sellingPlan {\n                              id\n                              name\n                              priceAdjustments {\n                                adjustmentValue {\n                                  ... on SellingPlanPercentagePriceAdjustment {\n                                    adjustmentPercentage\n                                  }\n                                  ... on SellingPlanFixedPriceAdjustment {\n                                    price {\n                                      amount\n                                      currencyCode\n                                    }\n                                  }\n                                }\n                              }\n                            }\n                          }\n                        }\n                      }\n                    }\n                  }\n                }\n                metafields(identifiers: [\n                  {namespace: "custom", key: "cart_upsell_product"}\n                ])\n                { \n                  type \n                  namespace\n                  key\n                  value\n                }\n              }\n            }\n          }\n          ',
                                    variables: n
                                })
                            }).then((function(e) {
                                return e.json()
                            })).then((function(n) {
                                console.log("getCartProductsDetails() response", n), n.data.nodes.forEach((function(n) {
                                    var i;
                                    console.log("PRODUUUUUUUUCT", n), null == n || null === (i = n.variants) || void 0 === i || i.edges.forEach((function(e) {
                                        var t = e.node.id.split("gid://shopify/ProductVariant/")[1];
                                        a.cart.items.forEach((function(a) {
                                            a.variant_id == t && (a.sellingPlanAllocations = e.node.sellingPlanAllocations), a.variantOriginalPrice = e.node.priceV2.amount
                                        }))
                                    })), n.metafields && n.metafields.forEach((function(a) {
                                        a && "cart_upsell_product" == a.key && !e.includes(a.value) && t.push(a.value)
                                    }))
                                })), console.log("metafieldProductIds=============================", t, t.length), t.length > 0 ? (console.log("metafieldProductIds are greater than 0"), a.getUpsellProducts(t)) : a.upsellProducts = []
                            }))
                        },
                        getUpsellProducts: function(e) {
                            var a = this;
                            console.log("getUpsellProducts(productIds)=============================", e);
                            var t = {
                                ids: e
                            };
                            fetch(this.graphQlEndPoint, {
                                headers: this.graphQlHeaders,
                                method: "POST",
                                body: JSON.stringify({
                                    query: "query productByIds($ids: [ID!]!) {\n            nodes(ids: $ids) {\n              ... on Product {\n                handle\n                title\n                vendor\n                variants(first: 10) {\n                  edges {\n                    node {\n                      currentlyNotInStock\n                      availableForSale\n                      priceV2 {\n                        amount\n                        currencyCode\n                      }\n                      id\n                      quantityAvailable\n                      title\n                      sku\n                      image {\n                        altText\n                        id\n                      }\n                      selectedOptions {\n                        name\n                        value\n                      }\n                    }\n                  }\n                }\n                media(first: 10) {\n                  edges {\n                    node {\n                      mediaContentType\n                      alt\n                      ... on MediaImage {\n                        id\n                        image {\n                          src\n                          originalSrc\n                          width\n                          height\n                          altText\n                        }\n                      }\n                      ... on Video {\n                        id\n                        alt\n                        sources {\n                          format\n                          height\n                          mimeType\n                          url\n                          width\n                        }\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          }\n          ",
                                    variables: t
                                })
                            }).then((function(e) {
                                return e.json()
                            })).then((function(e) {
                                if (console.log("======= ** UPSELLL response ** =======", JSON.stringify(e), e.data.nodes, null != e.data.nodes[0]), null == e.data.nodes[0]) return a.upsellProducts = [], console.log("No products in upsell");
                                a.upsellProducts = e.data.nodes, a.upsellProducts = Array.from(new Set(e.data.nodes.map(JSON.stringify))).map(JSON.parse), console.log("this.upsellProducts", a.upsellProducts), setTimeout((function() {
                                    a.initUpsellSlider()
                                }), 500)
                            }))
                        },
                        initUpsellSlider: function() {
                            document.querySelector(".js-upsell-swiper") ? (this.upsellSwiper && null == this.upsellSwiper.destroyed && this.upsellSwiper.destroy(), document.querySelectorAll(".js-upsell-swiper .swiper-slide").length, this.upsellSwiper = new ne(".js-upsell-swiper", {
                                grabCursor: !0,
                                spaceBetween: 40,
                                threshold: 10,
                                initialSlide: 0,
                                slidesPerView: 1,
                                slideToClickedSlide: !1,
                                navigation: {
                                    nextEl: ".js-upsell-swiper .swiper-button-next",
                                    prevEl: ".js-upsell-swiper .swiper-button-prev"
                                },
                                pagination: {
                                    el: ".js-upsell-swiper .swiper-pagination",
                                    clickable: !0
                                }
                            })) : this.upsellSwiper = ""
                        },
                        checkProperty: function(e, a) {
                            return "_" !== e[0]
                        },
                        determineIfGift: function(e) {
                            e.note ? (this.addGiftMessage = !0, this.hasGiftMessage = !0, this.giftMessage = e.note) : (this.addGiftMessage = !1, this.hasGiftMessage = !1, this.giftMessage = "")
                        },
                        setCartItemCount: function() {
                            this.quantity = this.cart.items.reduce((function(e, a) {
                                return e + a.quantity
                            }), 0), We && (We.innerHTML = this.quantity)
                        },
                        addGiftNote: function() {
                            var e = this,
                                a = this.giftMessage;
                            this.isGiftNoteUpdating = !0, fetch("/cart/update.js", {
                                method: "POST",
                                credentials: "same-origin",
                                headers: {
                                    "Content-Type": "application/json",
                                    "X-Requested-With": "xmlhttprequest"
                                },
                                body: JSON.stringify({
                                    note: a
                                })
                            }).then((function(e) {
                                return e.json()
                            })).then((function(a) {
                                e.getCart(), e.isGiftNoteUpdating = !1
                            })).catch((function(a) {
                                console.error("Error:", a), e.isGiftNoteUpdating = !1
                            }))
                        },
                        removeGiftNote: function() {
                            var e = this,
                                a = this.giftMessage,
                                t = this.cart.note.replace(a, "");
                            fetch("/cart/update.js", {
                                method: "POST",
                                credentials: "same-origin",
                                headers: {
                                    "Content-Type": "application/json",
                                    "X-Requested-With": "xmlhttprequest"
                                },
                                body: JSON.stringify({
                                    note: t
                                })
                            }).then((function(e) {
                                return e.json()
                            })).then((function(a) {
                                e.getCart()
                            })).catch((function(e) {
                                console.error("Error:", e)
                            }))
                        }
                    }
                }),
                function() {
                    if (document.getElementById("main-cart")) {
                        var e = document.querySelector(".js-cart-count");
                        console.log("cartCountElem", e), window.mainCart = new window.Vue({
                            el: "#main-cart",
                            delimiters: ["<%", "%>"],
                            data: {
                                loaded: !0,
                                cart: [],
                                checkoutUrl: "",
                                freeShippingEnabled: window.globals.freeShippingEnabled,
                                freeShippingThreshold: window.globals.freeShippingThreshold || 0,
                                freeShippingQualified: window.globals.freeShippingQualified || "",
                                freeShippingText: window.globals.freeShippingNotice || "",
                                quantity: 0,
                                hasGiftMessage: !1,
                                addGiftMessage: !1,
                                giftMessage: "",
                                giftMessageInterval: 1e3,
                                isGiftNoteUpdating: !1,
                                graphQlEndPoint: "https://wearesuperzero.myshopify.com/api/2023-01/graphql.json",
                                graphQlHeaders: {
                                    "Content-Type": "application/json",
                                    "X-Shopify-Storefront-Access-Token": "ade3b5c37a246538ba36205c5e6f5d9b"
                                },
                                upsellEnabled: window.globals.upsellEnabled || !1,
                                upsellTitle: window.globals.upsellTitle || "",
                                upsellProducts: []
                            },
                            mounted: function() {
                                this.getCart(), this.toggleMiniCart()
                            },
                            filters: {
                                truncateCharacters: function(e, a) {
                                    return e.length > a ? e.substring(0, a) + "..." : e
                                },
                                strippedContent: function(e) {
                                    return e.replace(/<\/?[^>]+>/gi, " ").split(" - ")[0]
                                },
                                currencydecimal: function(e) {
                                    return Math.round(parseFloat(e / 100).toFixed(2))
                                },
                                freeShippingCurrencydecimal: function(e) {
                                    return e.toFixed(2)
                                },
                                imageSrcset: function(e) {
                                    var a = e.substring(0, e.lastIndexOf(".") + 1).slice(0, -1),
                                        t = e.substring(e.lastIndexOf(".") + 1, e.length);
                                    return a + "_200x." + t + ", " + a + "_200x@2x." + t + " 2x, " + a + "_200x@3x." + t + " 3x"
                                }
                            },
                            methods: {
                                freeShippingPercent: function(e) {
                                    var a = 100 * parseInt(this.freeShippingThreshold);
                                    console.log("saodsapdpsapodasdasdopas", a);
                                    var t = parseFloat(e);
                                    return 100 * t / a > 100 ? 100 : 100 * t / a
                                },
                                toggleMiniCart: function() {
                                    var e = document.querySelectorAll(".js-toggle-cart"),
                                        a = document.querySelector(".mini-cart");
                                    e.forEach((function(e) {
                                        e.addEventListener("click", (function(e) {
                                            document.body.classList.remove("nav-open"), document.body.classList.remove("search-open"), document.body.classList.remove("filter-open"), a.scrollTo(0, 0)
                                        }))
                                    }))
                                },
                                openMiniCart: function() {
                                    var e = document.querySelector(".mini-cart");
                                    document.body.classList.add("mini-cart-open"), document.body.classList.remove("nav-open"), document.body.classList.remove("search-open"), document.body.classList.remove("filter-open"), e.scrollTo(0, 0)
                                },
                                closeMiniCart: function() {
                                    document.body.classList.remove("mini-cart-open"), console.log("closing minicart")
                                },
                                giftNoteKeyup: function() {
                                    var e = this;
                                    clearInterval(e.giftMessageInterval), e.giftMessageInterval = setInterval((function() {
                                        e.addGiftNote(), clearInterval(e.giftMessageInterval)
                                    }), 1e3)
                                },
                                getCart: function() {
                                    var e = this,
                                        a = [];
                                    fetch("/cart.js", {
                                        method: "GET"
                                    }).then((function(e) {
                                        return e.json()
                                    })).then((function(t) {
                                        t.items.forEach((function(e) {
                                            a.push("gid://shopify/Product/" + e.product_id)
                                        })), console.log(a), e.cart = t, e.getCartProductsDetails(a), e.setCartItemCount(), e.determineIfGift(t), console.log(t)
                                    })).catch((function(a) {
                                        e.errored = !0
                                    }))
                                },
                                addToCart: function(e) {
                                    var a = this;
                                    fetch("/cart/add.js", {
                                        method: "POST",
                                        credentials: "same-origin",
                                        headers: {
                                            "Content-Type": "application/json",
                                            "X-Requested-With": "xmlhttprequest"
                                        },
                                        body: JSON.stringify({
                                            items: e
                                        })
                                    }).then((function(e) {
                                        return e.json()
                                    })).then((function(e) {
                                        422 == e.status ? alert(e.description) : a.getCart()
                                    })).catch((function(e) {
                                        console.error("Error:", e)
                                    }))
                                },
                                emptyCart: function() {
                                    var e = this;
                                    fetch("/cart/clear.js", {
                                        method: "POST"
                                    }).then((function(e) {
                                        return e.json()
                                    })).then((function(a) {
                                        e.getCart()
                                    })).catch((function(a) {
                                        e.errored = !0
                                    }))
                                },
                                updateLineItem: function(e, a) {
                                    var t = this;
                                    console.log("Update Lien Item called...."), fetch("/cart/change.js", {
                                        method: "POST",
                                        credentials: "same-origin",
                                        headers: {
                                            "Content-Type": "application/json",
                                            "X-Requested-With": "xmlhttprequest"
                                        },
                                        body: JSON.stringify({
                                            line: e,
                                            quantity: a
                                        })
                                    }).then((function(e) {
                                        return e.json()
                                    })).then((function(e) {
                                        t.getCart()
                                    }))
                                },
                                updateItemSelling: function(e, a, t, n) {
                                    var i = this;
                                    fetch("/cart/change.js", {
                                        method: "POST",
                                        credentials: "same-origin",
                                        headers: {
                                            "Content-Type": "application/json",
                                            "X-Requested-With": "xmlhttprequest"
                                        },
                                        body: JSON.stringify({
                                            quantity: 0,
                                            line: e
                                        })
                                    }).then((function(e) {
                                        i.addToCart([{
                                            quantity: "".concat(a),
                                            selling_plan: t ? "".concat(t) : "",
                                            id: "".concat(n)
                                        }])
                                    }))
                                },
                                checkIfContainsOptions: function(e) {
                                    return e.length > 1 || (e[0].name, !1)
                                },
                                getCartProductsDetails: function(e) {
                                    var a = this,
                                        t = [],
                                        n = {
                                            ids: e
                                        };
                                    console.log(n), fetch(this.graphQlEndPoint, {
                                        headers: this.graphQlHeaders,
                                        method: "POST",
                                        body: JSON.stringify({
                                            query: 'query productByIds($ids: [ID!]!) {\n            nodes(ids: $ids) {\n              ... on Product {\n                id\n                title\n                handle\n                availableForSale\n                variants(first: 10) {\n                  edges {\n                    node {\n                      id\n                      quantityAvailable\n                      title\n                      sku\n                      priceV2 {\n                        amount\n                        currencyCode\n                      }\n                      sellingPlanAllocations(first: 10) {\n                        edges {\n                          node {\n                            priceAdjustments {\n                              price {\n                                amount\n                                currencyCode\n                              }\n                            }\n                            sellingPlan {\n                              id\n                              name\n                              priceAdjustments {\n                                adjustmentValue {\n                                  ... on SellingPlanPercentagePriceAdjustment {\n                                    adjustmentPercentage\n                                  }\n                                  ... on SellingPlanFixedPriceAdjustment {\n                                    price {\n                                      amount\n                                      currencyCode\n                                    }\n                                  }\n                                }\n                              }\n                            }\n                          }\n                        }\n                      }\n                    }\n                  }\n                }\n                metafields(identifiers: [\n                  {namespace: "custom", key: "cart_upsell_product"}\n                ])\n                { \n                  type \n                  namespace\n                  key\n                  value\n                }\n              }\n            }\n          }\n          ',
                                            variables: n
                                        })
                                    }).then((function(e) {
                                        return e.json()
                                    })).then((function(n) {
                                        console.log(n), n.data.nodes.forEach((function(n) {
                                            var i;
                                            null == n || null === (i = n.variants) || void 0 === i || i.edges.forEach((function(e) {
                                                var t = e.node.id.split("gid://shopify/ProductVariant/")[1];
                                                a.cart.items.forEach((function(a) {
                                                    a.variant_id == t && (a.sellingPlanAllocations = e.node.sellingPlanAllocations), a.variantOriginalPrice = e.node.priceV2.amount
                                                }))
                                            })), n.metafields && n.metafields.forEach((function(a) {
                                                a && "cart_upsell_product" == a.key && !e.includes(a.value) && t.push(a.value)
                                            }))
                                        })), a.getUpsellProducts(t)
                                    }))
                                },
                                getUpsellProducts: function(e) {
                                    var a = this,
                                        t = {
                                            ids: e
                                        };
                                    fetch(this.graphQlEndPoint, {
                                        headers: this.graphQlHeaders,
                                        method: "POST",
                                        body: JSON.stringify({
                                            query: "query productByIds($ids: [ID!]!) {\n            nodes(ids: $ids) {\n              ... on Product {\n                handle\n                title\n                vendor\n                variants(first: 10) {\n                  edges {\n                    node {\n                      currentlyNotInStock\n                      availableForSale\n                      priceV2 {\n                        amount\n                        currencyCode\n                      }\n                      id\n                      quantityAvailable\n                      title\n                      sku\n                      image {\n                        altText\n                        id\n                      }\n                      selectedOptions {\n                        name\n                        value\n                      }\n                    }\n                  }\n                }\n                media(first: 10) {\n                  edges {\n                    node {\n                      mediaContentType\n                      alt\n                      ... on MediaImage {\n                        id\n                        image {\n                          src\n                          originalSrc\n                          width\n                          height\n                          altText\n                        }\n                      }\n                      ... on Video {\n                        id\n                        alt\n                        sources {\n                          format\n                          height\n                          mimeType\n                          url\n                          width\n                        }\n                      }\n                    }\n                  }\n                }\n              }\n            }\n          }\n          ",
                                            variables: t
                                        })
                                    }).then((function(e) {
                                        return e.json()
                                    })).then((function(e) {
                                        console.log(e), a.upsellProducts = e.data.nodes, a.upsellProducts = Array.from(new Set(e.data.nodes.map(JSON.stringify))).map(JSON.parse), console.log("this.upsellProducts", a.upsellProducts)
                                    }))
                                },
                                initUpsellSlider: function() {
                                    document.querySelector(".js-upsell-swiper") ? (this.upsellSwiper && null == this.upsellSwiper.destroyed && this.upsellSwiper.destroy(), document.querySelectorAll(".js-upsell-swiper .swiper-slide").length, this.upsellSwiper = new ne(".js-upsell-swiper", {
                                        grabCursor: !0,
                                        spaceBetween: 20,
                                        threshold: 10,
                                        initialSlide: 0,
                                        slidesPerView: 1,
                                        slideToClickedSlide: !1,
                                        pagination: {
                                            el: ".swiper-pagination",
                                            type: "bullets",
                                            clickable: !0
                                        },
                                        breakpoints: {
                                            640: {
                                                slidesPerView: 1
                                            }
                                        }
                                    })) : this.upsellSwiper = ""
                                },
                                checkProperty: function(e, a) {
                                    return "_" !== e[0]
                                },
                                determineIfGift: function(e) {
                                    e.note ? (this.addGiftMessage = !0, this.hasGiftMessage = !0, this.giftMessage = e.note) : (this.addGiftMessage = !1, this.hasGiftMessage = !1, this.giftMessage = "")
                                },
                                setCartItemCount: function() {
                                    this.quantity = this.cart.items.reduce((function(e, a) {
                                        return e + a.quantity
                                    }), 0), e.innerHTML = this.quantity
                                },
                                addGiftNote: function() {
                                    var e = this,
                                        a = this.giftMessage;
                                    this.isGiftNoteUpdating = !0, fetch("/cart/update.js", {
                                        method: "POST",
                                        credentials: "same-origin",
                                        headers: {
                                            "Content-Type": "application/json",
                                            "X-Requested-With": "xmlhttprequest"
                                        },
                                        body: JSON.stringify({
                                            note: a
                                        })
                                    }).then((function(e) {
                                        return e.json()
                                    })).then((function(a) {
                                        e.getCart(), e.isGiftNoteUpdating = !1
                                    })).catch((function(a) {
                                        console.error("Error:", a), e.isGiftNoteUpdating = !1
                                    }))
                                },
                                removeGiftNote: function() {
                                    var e = this,
                                        a = this.giftMessage,
                                        t = this.cart.note.replace(a, "");
                                    fetch("/cart/update.js", {
                                        method: "POST",
                                        credentials: "same-origin",
                                        headers: {
                                            "Content-Type": "application/json",
                                            "X-Requested-With": "xmlhttprequest"
                                        },
                                        body: JSON.stringify({
                                            note: t
                                        })
                                    }).then((function(e) {
                                        return e.json()
                                    })).then((function(a) {
                                        e.getCart()
                                    })).catch((function(e) {
                                        console.error("Error:", e)
                                    }))
                                },
                                calculateShipping: function() {
                                    var e = document.querySelector("#country-select").value || null,
                                        a = document.querySelector("#state-select").value || null,
                                        t = document.querySelector("#zip").value || null;
                                    null != e && null != a && null != t && (console.log(e), console.log(a), console.log(t), fetch("/cart/shipping_rates.json?shipping_address%5Bzip%5D=".concat(t, "&shipping_address%5Bcountry%5D=").concat(e, "&shipping_address%5Bprovince%5D=").concat(a), {
                                        method: "GET"
                                    }).then((function(e) {
                                        return e.json()
                                    })).then((function(t) {
                                        var n = document.querySelector("#calculate-shipping-text");
                                        n.textContent = n && t ? "This is one shipping rate available for ".concat(a, ", ").concat(e, " .Standard Shipping at $").concat(t.shipping_rates[0].price, " USD ") : "Input data is not correct, please check above data"
                                    })).catch((function(e) {
                                        console.error("Error:", e), document.querySelector("#calculate-shipping-text").textContent = "Input data is not correct, please check above data"
                                    })))
                                }
                            }
                        })
                    }
                }(), window.searchPageOptions = new window.Vue({
                    el: "#search",
                    delimiters: ["<%", "%>"],
                    data: function() {
                        return {
                            searchTerm: "",
                            items: [],
                            otherItems: {
                              articles: [],
                              collections: [],
                              pages: []
                            },
                            loading: !0,
                            message: "",
                            searchSlider: null,
                            graphQlEndPoint: "https://sage-sound.myshopify.com/api/2023-01/graphql.json",
                            graphQlHeaders: {
                                "Content-Type": "application/json",
                                "X-Shopify-Storefront-Access-Token": "c4265a71598b9f3557823dbec1f73b81"
                            }
                        }
                    },
                    methods: {
                        strippedHtml: function(e) {
                            return e.replace(/(<([^>]+)>)/gi, "")
                        },

                        formatDate(dateString) {
                              if (!dateString) return '';
                              const date = new Date(dateString);
                              const mm = String(date.getUTCMonth() + 1).padStart(2, '0');
                              const dd = String(date.getUTCDate()).padStart(2, '0');
                              const yy = String(date.getUTCFullYear()).slice(-2);
                              return `${mm}/${dd}/${yy}`;
                        },
                        search: function(e) {
                            var a = this;
                            this.items = [];
                            
                            
                          
                            var t = [];
                            "" != e ? (this.loading = !0, fetch("/search/suggest.json?q=".concat(e, "&resources[type]=product,page,article,collection&resources[limit]=10&resources[options][fields]=title,product_type,variants.title,body,tag")).then((function(e) {
                                return e.json()
                            })).then((function(e) {
                                var n = e.resources.results.products;

                                a.otherItems = {
                                  // articles: e.resources.results.articles,
                                  articles: e.resources.results.articles.map(article => ({
                                    ...article,
                                    published_at: a.formatDate(article.published_at)
                                  })),
                                  collections: e.resources.results.collections,
                                  // pages: e.resources.results.pages
                                  pages: e.resources.results.pages.map(page => ({
                                    ...page,
                                    published_at: a.formatDate(page.published_at)
                                  })),
                                };

                                console.log('Other items: ', a.otherItems);
                              
                                console.log('results products: ', n), n.length > 0 ? (a.items = n, a.items.forEach((function(e) {
                                    t.push("gid://shopify/Product/" + e.id)
                                })), a.getSearchProductsDetails(t)) : (a.items = [], a.message = "")
                            }))) : this.message = "Please enter a search term"
                        },
                        searchSwiper: function() {
                            var e = document.querySelector(".js-search-swiper");
                            this.searchSlider && this.searchSlider.destroy(), e && (this.searchSlider = new ne(".js-search-swiper", {
                                slidesPerView: 2,
                                spaceBetween: 16,
                                a11y: !0,
                                navigation: {
                                    nextEl: ".js-search-swiper .swiper-button-next",
                                    prevEl: ".js-search-swiper .swiper-button-prev"
                                },
                                breakpoints: {
                                    768: {
                                        slidesPerView: 3,
                                        spaceBetween: 28
                                    },
                                    1024: {
                                        slidesPerView: 4,
                                        spaceBetween: 28
                                    }
                                }
                            }))
                        },
                        getSearchProductsDetails: function(a) {
                            var t = this,
                                n = {
                                    ids: a
                                };
                            console.log(n), fetch(this.graphQlEndPoint, {
                                headers: this.graphQlHeaders,
                                method: "POST",
                                body: JSON.stringify({
                                    query: "query productByIds($ids: [ID!]!) {\n          nodes(ids: $ids) {\n            ... on Product {\n              id\n              title\n              handle\n              availableForSale\n              variants(first: 10) {\n                edges {\n                  node {\n                    id\n                    quantityAvailable\n                    title\n                    sku\n                    priceV2 {\n                      amount\n                      currencyCode\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n        ",
                                    variables: n
                                })
                            }).then((function(e) {
                                return e.json()
                            })).then((function(a) {
                                console.log("response", a), a.data.nodes.forEach((function(e) {
                                    if (e && e.id) {
                                        var a = e.id.split("gid://shopify/Product/")[1];
                                        t.items.forEach((function(t) {
                                            t.id == a && (t.first_variant = e.variants.edges[0].node)
                                        }))
                                    }
                                })), t.loading = !1, t.searchSwiper(), t.$nextTick((function() {
                                    e()
                                }))
                            }))
                        }
                    }
                }), window.mobileSearchPageOptions = new window.Vue({
                    el: "#mobile-search",
                    delimiters: ["<%", "%>"],
                    data: function() {
                        return {
                            searchTerm: "",
                            items: [],
                            otherItems: {
                                articles: [],
                                collections: [],
                                pages: []
                            },
                            loading: !0,
                            message: "",
                            searchSlider: null,
                            graphQlEndPoint: "https://sage-sound.myshopify.com/api/2023-01/graphql.json",
                            graphQlHeaders: {
                                "Content-Type": "application/json",
                                "X-Shopify-Storefront-Access-Token": "c4265a71598b9f3557823dbec1f73b81"
                            }
                        }
                    },

                    
                    methods: {
                        strippedHtml: function(e) {
                            return e.replace(/(<([^>]+)>)/gi, "")
                        },
                        formatDate(dateString) {
                            if (!dateString) return '';
                            const date = new Date(dateString);
                            const mm = String(date.getUTCMonth() + 1).padStart(2, '0');
                            const dd = String(date.getUTCDate()).padStart(2, '0');
                            const yy = String(date.getUTCFullYear()).slice(-2);
                            return `${mm}/${dd}/${yy}`;
                        },
                        search: function(e) {
                            var a = this;
                            console.log("this", this), this.items = [];
                            var t = [];
                            "" != e ? (this.loading = !0, fetch("/search/suggest.json?q=".concat(e, "&resources[type]=product,page,article,collection&resources[limit]=10&resources[options][fields]=title,product_type,variants.title,body,tag")).then((function(e) {
                                return e.json()
                            })).then((function(e) {

                                    var n = e.resources.results.products;

                                    a.otherItems = {
                                        // articles: e.resources.results.articles,
                                        articles: e.resources.results.articles.map(article => ({
                                        ...article,
                                        published_at: a.formatDate(article.published_at)
                                        })),
                                        collections: e.resources.results.collections,
                                        // pages: e.resources.results.pages
                                        pages: e.resources.results.pages.map(page => ({
                                        ...page,
                                        published_at: a.formatDate(page.published_at)
                                        })),
                                    };
  
                                    console.log('Other items: ', a.otherItems);



                                console.log(n), n.length > 0 ? (a.items = n, a.items.forEach((function(e) {
                                    t.push("gid://shopify/Product/" + e.id)
                                })), a.getSearchProductsDetails(t)) : (a.items = [], a.message = "")
                            }))) : this.message = "Please enter a search term"
                        },
                        searchSwiper: function() {
                            var e = document.querySelector("#mobile-search .js-search-swiper");
                            this.searchSlider && this.searchSlider.destroy(), e && (this.searchSlider = new ne("#mobile-search .js-search-swiper", {
                                slidesPerView: 2,
                                loop: true,
                                spaceBetween: 16,
                                a11y: !0,
                                navigation: {
                                    nextEl: "#mobile-search .js-search-swiper .swiper-button-next",
                                    prevEl: "#mobile-search .js-search-swiper .swiper-button-prev"
                                }
                            }))
                        },
                        getSearchProductsDetails: function(a) {
                            var t = this,
                                n = {
                                    ids: a
                                };
                            console.log(n), fetch(this.graphQlEndPoint, {
                                headers: this.graphQlHeaders,
                                method: "POST",
                                body: JSON.stringify({
                                    query: "query productByIds($ids: [ID!]!) {\n          nodes(ids: $ids) {\n            ... on Product {\n              id\n              title\n              handle\n              availableForSale\n              variants(first: 10) {\n                edges {\n                  node {\n                    id\n                    quantityAvailable\n                    title\n                    sku\n                    priceV2 {\n                      amount\n                      currencyCode\n                    }\n                  }\n                }\n              }\n            }\n          }\n        }\n        ",
                                    variables: n
                                })
                            }).then((function(e) {
                                return e.json()
                            })).then((function(a) {
                                console.log("response", a), a.data.nodes.forEach((function(e) {
                                    if (e && e.id) {
                                        var a = e.id.split("gid://shopify/Product/")[1];
                                        t.items.forEach((function(t) {
                                            t.id == a && (t.first_variant = e.variants.edges[0].node)
                                        }))
                                    }
                                })), t.loading = !1, t.searchSwiper(), t.$nextTick((function() {
                                    e()
                                }))
                            }))
                        }
                    }
                }), xe(), Fe = document.querySelectorAll("[data-recover-toggle]"), _e = document.querySelector("[data-login-form]"), Ye = document.querySelector("[data-recover-form]"), document.querySelector(".recover-password-message") && (_e.classList.toggle("hidden"), Ye.classList.toggle("hidden")), Fe.forEach((function(e) {
                    e.addEventListener("click", (function() {
                        _e.classList.toggle("hidden"), Ye.classList.toggle("hidden")
                    }))
                })),
                function() {
                    var e = document.querySelector(".js-pdp-swiper");
                    if (e && e.getAttribute("data-image-count")) {
                        var a = parseInt(e.getAttribute("data-image-count")),
                            t = !0;
                        a <= 1 && (t = !1), new ne(".js-pdp-swiper", {
                            spaceBetween: 12,
                            speed: 300,
                            centeredSlides: !0,
                            centeredSlidesBounds: !0,
                            slidesPerView: a <= 1 ? 1 : 1.2,
                            loop: t,
                            loopedSlides: 1,
                            slidesPerGroup: 1,
                            threshold: 10,
                            pagination: {
                                el: ".swiper-pagination",
                                clickable: !0,
                                dynamicBullets: 1,
                                dynamicMainBullets: 3
                            },
                            navigation: {
                                nextEl: ".swiper-button-next",
                                prevEl: ".swiper-button-prev"
                            },
                            breakpoints: {
                                769: {
                                    slidesPerView: 1,
                                    loop: true,
                                    spaceBetween: 22,
                                    initialSlide: 0
                                }
                            }
                        })
                    }
                }(),
                function() {
                    document.querySelectorAll(".js-toggle-read-more").forEach((function(e) {
                        e.addEventListener("click", (function(e) {
                            e.stopImmediatePropagation();
                            var a = e.target.parentElement,
                                t = e.target.parentElement.parentElement.previousElementSibling.innerHTML;

                            console.log('Target element: ', e);

                            if (a.nodeName == 'BUTTON') {
                                a = a.parentElement;
                            }

                            console.log(a, t),
                                a.replaceWith(t);


                        }), !1)
                    }));

                    var e = document.querySelector(".js-main-pdp");
                    if (console.log("main_pdp", e), e) {
                        var a = e.getAttribute("data-product-type").replace(/\s/g, "");
                        console.log("product_type", a), a && document.body.classList.add("product-type-" + a)
                    }
                }(), Xe = document.querySelectorAll(".js-services-nav-page")[0], Je = document.querySelector(".js-services-nav-header"), Ue = document.querySelectorAll(".js-study-nav-page")[0], Ze = document.querySelector(".js-study-nav-header"), Qe = document.querySelectorAll(".js-holiday-nav-page")[0], ea = document.querySelector(".js-gifting-nav-header"), Xe && Je && (Je.innerHTML = Xe.innerHTML, Xe.remove()), Ue && Ze && (Ze.innerHTML = Ue.innerHTML, Ue.remove()), Qe && ea && (ea.innerHTML = Qe.innerHTML, Qe.remove()), new De, aa()
        }()
}();